(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7554],{

/***/ 41154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ safeUrl; },
/* harmony export */   "L": function() { return /* binding */ handlePathDelay; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "Qs": function() { return /* binding */ parseTourLink; },
/* harmony export */   "k6": function() { return /* binding */ asyncStore; },
/* harmony export */   "nA": function() { return /* binding */ checkIsFavourite; },
/* harmony export */   "wv": function() { return /* binding */ parsePathDestinationSweepData; }
/* harmony export */ });
/* unused harmony export capitalizeFirstLetter */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var _models_Game__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81766);


var asyncStore = {
    regularActivePath: null,
    pathSnapshot: {},
    pathIds: [],
    locksPathTimeline: {},
    hidePathTimeline: {},
    revealPathTimeline: {},
    restoreTagsTimeline: {},
    pushRestoreTagsTimeline: function(pathId, tagSid) {
        console.log("bbb pushRestoreTagsTimeline", pathId, tagSid);
        if (!asyncStore.restoreTagsTimeline[pathId]) {
            asyncStore.restoreTagsTimeline[pathId] = [];
        }
        asyncStore.restoreTagsTimeline[pathId].push(tagSid);
    },
    pushRevealPathTimeline: function(pathId, conditions) {
        var _pathId;
        if (!asyncStore.revealPathTimeline[pathId]) {
            asyncStore.revealPathTimeline[pathId] = [];
        }
        (_pathId = asyncStore.revealPathTimeline[pathId]).push.apply(_pathId, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(conditions));
    },
    pushHidePathTimeline: function(pathId, conditions) {
        var _pathId;
        if (!asyncStore.hidePathTimeline[pathId]) {
            asyncStore.hidePathTimeline[pathId] = [];
        }
        (_pathId = asyncStore.hidePathTimeline[pathId]).push.apply(_pathId, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(conditions));
    },
    pushLockPathTimeline: function(pathId, lockData) {
        if (!asyncStore.locksPathTimeline[pathId]) {
            asyncStore.locksPathTimeline[pathId] = [];
        }
        asyncStore.locksPathTimeline[pathId].push(lockData);
    }
};
var parseTourLink = function(link, slug) {
    var linkSlug = link.replace(/(.+\/)|(\?.+)/g, "");
    if (slug && linkSlug !== slug) return false;
    var res = new URLSearchParams(link.replace(/(.+\?)/, "?"));
    return {
        s: res.get("s"),
        x: Number(res.get("x")),
        y: Number(res.get("y"))
    };
};
var checkIsFavourite = function() {
    var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], product = arguments.length > 1 ? arguments[1] : void 0, mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (mode === 0) {
        return products === null || products === void 0 ? void 0 : products.find(function(id) {
            return id === (product === null || product === void 0 ? void 0 : product.id);
        });
    }
    return products === null || products === void 0 ? void 0 : products.find(function(id) {
        return id === (product === null || product === void 0 ? void 0 : product.eCommerceProductId);
    });
};
var capitalizeFirstLetter = function(str) {
    if (!str) return null;
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var safeUrl = function(url) {
    if (!url.includes("http")) return "http://".concat(url);
    return url;
};
var appearanceDelayTimeout = null;
var handlePathDelay = function(delay, setDelayedDisable) {
    if (appearanceDelayTimeout) {
        clearTimeout(appearanceDelayTimeout);
        appearanceDelayTimeout = null;
    }
    if (delay) {
        setDelayedDisable(true);
        appearanceDelayTimeout = setTimeout(function() {
            setDelayedDisable(false);
        }, delay * 1000);
    } else {
        setDelayedDisable(false);
    }
};
var isImage = function(value) {
    return /[^"]*?\.(jpg|png|bmp|wepb|gif|jpeg|tif|tiff)/.test(value === null || value === void 0 ? void 0 : value.toLowerCase());
};
var parsePathDestinationSweepData = function(pathData) {
    var res = {
        sweepUuid: pathData === null || pathData === void 0 ? void 0 : pathData.sweepUuid,
        isTourLink: (pathData === null || pathData === void 0 ? void 0 : pathData.locationSrc) === _models_Game__WEBPACK_IMPORTED_MODULE_0__/* .LocationSrc.tourLink */ .JK.tourLink,
        x: null,
        y: null
    };
    try {
        if (res.isTourLink) {
            var parsedLink = parseTourLink(pathData.locationSmartLink);
            if (parsedLink && (parsedLink === null || parsedLink === void 0 ? void 0 : parsedLink.s) && (parsedLink === null || parsedLink === void 0 ? void 0 : parsedLink.x) && (parsedLink === null || parsedLink === void 0 ? void 0 : parsedLink.y)) {
                res.x = parsedLink.x;
                res.y = parsedLink.y;
                res.sweepUuid = parsedLink.s;
            }
        }
    } finally{
        return res;
    }
};


/***/ }),

/***/ 66725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ dLog; },
/* harmony export */   "d": function() { return /* binding */ stopLogs; }
/* harmony export */ });


var colors = "#556b2f,#a0522d,#483d8b,#008000,#008b8b,#9acd32,#00008b,#7f007f,#8fbc8f,#b03060,#ff4500,#ff8c00,#ffd700,#7cfc00,#8a2be2,#00ff7f,#dc143c,#00ffff,#00bfff,#f4a460,#0000ff,#b0c4de,#ff00ff,#1e90ff,#90ee90,#ff1493,#ee82ee,#ffe4b5,#ffb6c1".split(",");
var components = {};
var cr = function() {
    return Math.random() * (255 - 1) + 1;
};
var showRenderStats = function() {
    var componentsMap = Object.keys(components).map(function(key) {
        return _object_spread_props(_object_spread({}, components[key]), {
            name: key
        });
    }).sort(function(comp1, comp2) {
        return comp1.i > comp2 ? 1 : comp1 === comp2 ? 0 : -1;
    });
    componentsMap.forEach(function(comp) {
        console.log("%c render_d ".concat(comp.name, " ").concat(comp.i), "color:white;background:".concat(comp.color, ";"));
    });
};
var stopLogs = true;
if (false) {}
var dLog = function(componentName) {
    if (false) {}
};


/***/ }),

/***/ 98144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ storage; }
/* harmony export */ });
var storage = function(key) {
    var get = function() {
        var serializedValue = localStorage.getItem(key);
        if (serializedValue !== null) {
            return JSON.parse(serializedValue);
        }
        return null;
    };
    var set = function(value) {
        var serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
    };
    return {
        get: get,
        set: set
    };
};



/***/ }),

/***/ 91833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ createHTMLMesh; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get.mjs + 1 modules
var _get = __webpack_require__(45785);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(99477);
;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/html2canvas.ts



var html2canvas = function(element, canvases) {
    var Clipper = function Clipper(context) {
        var clips = [];
        var isClipping = false;
        function doClip() {
            if (isClipping) {
                isClipping = false;
                context.restore();
            }
            if (clips.length === 0) return;
            var minX = -Infinity, minY = -Infinity;
            var maxX = Infinity, maxY = Infinity;
            for(var i = 0; i < clips.length; i++){
                var clip = clips[i];
                minX = Math.max(minX, clip.x);
                minY = Math.max(minY, clip.y);
                maxX = Math.min(maxX, clip.x + clip.width);
                maxY = Math.min(maxY, clip.y + clip.height);
            }
            context.save();
            context.beginPath();
            context.rect(minX, minY, maxX - minX, maxY - minY);
            context.clip();
            isClipping = true;
        }
        return {
            add: function add(clip) {
                clips.push(clip);
                doClip();
            },
            remove: function remove() {
                clips.pop();
                doClip();
            }
        };
    };
    var getLines = function getLines(element, text, maxWidth) {
        var words = text.split(" ");
        var lines = [];
        var currentLine = words[0];
        for(var i = 1; i < words.length; i++){
            // Somehow, the textnode width in pixels differs from the parent element width.
            // Using the range instead of the context to compute the wrapping width fixes this problem.
            var word = words[i];
            range.setStart(element, 0);
            var newLine = currentLine + " " + word;
            range.setEnd(element, newLine.length);
            var width = range.getBoundingClientRect().width;
            if (width < maxWidth) currentLine = newLine;
            else {
                lines.push(currentLine);
                currentLine = word;
            }
        }
        lines.push(currentLine);
        return lines;
    };
    var drawText = function drawText(style, x, y, string) {
        if (string !== "") {
            if (style.textTransform === "uppercase") {
                string = string.toUpperCase();
            }
            context.font = style.fontWeight + " " + style.fontSize + " " + style.fontFamily;
            context.textBaseline = "top";
            context.fillStyle = style.color;
            context.fillText(string, x, y + parseFloat(style.fontSize) * 0.1);
        }
    };
    var buildRectPath = function buildRectPath(x, y, w, h, r) {
        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        context.beginPath();
        context.moveTo(x + r, y);
        context.arcTo(x + w, y, x + w, y + h, r);
        context.arcTo(x + w, y + h, x, y + h, r);
        context.arcTo(x, y + h, x, y, r);
        context.arcTo(x, y, x + w, y, r);
        context.closePath();
    };
    var drawBorder = function drawBorder(style, which, x, y, width, height) {
        var borderWidth = style[which + "Width"];
        var borderStyle = style[which + "Style"];
        var borderColor = style[which + "Color"];
        if (borderWidth !== "0px" && borderStyle !== "none" && borderColor !== "transparent" && borderColor !== "rgba(0, 0, 0, 0)") {
            context.strokeStyle = borderColor;
            context.lineWidth = parseFloat(borderWidth);
            context.beginPath();
            context.moveTo(x, y);
            context.lineTo(x + width, y + height);
            context.stroke();
        }
    };
    var range = document.createRange();
    var color = new three_module/* Color */.Ilk();
    function drawElement(element, style) {
        var x = 0, y = 0, width = 0, height = 0;
        if (element.nodeType === Node.TEXT_NODE) {
            // text
            range.selectNode(element);
            var rect = range.getBoundingClientRect();
            x = rect.left - offset.left - 0.5;
            y = rect.top - offset.top - 0.5;
            width = rect.width;
            height = rect.height;
            // drawText(style, x, y, element.nodeValue.trim());
            var text = element.nodeValue.trim();
            if (element.parentElement) {
                var parentEl = element.parentElement;
                var parentWidth = parentEl.offsetWidth;
                //set to nowrap so that range doesn't warp in the getLines function
                parentEl.style.whiteSpace = "nowrap";
                var lineHeight = range.getBoundingClientRect().height;
                var lines = getLines(element, text, parentWidth);
                parentEl.style.whiteSpace = null;
                range.selectNode(element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var line = _step.value;
                        drawText(style, x, y, line);
                        y += lineHeight;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else drawText(style, x, y, text);
        } else if (element.nodeType === Node.COMMENT_NODE) {
            return;
        } else if ((0,_instanceof/* default */.Z)(element, HTMLCanvasElement)) {
            // Canvas element
            if (element.style.display === "none") return;
            context.save();
            var dpr = window.devicePixelRatio;
            context.scale(1 / dpr, 1 / dpr);
            context.drawImage(element, 0, 0);
            context.restore();
        } else {
            if (element.style.display === "none") return;
            var rect1 = element.getBoundingClientRect();
            x = rect1.left - offset.left - 0.5;
            y = rect1.top - offset.top - 0.5;
            width = rect1.width;
            height = rect1.height;
            style = window.getComputedStyle(element);
            // Get the border of the element used for fill and border
            buildRectPath(x, y, width, height, parseFloat(style.borderRadius));
            var backgroundColor = style.backgroundColor;
            if (backgroundColor !== "transparent" && backgroundColor !== "rgba(0, 0, 0, 0)") {
                context.fillStyle = backgroundColor;
                context.fill();
            }
            // If all the borders match then stroke the round rectangle
            var borders = [
                "borderTop",
                "borderLeft",
                "borderBottom",
                "borderRight"
            ];
            var match = true;
            var prevBorder = null;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = borders[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var border = _step1.value;
                    if (prevBorder !== null) {
                        match = style[border + "Width"] === style[prevBorder + "Width"] && style[border + "Color"] === style[prevBorder + "Color"] && style[border + "Style"] === style[prevBorder + "Style"];
                    }
                    if (match === false) break;
                    prevBorder = border;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            if (match === true) {
                // They all match so stroke the rectangle from before allows for border-radius
                var width1 = parseFloat(style.borderTopWidth);
                if (style.borderTopWidth !== "0px" && style.borderTopStyle !== "none" && style.borderTopColor !== "transparent" && style.borderTopColor !== "rgba(0, 0, 0, 0)") {
                    context.strokeStyle = style.borderTopColor;
                    context.lineWidth = width1;
                    context.stroke();
                }
            } else {
                // Otherwise draw individual borders
                drawBorder(style, "borderTop", x, y, width, 0);
                drawBorder(style, "borderLeft", x, y, 0, height);
                drawBorder(style, "borderBottom", x, y + height, width, 0);
                drawBorder(style, "borderRight", x + width, y, 0, height);
            }
            if ((0,_instanceof/* default */.Z)(element, HTMLInputElement)) {
                var accentColor = style.accentColor;
                if (accentColor === undefined || accentColor === "auto") accentColor = style.color;
                color.set(accentColor);
                var luminance = Math.sqrt(0.299 * Math.pow(color.r, 2) + 0.587 * Math.pow(color.g, 2) + 0.114 * Math.pow(color.b, 2));
                var accentTextColor = luminance < 0.5 ? "white" : "#111111";
                if (element.type === "radio") {
                    buildRectPath(x, y, width, height, height);
                    context.fillStyle = "white";
                    context.strokeStyle = accentColor;
                    context.lineWidth = 1;
                    context.fill();
                    context.stroke();
                    if (element.checked) {
                        buildRectPath(x + 2, y + 2, width - 4, height - 4, height);
                        context.fillStyle = accentColor;
                        context.strokeStyle = accentTextColor;
                        context.lineWidth = 2;
                        context.fill();
                        context.stroke();
                    }
                }
                if (element.type === "checkbox") {
                    buildRectPath(x, y, width, height, 2);
                    context.fillStyle = element.checked ? accentColor : "white";
                    context.strokeStyle = element.checked ? accentTextColor : accentColor;
                    context.lineWidth = 1;
                    context.stroke();
                    context.fill();
                    if (element.checked) {
                        var currentTextAlign = context.textAlign;
                        context.textAlign = "center";
                        var properties = {
                            color: accentTextColor,
                            fontFamily: style.fontFamily,
                            fontSize: height + "px",
                            fontWeight: "bold"
                        };
                        drawText(properties, x + width / 2, y, "✔");
                        context.textAlign = currentTextAlign;
                    }
                }
                if (element.type === "range") {
                    var ref = (0,_sliced_to_array/* default */.Z)([
                        "min",
                        "max",
                        "value"
                    ].map(function(property) {
                        return parseFloat(element[property]);
                    }), 3), min = ref[0], max = ref[1], value = ref[2];
                    var position = (value - min) / (max - min) * (width - height);
                    buildRectPath(x, y + height / 4, width, height / 2, height / 4);
                    context.fillStyle = accentTextColor;
                    context.strokeStyle = accentColor;
                    context.lineWidth = 1;
                    context.fill();
                    context.stroke();
                    buildRectPath(x, y + height / 4, position + height / 2, height / 2, height / 4);
                    context.fillStyle = accentColor;
                    context.fill();
                    buildRectPath(x + position, y, height, height, height / 2);
                    context.fillStyle = accentColor;
                    context.fill();
                }
                if (element.type === "color" || element.type === "text" || element.type === "number") {
                    clipper.add({
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    });
                    drawText(style, x + parseInt(style.paddingLeft), y + parseInt(style.paddingTop), element.value);
                    clipper.remove();
                }
            }
        }
        /*
    // debug
    context.strokeStyle = '#' + Math.random().toString( 16 ).slice( - 3 );
    context.strokeRect( x - 0.5, y - 0.5, width + 1, height + 1 );
    */ var isClipping = style.overflow === "auto" || style.overflow === "hidden";
        if (isClipping) clipper.add({
            x: x,
            y: y,
            width: width,
            height: height
        });
        for(var i = 0; i < element.childNodes.length; i++){
            drawElement(element.childNodes[i], style);
        }
        if (isClipping) clipper.remove();
    }
    var offset = element.getBoundingClientRect();
    var canvas = canvases.get(element);
    if (canvas === undefined) {
        canvas = document.createElement("canvas");
        canvas.width = offset.width;
        canvas.height = offset.height;
        canvases.set(element, canvas);
    }
    var context = canvas.getContext("2d" /*, { alpha: false }*/ );
    // @ts-ignore
    var clipper = new Clipper(context);
    // console.time( 'drawElement' );
    // @ts-ignore
    drawElement(element);
    // console.timeEnd( 'drawElement' );
    return canvas;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/htmlevent.ts


var htmlevent = function(element, event, x, y) {
    var mouseEventInit = {
        clientX: x * element.offsetWidth + element.offsetLeft,
        clientY: y * element.offsetHeight + element.offsetTop,
        view: element.ownerDocument.defaultView
    };
    //causes error in tours with 'react-zoom-pan-pinch'
    if (event === "mousedown") return;
    window.dispatchEvent(new MouseEvent(event, mouseEventInit));
    var rect = element.getBoundingClientRect();
    x = x * rect.width + rect.left;
    y = y * rect.height + rect.top;
    function traverse(element) {
        if (element.nodeType !== Node.TEXT_NODE && element.nodeType !== Node.COMMENT_NODE) {
            var rect = element.getBoundingClientRect();
            if (x > rect.left && x < rect.right && y > rect.top && y < rect.bottom) {
                element.dispatchEvent(new MouseEvent(event, mouseEventInit));
                if ((0,_instanceof/* default */.Z)(element, HTMLInputElement) && element.type === "range" && (event === "mousedown" || event === "click")) {
                    var ref = (0,_sliced_to_array/* default */.Z)([
                        "min",
                        "max"
                    ].map(function(property) {
                        return parseFloat(element[property]);
                    }), 2), min = ref[0], max = ref[1];
                    var width = rect.width;
                    var offsetX = x - rect.x;
                    var proportion = offsetX / width;
                    // @ts-ignore
                    element.value = min + (max - min) * proportion;
                    element.dispatchEvent(new InputEvent("input", {
                        bubbles: true
                    }));
                }
            }
            for(var i = 0; i < element.childNodes.length; i++){
                traverse(element.childNodes[i]);
            }
        }
    }
    traverse(element);
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/HTMLMesh.tsx







var createHTMLMesh = function(dom, THREE) {
    var canvases = new WeakMap();
    var HTMLTexture = /*#__PURE__*/ function(_CanvasTexture) {
        "use strict";
        (0,_inherits/* default */.Z)(HTMLTexture, _CanvasTexture);
        var _super = (0,_create_super/* default */.Z)(HTMLTexture);
        function HTMLTexture() {
            (0,_class_call_check/* default */.Z)(this, HTMLTexture);
            var _this;
            _this = _super.call(this, html2canvas(dom, canvases));
            _this.dom = dom;
            _this.anisotropy = 16;
            _this.encoding = THREE.sRGBEncoding;
            _this.minFilter = THREE.LinearFilter;
            _this.magFilter = THREE.LinearFilter;
            // Create an observer on the DOM, and run html2canvas update in the next loop
            var observer = new MutationObserver(function() {
                if (!_this.scheduleUpdate) {
                    // ideally should use xr.requestAnimationFrame, here setTimeout to avoid passing the renderer
                    _this.scheduleUpdate = setTimeout(function() {
                        return _this.update();
                    }, 16);
                }
            });
            var config = {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            };
            observer.observe(dom, config);
            _this.observer = observer;
            return _this;
        }
        var _proto = HTMLTexture.prototype;
        _proto.dispatchDOMEvent = function dispatchDOMEvent(event) {
            if (event.data) {
                htmlevent(this.dom, event.type, event.data.x, event.data.y);
            }
        };
        _proto.update = function update() {
            this.image = html2canvas(this.dom, canvases);
            this.needsUpdate = true;
            this.scheduleUpdate = null;
        };
        _proto.dispose = function dispose() {
            if (this.observer) {
                this.observer.disconnect();
            }
            this.scheduleUpdate = clearTimeout(this.scheduleUpdate);
            (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(HTMLTexture.prototype), "dispose", this).call(this);
        };
        return HTMLTexture;
    }(THREE.CanvasTexture);
    var HTMLMesh = /*#__PURE__*/ function(_Mesh) {
        "use strict";
        (0,_inherits/* default */.Z)(HTMLMesh, _Mesh);
        var _super = (0,_create_super/* default */.Z)(HTMLMesh);
        function HTMLMesh() {
            (0,_class_call_check/* default */.Z)(this, HTMLMesh);
            var _this;
            var onEvent = function onEvent(event) {
                material.map.dispatchDOMEvent(event);
            };
            var texture = new HTMLTexture();
            var geometry = new THREE.PlaneGeometry(texture.image.width * 0.001, texture.image.height * 0.001);
            var material = new THREE.MeshBasicMaterial({
                map: texture,
                toneMapped: false,
                transparent: true
            });
            _this = _super.call(this, geometry, material);
            _this.addEventListener("mousedown", onEvent);
            _this.addEventListener("mousemove", onEvent);
            _this.addEventListener("mouseup", onEvent);
            _this.addEventListener("click", onEvent);
            _this.dispose = function() {
                geometry.dispose();
                material.dispose();
                material.map.dispose();
                canvases.delete(dom);
                this.removeEventListener("mousedown", onEvent);
                this.removeEventListener("mousemove", onEvent);
                this.removeEventListener("mouseup", onEvent);
                this.removeEventListener("click", onEvent);
            };
            return _this;
        }
        return HTMLMesh;
    }(THREE.Mesh);
    return new HTMLMesh();
};


/***/ }),

/***/ 39277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AbstractHTMLMesh; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71418);
/* harmony import */ var _models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98472);
/* harmony import */ var _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15864);






var AbstractHTMLMesh = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AbstractHTMLMesh, SceneComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(AbstractHTMLMesh);
    function AbstractHTMLMesh() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, AbstractHTMLMesh);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.inputs = {
            html: null,
            visible: false,
            scale: 1
        };
        _this.outputs = {
            loadingState: _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_1__/* .LoadingState.Idle */ .Gu.Idle
        };
        var _obj;
        _this.events = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__/* .ComponentInteractionType.CLICK */ .td.CLICK, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__/* .ComponentInteractionType.HOVER */ .td.HOVER, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__/* .ComponentInteractionType.DRAG */ .td.DRAG, false), _obj);
        return _this;
    }
    var _proto = AbstractHTMLMesh.prototype;
    _proto.initRoot = function initRoot() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.root.visible = this.inputs.visible;
        this.root.scale.set(this.inputs.scale, this.inputs.scale, this.inputs.scale);
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
        this.outputs.collider = this.root;
        this.outputs.loadingState = _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_1__/* .LoadingState.Loading */ .Gu.Loading;
    };
    _proto.getXRController = function getXRController() {
        var _this = this;
        this.controllerL = this.context.renderer.xr.getController(1);
        this.controllerL.addEventListener("connected", function(event) {
            _this.gamepadL = event.data.gamepad;
        });
        this.controllerR = this.context.renderer.xr.getController(0);
        this.controllerR.addEventListener("connected", function(event) {
            _this.gamepadR = event.data.gamepad;
        });
    };
    _proto.setVisible = function setVisible(visible) {
        this.inputs.visible = visible;
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        this.root.visible = this.inputs.visible;
    };
    _proto.onDestroy = function onDestroy() {};
    return AbstractHTMLMesh;
}(_models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__/* .SceneComponent */ .Ad);


/***/ }),

/***/ 79502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ InteractiveGroup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99477);




var _pointer = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
var _event = {
    type: "",
    data: _pointer
};
var InteractiveGroup = /*#__PURE__*/ function(Group) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(InteractiveGroup, Group);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(InteractiveGroup);
    function InteractiveGroup(renderer, camera, context) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, InteractiveGroup);
        var _this;
        _this = _super.call(this);
        _this.isPointerOver = false;
        var debug = false;
        var arrowHelper1;
        var arrowHelper2;
        if (context && debug) {
            var dir = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(1, 0, 0);
            dir.normalize();
            var origin = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(0, 0, 0);
            var length = 1;
            var hex = 0xffff00;
            arrowHelper1 = new context.three.ArrowHelper(dir, origin, length, hex);
            arrowHelper2 = new context.three.ArrowHelper(dir, origin, length, hex);
            context.scene.add(arrowHelper1);
            context.scene.add(arrowHelper2);
        }
        var raycasterL = new three__WEBPACK_IMPORTED_MODULE_0__/* .Raycaster */ .iMs();
        var raycasterR = new three__WEBPACK_IMPORTED_MODULE_0__/* .Raycaster */ .iMs();
        var tempMatrix = new three__WEBPACK_IMPORTED_MODULE_0__/* .Matrix4 */ .yGw();
        var element = renderer.domElement;
        var onPointerEvent = function(event) {
            event.stopPropagation();
            var rect = renderer.domElement.getBoundingClientRect();
            _pointer.x = (event.clientX - rect.left) / rect.width * 2 - 1;
            _pointer.y = -(event.clientY - rect.top) / rect.height * 2 + 1;
            raycasterL.setFromCamera(_pointer, camera);
            raycasterR.setFromCamera(_pointer, camera);
            var intersectsL = raycasterL.intersectObjects(_this.children, false);
            var intersectsR = raycasterR.intersectObjects(_this.children, false);
            if (!intersectsL.length && _this.isPointerOver && _this.targetObject) {
                _this.isPointerOver = false;
                _this.targetObject.userData.isPointerOver = _this.isPointerOver;
            }
            if (!intersectsR.length && _this.isPointerOver && _this.targetObject) {
                _this.isPointerOver = false;
                _this.targetObject.userData.isPointerOver = _this.isPointerOver;
            }
            if (intersectsL.length > 0) {
                var intersection = intersectsL[0];
                _this.targetObject = intersection.object;
                var uv = intersection.uv;
                _event.type = event.type;
                _event.data.set(uv.x, 1 - uv.y);
                if (!_this.isPointerOver) {
                    _this.isPointerOver = true;
                    _this.targetObject.userData.isPointerOver = _this.isPointerOver;
                }
                _this.targetObject.dispatchEvent(_event);
            }
            if (intersectsR.length > 0) {
                var intersection1 = intersectsR[0];
                _this.targetObject = intersection1.object;
                var uv1 = intersection1.uv;
                _event.type = event.type;
                _event.data.set(uv1.x, 1 - uv1.y);
                if (!_this.isPointerOver) {
                    _this.isPointerOver = true;
                    _this.targetObject.userData.isPointerOver = _this.isPointerOver;
                }
                _this.targetObject.dispatchEvent(_event);
            }
        };
        element.addEventListener("pointerdown", onPointerEvent);
        element.addEventListener("pointerup", onPointerEvent);
        element.addEventListener("pointermove", onPointerEvent);
        element.addEventListener("mousedown", onPointerEvent);
        element.addEventListener("mouseup", onPointerEvent);
        element.addEventListener("mousemove", onPointerEvent);
        element.addEventListener("click", onPointerEvent);
        // WebXR Controller Events
        // TODO: Dispatch pointerevents too
        var events = {
            move: "mousemove",
            select: "click",
            selectstart: "mousedown",
            selectend: "mouseup"
        };
        var controller1 = renderer.xr.getController(0);
        var controller2 = renderer.xr.getController(1);
        var visualiseRaycaster = function(arrowHelper, raycaster) {
            if (!debug) return;
            arrowHelper.setDirection(raycaster.ray.direction);
            arrowHelper.position.set(raycaster.ray.origin.x, raycaster.ray.origin.y, raycaster.ray.origin.z);
        };
        var onXRControllerEvent = function(event) {
            var controller = event.target;
            var raycaster;
            var arrowHelper;
            if (event.target === controller1) {
                raycaster = raycasterR;
                arrowHelper = arrowHelper1;
            }
            if (event.target === controller2) {
                raycaster = raycasterL;
                arrowHelper = arrowHelper2;
            }
            tempMatrix.identity().extractRotation(controller.matrixWorld);
            raycaster.ray.origin.setFromMatrixPosition(controller.matrixWorld);
            raycaster.ray.direction.set(0, 0, -1).applyMatrix4(tempMatrix);
            if (arrowHelper) visualiseRaycaster(arrowHelper, raycaster);
            var intersections = raycaster.intersectObjects(_this.children, false);
            if (intersections.length > 0) {
                var intersection = intersections[0];
                var object = intersection.object;
                var uv = intersection.uv;
                _event.type = events[event.type];
                _event.data.set(uv.x, 1 - uv.y);
                object.dispatchEvent(_event);
            }
        };
        controller1.addEventListener("move", onXRControllerEvent);
        controller1.addEventListener("select", onXRControllerEvent);
        controller1.addEventListener("selectstart", onXRControllerEvent);
        controller1.addEventListener("selectend", onXRControllerEvent);
        controller2.addEventListener("move", onXRControllerEvent);
        controller2.addEventListener("select", onXRControllerEvent);
        controller2.addEventListener("selectstart", onXRControllerEvent);
        controller2.addEventListener("selectend", onXRControllerEvent);
        return _this;
    }
    return InteractiveGroup;
}(three__WEBPACK_IMPORTED_MODULE_0__/* .Group */ .ZAu);



/***/ }),

/***/ 87161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getRelativePaddingLeft; },
/* harmony export */   "X": function() { return /* binding */ getRelativePaddingTop; }
/* harmony export */ });
var getRelativePaddingTop = function(html) {
    var rect = html.getBoundingClientRect();
    var paddingTop = parseInt(getComputedStyle(html).paddingTop, 10);
    return paddingTop * 100 / rect.height * 0.01;
};
var getRelativePaddingLeft = function(html) {
    var rect = html.getBoundingClientRect();
    var paddingLeft = parseInt(getComputedStyle(html).paddingLeft, 10);
    return paddingLeft * 100 / rect.width * 0.01;
};


/***/ }),

/***/ 12917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OT": function() { return /* binding */ makePathFinderLineComponent; },
  "pu": function() { return /* binding */ pathFinderLineComponentType; }
});

// UNUSED EXPORTS: PathFinderLineComponent

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/three/examples/jsm/libs/tween.module.min.js
var tween_module_min = __webpack_require__(27970);
// EXTERNAL MODULE: ./_models/virtualStaging/Scene.component.tsx
var Scene_component = __webpack_require__(98472);
// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
;// CONCATENATED MODULE: ./_models/virtualStaging/PathFinderLine/utils/getCurveLength.ts
var getCurveLength = function(curve) {
    var point1 = curve.getPointAt(0);
    var point2 = curve.getPointAt(1);
    // Calculate the Euclidean distance between the two points
    return point1.distanceTo(point2);
};

;// CONCATENATED MODULE: ./_models/virtualStaging/PathFinderLine/utils/calculateSubSegments.ts
var calculateSubsegments = function(parentLength, subsegmentLength) {
    var subsegments = Math.ceil(parentLength / subsegmentLength);
    var subsegmentLengthActual = parentLength / subsegments;
    return {
        subsegments: subsegments,
        subsegmentLengthActual: subsegmentLengthActual
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/PathFinderLine/component/PathFinderLine.component.ts









var PathFinderLineComponent = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PathFinderLineComponent, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(PathFinderLineComponent);
    function PathFinderLineComponent() {
        (0,_class_call_check/* default */.Z)(this, PathFinderLineComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.sphereArr = [];
        _this.animationId = null;
        _this.inputs = {
            camera: null,
            path: [],
            visible: true,
            color: "white",
            arrowRef: null,
            onDistanceChanged: null
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        var _obj;
        _this.events = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.CLICK */.td.CLICK, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.HOVER */.td.HOVER, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.DRAG */.td.DRAG, false), _obj);
        return _this;
    }
    var _proto = PathFinderLineComponent.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        this.frustum = new THREE.Frustum();
        this.cameraViewProjectionMatrix = new THREE.Matrix4();
        this.cameraDirectionVector = new THREE.Vector3();
        this.horizonVector = new THREE.Vector3();
        this.calculatedCameraDirectionVector = new THREE.Vector3();
        this.root = new THREE.Object3D();
        this.root.visible = this.inputs.visible;
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
        this.createHelperSpheres();
        if (this.inputs.path.length) {
            this.createLineFromPath(this.inputs.path);
        }
    };
    _proto.createHelperSpheres = function createHelperSpheres() {
        var THREE = this.context.three;
        var geometry = new THREE.SphereGeometry(0.1, 32, 16);
        var material = new THREE.MeshBasicMaterial({
            color: 0xffff00
        });
        this.leftHelperSphere = new THREE.Mesh(geometry, material);
        this.rightHelperSphere = new THREE.Mesh(geometry, material);
        this.leftHelperSphere.scale.setScalar(0);
        this.rightHelperSphere.scale.setScalar(0);
        this.leftHelperSphere.position.x = -0.75;
        this.leftHelperSphere.position.z = -1;
        this.rightHelperSphere.position.x = 0.75;
        this.rightHelperSphere.position.z = -1;
        this.inputs.camera.add(this.leftHelperSphere);
        this.inputs.camera.add(this.rightHelperSphere);
        this.pathSphereHelper = new THREE.Vector3();
        this.leftHelperSphereWorld = new THREE.Vector3();
        this.rightHelperSphereWorld = new THREE.Vector3();
        this.cameraWorld = new THREE.Vector3();
        this.cameraWorldQuaternion = new THREE.Quaternion();
    };
    _proto.createLineFromPath = function createLineFromPath(matterPath) {
        var THREE = this.context.three;
        var fullDistance = 0;
        for(var i = 0; i < matterPath.length; i++){
            if (matterPath[i] && matterPath[i + 1]) {
                var start = new THREE.Vector3(matterPath[i].data.position.x, matterPath[i].data.position.y - 1.15, matterPath[i].data.position.z);
                var end = new THREE.Vector3(matterPath[i + 1].data.position.x, matterPath[i + 1].data.position.y - 1.15, matterPath[i + 1].data.position.z);
                var path = new THREE.CatmullRomCurve3([
                    start,
                    end
                ]);
                var distance = getCurveLength(path);
                fullDistance += distance;
                var subsegments = calculateSubsegments(distance, 0.4).subsegments;
                this.createSubSegments(subsegments, path, i === matterPath.length - 2);
            }
        }
        this.animateLine();
        this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
        this.emitDistanceEvent(fullDistance);
    };
    _proto.createSubSegments = function createSubSegments(count, path, isLastSegment) {
        var THREE = this.context.three;
        var textureLoader = new THREE.TextureLoader();
        this.texture = textureLoader.load("/images/path-sphere.png");
        var planeGeometry = new THREE.PlaneGeometry(0.13, 0.13);
        var sphereColor = new THREE.Color(0x39b6fe);
        for(var i = 0; i < count; i++){
            var start = path.getPointAt(i / count);
            var end = path.getPointAt((i + 1) / count);
            var curve = new THREE.CatmullRomCurve3([
                start,
                end
            ]);
            var startPoint = curve.getPointAt(0);
            var endPoint = curve.getPointAt(1);
            var planeMaterial = new THREE.MeshBasicMaterial({
                color: sphereColor,
                map: this.texture,
                side: THREE.DoubleSide,
                transparent: true
            });
            planeMaterial.depthWrite = false;
            // Create a sphere at the start point
            var startSphere = new THREE.Mesh(planeGeometry, planeMaterial);
            startSphere.position.copy(startPoint);
            this.pivot.add(startSphere);
            this.sphereArr.push(startSphere);
            // Create a sphere at the end point of the last segment
            if (i === count - 1 && isLastSegment) {
                var planeMaterialCopy = new THREE.MeshBasicMaterial({
                    color: sphereColor,
                    map: this.texture,
                    side: THREE.DoubleSide,
                    transparent: true
                });
                var endSphere = new THREE.Mesh(planeGeometry, planeMaterialCopy);
                endSphere.position.copy(endPoint);
                this.pivot.add(endSphere);
                this.sphereArr.push(endSphere);
            }
        }
    };
    _proto.animateLine = function animateLine() {
        var _this = this;
        var THREE = this.context.three;
        var currentIndex = 0;
        var animate = function() {
            if (!_this.sphereArr || _this.sphereArr.length === 0) {
                clearTimeout(_this.animationId);
                return;
            }
            if (!_this.sphereArr[currentIndex]) return;
            _this.sphereArr.forEach(function(mesh, index) {
                var isBlueSegment = index === currentIndex;
                if (isBlueSegment) {
                    var startColor = new THREE.Color(0x39b6fe);
                    var endColor = new THREE.Color(0xffffff);
                    var fadeOutTween = new tween_module_min/* TWEEN.Tween */.w.Tween(mesh.material.color).to(startColor, 35).easing(tween_module_min/* TWEEN.Easing.Quadratic.In */.w.Easing.Quadratic.In).delay(10); // transition duration
                    var fadeInTween = new tween_module_min/* TWEEN.Tween */.w.Tween(mesh.material.color).to(endColor, 35).easing(tween_module_min/* TWEEN.Easing.Quadratic.Out */.w.Easing.Quadratic.Out).onComplete(function() {
                        fadeOutTween.start();
                    });
                    fadeInTween.start();
                }
            });
            currentIndex = (currentIndex + 1) % _this.sphereArr.length;
            if (currentIndex === 0) _this.animationId = setTimeout(animate, 1000);
            else _this.animationId = setTimeout(animate, 80);
        };
        animate();
    };
    _proto.stopAnimation = function stopAnimation() {
        clearTimeout(this.animationId);
        this.animationId = null;
    };
    _proto.setVisible = function setVisible(visible) {
        this.inputs.visible = visible;
    };
    _proto.reset = function reset() {
        this.stopAnimation();
        if (this.sphereArr.length) this.sphereArr.forEach(function(sphere) {
            sphere.removeFromParent();
        });
        this.sphereArr = [];
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        this.reset();
        if (this.inputs.path.length > 1) {
            this.createLineFromPath(this.inputs.path);
        } else {
            this.emitDistanceEvent(0);
        }
    };
    _proto.getCameraAngle = function getCameraAngle() {
        var arrowElement = this.inputs.arrowRef.current;
        this.inputs.camera.getWorldPosition(this.pathSphereHelper);
        if (this.sphereArr.length >= 5) {
            this.pathSphereHelper.x = this.sphereArr[4].position.x;
            this.pathSphereHelper.z = this.sphereArr[4].position.z;
        } else {
            this.pathSphereHelper.x = this.sphereArr[this.sphereArr.length - 1].position.x;
            this.pathSphereHelper.z = this.sphereArr[this.sphereArr.length - 1].position.z;
        }
        this.inputs.camera.getWorldPosition(this.cameraWorld);
        this.cameraDirectionVector.subVectors(this.pathSphereHelper, this.cameraWorld);
        this.cameraDirectionVector.project(this.inputs.camera);
        if (!this.isCameraFocused && this.leftHelperSphere) {
            var targetPathSphere = this.sphereArr.length >= 5 ? this.sphereArr[4] : this.sphereArr[this.sphereArr.length - 1];
            this.leftHelperSphere.getWorldPosition(this.leftHelperSphereWorld);
            this.rightHelperSphere.getWorldPosition(this.rightHelperSphereWorld);
            var arrowDirection = this.leftHelperSphereWorld.distanceTo(targetPathSphere.position) > this.rightHelperSphereWorld.distanceTo(targetPathSphere.position) ? "right" : "left";
            var left = arrowDirection === "left" ? 40 : window.innerWidth - 40;
            var sign = arrowDirection === "left" ? 1 : -1;
            this.horizonVector.set(0, this.inputs.camera.getWorldPosition(this.cameraWorld).y, 0).normalize();
            this.calculatedCameraDirectionVector.set(0, 0, -1).applyQuaternion(this.inputs.camera.getWorldQuaternion(this.cameraWorldQuaternion)).normalize();
            var cosAngle = this.calculatedCameraDirectionVector.y;
            var top;
            if (cosAngle < 0) {
                // eslint-disable-next-line no-restricted-properties
                top = (Math.pow(cosAngle, 4) * 0.25 + 0.5) * window.innerHeight;
            } else {
                // eslint-disable-next-line no-restricted-properties
                top = (Math.pow(cosAngle, 4) * -0.25 + 0.5) * window.innerHeight;
            }
            arrowElement.style.left = "".concat(left, "px");
            arrowElement.style.top = "".concat(top, "px");
            arrowElement.style.opacity = 1;
            arrowElement.style.transform = "rotate(".concat((1 - top / (window.innerHeight * 0.5)) * 0.25 * -sign + (sign === -1 ? 0 : 0.5), "turn)");
        } else arrowElement.style.opacity = 0;
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref;
        this.inputs.camera.matrixWorldInverse.copy(this.inputs.camera.matrixWorld).invert();
        this.cameraViewProjectionMatrix.multiplyMatrices(this.inputs.camera.projectionMatrix, this.inputs.camera.matrixWorldInverse);
        this.frustum.setFromProjectionMatrix(this.cameraViewProjectionMatrix);
        if (this.sphereArr.length) {
            var ref1;
            this.sphereArr.forEach(function(sphere) {
                var _position = _this.inputs.camera.parent.position, x = _position.x, y = _position.y, z = _position.z;
                sphere.lookAt(x, y, z);
            });
            this.isCameraFocused = false;
            this.sphereArr.forEach(function(sphere) {
                if (_this.frustum.intersectsObject(sphere)) _this.isCameraFocused = true;
            });
            if ((ref1 = this.inputs.arrowRef) === null || ref1 === void 0 ? void 0 : ref1.current) this.getCameraAngle();
        } else if ((ref = this.inputs.arrowRef) === null || ref === void 0 ? void 0 : ref.current) {
            var arrowElement = this.inputs.arrowRef.current;
            arrowElement.style.opacity = 0;
        }
    };
    _proto.onDestroy = function onDestroy() {};
    _proto.emitDistanceEvent = function emitDistanceEvent(distance) {
        if (this.inputs.onDistanceChanged) {
            this.inputs.onDistanceChanged(distance % 1 === 0 ? distance.toString() : distance.toFixed(1));
        }
    };
    return PathFinderLineComponent;
}(Scene_component/* SceneComponent */.Ad);
var pathFinderLineComponentType = "mp.pathFinderLineComponent";
var makePathFinderLineComponent = function() {
    return new PathFinderLineComponent();
};


/***/ }),

/***/ 20594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ VSSettings; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var three_src_math_MathUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69542);


var VSSettings = function VSSettings() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, VSSettings);
    this.id = model.id;
    this.tourId = model.tourId;
    this.ambientLight = model.ambientLight * 1.3 || 9.5;
    this.pointLight = model.pointLight * 1.3 || 33 * 3;
    this.lightHeight = model.lightHeight * 5 || 75 * 0.5;
    this.shadowIntensity = model.shadowIntensity >= 0 ? model.shadowIntensity : 0.2;
    this.lightAngle = model.lightAngle || 0;
    this.directionalLightStrength = model.directionalLightStrength || 0;
    this.directionalLightAngleX = model.directionalLightAngleX ? (0,three_src_math_MathUtils__WEBPACK_IMPORTED_MODULE_1__/* .degToRad */ .Id)(model.directionalLightAngleX * 4) / Math.PI : 0;
    this.directionalLightAngleY = model.directionalLightAngleY ? (0,three_src_math_MathUtils__WEBPACK_IMPORTED_MODULE_1__/* .degToRad */ .Id)(model.directionalLightAngleY * 4) / Math.PI : 0;
    this.updatedAt = model.updatedAt;
};


/***/ }),

/***/ 97387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WV": function() { return /* binding */ AVATAR_ROTATION_SPEED; },
/* harmony export */   "iG": function() { return /* binding */ AVATAR_CIRCLE_RADIUS; },
/* harmony export */   "lZ": function() { return /* binding */ AVATAR_ANIMATION_BLENDING; },
/* harmony export */   "pK": function() { return /* binding */ DEFAULT_AVATARS; },
/* harmony export */   "qE": function() { return /* binding */ Avatar; },
/* harmony export */   "rQ": function() { return /* binding */ AVATAR_WALKING_SPEED; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_0__);


var DEFAULT_AVATARS = [
    "https://static.treedis.com/avatars/62cd861b48960be56eae26b8.glb",
    "https://static.treedis.com/avatars/62f3ae0a3e172e00542676ec.glb",
    "https://static.treedis.com/avatars/635fcfdb41d7a22057ef1495.glb",
    "https://static.treedis.com/avatars/63626a6efff3a4d4797dae05.glb",
    "https://static.treedis.com/avatars/63626a94fff3a4d4797dae46.glb",
    "https://static.treedis.com/avatars/63626accfff3a4d4797daeb5.glb",
    "https://static.treedis.com/avatars/63626adffff3a4d4797daee4.glb",
    "https://static.treedis.com/avatars/63626b6e52b953b7b71fce6a.glb",
    "https://static.treedis.com/avatars/63626bb152b953b7b71fcef0.glb",
    "https://static.treedis.com/avatars/63626bd552b953b7b71fcf39.glb",
    "https://static.treedis.com/avatars/63626c8a52b953b7b71fd044.glb",
    "https://static.treedis.com/avatars/636269effff3a4d4797dad1f.glb",
    "https://static.treedis.com/avatars/6317163a666e9239d9c635cf.glb",
    "https://static.treedis.com/avatars/63171619666e9239d9c63168.glb", 
];
var AVATAR_CIRCLE_RADIUS = 0.65;
var AVATAR_WALKING_SPEED = 1.5; // Avatar speed in m/s
var AVATAR_ROTATION_SPEED = 0.5; // Avatar rotation speed
var AVATAR_ANIMATION_BLENDING = 0.2; // How smooth avatar animations transition between each other
var Avatar = function Avatar() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Avatar);
    this.name = model.name || "";
    this.bodyType = model.bodyType;
    this.url = model.url;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.quaternionX = model.quaternionX || 0;
    this.quaternionY = model.quaternionY || 0;
    this.quaternionZ = model.quaternionZ || 0;
    this.quaternionW = model.quaternionW || 0;
    this.uuid = model.uuid || null;
    this.color = model.color || "0xEA475C";
    this.muted = lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default()(model.muted) || model.muted;
    this.visible = typeof model.visible === "boolean" ? model.visible : true;
    this.degree = model.degree || null;
};


/***/ }),

/***/ 71425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ AvatarPredictor; },
/* harmony export */   "v": function() { return /* binding */ AUPredictorQuality; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _quarkworks_inc_avatar_webkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9995);




var AUPredictorQuality;
(function(AUPredictorQuality) {
    AUPredictorQuality["Low"] = "low";
    AUPredictorQuality["High"] = "high";
})(AUPredictorQuality || (AUPredictorQuality = {}));
var AvatarPredictor = /*#__PURE__*/ function() {
    "use strict";
    function AvatarPredictor(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, AvatarPredictor);
        this.predictor = new _quarkworks_inc_avatar_webkit__WEBPACK_IMPORTED_MODULE_0__/* .AUPredictor */ .SM({
            apiToken: "fbd204a7-318e-4dd3-86e0-e6d524fc3f98",
            shouldMirrorOutput: false,
            fps: 30,
            predictionQuality: config.predictionQuality || AUPredictorQuality.Low
        });
    }
    var _proto = AvatarPredictor.prototype;
    _proto.start = function start(stream, cb) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var ref, hasVideoTrack;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hasVideoTrack = stream === null || stream === void 0 ? void 0 : (ref = stream.getTracks) === null || ref === void 0 ? void 0 : ref.call(stream).some(function(track) {
                            return track.kind === "video";
                        });
                        if (!hasVideoTrack) {
                            throw new Error("Video track not found.");
                        }
                        return [
                            4,
                            _this.predictor.start({
                                stream: stream
                            })
                        ];
                    case 1:
                        _state.sent();
                        _this.predictor.dataStream.subscribe(cb);
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.stop = function stop() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.predictor.stop()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return AvatarPredictor;
}();


/***/ }),

/***/ 38404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lZ": function() { return /* reexport */ Avatar/* AVATAR_ANIMATION_BLENDING */.lZ; },
  "iG": function() { return /* reexport */ Avatar/* AVATAR_CIRCLE_RADIUS */.iG; },
  "WV": function() { return /* reexport */ Avatar/* AVATAR_ROTATION_SPEED */.WV; },
  "rQ": function() { return /* reexport */ Avatar/* AVATAR_WALKING_SPEED */.rQ; },
  "qE": function() { return /* reexport */ Avatar/* Avatar */.qE; },
  "KP": function() { return /* reexport */ AvatarPredictor/* AvatarPredictor */.K; },
  "bB": function() { return /* reexport */ avatarComponentType; },
  "Sr": function() { return /* reexport */ makeAvatarComponent; }
});

// UNUSED EXPORTS: AvatarComponent, DEFAULT_AVATARS

// EXTERNAL MODULE: ./_models/virtualStaging/avatar/AvatarPredictor.ts
var AvatarPredictor = __webpack_require__(71425);
// EXTERNAL MODULE: ./_models/virtualStaging/avatar/Avatar.tsx
var Avatar = __webpack_require__(97387);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@quarkworks-inc/avatar-webkit/dist/index.modern.js
var index_modern = __webpack_require__(9995);
// EXTERNAL MODULE: ./node_modules/three/examples/jsm/libs/tween.module.min.js
var tween_module_min = __webpack_require__(27970);
// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/emojiKeyMap.ts
var emojiKeyMap = {
    mouthOpen: "mouthOpen",
    mouthSmile: "mouthSmile",
    eyesClosed: "eyesClosed",
    eyesLookUp: "eyesLookUp",
    eyesLookDown: "eyesLookDown",
    eyeBlinkLeft: "eyeBlink_L",
    eyeBlinkRight: "eyeBlink_R",
    eyeSquintLeft: "eyeSquint_L",
    eyeSquintRight: "eyeSquint_R",
    eyeWideLeft: "eyeWide_L",
    eyeWideRight: "eyeWide_R",
    jawForward: "jawForward",
    jawLeft: "jawLeft",
    jawRight: "jawRight",
    jawOpen: "jawOpen",
    mouthClose: "mouthClose",
    mouthFunnel: "mouthFunnel",
    mouthPucker: "mouthPucker",
    mouthLeft: "mouthLeft",
    mouthRight: "mouthRight",
    // mouthSmileLeft: 'mouthSmileLeft',
    mouthSmileLeft: "mouthSmile_L",
    mouthSmileRight: "mouthSmile_R",
    mouthFrownLeft: "mouthFrown_L",
    mouthFrownRight: "mouthFrown_R",
    mouthDimpleLeft: "mouthDimple_L",
    mouthDimpleRight: "mouthDimple_R",
    mouthStretchLeft: "mouthStretch_L",
    mouthStretchRight: "mouthStretch_R",
    mouthRollLower: "mouthRollLower",
    mouthRollUpper: "mouthRollUpper",
    mouthShrugLower: "mouthShrugLower",
    mouthShrugHigher: "mouthShrugHigher",
    mouthPressLeft: "mouthPress_L",
    mouthPressRight: "mouthPress_R",
    mouthLowerDownLeft: "mouthLowerDown_L",
    mouthLowerDownRight: "mouthLowerDown_R",
    mouthUpperUpLeft: "mouthUpperUp_L",
    mouthUpperUpRight: "mouthUpperUp_R",
    browDownLeft: "browDown_L",
    browDownRight: "browDown_R",
    browInnerUp: "browInnerUp",
    browOuterUpLeft: "browOuterUp_L",
    browOuterUpRight: "browOuterUp_R",
    cheekPuff: "cheekPuff",
    cheekSquintLeft: "cheekSquint_L",
    cheekSquintRight: "cheekSquint_R",
    noseSneerLeft: "noseSneer_L",
    noseSneerRight: "noseSneer_R",
    tongueOut: "tongueOut",
    mouthShrugUpper: "mouthShrugUpper",
    eyeLookInLeft: "eyeLookIn_L",
    eyeLookInRight: "eyeLookIn_R",
    eyeLookOutLeft: "eyeLookOut_L",
    eyeLookOutRight: "eyeLookOut_R",
    eyeLookUpLeft: "eyeLookUp_L",
    eyeLookUpRight: "eyeLookUp_R",
    eyeLookDownLeft: "eyeLookDown_L",
    eyeLookDownRight: "eyeLookDown_R"
}; // mouthOpen: 0
 // mouthSmile: 1

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/helper.ts
var findObject3DChildByName = function(object, name) {
    return object.children.find(function(child) {
        return child.name === name;
    });
};
var setMorphTarget = function(mesh, key, value) {
    if (!mesh) return;
    var idx = mesh.morphTargetDictionary[key];
    if (!idx) return;
    mesh.morphTargetInfluences[idx] = value;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/index.ts



// EXTERNAL MODULE: ./_models/virtualStaging/Scene.component.tsx
var Scene_component = __webpack_require__(98472);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(99477);
;// CONCATENATED MODULE: ./_models/virtualStaging/materials/CircleShaderMaterial.ts

var getCircleShaderMaterial = function(texture, radius, planeWidth, planeHeight) {
    return new three_module/* ShaderMaterial */.jyz({
        uniforms: {
            uTexture: {
                value: texture
            },
            uRadius: {
                value: radius
            },
            uPlaneWidth: {
                value: planeWidth
            },
            uPlaneHeight: {
                value: planeHeight
            }
        },
        vertexShader: "\n        varying vec2 vUv;\n        void main() {\n            vUv = uv;\n            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n        }\n    ",
        fragmentShader: "\n    uniform sampler2D uTexture;\n    uniform float uRadius;\n    uniform float uPlaneWidth;\n    uniform float uPlaneHeight;\n    varying vec2 vUv;\n    void main() {\n        vec2 aspectCorrectedUV = uPlaneHeight < uPlaneWidth ? \n                         vec2(vUv.x * uPlaneWidth / uPlaneHeight, vUv.y) :\n                         vec2(vUv.x, vUv.y * uPlaneHeight / uPlaneWidth);\n        float dist = distance(aspectCorrectedUV, vec2(0.5 * uPlaneWidth, 0.5 * uPlaneHeight));\n        if (dist > uRadius) discard;\n\n        gl_FragColor = texture2D(uTexture, vUv);\n    }\n",
        transparent: true
    });
};

;// CONCATENATED MODULE: ./utils/normalizeDimensions.ts
var normalizeDimensions = function(width, height) {
    var normalizedWidth, normalizedHeight;
    if (width > height) {
        normalizedWidth = width / height;
        normalizedHeight = 1;
    } else {
        normalizedHeight = height / width;
        normalizedWidth = 1;
    }
    return {
        width: normalizedWidth,
        height: normalizedHeight
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/AbstractAvatar.ts
/* eslint-disable no-prototype-builtins */ 








var AbstractAvatar = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AbstractAvatar, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(AbstractAvatar);
    function AbstractAvatar() {
        (0,_class_call_check/* default */.Z)(this, AbstractAvatar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.id = null;
        _this.root = null;
        _this.pivot = null;
        _this.label = null;
        _this.labelSize = [
            0,
            0
        ];
        _this.model = null;
        _this.inputs = {
            color: 0xff0033,
            label: "User",
            bodyType: null,
            url: null,
            uuid: null,
            visible: true,
            sweep: null
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        _this.getPosition = function() {
            return _this.model.position;
        };
        _this.loadAsync = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(THREE, url) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (url.includes(".gltf") || url.includes(".glb")) return [
                        2,
                        new Promise(function(resolve, reject) {
                            var loader = new THREE.GLTFLoader();
                            loader.load(url, function(gltf) {
                                return resolve(gltf);
                            }, function() {
                                return null;
                            }, function(err) {
                                return reject(err);
                            });
                        })
                    ];
                    if (url.includes(".fbx")) return [
                        2,
                        new Promise(function(resolve, reject) {
                            var loader = new THREE.FBXLoader();
                            loader.load(url, function(model) {
                                return resolve(model);
                            }, function() {
                                return null;
                            }, function(err) {
                                return reject(err);
                            });
                        })
                    ];
                    if (url.includes(".png") || url.includes(".jpg") || url.includes("base64")) return [
                        2,
                        new Promise(function(resolve, reject) {
                            var loader = new THREE.TextureLoader();
                            loader.load(url, function(texture) {
                                return resolve(texture);
                            }, function() {
                                return null;
                            }, function(err) {
                                return reject(err);
                            });
                        })
                    ];
                    return [
                        2
                    ];
                });
            });
            return function(THREE, url) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    var _proto = AbstractAvatar.prototype;
    _proto.initRoot = function initRoot() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
    };
    _proto.initLabel = function initLabel() {
        this.label = this.makeLabel(this.inputs.label, {
            fontsize: 48,
            textColor: {
                r: 255,
                g: 255,
                b: 255,
                a: 1.0
            },
            borderColor: {
                r: 0,
                g: 0,
                b: 0,
                a: 0
            },
            backgroundColor: {
                r: 0,
                g: 0,
                b: 0,
                a: 0.7
            },
            borderThickness: 16
        });
        if (this.inputs.bodyType === "fullbody") {
            this.label.rotateX(Math.PI / 2);
            this.label.position.setY(-0.05);
            this.label.position.setZ(2.3);
            this.pivot.add(this.label);
        } else {
            this.label.position.setY(0.83);
            this.pivot.add(this.label);
        }
        if (this.root && this.root.parent) {
            this.root.parent.visible = this.inputs.visible;
        }
    };
    _proto.getLabelSize = function getLabelSize() {
        return this.labelSize;
    };
    _proto.makeLabel = function makeLabel(message, parameters) {
        var THREE = this.context.three;
        if (parameters === undefined) parameters = {};
        var fontface = parameters.hasOwnProperty("fontface") ? parameters.fontface : "Arial";
        var fontsize = parameters.hasOwnProperty("fontsize") ? parameters.fontsize : 18;
        var borderThickness = parameters.hasOwnProperty("borderThickness") ? parameters.borderThickness : 4;
        var borderColor = parameters.hasOwnProperty("borderColor") ? parameters.borderColor : {
            r: 0,
            g: 0,
            b: 0,
            a: 1.0
        };
        var backgroundColor = parameters.hasOwnProperty("backgroundColor") ? parameters.backgroundColor : {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        var textColor = parameters.hasOwnProperty("textColor") ? parameters.textColor : {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        context.font = "Bold ".concat(fontsize, "px ").concat(fontface);
        var metrics = context.measureText(message);
        var textWidth = metrics.width;
        context.fillStyle = "rgba(".concat(backgroundColor.r, ",").concat(backgroundColor.g, ",").concat(backgroundColor.b, ",").concat(backgroundColor.a, ")");
        context.strokeStyle = "rgba(".concat(borderColor.r, ",").concat(borderColor.g, ",").concat(borderColor.b, ",").concat(borderColor.a, ")");
        context.lineWidth = borderThickness;
        var rectW = (textWidth + borderThickness) * 1.1;
        var rectH = fontsize * 1.4 + borderThickness;
        this.roundRect(context, borderThickness / 2, borderThickness / 2, rectW, rectH, 8);
        context.fillStyle = "rgba(".concat(textColor.r, ", ").concat(textColor.g, ", ").concat(textColor.b, ", 1.0)");
        context.fillText(message, borderThickness, fontsize + borderThickness);
        // crop exactly the rectangle size
        var label = this.crop(canvas, 0, 0, rectW + borderThickness, rectH + borderThickness);
        var texture = new THREE.Texture(label);
        texture.needsUpdate = true;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.encoding = THREE.sRGBEncoding;
        texture.repeat.set(1, 1);
        var planeWidth = label.width / 1000; // scaling down
        var planeHeight = label.height / 1000;
        // need for dynamic mute button positioning
        this.labelSize = [
            planeWidth,
            planeHeight
        ];
        var plane = this.makePlane(planeWidth, planeHeight, texture);
        plane.scale.set(1, 1, 1);
        return plane;
    };
    _proto.makeAvatarImageRound = function makeAvatarImageRound(str) {
        if (!str) {
            console.error("Invalid name");
            return;
        }
        var THREE = this.context.three;
        var colors = [
            {
                bg: "red",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            },
            {
                bg: "green",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            },
            {
                bg: "blue",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            },
            {
                bg: "pink",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            },
            {
                bg: "orange",
                text: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1.0
                }
            },
            {
                bg: "white",
                text: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1.0
                }
            },
            {
                bg: "grey",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            }, 
        ];
        var letter = str[0].toUpperCase();
        var asciiValue = letter.charCodeAt(0);
        var colorIndex = asciiValue % colors.length;
        var letterObject = this.makeLabel(letter, {
            fontsize: 48,
            textColor: colors[colorIndex].text,
            borderColor: {
                r: 0,
                g: 0,
                b: 0,
                a: 0
            },
            backgroundColor: {
                r: 255,
                g: 255,
                b: 255,
                a: 0
            },
            borderThickness: 0,
            shape: "round"
        });
        letterObject.scale.setScalar(7);
        var geometry = new THREE.CircleGeometry(0.5, 32);
        var material = new THREE.MeshBasicMaterial({
            color: colors[colorIndex].bg
        });
        var backgroundCircle = new THREE.Mesh(geometry, material);
        var avatarImage = new THREE.Group();
        avatarImage.add(backgroundCircle);
        avatarImage.add(letterObject);
        letterObject.position.z = 0.05;
        return avatarImage;
    };
    // function for drawing rounded rectangles
    // eslint-disable-next-line class-methods-use-this
    _proto.roundRect = function roundRect(ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + w - r, y);
        ctx.quadraticCurveTo(x + w, y, x + w, y + r);
        ctx.lineTo(x + w, y + h - r);
        ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
        ctx.lineTo(x + r, y + h);
        ctx.quadraticCurveTo(x, y + h, x, y + h - r);
        ctx.lineTo(x, y + r);
        ctx.quadraticCurveTo(x, y, x + r, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
    };
    _proto.makePlane = function makePlane(width, height, texture) {
        var THREE = this.context.three;
        var geometry = new THREE.PlaneGeometry(width, height, 10, 10);
        var material = new THREE.MeshBasicMaterial({
            map: texture,
            side: THREE.DoubleSide,
            blending: THREE.NormalBlending,
            transparent: true
        });
        return new THREE.Mesh(geometry, material);
    };
    _proto.makeRoundPlane = function makeRoundPlane(texture) {
        // uncomment if we need adaptive border color
        // const { r, g, b } = getAverageRGB(texture.image);
        // const luma = parseInt(`${getBrightness(r, g, b)}`, 10);
        var THREE = this.context.three;
        var ref = normalizeDimensions(texture.image.width, texture.image.height), width = ref.width, height = ref.height;
        var radius = Math.min(width, height) / 2;
        var material = getCircleShaderMaterial(texture, radius, width, height);
        var geometry = new THREE.PlaneGeometry(width, height);
        var outerCircleGeometry = new THREE.CircleGeometry(Math.min(width, height) / 2, 64);
        var outerCircleMaterial = new THREE.MeshBasicMaterial({
            color: "white"
        });
        var outerCircle = new THREE.Mesh(outerCircleGeometry, outerCircleMaterial);
        var image = new THREE.Mesh(geometry, material);
        var group = new THREE.Group();
        group.add(outerCircle);
        group.add(image);
        image.position.z = 0.005;
        image.scale.setScalar(0.92);
        return group;
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.crop = function crop(can, x, y, w, h) {
        // get your canvas and a context for it
        var ctx = can.getContext("2d");
        // get the image data you want to keep.
        var imageData = ctx.getImageData(x, y, w * 2, h);
        // create a new cavnas same as clipped size and a context
        var newCan = document.createElement("canvas");
        newCan.width = w - x;
        newCan.height = h - y;
        var newCtx = newCan.getContext("2d");
        // put the clipped image on the new canvas.
        newCtx.putImageData(imageData, 0, 0);
        return newCan;
    };
    _proto.loadAnimation = function loadAnimation(THREE, url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.loadAsync(THREE, url)
                ];
            });
        })();
    };
    _proto.loadModel = function loadModel(THREE, url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var modelData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.loadAsync(THREE, url)
                        ];
                    case 1:
                        modelData = _state.sent();
                        if (modelData.isTexture) {
                            return [
                                2,
                                _this.makeRoundPlane(modelData)
                            ];
                        } else {
                            modelData.scene.position.set(0, 0, 0);
                            return [
                                2,
                                modelData.scene
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return AbstractAvatar;
}(Scene_component/* SceneComponent */.Ad);
/* harmony default export */ var component_AbstractAvatar = (AbstractAvatar);

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/Avatar.component.tsx
/* eslint-disable no-prototype-builtins */ 











var AvatarComponent = /*#__PURE__*/ function(AbstractAvatar) {
    "use strict";
    (0,_inherits/* default */.Z)(AvatarComponent, AbstractAvatar);
    var _super = (0,_create_super/* default */.Z)(AvatarComponent);
    function AvatarComponent() {
        (0,_class_call_check/* default */.Z)(this, AvatarComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.animationActions = [];
        _this.activeAnimation = null;
        // instantly teleport avatar to position on first avatar_move event
        _this.avatarHasMoved = false;
        _this.setMorphTarget = function(mesh, key, value) {
            if (!mesh) return;
            var idx = mesh.morphTargetDictionary[key];
            if (!idx) return;
            mesh.morphTargetInfluences[idx] = value;
        };
        return _this;
    }
    var _proto = AvatarComponent.prototype;
    _proto.onInit = function onInit() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var THREE, _tmp, _, ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.outputs.loadingState = VSObject/* LoadingState.Loading */.Gu.Loading;
                        THREE = _this.context.three;
                        _this.vec3 = new THREE.Vector3();
                        _this.initRoot();
                        _this.root.visible = false;
                        if (!_this.inputs.url || _this.inputs.url.includes(".png") || _this.inputs.url.includes(".jpg") || _this.inputs.url.includes(".jpeg")) _this.inputs.bodyType = "image";
                        if (!_this.inputs.url) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this.loadModel(THREE, _this.inputs.url)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = _this.makeAvatarImageRound(_this.inputs.label);
                        _state.label = 3;
                    case 3:
                        _this.model = _tmp;
                        _ = _this.inputs.bodyType;
                        switch(_){
                            case "fullbody":
                                return [
                                    3,
                                    4
                                ];
                            case "halfbody":
                                return [
                                    3,
                                    6
                                ];
                            case "image":
                                return [
                                    3,
                                    7
                                ];
                        }
                        return [
                            3,
                            8
                        ];
                    case 4:
                        ref = (0,_sliced_to_array/* default */.Z)(_this.model.children, 1), _this.avatarRoot = ref[0], ref;
                        _this.faceNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Head");
                        _this.teethNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Teeth");
                        _this.wolf3DAvatar = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Avatar");
                        _this.mixer = new THREE.AnimationMixer(_this.wolf3DAvatar);
                        _this.root.parent.position.y = 0;
                        _this.pivot.rotation.set(-Math.PI / 2, 0, 0);
                        _this.model.scale.set(1.1, 1.1, 1.1);
                        return [
                            4,
                            _this.initAnimations()
                        ];
                    case 5:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 6:
                        ref1 = (0,_sliced_to_array/* default */.Z)(_this.model.children, 1), _this.avatarRoot = ref1[0], ref1;
                        _this.faceNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Head");
                        _this.teethNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Teeth");
                        _this.wolf3DAvatar = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Avatar");
                        _this.mixer = new THREE.AnimationMixer(_this.wolf3DAvatar);
                        return [
                            3,
                            9
                        ];
                    case 7:
                        _this.model.scale.setScalar(0.4);
                        _this.model.position.y = 1.1;
                        _this.pivot.position.y = -1.2;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        return [
                            3,
                            9
                        ];
                    case 9:
                        _this.model.frustumCulled = false;
                        if (_this.model.children) _this.model.traverse(function(object) {
                            object.frustumCulled = false;
                        });
                        _this.pivot.add(_this.model);
                        _this.initLabel();
                        _this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initAnimations = function initAnimations() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var THREE, idleAnimation, walkingAnimation, idleAnimationAction, walkingAnimationAction;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        THREE = _this.context.three;
                        return [
                            4,
                            _this.loadAnimation(THREE, "../../Idle.fbx")
                        ];
                    case 1:
                        idleAnimation = _state.sent();
                        idleAnimation.animations[0].name = "idle";
                        return [
                            4,
                            _this.loadAnimation(THREE, "../../Walking.fbx")
                        ];
                    case 2:
                        walkingAnimation = _state.sent();
                        walkingAnimation.animations[0].name = "walking";
                        idleAnimationAction = _this.mixer.clipAction(idleAnimation.animations[0]);
                        walkingAnimationAction = _this.mixer.clipAction(walkingAnimation.animations[0]);
                        _this.animationActions.push(idleAnimationAction);
                        _this.animationActions.push(walkingAnimationAction);
                        console.log("Avatar: ".concat(_this.inputs.label, "\n Animations loaded, initializing 'idle' state..."), _this.animationActions, _this);
                        _this.fadeInAnimation("idle");
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.fadeInAnimation = function fadeInAnimation(clipName) {
        var animation = this.animationActions.find(function(action) {
            return action.getClip().name === clipName;
        });
        if (animation) {
            if (animation === this.activeAnimation) {
                return;
            }
            if (this.activeAnimation) this.activeAnimation.fadeOut(Avatar/* AVATAR_ANIMATION_BLENDING */.lZ);
            console.log("Avatar: ".concat(this.inputs.label, "\n Animation ").concat(animation._clip.name, " start, last active animation is ").concat(this.activeAnimation ? this.activeAnimation._clip.name : "null"), animation);
            animation.reset().fadeIn(Avatar/* AVATAR_ANIMATION_BLENDING */.lZ).play();
            this.activeAnimation = animation;
        }
    };
    _proto.moveToPos = function moveToPos(target, qt, onStart, onComplete) {
        var _this = this;
        var distance = this.root.parent.position.distanceTo(target);
        if (this.avatarHasMoved) {
            var tween = new tween_module_min/* TWEEN.Tween */.w.Tween(this.root.parent.position).to({
                x: target.x,
                y: target.y - 1.25,
                z: target.z
            }, distance / (Avatar/* AVATAR_WALKING_SPEED */.rQ / 1000)).onStart(function() {
                _this.fadeInAnimation("walking");
                if (onStart) onStart(tween);
            }).onComplete(function() {
                _this.fadeInAnimation("idle");
                if (onComplete) onComplete(tween);
            }).onUpdate(function() {
                _this.root.quaternion.set(qt.x, qt.y, qt.z, qt.w);
            }).start();
        } else {
            this.root.parent.position.set(target.x, target.y - 1.25, target.z);
            this.root.visible = true;
            this.avatarHasMoved = true;
        }
    };
    _proto.rotateTo = function rotateTo(target, onStart, onComplete) {
        var _this = this;
        var alpha = {
            current: 0
        };
        var tween = new tween_module_min/* TWEEN.Tween */.w.Tween(alpha).to({
            current: 1
        }, 1000 * Avatar/* AVATAR_ROTATION_SPEED */.WV).onStart(function() {
            if (onStart) onStart(tween);
        }).onUpdate(function() {
            _this.root.quaternion.slerpQuaternions(_this.root.quaternion, target, alpha.current);
        }).onComplete(function() {
            if (onComplete) onComplete(tween);
        }).start();
    };
    _proto.onDestroy = function onDestroy() {
        if (this.label) {
            this.label.geometry.dispose();
            this.label.material.dispose();
        }
    };
    _proto.onTick = function onTick(tickDelta) {
        if (this.context.camera && this.inputs.bodyType === "image") {
            this.context.camera.getWorldPosition(this.vec3);
            var _vec3 = this.vec3, x = _vec3.x, z = _vec3.z;
            var vec = new this.context.three.Vector3();
            this.root.getWorldPosition(vec);
            this.root.lookAt(x, vec.y, z);
        }
        if (this.mixer) {
            this.mixer.update(tickDelta / 1000);
        }
    // super.onTick(tickDelta);
    };
    // called back when any inputs properties change
    _proto.onInputsUpdated = function onInputsUpdated() {
        if (this.outputs.loadingState !== VSObject/* LoadingState.Loading */.Gu.Loading) this.onInit();
    };
    _proto.updateFromResults = function updateFromResults(prediction) {
        if (!this.model) return;
        // this.updateMorphTargets(prediction.blendShapes);
        if (this.inputs.bodyType === "halfbody") {
            this.updateHeadRotation(-prediction.rotation.pitch, -prediction.rotation.yaw, -prediction.rotation.roll);
            this.updatePosition(prediction.transform.x, prediction.transform.y, prediction.transform.z);
        }
    };
    // @ts-ignore morph targets are not currently used
    _proto.updateMorphTargets = function updateMorphTargets(blendShapes) {
        for(var key in blendShapes){
            // RPM uses the ARKit key convention ("mouthSmileLeft" as opposed to "mouthSmile_L")
            var arKitKey = index_modern/* BlendShapeKeys.toARKitConvention */.lN.toARKitConvention(key);
            // Need to set all morphtargets for both meshes
            // ex. only setting jaw open for wolf3DAvatar will result in the mesh mouth opening but not the bones movingss1
            this.setMorphTarget(this.faceNode, arKitKey, blendShapes[key]);
            this.setMorphTarget(this.teethNode, arKitKey, blendShapes[key]);
            this.setMorphTarget(this.wolf3DAvatar, arKitKey, blendShapes[key]);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
    _proto.updateHeadRotation = function updateHeadRotation(pitch, yaw, roll) {
        // Inverse yaw & roll effects for yourself to give mirror effect
        this.pivot.rotation.set(pitch, yaw, roll);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
    _proto.updatePosition = function updatePosition(x, y, z) {
    // const SCALE = 0.2;
    // const Y_OFFSET = 0;
    // this.avatarRoot?.position.set(x * SCALE, Y_OFFSET + y * SCALE, z);
    };
    return AvatarComponent;
}(component_AbstractAvatar);
var avatarComponentType = "mp.avatarComponent";
var makeAvatarComponent = function() {
    return new AvatarComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/index.ts





/***/ }),

/***/ 83680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var _API__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2300);






var API_VERSION = "v1";
var PREFIX = "".concat(API_VERSION, "/admin/tour/");
var PUBLIC_PREFIX = "".concat(API_VERSION, "/public");
var GAME_PREFIX = "".concat(API_VERSION, "/admin/game");
var TreedisAdminDAO = /*#__PURE__*/ function(API) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(TreedisAdminDAO, API);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(TreedisAdminDAO);
    function TreedisAdminDAO() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, TreedisAdminDAO);
        var _this;
        _this = _super.call(this);
        var parent = _this.public;
        _this.public = {
            /** Virtual Staging */ getTourVSObjects: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(tourId, "/vstaging")
                }, options));
            },
            getTourVSImages: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-images")
                }, options));
            },
            getTourVSHtmls: function(slug) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-html")
                }, options));
            },
            getVSSettings: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(tourId, "/vs-settings")
                }, options));
            },
            getPolygons: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/polygons")
                }, options));
            },
            getTourVSVideos: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-videos")
                }, options));
            },
            getFRFloors: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vs-settings/frfloors")
                }, options));
            },
            /** Game * */ saveAnalytics: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(GAME_PREFIX, "/analytic/save")
                }, options));
            },
            createPaymentSecret: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PUBLIC_PREFIX, "/payment/secret")
                }, options));
            }
        };
        return _this;
    }
    return TreedisAdminDAO;
}(_API__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var DAO = new TreedisAdminDAO().public;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
/* harmony default export */ __webpack_exports__["Z"] = (DAO);


/***/ }),

/***/ 79575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ getVSItems; },
/* harmony export */   "QM": function() { return /* binding */ getSweepIndex; },
/* harmony export */   "Uv": function() { return /* binding */ getSweeps; },
/* harmony export */   "VB": function() { return /* binding */ getDuplicates; },
/* harmony export */   "lB": function() { return /* binding */ getFloorPlans; }
/* harmony export */ });
/* unused harmony exports getPolygons, getTourVSObjects, getTourVSImages, getTourVSVideos, getTourVSHtmls, getTourVSSettings */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80250);
/* harmony import */ var _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83680);
/* harmony import */ var _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15864);
/* harmony import */ var _models_virtualStaging_VSSettings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20594);
/* harmony import */ var _models_virtualStaging_Polygon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59524);
/* harmony import */ var _components_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97666);









var getFloorPlans = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getFloorPlans */ .Z.getFloorPlans({
                            id: id
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (res === null || res === void 0 ? void 0 : res.floorPlans) || []
                    ];
            }
        });
    });
    return function getFloorPlans(id) {
        return _ref.apply(this, arguments);
    };
}();
var getDuplicates = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDuplicates */ .Z.getDuplicates(id)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (res === null || res === void 0 ? void 0 : res.duplicates) || []
                    ];
            }
        });
    });
    return function getDuplicates(id) {
        return _ref.apply(this, arguments);
    };
}();
var getPolygons = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPolygons */ .Z.getPolygons(slug)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.data
                    ];
            }
        });
    });
    return function getPolygons(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getSweeps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(matterId, slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matterId) return [
                        2,
                        []
                    ];
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getSweeps */ .Z.getSweeps({
                            matterId: matterId,
                            slug: slug,
                            auth: (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .getQueryVariable */ .Dv)(window.location.href, "auth")
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (res === null || res === void 0 ? void 0 : res.sweeps) || []
                    ];
            }
        });
    });
    return function getSweeps(matterId, slug) {
        return _ref.apply(this, arguments);
    };
}();
var getSweepIndex = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(matterId, slug, sweepId) {
        var ref, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matterId || !sweepId) return [
                        2,
                        -1
                    ];
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getSweepIndex */ .Z.getSweepIndex({
                            matterId: matterId,
                            slug: slug,
                            sweepId: sweepId,
                            auth: (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .getQueryVariable */ .Dv)(window.location.href, "auth")
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sweepIndex) + 1 || -1
                    ];
            }
        });
    });
    return function getSweepIndex(matterId, slug, sweepId) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSObjects = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTourVSObjects */ .Z.getTourVSObjects(id)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.tourVSObjects
                    ];
            }
        });
    });
    return function getTourVSObjects(id) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSImages = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTourVSImages */ .Z.getTourVSImages(slug)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.tourVSImages
                    ];
            }
        });
    });
    return function getTourVSImages(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSVideos = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTourVSVideos */ .Z.getTourVSVideos(slug)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.data
                    ];
            }
        });
    });
    return function getTourVSVideos(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSHtmls = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTourVSHtmls */ .Z.getTourVSHtmls(slug)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.data
                    ];
            }
        });
    });
    return function getTourVSHtmls(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSSettings = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getVSSettings */ .Z.getVSSettings(id)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.vsSettings
                    ];
            }
        });
    });
    return function getTourVSSettings(id) {
        return _ref.apply(this, arguments);
    };
}();
var getVSItems = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(isMatterportLink, param) {
        var slug, id, ref, polygons, vsObjectsRes, vsImages, vsSettings, tourVideosData, vsHtmls, tourVideos, tourImages, tourHtmls, vsObjects;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, id = param.id;
                    return [
                        4,
                        Promise.all([
                            !isMatterportLink ? getPolygons(slug) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSObjects(id) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSImages(slug) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSSettings(id) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSVideos(slug) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSHtmls(slug) : Promise.resolve(null)
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        6
                    ]), polygons = ref[0], vsObjectsRes = ref[1], vsImages = ref[2], vsSettings = ref[3], tourVideosData = ref[4], vsHtmls = ref[5];
                    tourVideos = (tourVideosData || []).map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__/* .TourVideo */ .Up(item);
                    });
                    tourImages = (vsImages === null || vsImages === void 0 ? void 0 : vsImages.map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__/* .TourImage */ .oP(item);
                    })) || [];
                    tourHtmls = (vsHtmls === null || vsHtmls === void 0 ? void 0 : vsHtmls.map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__/* .TourVSHtml */ .q8(item);
                    })) || [];
                    vsObjects = (vsObjectsRes || []).map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__/* .TourObject */ .zB(item);
                    }).concat(tourImages).concat(tourHtmls).concat(tourVideos);
                    return [
                        2,
                        {
                            polygons: polygons ? polygons.map(function(polygon) {
                                return new _models_virtualStaging_Polygon__WEBPACK_IMPORTED_MODULE_3__/* .Polygon */ .mg(polygon);
                            }) : [],
                            vsSettings: new _models_virtualStaging_VSSettings__WEBPACK_IMPORTED_MODULE_8__/* .VSSettings */ .E(vsSettings || {}),
                            vsObjects: vsObjects
                        }
                    ];
            }
        });
    });
    return function getVSItems(isMatterportLink, _) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 17937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PathSelectModal */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _helpers_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41154);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12781);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18533);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  /* bottom: 0; */\n  /* width: 100%; */\n  z-index: 999;\n  background: rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(7.5px);\n  /* border-radius: 20px 20px 0px 0px; */\n  padding: 20px;\n  color: white;\n  font-size: 16px;\n  max-height: 90vh;\n  padding-top: 0;\n\n  width: 300px;\n  bottom: 200px;\n  right: 50px;\n  border-radius: 20px;\n\n  animation: 1s ease 0s 1 normal forwards running alert-toast-appear;\n\n  &.dsp-sbIsOpen {\n    right: 162px;\n  }\n\n  .psm-header {\n    display: flex;\n    justify-content: space-between;\n\n    align-items: center;\n    margin-bottom: 3px;\n  }\n  .psm-closeBlock {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .psm-item {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 13px;\n    background: rgba(0, 0, 0, 0.18);\n    border-radius: 15px;\n    padding: 6px 7px;\n  }\n  .psm-imgWrap {\n    width: 40px;\n    height: 40px;\n    border-radius: 9px;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    margin-right: 7px;\n  }\n  .psm-name {\n    font-size: 14px;\n  }\n  .psm-next {\n    margin-right: 17px;\n    align-items: center;\n    display: flex;\n  }\n  .psm-steps {\n    font-size: 12px;\n  }\n  .psm-imgDeskWrap {\n    display: flex;\n  }\n  i {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PathSelectModal = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "DesktopSwitchPath__PathSelectModal",
    componentId: "sc-acea37c2-0"
})(_templateObject());
var DesktopSwitchPath = function(props) {
    var pathLocks = props.pathLocks, pathLockId = props.pathLockId, currentPathStepId = props.currentPathStepId, gameId = props.gameId, handleChangePath = props.handleChangePath, finishedPaths = props.finishedPaths;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,store__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(store__WEBPACK_IMPORTED_MODULE_3__/* .forceShowPathSwitchMobileModalState */ .g$), 2), forceShowPathSwitchMobileModal = ref[0], setForceShowPathSwitchMobileModal = ref[1];
    var translation = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(store__WEBPACK_IMPORTED_MODULE_3__/* .translationDataState */ .Jv);
    var sbIsOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(store__WEBPACK_IMPORTED_MODULE_3__/* .sidebarOpenState */ .eo);
    var device = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)().device;
    var pathSnapshot = _helpers_base__WEBPACK_IMPORTED_MODULE_2__/* .asyncStore */ .k6 === null || _helpers_base__WEBPACK_IMPORTED_MODULE_2__/* .asyncStore */ .k6 === void 0 ? void 0 : _helpers_base__WEBPACK_IMPORTED_MODULE_2__/* .asyncStore.pathSnapshot */ .k6.pathSnapshot;
    var handleCloseSwitchModal = function() {
        setForceShowPathSwitchMobileModal(false);
    };
    var onChangePath = function(id) {
        return function() {
            setForceShowPathSwitchMobileModal(false);
            if (handleChangePath) handleChangePath({
                target: {
                    value: id
                }
            });
        };
    };
    return !(device === null || device === void 0 ? void 0 : device.mobile) && forceShowPathSwitchMobileModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PathSelectModal, {
        className: sbIsOpen && "dsp-sbIsOpen",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "psm-header",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: (translation === null || translation === void 0 ? void 0 : translation.multipathSwitcher) || "Multipath switcher"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "psm-closeBlock",
                        onClick: handleCloseSwitchModal,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                            className: "far fa-times"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "psm-items-wrap",
                children: pathLocks === null || pathLocks === void 0 ? void 0 : pathLocks.map(function(p) {
                    var ref;
                    var isFinished = finishedPaths === null || finishedPaths === void 0 ? void 0 : finishedPaths.includes(p.id);
                    //use this if p.id = currentLock
                    var currentStep;
                    var stepsLength;
                    if (p.id === pathLockId) {
                        var ref1, ref2;
                        currentStep = ((ref1 = (_helpers_base__WEBPACK_IMPORTED_MODULE_2__/* .asyncStore */ .k6 === null || _helpers_base__WEBPACK_IMPORTED_MODULE_2__/* .asyncStore */ .k6 === void 0 ? void 0 : _helpers_base__WEBPACK_IMPORTED_MODULE_2__/* .asyncStore.pathIds */ .k6.pathIds) || []) === null || ref1 === void 0 ? void 0 : ref1.indexOf(currentPathStepId)) + 1;
                        stepsLength = _helpers_base__WEBPACK_IMPORTED_MODULE_2__/* .asyncStore */ .k6 === null || _helpers_base__WEBPACK_IMPORTED_MODULE_2__/* .asyncStore */ .k6 === void 0 ? void 0 : (ref2 = _helpers_base__WEBPACK_IMPORTED_MODULE_2__/* .asyncStore.pathIds */ .k6.pathIds) === null || ref2 === void 0 ? void 0 : ref2.length;
                    } else if (pathSnapshot[p.id]) {
                        var ref3, ref4, ref5, ref6, ref7, ref8;
                        currentStep = ((ref4 = ((ref3 = pathSnapshot[p.id]) === null || ref3 === void 0 ? void 0 : ref3.pathIds) || []) === null || ref4 === void 0 ? void 0 : ref4.indexOf((ref5 = pathSnapshot[p.id]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.currentPathStep) === null || ref6 === void 0 ? void 0 : ref6.id)) + 1;
                        stepsLength = (ref7 = pathSnapshot[p.id]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.pathIds) === null || ref8 === void 0 ? void 0 : ref8.length;
                    } else {
                        var ref9;
                        currentStep = 1;
                        stepsLength = p === null || p === void 0 ? void 0 : (ref9 = p.paths) === null || ref9 === void 0 ? void 0 : ref9.length;
                    }
                    //if not, we need to check is it exists on pathSnapshot
                    //if yes - get data from there
                    //if no - cound steps and set 0 / length
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "psm-item",
                        onClick: isFinished ? undefined : onChangePath(p.id),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "psm-imgDeskWrap",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "psm-imgWrap",
                                        style: {
                                            backgroundImage: "url(".concat("".concat("https://cdn.treedis.com", "/games/").concat(gameId, "/locks/").concat(p.id, "/").concat((ref = p.pathSetting) === null || ref === void 0 ? void 0 : ref.icon), ")")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "psm-deskWrap",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "psm-name",
                                                children: p.name
                                            }),
                                            isFinished ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "psm-steps",
                                                children: translation.finished || "finished"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "psm-steps",
                                                children: [
                                                    currentStep,
                                                    "/",
                                                    stepsLength,
                                                    " ",
                                                    translation.stepsCompleted || "steps completed"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "psm-next",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    className: "far fa-arrow-right"
                                })
                            })
                        ]
                    }, p === null || p === void 0 ? void 0 : p.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DesktopSwitchPath);


/***/ }),

/***/ 46116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BaseTour; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 150 modules
var dist = __webpack_require__(58490);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/index.js
var react_loader_spinner_dist = __webpack_require__(31607);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(70918);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./components-new/common/LegalNote.tsx



function LegalNote(param) {
    var note = param.note;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
        id: "legal-note",
        elevation: 3,
        sx: {
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 99,
            margin: 0.5,
            padding: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body2",
            color: "textSecondary",
            align: "center",
            sx: {
                color: "white"
            },
            children: (0,html_react_parser/* default */.ZP)(note)
        })
    });
}

// EXTERNAL MODULE: ./node_modules/three/examples/jsm/libs/tween.module.min.js
var tween_module_min = __webpack_require__(27970);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./_models/Agent.tsx
var Agent = __webpack_require__(2828);
// EXTERNAL MODULE: ./_models/Game.tsx
var Game = __webpack_require__(81766);
// EXTERNAL MODULE: ./_models/game/GameBook.ts
var GameBook = __webpack_require__(97741);
// EXTERNAL MODULE: ./_models/Menu.tsx
var Menu = __webpack_require__(78073);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_models/virtualStaging/avatar/index.ts + 7 modules
var virtualStaging_avatar = __webpack_require__(38404);
;// CONCATENATED MODULE: ./_models/virtualStaging/FRFloor.tsx

var FRFloor = function FRFloor() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_class_call_check/* default */.Z)(this, FRFloor);
    this.id = model.id || null;
    this.tourId = model.tourId;
    this.floor = model.floor;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.updatedAt = model.updatedAt;
    this.position = model.position;
    this.sweeps = model.sweeps || [];
};

;// CONCATENATED MODULE: ./_models/virtualStaging/helper.ts
var getAspectRatio = function(src) {
    return new Promise(function(resolve) {
        var img = document.createElement("img");
        img.src = src;
        img.onload = function() {
            img.style.visibility = "hidden";
            document.body.appendChild(img);
            resolve([
                img.clientWidth,
                img.clientHeight
            ]);
            document.body.removeChild(img);
        };
    });
};
/**
 * Calculate x and y in circle's circumference
 * @param {number} r - The circle's radius
 * @param {number} angle - The angle in degrees
 * @param {number} cx - The circle's origin x
 * @param {number} cz - The circle's origin z
 * @returns {Array[number,number]} The calculated x and y
 */ // eslint-disable-next-line class-methods-use-this
var pointsOnCircle2D = function(r, angle, cx, cz) {
    var a = angle * (Math.PI / 180); // convert from degrees to radians
    var x = cx + r * Math.cos(a);
    var z = cz + r * Math.sin(a);
    return [
        x,
        z
    ];
};


// EXTERNAL MODULE: ./_models/virtualStaging/LoadingQueue.ts + 1 modules
var LoadingQueue = __webpack_require__(44041);
// EXTERNAL MODULE: ./_models/virtualStaging/Polygon.tsx
var Polygon = __webpack_require__(59524);
// EXTERNAL MODULE: ./_models/virtualStaging/VideoRenderer.component.tsx
var VideoRenderer_component = __webpack_require__(23276);
// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
// EXTERNAL MODULE: ./_models/virtualStaging/VSSettings.tsx
var VSSettings = __webpack_require__(20594);
// EXTERNAL MODULE: ./components/common/CookieConsent.tsx
var CookieConsent = __webpack_require__(72789);
;// CONCATENATED MODULE: ./components/util/sdk/mattertag/data.ts



/**
 * Merge tags from matterport and treedis
 * @param matterTags
 * @param treedisTags
 * @param threads
 */ var getAllTags = function(matterTags, treedisTags, threads) {
    var allTags = new Map();
    var matterTagsArray = [];
    matterTags.forEach(function(t) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var index = treedisTags.findLastIndex(function(item) {
            return t.sid === (item === null || item === void 0 ? void 0 : item.sid);
        });
        var found = index === -1 ? null : treedisTags[index];
        var media;
        if (t.media) {
            media = t.media;
        }
        var tag = Object.assign(cloneDeep_default()(found) || {}, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            title: found && found.title && found.title.length ? found.title : t.label,
            positionX: (found === null || found === void 0 ? void 0 : found.positionX) ? found.positionX : t === null || t === void 0 ? void 0 : (ref = t.position) === null || ref === void 0 ? void 0 : ref.x,
            positionY: (found === null || found === void 0 ? void 0 : found.positionY) ? found.positionY : t === null || t === void 0 ? void 0 : (ref1 = t.position) === null || ref1 === void 0 ? void 0 : ref1.y,
            positionZ: (found === null || found === void 0 ? void 0 : found.positionZ) ? found.positionZ : t === null || t === void 0 ? void 0 : (ref2 = t.position) === null || ref2 === void 0 ? void 0 : ref2.z,
            stemVectorX: (found === null || found === void 0 ? void 0 : found.stemVectorX) && (found === null || found === void 0 ? void 0 : found.svXEnabled) ? found.stemVectorX : (t === null || t === void 0 ? void 0 : (ref3 = t.stem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.direction) === null || ref4 === void 0 ? void 0 : ref4.x) || 0,
            stemVectorY: (found === null || found === void 0 ? void 0 : found.stemVectorY) && (found === null || found === void 0 ? void 0 : found.svYEnabled) ? found.stemVectorY : (t === null || t === void 0 ? void 0 : (ref5 = t.stem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.direction) === null || ref6 === void 0 ? void 0 : ref6.y) || 0.3,
            stemVectorZ: (found === null || found === void 0 ? void 0 : found.stemVectorZ) && (found === null || found === void 0 ? void 0 : found.svZEnabled) ? found.stemVectorZ : (t === null || t === void 0 ? void 0 : (ref7 = t.stem) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.direction) === null || ref8 === void 0 ? void 0 : ref8.z) || 0,
            iconColor: found ? found.iconColor : t.color,
            opacity: found ? found.opacity : 100,
            mpTitle: found ? found.mpTitle : true,
            mpTooltip: found ? found.mpTooltip : true,
            mpNavigation: found ? found.mpNavigation : true,
            whiteCircle: found ? found.whiteCircle : false,
            transparentBackground: found ? found.transparentBackground : false,
            id: (found === null || found === void 0 ? void 0 : found.id) || t.sid || t.defaultSid
        }, t), {
            media: media,
            description: (found === null || found === void 0 ? void 0 : (ref9 = found.description) === null || ref9 === void 0 ? void 0 : ref9.length) ? found.description : t.description,
            enabled: found && typeof found.enabled === "boolean" ? found.enabled : false,
            customIcon: found ? found.customIcon : false
        }));
        if (found) {
            tag.modifiedTag = true; //flag that tag has been modified through treedis
        } else {
            matterTagsArray.push(tag);
        }
        treedisTags[index] = tag;
    });
    treedisTags.concat(matterTagsArray).forEach(function(tag) {
        allTags.set(tag.sid, cloneDeep_default()(tag));
    });
    threads.forEach(function(thread) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var media;
        if (thread.media) {
            media = thread.media;
        }
        var tag = Object.assign(cloneDeep_default()(thread) || {}, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            title: thread.title,
            positionX: thread === null || thread === void 0 ? void 0 : thread.positionX,
            positionY: thread === null || thread === void 0 ? void 0 : thread.positionY,
            positionZ: thread === null || thread === void 0 ? void 0 : thread.positionZ,
            stemVectorX: (thread === null || thread === void 0 ? void 0 : thread.stemVectorX) && (thread === null || thread === void 0 ? void 0 : thread.svXEnabled) ? thread.stemVectorX : (thread === null || thread === void 0 ? void 0 : (ref = thread.stem) === null || ref === void 0 ? void 0 : (ref1 = ref.direction) === null || ref1 === void 0 ? void 0 : ref1.x) || 0,
            stemVectorY: (thread === null || thread === void 0 ? void 0 : thread.stemVectorY) && (thread === null || thread === void 0 ? void 0 : thread.svYEnabled) ? thread.stemVectorY : (thread === null || thread === void 0 ? void 0 : (ref2 = thread.stem) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.direction) === null || ref3 === void 0 ? void 0 : ref3.y) || 0.3,
            stemVectorZ: (thread === null || thread === void 0 ? void 0 : thread.stemVectorZ) && (thread === null || thread === void 0 ? void 0 : thread.svZEnabled) ? thread.stemVectorZ : (thread === null || thread === void 0 ? void 0 : (ref4 = thread.stem) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.direction) === null || ref5 === void 0 ? void 0 : ref5.z) || 0,
            mpTitle: thread.mpTitle,
            mpTooltip: thread.mpTooltip,
            mpNavigation: true,
            whiteCircle: true,
            transparentBackground: false,
            id: thread.id
        }, thread), {
            media: media,
            description: thread.description,
            enabled: typeof thread.enabled === "boolean" ? thread.enabled : false,
            custom: true,
            customIcon: "thread",
            stemVisible: true,
            isThread: true
        }));
        allTags.set(thread.sid, cloneDeep_default()(tag));
    });
    return allTags;
};

;// CONCATENATED MODULE: ./components/util/sdk/mattertag/index.ts


var matterTags = new Map();
var Mattertag = function Mattertag() {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, Mattertag);
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
Mattertag.subscribe = function(param, subscriber) {
    var mpSdk = param.mpSdk, mpTags = param.mpTags, treedisTags = param.treedisTags, threads = param.threads;
    if (!mpTags) return subscriber(new Map());
    // eslint-disable-next-line array-callback-return
    Object.keys(mpTags).map(function(idx) {
        matterTags.set(idx, mpTags[idx]);
    });
    var matterportTags = Object.values(mpTags);
    var allTags = getAllTags(matterportTags, treedisTags, threads);
    subscriber(allTags);
// let addedMatterportTags = false;
// mpSdk.Mattertag.data.subscribe({
//   onAdded: (idx, item) => {
//     if (addedMatterportTags) {
//       // Added Transient Tag
//     } else {
//       // Added Matterport Tag
//       matterTags.set(idx, item);
//     }
//   },
//   onCollectionUpdated: (collection) => {
//     if (addedMatterportTags) return;
//     // Matterport tags finished initially adding
//     addedMatterportTags = true;
//     const matterportTags = Object.values(collection);
//     const allTags = getAllTags(matterportTags, treedisTags);
//     subscriber(allTags);
//   },
// });
};
Mattertag.getMatterTags = function() {
    return matterTags;
};

// EXTERNAL MODULE: ./utils/file.ts
var file = __webpack_require__(94697);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
// EXTERNAL MODULE: ./utils/index.ts + 8 modules
var utils = __webpack_require__(31344);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./components/util/popups.ts
var popups = __webpack_require__(62818);
// EXTERNAL MODULE: ./components/util/sdk.ts + 3 modules
var sdk = __webpack_require__(88327);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/styles.ts
var styles = __webpack_require__(24069);
// EXTERNAL MODULE: ./components/tour/regular/bottomBar/SoundControls.tsx
var SoundControls = __webpack_require__(67644);
// EXTERNAL MODULE: ./components/tour/regular/fullScreen/FullScreen.tsx
var FullScreen = __webpack_require__(44);
// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
;// CONCATENATED MODULE: ./components/tour/components/SetDataToRecoil.tsx




var SetDataToRecoil = function(props) {
    var translation = props.translation, tourConfigsInput = props.tourConfigsInput;
    var ref = (0,react.useState)(false), inited = ref[0], setInited = ref[1];
    var setTranslation = (0,store/* useSetRecoilState */.Zl)(store/* translationDataState */.Jv);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* tourConfigsState */.Uq), 2), tourConfigs = ref1[0], setTourConfigs = ref1[1];
    (0,react.useEffect)(function() {
        if (!inited) {
            if (translation && Object.keys(translation).length > 0) {
                setTranslation(translation);
                setTourConfigs((0,_object_spread/* default */.Z)({}, tourConfigs, tourConfigsInput));
                setInited(true);
            }
        }
    }, [
        translation
    ]);
    return null;
};
/* harmony default export */ var components_SetDataToRecoil = (SetDataToRecoil);

// EXTERNAL MODULE: ./api/TreedisAdminDAO.ts
var TreedisAdminDAO = __webpack_require__(83680);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
;// CONCATENATED MODULE: ./_models/game/GameAnalytic.ts


var GameAnalytic = function GameAnalytic(model) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, GameAnalytic);
    this.id = model.id || null;
    this.name = model.name || null;
    this.startDateTime = model.startDateTime || null;
    this.country = model.country || null;
    this.point = !isNil_default()(model.point) ? model.point : null;
    this.time = !isNil_default()(model.time) ? model.time : null;
    this.completed = model.completed || false;
    this.gameId = model.gameId || null;
    this.comment = model.comment || null;
    this.rating = !isNil_default()(model.rating) ? model.rating : null;
};

;// CONCATENATED MODULE: ./components/tour/game/services/GameAnalyticService.ts






var GameAnalyticService = /*#__PURE__*/ function() {
    "use strict";
    function GameAnalyticService(gameId) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, GameAnalyticService);
        this.analytic = new GameAnalytic({
            gameId: gameId,
            country: "",
            startDateTime: new Date()
        });
        window.addEventListener("beforeunload", function() {
            return _this.update();
        });
    }
    var _proto = GameAnalyticService.prototype;
    _proto.getTime = function getTime() {
        return this.analytic.time;
    };
    _proto.setTime = function setTime(time) {
        this.analytic.time = time;
    };
    _proto.getPoint = function getPoint() {
        return this.analytic.point;
    };
    _proto.setPoint = function setPoint(point) {
        this.analytic.point = point;
    };
    _proto.update = function update() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var obj, newAnalytic, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        obj = (0,_object_spread/* default */.Z)({}, data);
                        if (obj.id) delete obj.id;
                        newAnalytic = new GameAnalytic((0,_object_spread/* default */.Z)({}, _this.analytic, obj));
                        return [
                            4,
                            _this.saveAnalytics(newAnalytic)
                        ];
                    case 1:
                        res = _state.sent();
                        if (res) {
                            _this.analytic = new GameAnalytic(res.data);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.saveAnalytics = function saveAnalytics(analytic) {
        return TreedisAdminDAO/* default.saveAnalytics */.Z.saveAnalytics(analytic);
    };
    return GameAnalyticService;
}();


// EXTERNAL MODULE: ./api/queries.ts
var queries = __webpack_require__(79575);
;// CONCATENATED MODULE: ./components/tour/afterSweepInit.ts







var afterSweepsInit = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var sweeps, matterId, slug, iframeUrl, setData, cb, floors, isMatterportLink, frFloorsRes, _tmp, actualMatterId, deprecatedSweeps;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sweeps = param.sweeps, matterId = param.matterId, slug = param.slug, iframeUrl = param.iframeUrl, setData = param.setData, cb = param.cb;
                    if (!(sweeps === null || sweeps === void 0 ? void 0 : sweeps.length)) return [
                        3,
                        5
                    ];
                    floors = [];
                    isMatterportLink = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m") !== matterId;
                    if (!!isMatterportLink) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        TreedisAdminDAO/* default.getFRFloors */.Z.getFRFloors(slug)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = {
                        data: []
                    };
                    _state.label = 3;
                case 3:
                    frFloorsRes = _tmp;
                    // using sweep.floor_position to get the floor height position
                    sweeps.forEach(function(sweep) {
                        var ref;
                        if (!floors[sweep.floor_index]) {
                            var frFloor = frFloorsRes === null || frFloorsRes === void 0 ? void 0 : frFloorsRes.data.find(function(i) {
                                return i.floor === sweep.floor_index;
                            });
                            var floor = {
                                floor: sweep.floor_index,
                                position: sweep.floor_position
                            };
                            floors[sweep.floor_index] = frFloor ? new FRFloor((0,_object_spread/* default */.Z)({}, frFloor, floor)) : new FRFloor(floor);
                        }
                        (ref = floors[sweep.floor_index].sweeps) === null || ref === void 0 ? void 0 : ref.push(sweep);
                    });
                    actualMatterId = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m") || matterId;
                    return [
                        4,
                        (0,queries/* getSweeps */.Uv)(String(actualMatterId), slug)
                    ];
                case 4:
                    deprecatedSweeps = _state.sent();
                    setData({
                        deprecatedSweeps: deprecatedSweeps,
                        floors: floors
                    });
                    _state.label = 5;
                case 5:
                    cb();
                    return [
                        2
                    ];
            }
        });
    });
    return function afterSweepsInit(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/tour/calculateLocation.ts
function calculateLocation(sweep) {
    if (this.state.panoramaOn) return false;
    var px = this.state.mapWalkerX;
    var py = this.state.mapWalkerY;
    var minimaps = this.state.minimaps;
    var selectedMinimap = this.state.selectedMinimap;
    var tour = this.state.tour;
    var minimap = minimaps[selectedMinimap];
    if (tour.minimap && minimaps.length > 0 && minimap && minimap.originX != null && minimap.originY != null && minimap.width != null && minimap.height != null && minimap.ppm != null) {
        var hotspots = minimap.hotspots, custom = minimap.custom;
        var foundHotspot = null;
        hotspots.forEach(function(hotspot) {
            if (hotspot.scanId === sweep.sid) {
                hotspot.active = true;
                foundHotspot = hotspot;
            } else {
                hotspot.active = false;
            }
        });
        if (foundHotspot) {
            px = foundHotspot.x;
            py = foundHotspot.y;
        } else if (!custom) {
            var ref, ref1;
            px = (((ref = sweep.position) === null || ref === void 0 ? void 0 : ref.x) + minimap.originX * -1) * minimap.ppm / minimap.width * 100;
            py = 100 + (((ref1 = sweep.position) === null || ref1 === void 0 ? void 0 : ref1.z) + minimap.originY) * minimap.ppm / minimap.height * 100;
        }
    }
    return {
        px: px,
        py: py,
        minimaps: minimaps
    };
}

;// CONCATENATED MODULE: ./components/tour/regular/loadTourIframe/LoadTourIframe.tsx




var LoadTourIframe = function(param) {
    var mesurementsOn = param.mesurementsOn, iframeStyle = param.iframeStyle, iframeUrl = param.iframeUrl, isFullScreen = param.isFullScreen, iframeId = param.iframeId, cb = param.cb;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Frame */.RQ, {
        elementId: iframeId,
        iframeUrl: iframeUrl,
        className: classnames_default()("showcase", deviceManager/* default.isMobile */.Z.isMobile() && !isFullScreen && mesurementsOn && "mesurements-mobile-not-fullscreen"),
        style: iframeStyle,
        handleRef: cb
    });
};
/* harmony default export */ var loadTourIframe_LoadTourIframe = (LoadTourIframe);

// EXTERNAL MODULE: ./_helpers/base.tsx
var base = __webpack_require__(41154);
// EXTERNAL MODULE: ./_helpers/renderDebug.ts
var renderDebug = __webpack_require__(66725);
// EXTERNAL MODULE: ./_helpers/storage.ts
var storage = __webpack_require__(98144);
// EXTERNAL MODULE: ./_models/Tag.tsx
var Tag = __webpack_require__(42725);
// EXTERNAL MODULE: ./_models/User.tsx
var User = __webpack_require__(43500);
// EXTERNAL MODULE: ./_models/virtualStaging/HTMLMesh/HTMLMesh.tsx + 2 modules
var HTMLMesh = __webpack_require__(91833);
// EXTERNAL MODULE: ./_models/virtualStaging/HTMLMesh/utils/InteractiveGroup.ts
var InteractiveGroup = __webpack_require__(79502);
;// CONCATENATED MODULE: ./components/util/math/getXZCoordinatesOnCircle.ts
var getXZCoordinatesOnCircle = function(radius, angle) {
    var x = radius * Math.sin(Math.PI * 2 * angle / 360);
    var z = radius * Math.cos(Math.PI * 2 * angle / 360);
    return {
        x: x,
        z: z
    };
};
var getXYZCoordinatesOnCircle = function(radius, lon, lat) {
    var x = radius * Math.sin(Math.PI * 2 * lat / 360) * Math.cos(Math.PI * 2 * lon / 360);
    var y = radius * Math.sin(Math.PI * 2 * lon / 360);
    var z = radius * Math.cos(Math.PI * 2 * lat / 360) * Math.cos(Math.PI * 2 * lon / 360);
    return {
        x: x,
        y: y,
        z: z
    };
};

// EXTERNAL MODULE: ./_models/virtualStaging/HTMLMesh/component/AbstractHTMLMesh.ts
var AbstractHTMLMesh = __webpack_require__(39277);
;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/component/Backpack/BackpackMesh.component.ts
// eslint-disable-next-line @typescript-eslint/ban-ts-comment








var BackpackMeshComponent = /*#__PURE__*/ function(AbstractHTMLMesh) {
    "use strict";
    (0,_inherits/* default */.Z)(BackpackMeshComponent, AbstractHTMLMesh);
    var _super = (0,_create_super/* default */.Z)(BackpackMeshComponent);
    function BackpackMeshComponent() {
        (0,_class_call_check/* default */.Z)(this, BackpackMeshComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.inputs = {
            html: null,
            visible: false,
            scale: 1,
            refs: null
        };
        return _this;
    }
    var _proto = BackpackMeshComponent.prototype;
    _proto.onInit = function onInit() {
        var html = this.inputs.html;
        this.initMesh(html);
        this.initRoot();
        this.addMeshPointerEvents();
        this.getXRController();
        this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
    };
    _proto.initMesh = function initMesh(html) {
        this.mesh = (0,HTMLMesh/* createHTMLMesh */.x)(html, this.context.three);
        this.mesh.material.side = this.context.three.DoubleSide;
        this.mesh.material.depthWrite = false;
        this.mesh.material.depthTest = false;
        this.mesh.renderOrder = 980;
        this.mesh.scale.setScalar(2);
        this.mesh.userData = {
            isPointerOver: false
        };
    };
    _proto.addMeshPointerEvents = function addMeshPointerEvents() {
        var group = new InteractiveGroup/* InteractiveGroup */.e(this.context.renderer, this.context.camera, this.context);
        this.pivot.add(group);
        group.add(this.mesh);
    };
    _proto.setHostPose = function setHostPose(pose) {
        this.hostPose = pose;
    };
    _proto.setPositionFromPose = function setPositionFromPose(pose) {
        var ref = getXZCoordinatesOnCircle(0.85, pose.rotation.y + 180), x = ref.x, z = ref.z;
        this.root.position.set(pose.position.x + x, pose.position.y - 0.2, pose.position.z + z);
        this.root.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
    };
    _proto.setFromHostPose = function setFromHostPose() {
        this.setPositionFromPose(this.hostPose);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.cycleVR = function cycleVR(_session) {
        var ref, ref1, ref2, ref3;
        if (((ref1 = (ref = this.gamepadL) === null || ref === void 0 ? void 0 : ref.buttons[4]) === null || ref1 === void 0 ? void 0 : ref1.pressed) && this.hostPose && !this.gamepadButtonActive) {
            this.setVisible(!this.inputs.visible);
            this.setFromHostPose();
            this.gamepadButtonActive = true;
        }
        if (!((ref3 = (ref2 = this.gamepadL) === null || ref2 === void 0 ? void 0 : ref2.buttons[4]) === null || ref3 === void 0 ? void 0 : ref3.pressed) && this.gamepadButtonActive) {
            this.gamepadButtonActive = false;
        }
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref, ref1, ref2;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
            var _session = this.context.renderer.xr.getSession();
            _session.requestAnimationFrame(function() {
                return _this.cycleVR(_session);
            });
        }
    };
    return BackpackMeshComponent;
}(AbstractHTMLMesh/* AbstractHTMLMesh */.n);
var backpackMeshComponentType = "mp.backpackMeshComponent";
var makeBackpackMeshComponent = function() {
    return new BackpackMeshComponent();
};

// EXTERNAL MODULE: ./_models/virtualStaging/Scene.component.tsx
var Scene_component = __webpack_require__(98472);
// EXTERNAL MODULE: ./_models/virtualStaging/HTMLMesh/utils/getRelativePaddingTop.ts
var getRelativePaddingTop = __webpack_require__(87161);
;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createSVG.ts
var createCircleIconSVG = function(hexColor) {
    // Create the SVG element
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 48 48");
    svg.setAttribute("width", "48");
    svg.setAttribute("height", "48");
    // Create the outer circle
    var circleOuter = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circleOuter.setAttribute("cx", "24");
    circleOuter.setAttribute("cy", "24");
    circleOuter.setAttribute("r", "22.5");
    circleOuter.setAttribute("fill", hexColor);
    circleOuter.setAttribute("stroke", "#fff");
    circleOuter.setAttribute("stroke-width", "3");
    // Create the inner circle
    var group = document.createElementNS("http://www.w3.org/2000/svg", "g");
    group.setAttribute("transform", "translate(24, 24)");
    var circleInner = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circleInner.setAttribute("r", "10");
    circleInner.setAttribute("fill", "#fff");
    // Add the elements to the SVG element
    group.appendChild(circleInner);
    svg.appendChild(circleOuter);
    svg.appendChild(group);
    return svg;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/svgToPng.ts
function svgToPng(svgElement) {
    // Create a canvas element
    var canvas = document.createElement("canvas");
    canvas.width = svgElement.getAttribute("width");
    canvas.height = svgElement.getAttribute("height");
    // Get the SVG as a string
    var svgString = new XMLSerializer().serializeToString(svgElement);
    // Draw the SVG onto the canvas
    var ctx = canvas.getContext("2d");
    var img = new Image();
    img.onload = function() {
        ctx.drawImage(img, 0, 0);
        // Get the data URL of the resulting PNG image
        var dataUrl = canvas.toDataURL("image/png");
        return dataUrl;
    };
    return "data:image/svg+xml;base64," + btoa(svgString);
}

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/component/MatterTag/MatterTagMesh.component.tsx
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
















var MatterTagMeshComponent = /*#__PURE__*/ function(AbstractHTMLMesh) {
    "use strict";
    (0,_inherits/* default */.Z)(MatterTagMeshComponent, AbstractHTMLMesh);
    var _super = (0,_create_super/* default */.Z)(MatterTagMeshComponent);
    function MatterTagMeshComponent() {
        (0,_class_call_check/* default */.Z)(this, MatterTagMeshComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.inputs = {
            html: null,
            tagData: null,
            media: null,
            dimensions: {
                width: 400,
                height: 400
            },
            scale: 1,
            visible: true,
            popupVisible: false,
            popupScale: 16
        };
        var _obj;
        _this.events = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.CLICK */.td.CLICK, true), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.HOVER */.td.HOVER, true), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.DRAG */.td.DRAG, false), _obj);
        return _this;
    }
    var _proto = MatterTagMeshComponent.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        var _inputs = this.inputs, html = _inputs.html, media = _inputs.media;
        this.tagId = this.inputs.tagData.id;
        this.initRoot();
        this.textureLoader = new THREE.TextureLoader();
        this.initTag();
        this.initPopupMesh(html);
        if (media) this.initMedia(media);
        this.addMeshPointerEvents();
        this.getXRController();
        this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
    };
    _proto.initTag = function initTag() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var THREE, iconSVG, tag, tagIconUrl, iconSrc;
            return (0,tslib_es6.__generator)(this, function(_state) {
                THREE = _this.context.three;
                tag = _this.inputs.tagData;
                if (tag.iconFile) {
                    if (tag.iconFile.startsWith("http")) {
                        tagIconUrl = "".concat(tag.iconFile);
                    } else {
                        tagIconUrl = "".concat("https://cdn.treedis.com", "/tours/").concat(tag.tourId, "/tags/icons/").concat(tag.iconFile);
                    }
                } else if (tag.customIcon && tag.customIcon !== "null") {
                    tagIconUrl = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(tag.customIcon, "?hex=").concat(encodeURIComponent(tag.iconColor), "&circle=").concat(tag.whiteCircle);
                }
                if (_this.inputs.tagData.iconColor) iconSVG = createCircleIconSVG(_this.inputs.tagData.iconColor);
                else if (!_this.inputs.tagData.iconColor) iconSVG = createCircleIconSVG("#03687d");
                iconSrc = tagIconUrl || svgToPng(iconSVG);
                _this.textureLoader.load(iconSrc, function(texture) {
                    texture.image.width = 128;
                    texture.image.height = 128;
                    var aspect = texture.image.width / texture.image.height;
                    var ref = (0,_sliced_to_array/* default */.Z)(aspect >= 1 ? [
                        1,
                        1 / aspect
                    ] : [
                        1 / aspect,
                        1
                    ], 2), width = ref[0], height = ref[1];
                    var geometry = new THREE.PlaneGeometry(width, height);
                    var material = new THREE.MeshBasicMaterial({
                        map: texture,
                        side: THREE.DoubleSide,
                        blending: THREE.NormalBlending,
                        transparent: true
                    });
                    _this.tag = new THREE.Mesh(geometry, material);
                    _this.tag.name = "tag";
                    _this.pivot.add(_this.tag);
                    _this.root.position.set(_this.inputs.tagData.positionX + _this.inputs.tagData.stemVectorX, _this.inputs.tagData.positionY + _this.inputs.tagData.stemVectorY, _this.inputs.tagData.positionZ + _this.inputs.tagData.stemVectorZ);
                });
                return [
                    2
                ];
            });
        })();
    };
    _proto.initPopupMesh = function initPopupMesh(html) {
        this.popupMesh = (0,HTMLMesh/* createHTMLMesh */.x)(html, this.context.three);
        this.popupMesh.material.side = this.context.three.DoubleSide;
        this.popupMesh.material.depthWrite = false;
        this.popupMesh.material.depthTest = false;
        this.popupMesh.renderOrder = 970;
        this.popupMesh.scale.setScalar(0);
        this.popupMesh.userData = {
            isPointerOver: false
        };
    };
    _proto.initMedia = function initMedia(media) {
        var _this = this;
        var THREE = this.context.three;
        this.textureLoader.load(media, function(texture) {
            if (!texture) return;
            var texWidth = texture.image.width;
            var texHeight = texture.image.height;
            // Calculate the aspect ratio of the texture
            var aspectRatio = texWidth / texHeight;
            // Set the width and height of the mesh
            var meshWidth = 0.35;
            var meshHeight = 0.35 / aspectRatio;
            // Create the plane geometry and mesh
            var geometry = new THREE.PlaneGeometry(meshWidth, meshHeight);
            var material = new THREE.MeshBasicMaterial({
                map: texture,
                side: THREE.DoubleSide,
                blending: THREE.NormalBlending,
                transparent: true
            });
            _this.mediaMesh = new THREE.Mesh(geometry, material);
            _this.mediaMesh.material.depthWrite = false;
            _this.mediaMesh.material.depthTest = false;
            _this.mediaMesh.renderOrder = 975;
            _this.mediaMesh.position.z = 0.01;
            var offset = (0,getRelativePaddingTop/* getRelativePaddingTop */.X)(_this.inputs.html);
            _this.mediaMesh.position.y = (_this.popupMesh.geometry.parameters.height - _this.mediaMesh.geometry.parameters.height) * 0.5 - offset * _this.popupMesh.geometry.parameters.height;
            _this.popupMesh.add(_this.mediaMesh);
        });
    };
    _proto.initCloseBtn = function initCloseBtn() {
        var THREE = this.context.three;
        var geometry = new THREE.PlaneGeometry(1, 1);
        var texture = new THREE.TextureLoader().load("/images/close-icon.png");
        var material = new THREE.MeshBasicMaterial({
            map: texture,
            side: THREE.DoubleSide,
            transparent: true,
            color: "white"
        });
        var mesh = new THREE.Mesh(geometry, material);
        mesh.position.set(0.25, this.popupMesh.geometry.parameters.height * 0.5, 0);
        mesh.scale.setScalar(0.1);
        mesh.name = "closeBtn";
        mesh.renderOrder = 980;
        this.popupMesh.add(mesh);
        mesh.position.z = -0.1;
    };
    _proto.addMeshPointerEvents = function addMeshPointerEvents() {
        var group = new InteractiveGroup/* InteractiveGroup */.e(this.context.renderer, this.context.camera, this.context);
        this.context.camera.parent.parent.add(group);
        this.root.add(group);
        this.popupMeshInteractiveGroup = group;
        group.add(this.popupMesh);
        this.initCloseBtn();
    };
    _proto.setHostPose = function setHostPose(pose) {
        this.hostPose = pose;
    };
    _proto.setPopupFromPose = function setPopupFromPose(pose) {
        var THREE = this.context.three;
        var ref = getXZCoordinatesOnCircle(0.85, pose.rotation.y + 180), x = ref.x, z = ref.z;
        var worldPosition = new THREE.Vector3(pose.position.x + x, pose.position.y - 0.2, pose.position.z + z); // Replace with your world coordinates
        var localPosition = this.root.worldToLocal(worldPosition);
        this.popupMeshInteractiveGroup.position.copy(localPosition);
        this.popupMeshInteractiveGroup.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
    };
    _proto.setPopupFromHostPose = function setPopupFromHostPose() {
        this.setPopupFromPose(this.hostPose);
    };
    _proto.cycleVR = function cycleVR(session) {
        this.lookAtHost();
    };
    _proto.lookAtHost = function lookAtHost() {
        this.root.lookAt(this.hostPose.position.x, this.hostPose.position.y, this.hostPose.position.z);
        this.popupMesh.lookAt(this.hostPose.position.x, this.hostPose.position.y, this.hostPose.position.z);
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        if (previousInputs.popupVisible !== this.inputs.popupVisible) {
            if (this.inputs.popupVisible) {
                this.popupMesh.scale.setScalar(this.inputs.popupScale);
                if (this.hostPose) this.setPopupFromHostPose();
            } else this.popupMesh.scale.setScalar(0);
        }
        if (previousInputs.visible !== this.inputs.visible) {
            this.root.visible = this.inputs.visible;
        }
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref, ref1, ref2;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
            var _session = this.context.renderer.xr.getSession();
            _session.requestAnimationFrame(function() {
                return _this.cycleVR(_session);
            });
        }
    };
    return MatterTagMeshComponent;
}(AbstractHTMLMesh/* AbstractHTMLMesh */.n);
var matterTagMeshComponentType = "mp.matterTagMeshComponent";
var makeMatterTagMeshComponent = function() {
    return new MatterTagMeshComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/component/Menu/MenuMesh.component.ts
// eslint-disable-next-line @typescript-eslint/ban-ts-comment








var MenuMeshComponent = /*#__PURE__*/ function(AbstractHTMLMesh) {
    "use strict";
    (0,_inherits/* default */.Z)(MenuMeshComponent, AbstractHTMLMesh);
    var _super = (0,_create_super/* default */.Z)(MenuMeshComponent);
    function MenuMeshComponent() {
        (0,_class_call_check/* default */.Z)(this, MenuMeshComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.inputs = {
            html: null,
            visible: false,
            scale: 1,
            itemRefArr: []
        };
        return _this;
    }
    var _proto = MenuMeshComponent.prototype;
    _proto.onInit = function onInit() {
        var html = this.inputs.html;
        this.initMesh(html);
        this.initRoot();
        this.addMeshPointerEvents();
        this.getXRController();
        this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
    };
    _proto.initMesh = function initMesh(html) {
        this.mesh = (0,HTMLMesh/* createHTMLMesh */.x)(html, this.context.three);
        this.mesh.material.side = this.context.three.DoubleSide;
        this.mesh.material.depthWrite = false;
        this.mesh.material.depthTest = false;
        this.mesh.renderOrder = 980;
        this.mesh.scale.setScalar(2);
        this.mesh.userData = {
            isPointerOver: false
        };
    };
    _proto.addMeshPointerEvents = function addMeshPointerEvents() {
        var group = new InteractiveGroup/* InteractiveGroup */.e(this.context.renderer, this.context.camera, this.context);
        this.pivot.add(group);
        group.add(this.mesh);
    };
    _proto.setHostPose = function setHostPose(pose) {
        this.hostPose = pose;
    };
    _proto.setPositionFromPose = function setPositionFromPose(pose) {
        var ref = getXZCoordinatesOnCircle(0.85, pose.rotation.y + 180), x = ref.x, z = ref.z;
        this.root.position.set(pose.position.x + x, pose.position.y - 0.2, pose.position.z + z);
        this.root.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
    };
    _proto.setFromHostPose = function setFromHostPose() {
        this.setPositionFromPose(this.hostPose);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.cycleVR = function cycleVR(_session) {
        var ref, ref1, ref2, ref3;
        if (((ref1 = (ref = this.gamepadL) === null || ref === void 0 ? void 0 : ref.buttons[4]) === null || ref1 === void 0 ? void 0 : ref1.pressed) && !this.gamepadButtonActive && this.hostPose) {
            this.setVisible(!this.inputs.visible);
            this.setFromHostPose();
            this.gamepadButtonActive = true;
        }
        if (!((ref3 = (ref2 = this.gamepadL) === null || ref2 === void 0 ? void 0 : ref2.buttons[4]) === null || ref3 === void 0 ? void 0 : ref3.pressed) && this.gamepadButtonActive) {
            this.gamepadButtonActive = false;
        }
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref, ref1, ref2;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
            var _session = this.context.renderer.xr.getSession();
            _session.requestAnimationFrame(function() {
                return _this.cycleVR(_session);
            });
        }
    };
    return MenuMeshComponent;
}(AbstractHTMLMesh/* AbstractHTMLMesh */.n);
var menuMeshComponentType = "mp.menuMeshComponent";
var makeMenuMeshComponent = function() {
    return new MenuMeshComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/component/PathFinder/PathFinderMesh.component.tsx
// eslint-disable-next-line @typescript-eslint/ban-ts-comment









var PathFinderMeshComponent = /*#__PURE__*/ function(AbstractHTMLMesh) {
    "use strict";
    (0,_inherits/* default */.Z)(PathFinderMeshComponent, AbstractHTMLMesh);
    var _super = (0,_create_super/* default */.Z)(PathFinderMeshComponent);
    function PathFinderMeshComponent() {
        (0,_class_call_check/* default */.Z)(this, PathFinderMeshComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.inputs = {
            html: null,
            visible: false,
            scale: 1,
            refs: null,
            hasPathFinderData: false
        };
        return _this;
    }
    var _proto = PathFinderMeshComponent.prototype;
    _proto.onInit = function onInit() {
        var html = this.inputs.html;
        this.initPathFinderMesh(html);
        this.initRoot();
        this.addMeshPointerEvents();
        this.getXRController();
        this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
    };
    _proto.initPathFinderMesh = function initPathFinderMesh(pathFinderHTML) {
        this.mesh = (0,HTMLMesh/* createHTMLMesh */.x)(pathFinderHTML, this.context.three);
        this.mesh.material.side = this.context.three.DoubleSide;
        this.mesh.material.depthWrite = false;
        this.mesh.material.depthTest = false;
        this.mesh.renderOrder = 970;
        this.mesh.scale.setScalar(2);
        this.mesh.userData = {
            isPointerOver: false
        };
    };
    _proto.addMeshPointerEvents = function addMeshPointerEvents() {
        var group = new InteractiveGroup/* InteractiveGroup */.e(this.context.renderer, this.context.camera, this.context);
        this.pivot.add(group);
        group.add(this.mesh);
    };
    _proto.setHostPose = function setHostPose(pose) {
        this.hostPose = pose;
    };
    _proto.setPositionFromPose = function setPositionFromPose(pose) {
        if (!pose.rotation || !pose.position) return;
        var ref = getXZCoordinatesOnCircle(0.85, pose.rotation.y + 180), x = ref.x, z = ref.z;
        this.root.position.set(pose.position.x + x, pose.position.y - 0.2, pose.position.z + z);
        this.root.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
    };
    _proto.setFromHostPose = function setFromHostPose() {
        this.setPositionFromPose(this.hostPose);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.cycleVR = function cycleVR(_session) {
        var ref, ref1, ref2, ref3;
        this.setFromHostPose();
        tween_module_min/* TWEEN.update */.w.update();
        if (((ref1 = (ref = this.gamepadR) === null || ref === void 0 ? void 0 : ref.buttons[4]) === null || ref1 === void 0 ? void 0 : ref1.pressed) && !this.gamepadButtonActive && this.hostPose && this.inputs.hasPathFinderData) {
            this.setVisible(!this.inputs.visible);
            this.setFromHostPose();
            this.gamepadButtonActive = true;
        }
        if (!((ref3 = (ref2 = this.gamepadR) === null || ref2 === void 0 ? void 0 : ref2.buttons[4]) === null || ref3 === void 0 ? void 0 : ref3.pressed) && this.gamepadButtonActive) {
            this.gamepadButtonActive = false;
        }
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref, ref1, ref2;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
            var _session = this.context.renderer.xr.getSession();
            _session.requestAnimationFrame(function() {
                return _this.cycleVR(_session);
            });
        }
    };
    return PathFinderMeshComponent;
}(AbstractHTMLMesh/* AbstractHTMLMesh */.n);
var pathFinderMeshComponentType = "mp.pathFinderMeshComponent";
var makePathFinderMeshComponent = function() {
    return new PathFinderMeshComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createBackpackhtml.ts
var createBackpackhtml = function(items) {
    var wrapper = document.createElement("div");
    wrapper.id = "backpack-mesh";
    wrapper.className = "backpack-mesh-wrapper";
    var container = document.createElement("div");
    container.className = "backpack-mesh";
    wrapper.appendChild(container);
    var header = document.createElement("div");
    header.className = "backpack-mesh-header";
    header.innerHTML = "Backpack";
    var content = document.createElement("div");
    content.className = "backpack-mesh-content";
    var itemElements = [];
    items.forEach(function(item) {
        var count = document.createElement("p");
        count.className = "backpack-mesh-item";
        count.id = item.name;
        count.innerHTML = "".concat(item.name, " ").concat(item.collected.length, "/").concat(item.solution.split("|").length);
        content.appendChild(count);
        itemElements.push({
            name: item.name,
            ref: count
        });
    });
    container.appendChild(header);
    container.appendChild(content);
    document.body.appendChild(wrapper);
    return {
        html: wrapper,
        refs: {
            header: header,
            content: content,
            itemElements: itemElements
        }
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createMatterTagHTML.ts
var createMatterTagHTML = function(tag, media, dimensions) {
    var container = document.createElement("div");
    container.id = "tag-mesh";
    container.className = "tag-mesh-wrapper";
    container.style.width = "".concat(dimensions.width, "px");
    var header = document.createElement("div");
    header.className = "tag-mesh-header";
    header.innerHTML = !tag.enabled ? tag.title : null;
    var content = document.createElement("div");
    content.className = "tag-mesh-content";
    var description = document.createElement("div");
    description.className = "tag-mesh-description";
    description.innerHTML = tag.enabled && tag.type === "text" ? tag.text : tag.description;
    content.appendChild(description);
    var imageContainer = null;
    if (media) {
        imageContainer = document.createElement("img");
        imageContainer.className = "tag-mesh-image";
        container.prepend(imageContainer);
    }
    container.appendChild(header);
    container.appendChild(content);
    document.body.appendChild(container);
    return {
        html: container,
        imageContainer: imageContainer
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createMenuHTML.ts
var createMenuHTML = function(menus) {
    var container = document.createElement("div");
    container.id = "menu-mesh";
    container.className = "menu-mesh-wrapper";
    container.style.height = "".concat(60 + 36 * menus.length, "px");
    var header = document.createElement("div");
    header.className = "menu-mesh-header";
    header.innerHTML = "Menu";
    var content = document.createElement("div");
    content.className = "menu-mesh-content";
    var itemRefArr = [];
    menus.forEach(function(menu) {
        var menuItem = document.createElement("div");
        menuItem.className = "menu-mesh-item";
        menuItem.innerHTML = menu.title;
        itemRefArr.push(menuItem);
        content.appendChild(menuItem);
    });
    container.appendChild(header);
    container.appendChild(content);
    document.body.appendChild(container);
    return {
        html: container,
        itemRefArr: itemRefArr
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createPathFinderHTML.ts
var createPathFinderHTML = function() {
    var container = document.createElement("div");
    container.id = "pf-mesh";
    container.className = "pf-mesh-wrapper";
    var header = document.createElement("div");
    header.className = "pf-mesh-header";
    header.innerHTML = "";
    var content = document.createElement("div");
    content.className = "pf-mesh-content";
    var description = document.createElement("div");
    description.className = "pf-mesh-content-description";
    description.innerHTML = "";
    var stepCount = document.createElement("div");
    stepCount.className = "pf-mesh-content-step-count";
    stepCount.innerHTML = "";
    var footer = document.createElement("div");
    footer.className = "pf-mesh-footer";
    var buttonBack = document.createElement("button");
    buttonBack.className = "pf-mesh-button pf-mesh-button--back";
    buttonBack.innerHTML = "PREVIOUS";
    var buttonNext = document.createElement("button");
    buttonNext.className = "pf-mesh-button pf-mesh-button--next";
    buttonNext.innerHTML = "NEXT";
    content.appendChild(description);
    content.appendChild(stepCount);
    footer.appendChild(buttonBack);
    footer.appendChild(buttonNext);
    container.appendChild(header);
    container.appendChild(content);
    container.appendChild(footer);
    document.body.appendChild(container);
    return {
        html: container,
        refs: {
            header: header,
            description: description,
            stepCount: stepCount,
            footer: footer,
            buttonBack: buttonBack,
            buttonNext: buttonNext
        }
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/pathFinderUtils.ts
var hasPathFinderData = function(pathfinderDataState) {
    return !(Object.keys(pathfinderDataState).length === 0);
};
var updateStylesAndContent = function(param) {
    var pathFinderMeshComponent = param.pathFinderMeshComponent, pathfinderDataState = param.pathfinderDataState, game = param.game, prevPathFinderData = param.prevPathFinderData;
    var ref, ref1, ref2;
    var stepIndex = game === null || game === void 0 ? void 0 : (ref = game.paths) === null || ref === void 0 ? void 0 : (ref1 = ref.paths) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(step) {
        return step.id === pathfinderDataState.currentPathStepId;
    });
    var _refs = pathFinderMeshComponent.inputs.refs, header = _refs.header, description = _refs.description, stepCount = _refs.stepCount, footer = _refs.footer, buttonNext = _refs.buttonNext, buttonBack = _refs.buttonBack;
    var ref3 = (pathfinderDataState === null || pathfinderDataState === void 0 ? void 0 : pathfinderDataState.pathSettings) || {}, backgroundColor = ref3.backgroundColor, colorButton = ref3.colorButton, colorButtonText = ref3.colorButtonText, colorText = ref3.colorText, titleColorText = ref3.titleColorText, titleEnabled = ref3.titleEnabled, stepEnabled = ref3.stepEnabled;
    var _inputs = pathFinderMeshComponent.inputs, html = _inputs.html, refs = _inputs.refs;
    if (backgroundColor) html.style.backgroundColor = backgroundColor;
    if (colorButton) refs.buttonNext.style.backgroundColor = colorButton;
    if (colorButtonText) refs.buttonNext.style.color = colorButtonText;
    if (colorText) refs.description.style.color = colorText;
    if (titleEnabled) {
        header.innerHTML = pathfinderDataState.title;
        header.style.color = titleColorText || "black";
        header.style.width = "600px";
    }
    if (stepEnabled && typeof stepIndex === "number") {
        var ref4, ref5;
        stepCount.innerHTML = "Step ".concat(stepIndex + 1, "/").concat(game === null || game === void 0 ? void 0 : (ref4 = game.paths) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paths) === null || ref5 === void 0 ? void 0 : ref5.length);
        stepCount.style.color = colorText || "black";
    }
    if (pathfinderDataState === null || pathfinderDataState === void 0 ? void 0 : pathfinderDataState.isEnablePreviousStep) {
        buttonBack.style.display = "flex";
        footer.style.justifyContent = "space-between";
    } else {
        buttonBack.style.display = "none";
        footer.style.justifyContent = "end";
    }
    buttonNext.innerHTML = ((ref2 = pathfinderDataState.translation) === null || ref2 === void 0 ? void 0 : ref2.next) || "Next";
    description.innerHTML = pathfinderDataState.description;
    prevPathFinderData.description = pathfinderDataState.description;
    prevPathFinderData.isEnablePreviousStep = pathfinderDataState.isEnablePreviousStep;
};

// EXTERNAL MODULE: ./_models/virtualStaging/PathFinderLine/component/PathFinderLine.component.ts + 2 modules
var PathFinderLine_component = __webpack_require__(12917);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(99477);
;// CONCATENATED MODULE: ./utils/three/getHorizontalRotationBetweenPoints.ts

var getHorizontalRotationBetweenPoints = function(point1, point2) {
    var vOX = new three_module/* Vector3 */.Pa4(0, 0, 1); // OX axis
    var v1 = new three_module/* Vector3 */.Pa4(point1.data.position.x, point1.data.position.y, point1.data.position.z);
    var v2 = new three_module/* Vector3 */.Pa4(point2.data.position.x, point2.data.position.y, point2.data.position.z);
    var direction = new three_module/* Vector3 */.Pa4();
    direction.subVectors(v1, v2);
    direction.y = 0;
    direction.normalize();
    vOX.normalize();
    var dot = direction.dot(vOX);
    var cross = new three_module/* Vector3 */.Pa4().crossVectors(vOX, direction).y;
    var horizontalRotation = Math.acos(dot);
    if (cross < 0) {
        horizontalRotation = -horizontalRotation;
    }
    return three_module/* MathUtils.radToDeg */.M8C.radToDeg(horizontalRotation);
};

;// CONCATENATED MODULE: ./utils/timeout.ts


var timeout = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ms) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    return setTimeout(resolve, ms);
                })
            ];
        });
    });
    return function timeout(ms) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./_models/virtualStaging/PathFinderLine/ScenePathFinderLine.ts






var ScenePathFinderLine = /*#__PURE__*/ function() {
    "use strict";
    function ScenePathFinderLine(showCaseTemp, camera, currentSweep, setActionPathNavbarVisible, updateActionPathNavbar, pathArrowRef, moveToSweep) {
        (0,_class_call_check/* default */.Z)(this, ScenePathFinderLine);
        this.destinationTitle = "Move to location";
        this.showCaseTemp = showCaseTemp;
        this.camera = camera;
        this.currentSweep = currentSweep;
        this.setActionPathNavbarVisible = setActionPathNavbarVisible;
        this.updateActionPathNavbar = updateActionPathNavbar;
        this.pathArrowRef = pathArrowRef;
        this.moveToSweep = moveToSweep;
        this.create();
    }
    var _proto = ScenePathFinderLine.prototype;
    _proto.create = function create() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, src, dst, weight, modelNode;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Sweep.createGraph()
                        ];
                    case 1:
                        _this.sweepGraph = _state.sent();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = _this.sweepGraph.edges[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _value = _step.value, src = _value.src, dst = _value.dst, weight = _value.weight;
                                _this.sweepGraph.setEdge({
                                    src: src,
                                    dst: dst,
                                    weight: Math.pow(weight, 1.5)
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(PathFinderLine_component/* pathFinderLineComponentType */.pu, PathFinderLine_component/* makePathFinderLineComponent */.OT)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 3:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(PathFinderLine_component/* pathFinderLineComponentType */.pu, {
                                camera: _this.camera,
                                arrowRef: _this.pathArrowRef
                            })
                        ];
                    case 4:
                        _this.component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 5:
                        _state.sent();
                        _this.initSweepUpdates();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initSweepUpdates = function initSweepUpdates() {
        var _this = this;
        this.showCaseTemp.showcase.Sweep.current.subscribe(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(currentSweep) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (currentSweep.sid || currentSweep.sweep) {
                        _this.currentSID = currentSweep.sid || currentSweep.sweep;
                        if (!_this.targetSID) return [
                            2
                        ];
                        if (_this.currentSID === _this.targetSID) {
                            _this.reset();
                            return [
                                2
                            ];
                        }
                        _this.update(_this.currentSID, _this.targetSID);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(currentSweep) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    _proto.autoNavigateCurrentPath = function autoNavigateCurrentPath() {
        var _this = this;
        this.inAutoNavigate = true;
        this.updateActionPathNavbar();
        var _this1 = this;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(resolve, reject) {
                var path, i, ref, currentPoint, nextPoint, angleDegrees, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            path = _this1.component.inputs.path;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                ,
                                8
                            ]);
                            i = 0;
                            _state.label = 2;
                        case 2:
                            if (!(i < path.length - 2)) return [
                                3,
                                6
                            ];
                            currentPoint = path[i];
                            nextPoint = path[i + 2] === path[path.length - 1] ? path[path.length - 2] : path[i + 2];
                            if (!_this1.inAutoNavigate || ((ref = _this1.currentSweep) === null || ref === void 0 ? void 0 : ref.uuid) === "") return [
                                3,
                                6
                            ];
                            if (!nextPoint) return [
                                3,
                                5
                            ];
                            angleDegrees = getHorizontalRotationBetweenPoints(currentPoint, nextPoint);
                            // eslint-disable-next-line no-await-in-loop
                            return [
                                4,
                                _this1.moveToSweep(nextPoint.data.sid, {
                                    x: 0,
                                    y: angleDegrees
                                }, "FLY")
                            ];
                        case 3:
                            _state.sent();
                            // sleep function to prevent tour crash when trying to move during automatic movement
                            // eslint-disable-next-line no-await-in-loop
                            return [
                                4,
                                timeout(100)
                            ];
                        case 4:
                            _state.sent();
                            _state.label = 5;
                        case 5:
                            i += 2;
                            return [
                                3,
                                2
                            ];
                        case 6:
                            resolve(true);
                            return [
                                3,
                                8
                            ];
                        case 7:
                            error = _state.sent();
                            console.error("Error in autoNavigate:", error);
                            reject(error);
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(resolve, reject) {
                return _ref.apply(this, arguments);
            };
        }()).then(function() {
            if (_this.inAutoNavigate) {
                _this.showCaseTemp.showcase.Mattertag.navigateToTag(_this.targetObjectData.sid, _this.showCaseTemp.showcase.Mattertag.Transition.FLY);
                _this.reset();
            }
        });
    };
    _proto.update = function update(currentSID, targetSID, title, targetObjectData) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var startSweep, endSweep, AStarRunner, path;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (title) _this.destinationTitle = title;
                if (targetObjectData) _this.targetObjectData = targetObjectData;
                _this.currentSID = currentSID;
                _this.targetSID = targetSID;
                startSweep = _this.sweepGraph.vertex(currentSID);
                endSweep = _this.sweepGraph.vertex(targetSID);
                AStarRunner = _this.showCaseTemp.mpSDK.Graph.createAStarRunner(_this.sweepGraph, startSweep, endSweep);
                path = AStarRunner.exec().path;
                _this.component.inputs.path = path;
                _this.setActionPathNavbarVisible(true);
                _this.updateActionPathNavbar();
                AStarRunner.dispose();
                return [
                    2
                ];
            });
        })();
    };
    _proto.reset = function reset() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                _this.currentSID = null;
                _this.targetSID = null;
                _this.component.inputs.path = [];
                _this.destinationTitle = "Move to location";
                _this.setActionPathNavbarVisible(false);
                _this.targetObjectData = null;
                _this.inAutoNavigate = false;
                _this.updateActionPathNavbar();
                return [
                    2
                ];
            });
        })();
    };
    return ScenePathFinderLine;
}();

;// CONCATENATED MODULE: ./_models/virtualStaging/Tube/component/Tube.component.ts








var TubeComponent = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TubeComponent, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(TubeComponent);
    function TubeComponent() {
        (0,_class_call_check/* default */.Z)(this, TubeComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.isDestroyed = false;
        _this.arrowMaterial = null;
        _this.innerTubeMaterial = null;
        _this.renderer = null;
        _this.inputs = {
            position: {
                x: 0,
                y: 0,
                z: 0
            },
            rotation: {
                x: 0,
                y: 0,
                z: 0
            },
            visible: true,
            opacity: 0.35,
            color: "red",
            hasTexture: true,
            textureRepeat: {
                x: 7,
                y: 4
            },
            textureOffset: {
                x: 0,
                y: 0
            },
            length: 10,
            width: 1,
            scale: 1,
            arrowSpeed: 0.004,
            linkedPolygon: null,
            interval: 0,
            delay: 0
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        var _obj;
        _this.events = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.CLICK */.td.CLICK, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.HOVER */.td.HOVER, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.DRAG */.td.DRAG, false), _obj);
        return _this;
    }
    var _proto = TubeComponent.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.root.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
        this.root.visible = this.inputs.visible;
        this.root.scale.set(this.inputs.scale, this.inputs.scale, this.inputs.scale);
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.pivot.rotation.set(this.inputs.rotation.x, this.inputs.rotation.y, this.inputs.rotation.z);
        this.outputs.objectRoot = this.root;
        this.outputs.collider = this.root;
        this.createPipe();
        this.outputs.loadingState = VSObject/* LoadingState.Loading */.Gu.Loading;
    };
    _proto.createPipe = function createPipe() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var THREE, path, tubeGeometry, textureLoader, arrowTexture, outerTubeMesh, innerTubeMesh;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        THREE = _this.context.three;
                        path = new THREE.CatmullRomCurve3([
                            new THREE.Vector3(0, 0, 0),
                            new THREE.Vector3(0, 0, _this.inputs.length)
                        ]);
                        tubeGeometry = new THREE.TubeGeometry(path, 1, _this.inputs.width, 24, false);
                        _this.innerTubeMaterial = new THREE.MeshBasicMaterial({
                            transparent: true,
                            opacity: _this.inputs.opacity,
                            color: _this.inputs.color
                        });
                        if (!_this.inputs.hasTexture) return [
                            3,
                            2
                        ];
                        textureLoader = new THREE.TextureLoader();
                        return [
                            4,
                            textureLoader.load("/images/Arrow-Right.png")
                        ];
                    case 1:
                        arrowTexture = _state.sent();
                        arrowTexture.wrapS = THREE.RepeatWrapping;
                        arrowTexture.wrapT = THREE.RepeatWrapping;
                        arrowTexture.repeat.set(_this.inputs.textureRepeat.x, _this.inputs.textureRepeat.y);
                        arrowTexture.offset.set(_this.inputs.textureOffset.x, _this.inputs.textureOffset.y);
                        _this.arrowMaterial = new THREE.MeshBasicMaterial({
                            map: arrowTexture,
                            transparent: true,
                            opacity: 1,
                            depthWrite: false,
                            side: THREE.FrontSide
                        });
                        outerTubeMesh = new THREE.Mesh(tubeGeometry, _this.arrowMaterial);
                        outerTubeMesh.scale.set(1.05, 1.05, 1);
                        outerTubeMesh.renderOrder += 1;
                        _this.pivot.add(outerTubeMesh);
                        _state.label = 2;
                    case 2:
                        innerTubeMesh = new THREE.Mesh(tubeGeometry, _this.innerTubeMaterial);
                        _this.pivot.add(innerTubeMesh);
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.setVisible = function setVisible(visible) {
        this.inputs.visible = visible;
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        this.root.visible = this.inputs.visible;
        if (previousInputs.color !== this.inputs.color && this.innerTubeMaterial) {
            this.innerTubeMaterial.color.set(this.inputs.color);
            this.innerTubeMaterial.needsUpdate = true;
        }
    };
    _proto.onTick = function onTick() {
        var ref, ref1;
        if (this.arrowMaterial && !((ref = this.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.isPresenting)) {
            var arrowSpeed = this.inputs.arrowSpeed;
            var arrowOffset = this.arrowMaterial.map.offset;
            arrowOffset.x -= arrowSpeed;
            this.arrowMaterial.map.offset = arrowOffset;
        }
    };
    _proto.onDestroy = function onDestroy() {};
    return TubeComponent;
}(Scene_component/* SceneComponent */.Ad);
var tubeComponentType = "mp.tubeComponent";
var makeTubeComponent = function() {
    return new TubeComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/Tube/constants.ts
var PIPES_CONSTANTS = {
    POLYGONS: [
        "Pipe-Polygon1",
        "Pipe-Polygon2",
        "Pipe-Polygon3",
        "Pipe-Polygon4",
        "Pipe-Polygon5",
        "Pipe-Polygon6",
        "Pipe-Polygon7"
    ]
};
var PIPES_CONSTANTS_AMERICAN_WATER = {
    POLYGONS: [
        "Pipe-Polygon1",
        "Pipe-Polygon2",
        "Pipe-Polygon3"
    ]
};

;// CONCATENATED MODULE: ./utils/getRandomRange.ts
var getRandomRange = function() {
    var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return Math.random() * (max - min) + min;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/Tube/index.ts






var initTubeObject = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(options, showcaseTemp) {
        var modelNode, component;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        showcaseTemp.showcase.Scene.register(tubeComponentType, makeTubeComponent)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        showcaseTemp.mpSDK.Scene.createNode()
                    ];
                case 2:
                    modelNode = _state.sent();
                    return [
                        4,
                        modelNode.addComponent(tubeComponentType, options)
                    ];
                case 3:
                    component = _state.sent();
                    return [
                        4,
                        modelNode.start()
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        component
                    ];
            }
        });
    });
    return function initTubeObject(options, showcaseTemp) {
        return _ref.apply(this, arguments);
    };
}();
var getPolygonByTitle = function(title, polygons, modelNodes) {
    var ref;
    var uuid = (ref = polygons.find(function(polygon) {
        return polygon.title === title;
    })) === null || ref === void 0 ? void 0 : ref.uuid;
    if (uuid) {
        return modelNodes.find(function(node) {
            return node.length === 2 && node[0].obj3D.uuid === uuid;
        });
    }
};
var initPolygonUpdateFromVideo = function(asset, node, pipesData, THREE, renderer) {
    var targetPolygonIndex = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    var targetPolygon = pipesData.polygonArr[targetPolygonIndex];
    var linkedPipes = pipesData.components.filter(function(component) {
        var ref;
        return ((ref = component.inputs.linkedPolygon) === null || ref === void 0 ? void 0 : ref.id) === targetPolygon.id;
    });
    var lightGreen = new THREE.Color("#5cab89");
    var green = new THREE.Color("green");
    var red = new THREE.Color("#ff0000");
    var blue = new THREE.Color("#0000ff");
    var pipeColor = {
        current: new THREE.Color("white")
    };
    var setColor = function(polygonColor, color) {
        targetPolygon.polygon.material.color.set(polygonColor);
        linkedPipes.forEach(function(component) {
            component.inputs.color = "#".concat(color.getHexString());
        });
        pipeColor.current.set(color);
    };
    var animate = function() {
        var ref;
        requestAnimationFrame(animate);
        if (!(renderer === null || renderer === void 0 ? void 0 : (ref = renderer.xr) === null || ref === void 0 ? void 0 : ref.isPresenting)) {
            if ((node[1].video.currentTime < 2 || node[1].video.currentTime > 10) && !pipeColor.current.equals(blue)) {
                setColor(lightGreen, blue);
            }
            if (node[1].video.currentTime >= 2 && node[1].video.currentTime <= 9 && !pipeColor.current.equals(green)) {
                setColor(lightGreen, green);
            }
            if (node[1].video.currentTime > 4 && node[1].video.currentTime <= 8 && !pipeColor.current.equals(red)) {
                setColor(red, red);
            }
            if (node[1].video.currentTime > 8 && node[1].video.currentTime <= 10 && !pipeColor.current.equals(green)) {
                setColor(lightGreen, blue);
            }
        }
    };
    animate();
};
var initPipes = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(showcaseTemp, modelNodes, polygons, renderer) {
        var polygonArr, bottomPipe1, bottomPipe2, verticalPipeUp1, verticalPipeUp2, verticalPipeDown1, verticalPipeDown2, verticalPipeDown3, upperPipeLong, upperPipeLong2, upperPipeShort, outsidePipe1, components;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    polygonArr = [];
                    PIPES_CONSTANTS.POLYGONS.forEach(function(title) {
                        var polygon = getPolygonByTitle(title, polygons, modelNodes);
                        if ((polygon === null || polygon === void 0 ? void 0 : polygon.length) === 2) {
                            polygon[1].outputs.collider = null;
                            polygonArr.push(polygon[1]);
                        }
                    });
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 0.58,
                                z: 24.7
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 10,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 5.5,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 1:
                    bottomPipe1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 0.58,
                                z: 18.8
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 30,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 15,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[1]
                        }, showcaseTemp)
                    ];
                case 2:
                    bottomPipe2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 0.9,
                                z: 3.34
                            },
                            rotation: {
                                x: Math.PI / 2,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 0.7,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[1]
                        }, showcaseTemp)
                    ];
                case 3:
                    verticalPipeUp1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 2.2,
                                z: 3.34
                            },
                            rotation: {
                                x: Math.PI / 2,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 4,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 1,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[2]
                        }, showcaseTemp)
                    ];
                case 4:
                    verticalPipeUp2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 4.97,
                                y: 2.88,
                                z: 2.47
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 6,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 2.25,
                            width: 0.14,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[3]
                        }, showcaseTemp)
                    ];
                case 5:
                    verticalPipeDown1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 5.03,
                                y: 2.88,
                                z: 4.89
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 6,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 2.25,
                            width: 0.14,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[4]
                        }, showcaseTemp)
                    ];
                case 6:
                    verticalPipeDown2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 2.64,
                                z: 25.1
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 4,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 1.8,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 7:
                    verticalPipeDown3 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 7.9,
                                y: 3.49,
                                z: 3.31
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI * 1.5,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 5,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 2.3,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[2]
                        }, showcaseTemp)
                    ];
                case 8:
                    upperPipeLong = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -4.18,
                                y: 3.06,
                                z: 26.54
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI / 2,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 30,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 12.3,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 9:
                    upperPipeLong2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 4.99,
                                y: 3.49,
                                z: 3.95
                            },
                            rotation: {
                                x: 0,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 4,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 0.7,
                            width: 0.14,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[4]
                        }, showcaseTemp)
                    ];
                case 10:
                    upperPipeShort = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 17.28,
                                y: 0.69,
                                z: 9.25
                            },
                            rotation: {
                                x: 0,
                                y: 3.13,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 5,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 6.2,
                            width: 0.26,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[5]
                        }, showcaseTemp)
                    ];
                case 11:
                    outsidePipe1 = _state.sent();
                    components = [
                        bottomPipe1,
                        bottomPipe2,
                        verticalPipeUp1,
                        verticalPipeUp2,
                        verticalPipeDown1,
                        verticalPipeDown2,
                        verticalPipeDown3,
                        upperPipeLong,
                        upperPipeLong2,
                        upperPipeShort,
                        outsidePipe1
                    ];
                    components.forEach(function(component) {
                        component.renderer = renderer;
                    });
                    return [
                        2,
                        {
                            components: components,
                            polygonArr: polygonArr
                        }
                    ];
            }
        });
    });
    return function initPipes(showcaseTemp, modelNodes, polygons, renderer) {
        return _ref.apply(this, arguments);
    };
}();
var animateDustPipe = function(component) {
    var tweenUp = new tween_module_min/* TWEEN.Tween */.w.Tween(component.root.scale).to({
        y: 2.3
    }, getRandomRange(2000, 4000)).easing(tween_module_min/* TWEEN.Easing.Quadratic.InOut */.w.Easing.Quadratic.InOut); // Change this to suit your needs
    var tweenDown = new tween_module_min/* TWEEN.Tween */.w.Tween(component.root.scale).to({
        y: 1
    }, getRandomRange(2000, 4000)).easing(tween_module_min/* TWEEN.Easing.Quadratic.InOut */.w.Easing.Quadratic.InOut); // Change this to suit your needs
    // Modify onComplete to assign new random duration when tween finishes
    tweenUp.onComplete(function() {
        tweenDown.to({
            y: getRandomRange(1, 2.3)
        }, getRandomRange(2000, 4000));
    });
    tweenDown.onComplete(function() {
        tweenUp.to({
            y: getRandomRange(1, 2.3)
        }, getRandomRange(2000, 4000));
    });
    tweenUp.chain(tweenDown);
    tweenDown.chain(tweenUp);
    tweenUp.start();
};
var initPipesAmericanWater = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(showcaseTemp, modelNodes, polygons, renderer) {
        var polygonArr, outsidePipeVertical, outsidePipeHorizontal, innerPipeX1, innerPipeZ1, innerPipeZ2, innerPipeZ3Long, innerPipeY1, innerPipeY2, innerPipeY3, innerPipeX2, dustPipe, components;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    polygonArr = [];
                    PIPES_CONSTANTS_AMERICAN_WATER.POLYGONS.forEach(function(title) {
                        var polygon = getPolygonByTitle(title, polygons, modelNodes);
                        if ((polygon === null || polygon === void 0 ? void 0 : polygon.length) === 2) {
                            polygon[1].outputs.collider = null;
                            polygonArr.push(polygon[1]);
                        }
                    });
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 1.63,
                                y: 2.84,
                                z: 7.72
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 10,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 6.05,
                            width: 0.37,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 1:
                    outsidePipeVertical = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 1.59,
                                y: 9.75,
                                z: 7.27
                            },
                            rotation: {
                                x: Math.PI,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 1,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 0.5,
                            width: 0.38,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 2:
                    outsidePipeHorizontal = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -53.32,
                                y: 0.69,
                                z: 29.59
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI / 2,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 6,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 4.75,
                            width: 0.43,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 3:
                    innerPipeX1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -51.39,
                                y: 0.74,
                                z: 32.25
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 1.9,
                            width: 0.43,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[1]
                        }, showcaseTemp)
                    ];
                case 4:
                    innerPipeZ1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -53.76,
                                y: 0.69,
                                z: 32.18
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 1.9,
                            width: 0.46,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[2]
                        }, showcaseTemp)
                    ];
                case 5:
                    innerPipeZ2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -56.29,
                                y: 2.76,
                                z: 40
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 34,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 18,
                            width: 0.2,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 6:
                    innerPipeZ3Long = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -55.55,
                                y: 0.85,
                                z: 24.97
                            },
                            rotation: {
                                x: 1.52,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 0.4,
                            width: 0.13,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 7:
                    innerPipeY1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -55.9,
                                y: 0.43,
                                z: 24.96
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 0.4,
                            width: 0.13,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 8:
                    innerPipeY2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -53.86,
                                y: 0.43,
                                z: 25.07
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 0.4,
                            width: 0.13,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 9:
                    innerPipeY3 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -55.14,
                                y: 0.28,
                                z: 24.95
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI * 0.5,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 4,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 1.1,
                            width: 0.12,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 10:
                    innerPipeX2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -19,
                                y: -0.85,
                                z: 20.54
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "#b4d4bc",
                            hasTexture: false,
                            length: 6.05,
                            width: 2.3,
                            scale: 1
                        }, showcaseTemp)
                    ];
                case 11:
                    dustPipe = _state.sent();
                    animateDustPipe(dustPipe);
                    components = [
                        outsidePipeVertical,
                        outsidePipeHorizontal,
                        innerPipeZ1,
                        innerPipeZ2,
                        innerPipeZ3Long,
                        innerPipeX1,
                        innerPipeY1,
                        innerPipeY2,
                        innerPipeY3,
                        innerPipeX2
                    ];
                    components.forEach(function(component) {
                        component.renderer = renderer;
                    });
                    return [
                        2,
                        {
                            components: components,
                            polygonArr: polygonArr
                        }
                    ];
            }
        });
    });
    return function initPipesAmericanWater(showcaseTemp, modelNodes, polygons, renderer) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./_models/virtualStaging/VRPointer/component/VRPointer.component.ts






var VRPointerComponent = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VRPointerComponent, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(VRPointerComponent);
    function VRPointerComponent() {
        (0,_class_call_check/* default */.Z)(this, VRPointerComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.inputs = {
            visible: false,
            scale: 0.05,
            offset: {
                x: 0.006,
                y: -0.025,
                z: 0.03
            }
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        var _obj;
        _this.events = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.CLICK */.td.CLICK, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.HOVER */.td.HOVER, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.DRAG */.td.DRAG, false), _obj);
        return _this;
    }
    var _proto = VRPointerComponent.prototype;
    _proto.onInit = function onInit() {
        var _this = this;
        var ref, ref1, ref2, ref3;
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.vec3 = new THREE.Vector3();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
        this.root.visible = this.inputs.visible;
        this.pivot.visible = false;
        (ref = this.context.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("sessionstart", function() {
            _this.pivot.visible = true;
        });
        (ref2 = this.context.renderer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.xr) === null || ref3 === void 0 ? void 0 : ref3.addEventListener("sessionend", function() {
            _this.pivot.visible = false;
        });
        this.createPointer();
    };
    _proto.createPointer = function createPointer() {
        var _this = this;
        var THREE = this.context.three;
        new THREE.TextureLoader().load("/images/pointer_vr.png", function(texture) {
            var material = new THREE.MeshBasicMaterial({
                map: texture,
                side: THREE.DoubleSide,
                transparent: true
            });
            var geometry = new THREE.PlaneGeometry(1, 1);
            var mesh = new THREE.Mesh(geometry, material);
            var _offset = _this.inputs.offset, x = _offset.x, y = _offset.y, z = _offset.z;
            mesh.position.set(x, y, z);
            mesh.scale.setScalar(_this.inputs.scale);
            mesh.material.depthWrite = false;
            mesh.material.depthTest = false;
            mesh.renderOrder = 990;
            _this.pointerMesh = mesh;
            _this.pivot.add(mesh);
            _this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
        });
    };
    _proto.setVisible = function setVisible(visible) {
        this.inputs.visible = visible;
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        this.root.visible = this.inputs.visible;
    };
    _proto.cycleVR = function cycleVR(_session) {
        this.hostPose.getWorldPosition(this.vec3);
        var _vec3 = this.vec3, x = _vec3.x, y = _vec3.y, z = _vec3.z;
        this.root.lookAt(x, y, z);
    };
    _proto.onTick = function onTick() {
        var _this = this;
        if (this.root && this.hostPose) {
            var ref, ref1, ref2;
            if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
                var _session = this.context.renderer.xr.getSession();
                _session.requestAnimationFrame(function() {
                    return _this.cycleVR(_session);
                });
            }
        }
    };
    _proto.onDestroy = function onDestroy() {};
    return VRPointerComponent;
}(Scene_component/* SceneComponent */.Ad);
var VRPointerComponentType = "mp.VRPointerComponent";
var makeVRPointerComponent = function() {
    return new VRPointerComponent();
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./components/common/VSHTMLPopup/VSHTMLPopup.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.67);\n  backdrop-filter: blur(5px);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 80%;\n  height: 75%;\n  margin-bottom: ",
        "; ;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  flex-grow: 1;\n  background-color: white;\n  border-radius: 10px;\n  margin-bottom: ",
        "; ;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 35px;\n  height: 35px;\n  border-radius: 100rem;\n  background-color: white;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 10px;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: ",
        "; ;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VSHTMLPopup.styles__Overlay",
    componentId: "sc-c159b39c-0"
})(_templateObject());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VSHTMLPopup.styles__Container",
    componentId: "sc-c159b39c-1"
})(_templateObject1(), function(props) {
    return props.isHorizontal ? "2%" : "10%";
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VSHTMLPopup.styles__Content",
    componentId: "sc-c159b39c-2"
})(_templateObject2(), function(props) {
    return props.isHorizontal ? "2%" : "10%";
});
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "VSHTMLPopup.styles__Button",
    componentId: "sc-c159b39c-3"
})(_templateObject3());
var IFrame = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    displayName: "VSHTMLPopup.styles__IFrame",
    componentId: "sc-c159b39c-4"
})(_templateObject4());
var LoaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VSHTMLPopup.styles__LoaderContainer",
    componentId: "sc-c159b39c-5"
})(_templateObject5(), function(props) {
    return props.show ? "block" : "none";
});

;// CONCATENATED MODULE: ./components/common/VSHTMLPopup/index.tsx





var VSHTMLPopup = function(param) {
    var setShow = param.setShow, src = param.src;
    var ref = (0,react.useState)(true), showLoader = ref[0], setShowLoader = ref[1];
    var isHorizontal = deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            onClick: function() {
                setShow(false);
            },
            isHorizontal: isHorizontal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    isHorizontal: isHorizontal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                            show: showLoader,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Loader */.aN, {
                                color: "black"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrame, {
                            src: src,
                            onLoad: function() {
                                setShowLoader(false);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/cross.svg",
                        alt: "close"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/tour/addPinnedVideoFunc.ts

var addPinnedVideoFunc = function(p, pinnedVideosData, cb) {
    try {
        var ref;
        if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "video") {
            var pinnedVideos = (0,_to_consumable_array/* default */.Z)(pinnedVideosData);
            var index = pinnedVideos.findIndex(function(i) {
                return i.sid === p.sid;
            });
            var dominantIndex = pinnedVideos.findIndex(function(i) {
                return i.pinned === true;
            });
            if (dominantIndex >= 0) {
                var dominantSpeaker = pinnedVideos[dominantIndex];
                // replace the dominant speaker, first remove it
                if (dominantSpeaker.sid !== p.sid) {
                    pinnedVideos.splice(dominantIndex, 1);
                }
            }
            if (index >= 0) {
                pinnedVideos[index] = p;
            } else {
                pinnedVideos.push(p);
            }
            cb(pinnedVideos);
        }
    } catch (e) {
        console.error(e);
    }
};

;// CONCATENATED MODULE: ./components/tour/components/CrashScreen/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  font-family: 'Roboto';\n  font-size: 16px;\n  color: white;\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  z-index: 999;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  background: #333;\n\n  ",
        "\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: url('/crash.svg');\n  background-size: cover;\n  height: 12.5em;\n  width: 12.5em;\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 50px auto 0 auto;\n  max-width: 700px;\n  text-align: center;\n  ",
        "\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 3em;\n  line-height: 116.7%;\n  text-align: center;\n  color: #ffffff;\n  margin: 0 auto 30px;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  font-size: 1.25em;\n  padding: 0 50px;\n  margin-bottom: 30px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1em;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  & > button {\n    margin-right: 1.25em;\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 16px;\n  min-height: 40px;\n  background: rgba(107, 107, 107, 0.01);\n  border: 1px solid #ffffff;\n  border-radius: 4px;\n  color: white;\n\n  & > i {\n    margin-right: 0.2em;\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__Wrapper",
    componentId: "sc-e36e8c17-0"
})(styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    font-size: 12px;\n    height: calc(var(--vh, 1vh) * 100);\n  ";
});
var ImageBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__ImageBlock",
    componentId: "sc-e36e8c17-1"
})(styled_templateObject1());
var TextBlockWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__TextBlockWrap",
    componentId: "sc-e36e8c17-2"
})(styled_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n      margin-top: 20px;\n      ".concat(!theme.device.landscape && "max-width: 320px;", "\n    ");
});
var TitleText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__TitleText",
    componentId: "sc-e36e8c17-3"
})(styled_templateObject3());
var DescriptionText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__DescriptionText",
    componentId: "sc-e36e8c17-4"
})(styled_templateObject4());
var ButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__ButtonWrap",
    componentId: "sc-e36e8c17-5"
})(styled_templateObject5());
var styled_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styled__Button",
    componentId: "sc-e36e8c17-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./components/tour/components/CrashScreen/index.tsx


var defaultTranslation = {
    crashScreenTitle: "Seems like something isn't working",
    crashScreenDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    crashScreenRestoreBtn: "Restore",
    crashScreenRefreshBtn: "Reload"
};
var CrashScreen = function(param) {
    var show = param.show, onRestore = param.onRestore, backgroundImage = param.backgroundImage;
    var refresh = function() {
        window.location.reload();
    };
    if (!show) return null;
    var crashScreenTitle = defaultTranslation.crashScreenTitle, crashScreenRestoreBtn = defaultTranslation.crashScreenRestoreBtn, crashScreenRefreshBtn = defaultTranslation.crashScreenRefreshBtn, crashScreenDescription = defaultTranslation.crashScreenDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        backgroundImage: backgroundImage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextBlockWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                        className: "titleText",
                        children: crashScreenTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionText, {
                        children: crashScreenDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrap, {
                children: [
                    onRestore && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                        className: "mb-2",
                        onClick: onRestore,
                        children: crashScreenRestoreBtn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                        className: "mb-2",
                        onClick: refresh,
                        children: crashScreenRefreshBtn
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CrashScreen = (CrashScreen);

// EXTERNAL MODULE: ./components/tour/game/ScreenNavigationArrow/index.tsx
var ScreenNavigationArrow = __webpack_require__(20000);
;// CONCATENATED MODULE: ./components/tour/getIframeStyle.ts
var getIframeStyle = function(param) {
    var tour = param.tour, activeSweepGroup = param.activeSweepGroup, sweepGroups = param.sweepGroups;
    var iframeStyle = {};
    if (tour) {
        var brightness = tour.brightness === 1 ? "" : "brightness(".concat(tour.brightness, ")");
        var saturation = tour.saturation === 1 ? "" : "saturate(".concat(tour.saturation, ")");
        var contrast = tour.contrast === 1 ? "" : "contrast(".concat(tour.contrast, ")");
        iframeStyle = {
            filter: "".concat(brightness, " ").concat(saturation, " ").concat(contrast)
        };
        if (activeSweepGroup) {
            var sweepGroup = sweepGroups.find(function(sg) {
                return sg.id === activeSweepGroup;
            });
            if (sweepGroup) {
                var hasColorSettings = sweepGroup.brightness !== 1 || sweepGroup.saturation !== 1 || sweepGroup.contrast !== 1;
                if (hasColorSettings) {
                    var sweepBrightness = sweepGroup.brightness === 1 ? "" : "brightness(".concat(sweepGroup.brightness, ")");
                    var sweepSaturation = sweepGroup.saturation === 1 ? "" : "saturate(".concat(sweepGroup.saturation, ")");
                    var sweepContrast = sweepGroup.contrast === 1 ? "" : "contrast(".concat(sweepGroup.contrast, ")");
                    iframeStyle = {
                        filter: "".concat(sweepBrightness, " ").concat(sweepSaturation, " ").concat(sweepContrast)
                    };
                }
            }
        }
    }
    return iframeStyle;
};

;// CONCATENATED MODULE: ./components/tour/getUrlVariables.ts

var getUrlVariables = function(url, iframeUrl) {
    var id = (0,util/* getQueryVariable */.Dv)(url, "m");
    var iframeId = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m");
    var start = (0,util/* getQueryVariable */.Dv)(url, "start");
    // normal
    var sr = (0,util/* getQueryVariable */.Dv)(url, "sr"); // rotation
    var ss = (0,util/* getQueryVariable */.Dv)(url, "ss"); // sweep
    // floor plan or dollhouse
    var sm = (0,util/* getQueryVariable */.Dv)(url, "sm"); // mode
    var sz = (0,util/* getQueryVariable */.Dv)(url, "sz"); // zoom
    var sp = (0,util/* getQueryVariable */.Dv)(url, "sp"); // position
    var linkData = start ? JSON.parse(String(start)) : false;
    var rand = Math.floor(Math.random() * 1000000 + 1);
    var linkDataShort = sr && ss ? {
        sr: sr.split(","),
        ss: parseInt(String(ss), 10)
    } : false;
    if (!linkDataShort) linkDataShort = sp && sr && sm ? {
        sm: parseInt(sm, 10),
        sr: sr.split(","),
        sp: sp.split(","),
        sz: sz ? parseFloat(String(sz)) : null
    } : false;
    return {
        id: id,
        iframeId: iframeId,
        linkData: linkData,
        rand: rand,
        linkDataShort: linkDataShort
    };
};

;// CONCATENATED MODULE: ./components/tour/logoutHandler.ts




var logoutHandler = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ticket, ticketingOrderedTicket;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ticket = param.ticket, ticketingOrderedTicket = param.ticketingOrderedTicket;
                    if (!(ticket && ticketingOrderedTicket && ticketingOrderedTicket.ticketType === "tourByYourself")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        TreedisPublicDAO/* default.logoutTicket */.Z.logoutTicket({
                            ticketId: ticketingOrderedTicket === null || ticketingOrderedTicket === void 0 ? void 0 : ticketingOrderedTicket.id,
                            deviceId: (0,utils/* getDeviceFingerprint */.UI)()
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function logoutHandler(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/tour/stopApp.ts
var stopApp = function() {
    console.log("[reload] BaseTour.stopApp");
    window.location.reload();
};

;// CONCATENATED MODULE: ./components/tour/takePositionData.ts


var takePositionData = function(param) {
    var slug = param.slug, matterId = param.matterId, sweep = param.sweep, rotation = param.rotation;
    var segmants = window.location.href.split("/");
    var id = segmants[segmants.length - 1].split("?")[0];
    if (slug === id || matterId === id) {
        (0,util_all/* copyToClipboard */.vQ)((0,util_all/* buildLink */.DF)(sweep, rotation));
    } else {
        var baseUrl = (0,util_all/* getBaseURL */.BS)();
        var updatedUrl = baseUrl.split("/").map(function(part, index, arr) {
            return index === arr.length - 1 ? slug : part;
        }).join("/");
        var link = "".concat(updatedUrl, "?s=").concat(sweep, "&x=").concat(rotation.x, "&y=").concat(rotation.y);
        (0,util_all/* copyToClipboard */.vQ)(link);
    }
    react_toastify_esm/* toast.success */.Am.success("Copied current position");
};

// EXTERNAL MODULE: ./components/types.ts
var types = __webpack_require__(31828);
// EXTERNAL MODULE: ./hooks/useCookies.tsx
var useCookies = __webpack_require__(77666);
// EXTERNAL MODULE: ./units/index.ts + 32 modules
var units = __webpack_require__(19326);
// EXTERNAL MODULE: ./utils/extractSweepIdFromURL.ts
var extractSweepIdFromURL = __webpack_require__(33797);
;// CONCATENATED MODULE: ./utils/getProjectedQuaternion.ts
var getProjectedQuaternion = function(pos, target, axisVec, THREE) {
    var dir = new THREE.Vector3();
    dir.subVectors(target, pos).normalize();
    dir.projectOnPlane(axisVec);
    var mx = new THREE.Matrix4().lookAt(dir, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 1, 0));
    return new THREE.Quaternion().setFromRotationMatrix(mx);
};

;// CONCATENATED MODULE: ./utils/getRPMModelId.ts
var getRPMModelId = function(url) {
    return url.substring(url.lastIndexOf("/") + 1).split(".glb").at(0);
};

;// CONCATENATED MODULE: ./utils/randomNumberId.ts
var randomNumberId = function() {
    var nr = String(Math.random()).split(".")[1];
    if (Number(nr)) {
        return Number(nr);
    }
    return Math.random();
};

// EXTERNAL MODULE: ./components-new/common/AudioModule.ts + 2 modules
var AudioModule = __webpack_require__(29519);
// EXTERNAL MODULE: ./components/util/getLocationUrl.ts
var getLocationUrl = __webpack_require__(49058);
// EXTERNAL MODULE: ./components/tour/game/ClipScreen/index.tsx
var ClipScreen = __webpack_require__(13491);
// EXTERNAL MODULE: ./components/tour/game/ClipScreen/data.ts
var data = __webpack_require__(66446);
// EXTERNAL MODULE: ./components/tour/game/GameBookHandle/index.tsx + 40 modules
var GameBookHandle = __webpack_require__(25406);
// EXTERNAL MODULE: ./hooks/index.ts + 4 modules
var hooks = __webpack_require__(19004);
// EXTERNAL MODULE: ./components-new/eCommerce/DesktopSwitchPath.tsx
var DesktopSwitchPath = __webpack_require__(17937);
// EXTERNAL MODULE: ./node_modules/react-confirm-alert/lib/index.js
var lib = __webpack_require__(68045);
// EXTERNAL MODULE: ./node_modules/react-confirm-alert/src/react-confirm-alert.css
var react_confirm_alert = __webpack_require__(27986);
;// CONCATENATED MODULE: ./components/tour/game/RegularPaths/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable no-console */ 



















var pathSnapshot = base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.pathSnapshot */.k6.pathSnapshot;
var skipPathTo;


var RegularPaths = function(param) {
    var showcase = param.showcase, gamePaths = param.gamePaths, allTags = param.allTags, polygons = param.polygons, vsObjects = param.vsObjects, sweeps = param.sweeps, currentSweep = param.currentSweep, clickedElement = param.clickedElement, translation = param.translation, gameId = param.gameId, onAction = param.onAction, isRtl = param.isRtl, // panoIsOpen,
    __hideItems = param.__hideItems, __revealItems = param.__revealItems, hideElements = param.hideElements, showElements = param.showElements, pathfinderDataState = param.pathfinderDataState, setPathfinderDataState = param.setPathfinderDataState;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(null), lockPath = ref5[0], setLockPath = ref5[1];
    var currentPathStep = (0,react.useRef)(null);
    var paths = (0,react.useRef)(new Map());
    //@ts-ignore
    var ref6 = (0,react.useState)(false), isFinish = ref6[0], setIsFinish = ref6[1];
    var ref7 = (0,react.useState)([]), finishedPaths = ref7[0], setFinishedPaths = ref7[1];
    var ref8 = (0,react.useState)(true), delayedDisable = ref8[0], setDelayedDisable = ref8[1];
    var ref9 = (0,react.useState)(false), isEnablePreviousStep = ref9[0], setIsEnablePreviousStep = ref9[1];
    var ref10 = (0,react.useState)(false), _ = ref10[0], setUpdateState = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* forceShowPathSwitchMobileModalState */.g$), 2), forceShowPathSwitchMobileModal = ref11[0], setForceShowPathSwitchMobileModal = ref11[1];
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var tagRefForData = (0,react.useRef)();
    tagRefForData.current = {
        lockPath: lockPath,
        allTags: allTags
    };
    base/* asyncStore.currentPathStep */.k6.currentPathStep = currentPathStep.current;
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.triggerItem) !== -1 && (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.triggerType)) {
            setIsEnablePreviousStep(lockPath === null || lockPath === void 0 ? void 0 : lockPath.previousStep);
        } else {
            setIsEnablePreviousStep(false);
        }
    }, [
        currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current
    ]);
    (0,hooks/* useGlobalDOMEvents */.AG)({
        keyup: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(ev) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(ev.code === "Space")) return [
                                3,
                                2
                            ];
                            // eslint-disable-next-line no-use-before-define
                            return [
                                4,
                                handleNextStep()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(ev) {
                return _ref.apply(this, arguments);
            };
        }()
    }, [
        vsObjects,
        allTags
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var goToNextStep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(forcedLockPath) {
            var ref, ref1, _lockPath, nextStep, delay, nextStepId, ref2, ref3, step, allTagsArray, tagsToReveal, polygonsToReveal, vsImagesToReveal, vsVideosToReveal, vsItemsToReveal, ref4, ref5, prevStep, newFinishedPaths;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _lockPath = forcedLockPath || lockPath || ((ref = tagRefForData.current) === null || ref === void 0 ? void 0 : ref.lockPath);
                        nextStep = currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.next;
                        delay = parseInt(nextStep === null || nextStep === void 0 ? void 0 : nextStep.appearanceDelay);
                        nextStepId = nextStep === null || nextStep === void 0 ? void 0 : nextStep.id;
                        if (!(nextStepId && paths.current.has(nextStepId))) return [
                            3,
                            3
                        ];
                        step = paths === null || paths === void 0 ? void 0 : (ref2 = paths.current) === null || ref2 === void 0 ? void 0 : ref2.get(nextStepId);
                        if (!(_lockPath === null || _lockPath === void 0 ? void 0 : _lockPath.hideItems)) return [
                            3,
                            2
                        ];
                        allTagsArray = Array.from(allTags, function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                            return value;
                        });
                        tagsToReveal = step.locationType === Game/* EntityType.Tag */.py.Tag ? allTagsArray.filter(function(tag) {
                            return (tag === null || tag === void 0 ? void 0 : tag.id) === step.locationItem || tag.sid === step.locationItem || tag.defaultSid === step.locationItem;
                        }) : [];
                        polygonsToReveal = step.locationType === Game/* EntityType.Polygon */.py.Polygon ? polygons.filter(function(polygon) {
                            var ref;
                            return polygon.id === step.locationItem || ((ref = polygon.id) === null || ref === void 0 ? void 0 : ref.toString()) === step.locationItem;
                        }) : [];
                        vsImagesToReveal = step.locationType === Game/* EntityType.VSImage */.py.VSImage ? vsObjects.filter(function(object) {
                            var ref;
                            return (0,_instanceof/* default */.Z)(object, VSObject/* TourImage */.oP) && (object.id === step.locationItem || ((ref = object.id) === null || ref === void 0 ? void 0 : ref.toString()) === step.locationItem);
                        }) : [];
                        vsVideosToReveal = step.locationType === Game/* EntityType.VSVideo */.py.VSVideo ? vsObjects.filter(function(object) {
                            var ref;
                            return (0,_instanceof/* default */.Z)(object, VSObject/* TourVideo */.Up) && (object.id === step.locationItem || ((ref = object.id) === null || ref === void 0 ? void 0 : ref.toString()) === step.locationItem);
                        }) : [];
                        vsItemsToReveal = step.locationType === Game/* EntityType.VSItem */.py.VSItem ? vsObjects.filter(function(object) {
                            var ref;
                            return (0,_instanceof/* default */.Z)(object, VSObject/* TourObject */.zB) && (object.id === step.locationItem || ((ref = object.id) === null || ref === void 0 ? void 0 : ref.toString()) === step.locationItem);
                        }) : [];
                        return [
                            4,
                            showElements({
                                tagsToReveal: tagsToReveal.map(function(e) {
                                    return (e === null || e === void 0 ? void 0 : e.defaultSid) || (e === null || e === void 0 ? void 0 : e.sid);
                                }),
                                polygonsToReveal: polygonsToReveal.map(function(e) {
                                    var ref;
                                    return e === null || e === void 0 ? void 0 : (ref = e.id) === null || ref === void 0 ? void 0 : ref.toString();
                                }),
                                vsImagesToReveal: vsImagesToReveal.map(function(e) {
                                    var ref;
                                    return e === null || e === void 0 ? void 0 : (ref = e.id) === null || ref === void 0 ? void 0 : ref.toString();
                                }),
                                vsVideosToReveal: vsVideosToReveal.map(function(e) {
                                    var ref;
                                    return e === null || e === void 0 ? void 0 : (ref = e.id) === null || ref === void 0 ? void 0 : ref.toString();
                                }),
                                vsItemsToReveal: vsItemsToReveal.map(function(e) {
                                    var ref;
                                    return e === null || e === void 0 ? void 0 : (ref = e.id) === null || ref === void 0 ? void 0 : ref.toString();
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        if (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref3 = currentPathStep.current) === null || ref3 === void 0 ? void 0 : ref3.hideStep) {
                            ;
                            //hide clicked element
                            __hideItems([
                                {
                                    conditionType: "hide",
                                    entity_type: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref4 = currentPathStep.current) === null || ref4 === void 0 ? void 0 : ref4.locationType,
                                    entity_ids: [
                                        currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref5 = currentPathStep.current) === null || ref5 === void 0 ? void 0 : ref5.locationItem
                                    ]
                                }
                            ]);
                        }
                        prevStep = currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current;
                        currentPathStep.current = step;
                        //if delay then path will appear with timeout / reset previous timeout
                        (0,base/* handlePathDelay */.L)(delay, setDelayedDisable);
                        if (skipPathTo && skipPathTo !== prevStep.id) {
                            goToNextStep(_lockPath);
                        } else {
                            skipPathTo = null;
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        skipPathTo = null;
                        newFinishedPaths = (0,_to_consumable_array/* default */.Z)(finishedPaths).concat([
                            _lockPath === null || _lockPath === void 0 ? void 0 : _lockPath.id
                        ]);
                        //check if there is another uncomoleted paths?
                        // const unfinishedPaths = gamePaths.filter((path) => !newFinishedPaths.includes(path.id));
                        // if (unfinishedPaths.length > 0) {
                        //   _changePath(unfinishedPaths[0].id);
                        // } else {
                        //   setIsFinish(true);
                        // }
                        currentPathStep.current = null;
                        paths.current = null;
                        base/* asyncStore.pathIds */.k6.pathIds = [];
                        // console.debug('aaa setLockPath null 3');
                        setLockPath(null);
                        setFinishedPaths(newFinishedPaths);
                        _state.label = 4;
                    case 4:
                        //force update of path, because it's using data from reference which is not updating it's Reference
                        setUpdateState(function(updateState) {
                            return !updateState;
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function goToNextStep(forcedLockPath) {
            return _ref.apply(this, arguments);
        };
    }();
    var goToPreviousStep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, prevStepId, ref2, step;
            return (0,tslib_es6.__generator)(this, function(_state) {
                prevStepId = currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : (ref1 = ref.prev) === null || ref1 === void 0 ? void 0 : ref1.id;
                if (prevStepId) {
                    ;
                    step = paths === null || paths === void 0 ? void 0 : (ref2 = paths.current) === null || ref2 === void 0 ? void 0 : ref2.get(prevStepId);
                    if (step === null || step === void 0 ? void 0 : step.hideStep) {
                        //reveal previous hidden element
                        __revealItems([
                            {
                                conditionType: "reveal",
                                entity_type: step === null || step === void 0 ? void 0 : step.locationType,
                                entity_ids: [
                                    step === null || step === void 0 ? void 0 : step.locationItem
                                ]
                            }
                        ]);
                    }
                    currentPathStep.current = step;
                } else {
                    setIsEnablePreviousStep(false);
                }
                return [
                    2
                ];
            });
        });
        return function goToPreviousStep() {
            return _ref.apply(this, arguments);
        };
    }();
    //@ts-ignore commented debug
    var belongToCurrentPath = function() {
        var _skipPathTo;
        if (lockPath === null || lockPath === void 0 ? void 0 : lockPath.allowSkipping) {
            var safeCycle = 1000; //prevent infinite loop if linked to itself or recursive
            var currentStep = currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current;
            while(safeCycle > 0 && currentStep && !_skipPathTo){
                var ref, ref1, ref2, ref3, ref4;
                if (((currentStep === null || currentStep === void 0 ? void 0 : (ref = currentStep.locationItem) === null || ref === void 0 ? void 0 : ref.toString()) === clickedElement.id.toString() || (currentStep === null || currentStep === void 0 ? void 0 : (ref1 = currentStep.locationItem) === null || ref1 === void 0 ? void 0 : ref1.toString()) === (clickedElement === null || clickedElement === void 0 ? void 0 : clickedElement.sid) || (currentStep === null || currentStep === void 0 ? void 0 : (ref2 = currentStep.locationItem) === null || ref2 === void 0 ? void 0 : ref2.toString()) === (clickedElement === null || clickedElement === void 0 ? void 0 : clickedElement.defaultSid)) && (currentStep === null || currentStep === void 0 ? void 0 : currentStep.locationType) === clickedElement.type) {
                    _skipPathTo = currentStep.id;
                }
                currentStep = (ref3 = paths.current) === null || ref3 === void 0 ? void 0 : ref3.get(currentStep === null || currentStep === void 0 ? void 0 : (ref4 = currentStep.next) === null || ref4 === void 0 ? void 0 : ref4.id);
                safeCycle--;
            }
            if (_skipPathTo) {
                skipPathTo = _skipPathTo;
                goToNextStep();
                return true;
            }
        } else {
            var ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            //also check if it's belong to future steps & allowSkipping enabled
            if (((currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref5 = currentPathStep.current) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.locationItem) === null || ref6 === void 0 ? void 0 : ref6.toString()) === clickedElement.id.toString() || (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref7 = currentPathStep.current) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.locationItem) === null || ref8 === void 0 ? void 0 : ref8.toString()) === (clickedElement === null || clickedElement === void 0 ? void 0 : clickedElement.sid) || (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref9 = currentPathStep.current) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.locationItem) === null || ref10 === void 0 ? void 0 : ref10.toString()) === (clickedElement === null || clickedElement === void 0 ? void 0 : clickedElement.defaultSid)) && (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref11 = currentPathStep.current) === null || ref11 === void 0 ? void 0 : ref11.locationType) === clickedElement.type) {
                goToNextStep();
                return true;
            }
            return false;
        }
    };
    (0,react.useEffect)(function() {
        if (gamePaths && (gamePaths === null || gamePaths === void 0 ? void 0 : gamePaths.length)) {
            var defaultLock;
            if (gamePaths.length > 1) {
                defaultLock = gamePaths.find(function(path) {
                    var ref;
                    return path === null || path === void 0 ? void 0 : (ref = path.pathSetting) === null || ref === void 0 ? void 0 : ref.defaultPath;
                }) || gamePaths[0];
                base/* asyncStore.regularActivePath */.k6.regularActivePath = gamePaths.map(function(p) {
                    return p.id;
                }).indexOf(defaultLock.id);
            } else {
                defaultLock = gamePaths[0];
                base/* asyncStore.regularActivePath */.k6.regularActivePath = 0;
            }
            setLockPath(defaultLock);
        }
    }, [
        gamePaths
    ]);
    var createPath = function(items, triggerType, triggerItem) {
        var ref;
        var step = lockPath === null || lockPath === void 0 ? void 0 : (ref = lockPath.paths) === null || ref === void 0 ? void 0 : ref.find(function(path) {
            return path.triggerType === triggerType && (path.triggerItem === triggerItem || path.triggerItem === null && triggerItem === -1);
        });
        if (!step) return items;
        var next = lockPath === null || lockPath === void 0 ? void 0 : lockPath.paths.find(function(path) {
            return path.triggerType === step.locationType && path.triggerItem === step.locationItem;
        });
        var prev = lockPath === null || lockPath === void 0 ? void 0 : lockPath.paths.find(function(path) {
            return path.locationType === step.triggerType && path.locationItem === step.triggerItem;
        });
        if (!triggerType) {
            var ref1;
            currentPathStep.current = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
                prev: prev || null,
                next: next && next.id !== step.id ? next : null
            });
            var delay = parseInt(step === null || step === void 0 ? void 0 : (ref1 = step.appearanceDelay) === null || ref1 === void 0 ? void 0 : ref1.toString());
            //if delay then path will appear with timeout / reset previous timeout
            (0,base/* handlePathDelay */.L)(delay, setDelayedDisable);
        }
        items.set(step.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
            prev: prev || null,
            next: next && next.id !== step.id ? next : null
        }));
        base/* asyncStore.pathIds.push */.k6.pathIds.push(step.id);
        return next && !items.get(next.id) ? createPath(items, next.triggerType, next.triggerItem) : items;
    };
    var rotateCameraTo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(t) {
            var THREE, l, d, a, r, o, s, u, f, p, m, b, h, g, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        if (base/* asyncStore.vrIsOn */.k6.vrIsOn) return [
                            2,
                            console.error("Camera rotate is disabled for VR mode")
                        ];
                        return [
                            4,
                            (0,dist/* iTHREE */.Sc)()
                        ];
                    case 1:
                        THREE = _state.sent();
                        l = function(value) {
                            return value * Math.PI / 180;
                        };
                        d = new THREE.Vector3(0, 0, -1);
                        return [
                            4,
                            showcase.mpSDK.Camera.getPose()
                        ];
                    case 2:
                        a = _state.sent();
                        r = new THREE.Euler(l(a.rotation.x), l(a.rotation.y), 0, "XYZ");
                        o = d.clone().applyEuler(r);
                        s = new THREE.Vector3(a.position.x, a.position.y, a.position.z);
                        u = t.clone();
                        f = o.clone().normalize();
                        p = u.clone().sub(s).normalize();
                        m = new THREE.Vector3(f.x, 0, f.z);
                        b = new THREE.Vector3(p.x, 0, p.z);
                        h = m.angleTo(b);
                        g = f.x * p.z - f.z * p.x < 0 ? -1 : 1;
                        return [
                            4,
                            showcase.mpSDK.Camera.rotate(180 * h / Math.PI * g)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function rotateCameraTo(t) {
            return _ref.apply(this, arguments);
        };
    }();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var moveToPathStepElement = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type, value) {
            var destinationSweepData, pathSweep, obj, allTagsArray, ref, THREE, transitionType, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        destinationSweepData = (0,base/* parsePathDestinationSweepData */.wv)(currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current);
                        pathSweep = sweeps.find(function(sweep) {
                            return (destinationSweepData === null || destinationSweepData === void 0 ? void 0 : destinationSweepData.sweepUuid) === sweep.uuid || (destinationSweepData === null || destinationSweepData === void 0 ? void 0 : destinationSweepData.sweepUuid) === sweep.sid || (destinationSweepData === null || destinationSweepData === void 0 ? void 0 : destinationSweepData.sweepUuid) === sweep.sweep_uuid;
                        });
                        switch(type){
                            case GameBook/* ChapterType.Tag */._U.Tag:
                                {
                                    allTagsArray = Array.from(allTags, function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
                                        return v;
                                    });
                                    obj = allTagsArray === null || allTagsArray === void 0 ? void 0 : allTagsArray.find(function(item) {
                                        return value === (item === null || item === void 0 ? void 0 : item.id) || value === (item === null || item === void 0 ? void 0 : item.defaultSid) || value === (item === null || item === void 0 ? void 0 : item.sid);
                                    });
                                    break;
                                }
                            case GameBook/* ChapterType.Polygon */._U.Polygon:
                                {
                                    obj = polygons.find(function(item) {
                                        var ref;
                                        return value === item.id || value === ((ref = item.id) === null || ref === void 0 ? void 0 : ref.toString());
                                    });
                                    break;
                                }
                            case GameBook/* ChapterType.VSImage */._U.VSImage:
                                {
                                    obj = vsObjects.find(function(item) {
                                        var ref;
                                        return (0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && (value === item.id || value === ((ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()));
                                    });
                                    break;
                                }
                            case GameBook/* ChapterType.VSVideo */._U.VSVideo:
                                {
                                    obj = vsObjects.find(function(item) {
                                        var ref;
                                        return (0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && (value === item.id || value === ((ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()));
                                    });
                                    break;
                                }
                            case GameBook/* ChapterType.VSItem */._U.VSItem:
                                {
                                    obj = vsObjects.find(function(item) {
                                        var ref;
                                        return (0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && (value === item.id || value === ((ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()));
                                    });
                                    break;
                                }
                            default:
                                break;
                        }
                        if (!(obj && pathSweep)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            (0,dist/* iTHREE */.Sc)()
                        ];
                    case 1:
                        THREE = _state.sent();
                        transitionType = (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.transitionType) || Game/* GameLockPathTransitionType.INSTANT */.KO.INSTANT;
                        return [
                            4,
                            showcase.mpSDK.Sweep.moveTo(pathSweep.uuid, {
                                transition: showcase.mpSDK.Sweep.Transition[transitionType === null || transitionType === void 0 ? void 0 : transitionType.toUpperCase()]
                            })
                        ];
                    case 2:
                        _state.sent();
                        if (!!base/* asyncStore.vrIsOn */.k6.vrIsOn) return [
                            3,
                            5
                        ];
                        if (!destinationSweepData.isTourLink) return [
                            3,
                            3
                        ];
                        (ref1 = showcase.mpSDK) === null || ref1 === void 0 ? void 0 : ref1.Camera.setRotation({
                            x: destinationSweepData.x,
                            y: destinationSweepData.y
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            rotateCameraTo(new THREE.Vector3(obj.positionX, obj.positionY, obj.positionZ))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            2,
                            obj
                        ];
                }
            });
        });
        return function moveToPathStepElement(type, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNextStep = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, vsElement;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current)) return [
                        2
                    ];
                    if (!((currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current.sweepUuid) === currentSweep.uuid)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        goToNextStep()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        moveToPathStepElement(currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.locationType, currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.locationItem)
                    ];
                case 3:
                    vsElement = _state.sent();
                    if (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref2 = currentPathStep.current) === null || ref2 === void 0 ? void 0 : ref2.autoOpenDestination) {
                        onAction(vsElement, currentPathStep.current.locationType);
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        moveToPathStepElement
    ]);
    var handlePreviousStep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, vsElement;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            goToPreviousStep()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            moveToPathStepElement(currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.locationType, currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.locationItem)
                        ];
                    case 2:
                        vsElement = _state.sent();
                        if (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref2 = currentPathStep.current) === null || ref2 === void 0 ? void 0 : ref2.autoOpenDestination) {
                            onAction(vsElement, currentPathStep.current.locationType);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePreviousStep() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, pathArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(lockPath && !((ref = paths.current) === null || ref === void 0 ? void 0 : ref.size))) return [
                            3,
                            3
                        ];
                        base/* asyncStore.pathIds */.k6.pathIds = [];
                        paths.current = createPath(new Map(), null, -1);
                        pathArray = Array.from(paths.current, function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                            return value;
                        });
                        pathArray = pathArray.filter(function(e) {
                            var ref;
                            return e.id !== (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.id);
                        });
                        if (!(lockPath === null || lockPath === void 0 ? void 0 : lockPath.hideItems)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            hideElements({
                                hideTags: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.Tag */.py.Tag;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                }),
                                polygonsToHide: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.Polygon */.py.Polygon;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                }),
                                vsImagesToHide: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.VSImage */.py.VSImage;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                }),
                                vsVideosToHide: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.VSVideo */.py.VSVideo;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                }),
                                vsItemsToHide: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.VSItem */.py.VSItem;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        if (skipPathTo) {
                            goToNextStep();
                        } else {
                            //screen render update, because changing ref not trigger rerender
                            setUpdateState(function(updateState) {
                                return !updateState;
                            });
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lockPath,
        handleNextStep,
        paths === null || paths === void 0 ? void 0 : paths.current,
        skipPathTo
    ]);
    var _changePath = function(pathId, restart) {
        if (pathId == (lockPath === null || lockPath === void 0 ? void 0 : lockPath.id)) return;
        var skipChangePath = false;
        var path = gamePaths.find(function(p) {
            var ref;
            return p.id === pathId || ((ref = p.id) === null || ref === void 0 ? void 0 : ref.toString()) === pathId;
        });
        //save current path to restore later
        pathSnapshot[lockPath === null || lockPath === void 0 ? void 0 : lockPath.id] = {
            currentPathStep: currentPathStep.current,
            paths: paths.current,
            pathIds: base/* asyncStore.pathIds */.k6.pathIds
        };
        if (pathSnapshot[pathId] && !restart) {
            var ref, ref1, ref2;
            //set stored path as current
            currentPathStep.current = (ref = pathSnapshot[pathId]) === null || ref === void 0 ? void 0 : ref.currentPathStep;
            paths.current = (ref1 = pathSnapshot[pathId]) === null || ref1 === void 0 ? void 0 : ref1.paths;
            base/* asyncStore.pathIds */.k6.pathIds = (ref2 = pathSnapshot[pathId]) === null || ref2 === void 0 ? void 0 : ref2.pathIds;
            if (skipPathTo) {
                skipChangePath = true;
                goToNextStep(path);
            }
        } else {
            currentPathStep.current = null;
            paths.current = null;
            base/* asyncStore.pathIds */.k6.pathIds = [];
        }
        if (!skipChangePath) {
            // console.debug('aaa setLockPath _changePath 2', path);
            setLockPath(path);
        }
        base/* asyncStore.regularActivePath */.k6.regularActivePath = gamePaths.map(function(p) {
            return p.id;
        }).indexOf(path.id);
    };
    var askForReset = function(pathId) {
        (0,lib/* confirmAlert */._1)({
            title: "",
            message: translation.restartPath || "Do you wish to restart this path or continue where you left?",
            buttons: [
                {
                    label: translation.restart || "Restart",
                    onClick: function() {
                        skipPathTo = null;
                        _changePath(pathId, true);
                    }
                },
                {
                    label: translation.continue || "Continue",
                    onClick: function() {
                        _changePath(pathId);
                    }
                }, 
            ]
        });
    };
    var handleChangePath = function(ev) {
        if ((lockPath === null || lockPath === void 0 ? void 0 : lockPath.id) === ev.target.value) return;
        var targetPath = gamePaths.find(function(p) {
            var ref;
            return p.id === ev.target.value || ((ref = p.id) === null || ref === void 0 ? void 0 : ref.toString()) === ev.target.value;
        });
        (0,lib/* confirmAlert */._1)({
            title: "",
            message: translation.switchPath || "Are you sure you wish to begin a new path? The current path will be turned off",
            buttons: [
                {
                    label: translation.yes || "Yes",
                    onClick: function() {
                        var ref;
                        var pathId = ev.target.value;
                        if (targetPath === null || targetPath === void 0 ? void 0 : (ref = targetPath.pathSetting) === null || ref === void 0 ? void 0 : ref.resetPathOnSwitch) {
                            setTimeout(function() {
                                askForReset(pathId);
                            }, 1000);
                        } else {
                            _changePath(pathId);
                        }
                    }
                },
                {
                    label: translation.no || "No",
                    onClick: function() {
                        skipPathTo = null;
                    }
                }, 
            ]
        });
    };
    // console.debug('aaa -----------------------------------------------------------------------');
    // console.debug('aaa game', game);
    // console.debug('aaa lockPath', lockPath);
    // console.debug('aaa finishedPaths', finishedPaths);
    // console.debug('aaa currentPathStep.current', currentPathStep.current);
    // console.debug('aaa paths.current', paths.current);
    // console.debug('aaa asyncStore.pathIds', asyncStore.pathIds);
    // console.debug('aaa isShowPathLockByExperience && showPathLock', isShowPathLockByExperience, showPathLock);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isFinish && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopSwitchPath/* default */.Z, {
                finishedPaths: finishedPaths,
                gameId: gameId,
                pathLocks: gamePaths,
                pathLockId: lockPath === null || lockPath === void 0 ? void 0 : lockPath.id,
                currentPathStepId: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.id,
                handleChangePath: handleChangePath
            }),
            !isFinish && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* GameLockPathModal */.SR, {
                //@ts-ignore
                finishedPaths: finishedPaths,
                forceShowPathSwitchMobileModal: forceShowPathSwitchMobileModal,
                setForceShowPathSwitchMobileModal: setForceShowPathSwitchMobileModal,
                handleChangePath: handleChangePath,
                pathLocks: gamePaths,
                APP_AWS: "https://cdn.treedis.com",
                useRecoilValue: store/* useRecoilValue */.sJ,
                recoilStateObj: {
                    bottomBarOpenState: store/* bottomBarOpenState */.DF,
                    tourConfigsState: store/* tourConfigsState */.Uq
                },
                asyncStore: base/* asyncStore */.k6,
                theme: theme,
                color: utils/* color */.$_,
                pathSnapshot: pathSnapshot,
                currentPathStepId: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.id,
                pathfinderDataState: pathfinderDataState,
                setPathfinderDataState: setPathfinderDataState,
                delayedDisable: delayedDisable,
                isRtl: isRtl,
                pathLockId: lockPath === null || lockPath === void 0 ? void 0 : lockPath.id,
                gameId: gameId,
                pathSettings: (lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting) || {},
                handleNextStep: handleNextStep,
                handlePreviousStep: handlePreviousStep,
                translation: translation,
                title: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref2 = currentPathStep.current) === null || ref2 === void 0 ? void 0 : ref2.title,
                description: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref3 = currentPathStep.current) === null || ref3 === void 0 ? void 0 : ref3.description,
                isEnablePreviousStep: isEnablePreviousStep && (lockPath === null || lockPath === void 0 ? void 0 : lockPath.previousStep),
                // @ts-ignore property added to types
                isEnableNextStep: true,
                // @ts-ignore
                buttonOnlyMode: lockPath === null || lockPath === void 0 ? void 0 : lockPath.buttonOnlyMode,
                // @ts-ignore property added to types
                icon: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref4 = currentPathStep.current) === null || ref4 === void 0 ? void 0 : ref4.icon
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/tour/regular/ad-redesigned/AdRedesigned.tsx
var AdRedesigned = __webpack_require__(2520);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/tour/regular/menu-redesigned/MenuRedesigned.tsx





/* EXPLANATION OF THE LOGIC IN THIS COMPONENT
 * This component is a wrapper around the MenuRedesigned component from the tour-loader package.
 * Since the menu will overlap most of the popups in the tour (either from Matterport or from Treedis), we need to hide it if it's open and a popup is open and re-show it when the popup is closed. It's not possible to solve this problem with z-indexes. Plus, it's a better UX if the menu is hidden when a popup is open and then re-shown when the popup is closed.
 * To do this, we use MutationObservers to listen for changes in the DOM and check if the menu should be shown or hidden.
 * We have two different MutationObservers, one for Matterport popups and one for Treedis popups.
 * The Matterport MutationObserver is attached to the showcase iframe and listens for changes in the class attribute of the showcase.
 * The Treedis MutationObserver is attached to the .base-tour div and listens for changes in the childList and if the popup is added or removed.
 */ var MP_IFRAME_SELECTOR = ".showcase.showcase";
var TREEDIS_SELECTOR = ".base-tour";
// These a matterport triggers (ex: when a MP Image Tag popup is open)
// Classes
var showcaseTargets = [
    "modal-open",
    "side-panel tool-open"
];
// IDs
var baseTourTargets = [
    "tag-popup",
    "treedis-popup-container",
    "external-popup",
    "vsaction-popup"
];
function MenuRedesigned(props) {
    var settings = props.settings, rest = (0,_object_without_properties/* default */.Z)(props, [
        "settings"
    ]);
    var ref = (0,react.useState)(null), showcaseNode = ref[0], setShowcaseNode = ref[1];
    var ref1 = (0,react.useState)(), showcaseTrigger = ref1[0], setShowcaseTrigger = ref1[1];
    var ref2 = (0,react.useState)(), baseTourTrigger = ref2[0], setBaseTourTrigger = ref2[1];
    var isOpen = (0,react.useMemo)(function() {
        return props.open;
    }, [
        props.open
    ]);
    var openMenu = props.onOpen;
    var closeMenu = props.onClose;
    var shouldObserveMutations = (0,react.useMemo)(function() {
        return isOpen || showcaseTrigger || baseTourTrigger;
    }, [
        isOpen,
        showcaseTrigger,
        baseTourTrigger
    ]);
    var sanitizeSettings = function(menuSettings) {
        var clone = (0,_object_spread/* default */.Z)({}, menuSettings);
        Object.keys(clone).forEach(function(key) {
            if (clone[key] === null) clone[key] = false;
        });
        return clone;
    };
    // Get Showcase Iframe Node
    // Since it may take some time for the showcase to load, we need to keep trying to get the showcase iframe until we get it
    (0,react.useEffect)(function() {
        var getShowcaseIframe = function() {
            var retryCount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            var node = document.querySelector(MP_IFRAME_SELECTOR);
            if (node) {
                setShowcaseNode(node);
            } else if (retryCount < 10) {
                setTimeout(function() {
                    return getShowcaseIframe(retryCount + 1);
                }, 1000);
            }
        };
        getShowcaseIframe();
    }, [
        shouldObserveMutations
    ]);
    // MP SHOWCASE POPUPS LOGIC TO HIDE BM
    (0,react.useEffect)(function() {
        // Create a new instance of MutationObserver
        var observer = new MutationObserver(function(mutationsList) {
            // If we have a currentShowcaseTrigger, then we should check if the menu should be shown
            if (showcaseTrigger) {
                var shouldShowMenu = mutationsList.some(function(mutation) {
                    return showcaseTrigger === mutation.oldValue;
                });
                if (shouldShowMenu) {
                    openMenu();
                    setShowcaseTrigger(undefined);
                }
            } else {
                // If we don't have a currentShowcaseTrigger, then we should check if the menu should be hidden
                var shouldHideMenu = mutationsList.some(function(mutation) {
                    // @ts-ignore
                    var target = mutation.target.className;
                    if (showcaseTargets.includes(target)) {
                        setShowcaseTrigger(target);
                        return true;
                    }
                    return false;
                });
                if (shouldHideMenu) {
                    closeMenu();
                }
            }
        });
        // Start observing the target node and its descendants for DOM changes
        if (showcaseNode && showcaseNode.contentDocument && shouldObserveMutations) {
            observer.observe(showcaseNode.contentDocument, {
                attributes: true,
                attributeOldValue: true,
                subtree: true,
                attributeFilter: [
                    "class"
                ]
            });
        } else {
            observer.disconnect();
        }
        return function() {
            // Stop observing when the component unmounts
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showcaseNode,
        shouldObserveMutations,
        showcaseTrigger
    ]);
    // TREEDIS POPUPS LOGIC TO HIDE BM
    (0,react.useEffect)(function() {
        var node = document.querySelector(TREEDIS_SELECTOR);
        var observer = new MutationObserver(function(mutationsList) {
            // If we have a currentBaseTourTrigger, then we should check if the menu should be shown
            if (baseTourTrigger) {
                // Checking for addedNodes
                // @ts-ignore
                var shouldShowMenu = mutationsList.some(function(mutation) {
                    var ref, ref1;
                    return baseTourTrigger === ((ref = mutation.removedNodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id);
                });
                if (shouldShowMenu) {
                    openMenu();
                    setBaseTourTrigger(undefined);
                }
            } else {
                // If we don't have a currentBaseTourTrigger, then we should check if the menu should be hidden
                var shouldHideMenu = mutationsList.some(function(mutation) {
                    var ref, ref1;
                    // @ts-ignore
                    var target = (ref = mutation.addedNodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id;
                    // Checking for removedNodes
                    if (baseTourTargets.includes(target)) {
                        setBaseTourTrigger(target);
                        return true;
                    }
                    return false;
                });
                if (shouldHideMenu) {
                    closeMenu();
                }
            }
        });
        if (node && shouldObserveMutations) {
            observer.observe(node, {
                childList: true,
                subtree: true
            });
        } else {
            observer.disconnect();
        }
        // Special case for when Panorama is open on start
        // Was used to hide Menu when Panorama was open on start. Not needed anymore.
        // Delete this code in a few months
        // const panoPopup = document.querySelector('#panorama-overlay');
        // if (panoPopup && isOpen) {
        //   setBaseTourTrigger('panorama-overlay');
        //   closeMenu();
        // }
        return function() {
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        baseTourTrigger,
        isOpen,
        shouldObserveMutations
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MenuRedesigned */.rM, (0,_object_spread/* default */.Z)({
        settings: sanitizeSettings(settings)
    }, rest));
}

// EXTERNAL MODULE: ./components/tour/regular/menu/menuService.ts
var menuService = __webpack_require__(45019);
// EXTERNAL MODULE: ./components/tour/regular/mondelez-tablet-video/MondelezTabletVideo.tsx
var MondelezTabletVideo = __webpack_require__(39901);
// EXTERNAL MODULE: ./node_modules/three/src/math/MathUtils.js
var MathUtils = __webpack_require__(69542);
;// CONCATENATED MODULE: ./_models/virtualStaging/VRCameraController/index.ts



var VRCameraController = /*#__PURE__*/ function() {
    "use strict";
    function VRCameraController(THREE, renderer, camera, cameraPose) {
        (0,_class_call_check/* default */.Z)(this, VRCameraController);
        this.THREE = THREE;
        this.renderer = renderer;
        this.camera = camera;
        this.cameraPose = cameraPose;
    }
    var _proto = VRCameraController.prototype;
    // rotate VR view based on camera sweep and object for camera to look at
    _proto.rotateVRView = function rotateVRView(targetSweep, targetObj) {
        var _this = this;
        if (!this.baseReferenceSpace) {
            this.baseReferenceSpace = this.renderer.xr.getReferenceSpace();
        }
        var geometry = new this.THREE.BoxGeometry(1, 1, 1);
        var material = new this.THREE.MeshBasicMaterial({
            color: 0x000000,
            transparent: true,
            side: this.THREE.DoubleSide,
            opacity: 0,
            depthTest: false,
            depthWrite: false
        });
        var helperObj = new this.THREE.Mesh(geometry, material);
        this.camera.parent.parent.add(helperObj);
        helperObj.position.set(targetSweep.position.x, targetSweep.position.y, targetSweep.position.z);
        new tween_module_min/* TWEEN.Tween */.w.Tween(helperObj.material).to({
            opacity: 1
        }, 150).start().onComplete(function() {
            var transform2 = new XRRigidTransform(new _this.THREE.Vector3(), {
                x: 0,
                y: 0,
                z: 0,
                w: 1
            });
            var teleportSpaceOffset2 = _this.baseReferenceSpace.getOffsetReferenceSpace(transform2);
            _this.renderer.xr.setReferenceSpace(teleportSpaceOffset2);
            setTimeout(function() {
                var posAvatar = new _this.THREE.Vector3();
                _this.camera.getWorldPosition(posAvatar);
                var posObj = new _this.THREE.Vector3();
                if (targetObj) targetObj.getWorldPosition(posObj);
                else if (targetObj.hasOwnProperty("positionX") && targetObj.hasOwnProperty("positionY") && targetObj.hasOwnProperty("positionZ")) {
                    posObj.set(targetObj.position.x, targetObj.position.y, targetObj.position.z);
                }
                var xDist = posObj.x - posAvatar.x;
                var zDist = posObj.z - posAvatar.z;
                var angle = Math.atan2(zDist, xDist);
                var quaternion = new _this.THREE.Quaternion();
                quaternion.setFromAxisAngle(new _this.THREE.Vector3(0, 1, 0), (0,MathUtils/* degToRad */.Id)(_this.cameraPose.current.rotation.y) + angle + Math.PI / 2);
                var transform = new XRRigidTransform(new _this.THREE.Vector3(), {
                    x: quaternion.x,
                    y: quaternion.y,
                    z: quaternion.z,
                    w: quaternion.w
                });
                var teleportSpaceOffset = _this.baseReferenceSpace.getOffsetReferenceSpace(transform);
                _this.renderer.xr.setReferenceSpace(teleportSpaceOffset);
                new tween_module_min/* TWEEN.Tween */.w.Tween(helperObj.material).to({
                    opacity: 0
                }, 150).onComplete(function() {
                    _this.camera.parent.parent.remove(helperObj);
                    geometry.dispose();
                    material.dispose();
                    if (targetObj.userData.temp) {
                        _this.camera.parent.parent.remove(targetObj);
                        targetObj.geometry.dispose();
                        targetObj.material.dispose();
                    }
                }).start();
            }, 300);
        });
    };
    // Create helper object based on target camera rotation direction then rotate VR view
    _proto.rotateVRViewByCameraRotation = function rotateVRViewByCameraRotation(targetSweep, rotation) {
        var vec = this.getDirectionFromRotation(rotation.x, rotation.y);
        var geometry = new this.THREE.SphereGeometry(0.3, 32, 16);
        var material = new this.THREE.MeshBasicMaterial({
            color: 0xffff00
        });
        var sphere = new this.THREE.Mesh(geometry, material);
        sphere.visible = false;
        sphere.position.set(targetSweep.position.x + vec.x, targetSweep.position.y + vec.y, targetSweep.position.z + vec.z);
        this.camera.parent.parent.add(sphere);
        sphere.userData = {
            temp: true
        };
        this.rotateVRView(targetSweep, sphere);
    };
    _proto.getDirectionFromRotation = function getDirectionFromRotation(rotationX, rotationY) {
        var forward = new this.THREE.Vector3(0, 0, -1);
        var euler = new this.THREE.Euler(this.THREE.MathUtils.degToRad(rotationX), this.THREE.MathUtils.degToRad(rotationY), 0, "YXZ");
        forward.applyEuler(euler);
        return forward;
    };
    return VRCameraController;
}();

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
;// CONCATENATED MODULE: ./utils/isImage.ts
function isImage(url) {
    return new Promise(function(resolve) {
        var img = new Image();
        img.onload = function() {
            return resolve(true);
        };
        img.onerror = function() {
            return resolve(false);
        };
        img.src = url;
    });
}

;// CONCATENATED MODULE: ./components/tour/regular/custom-button/CustomButton.tsx






function CustomButton(param) {
    var onClick = param.onClick, tourId = param.tourId, customButtonIcon = param.customButtonIcon;
    var ref = (0,react.useState)(), buttonUrl = ref[0], setButtonUrl = ref[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var url, isValidImage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = "".concat("https://cdn.treedis.com", "/tours/").concat(tourId, "/").concat(customButtonIcon);
                        return [
                            4,
                            isImage(url)
                        ];
                    case 1:
                        isValidImage = _state.sent();
                        if (isValidImage) {
                            setButtonUrl(url);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        customButtonIcon,
        tourId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        id: "custom-button",
        sx: {
            borderRadius: "10px 0 0 10px",
            padding: "0",
            transition: "all 0.2s ease-in-out",
            overflow: "hidden",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "white",
            "&:hover": {
                opacity: 0.8,
                transform: "scale(1.1)",
                backgroundColor: "rgba(0, 0, 0, 0.7)"
            }
        },
        onClick: onClick,
        children: customButtonIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "img",
            sx: {
                width: "100%",
                height: "100%",
                objectFit: "cover"
            },
            src: buttonUrl
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "far fa-crown"
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(21448);
;// CONCATENATED MODULE: ./components/tour/regular/get-in-touch-button/GetInTouchButton.tsx



function GetInTouchButton(param) {
    var onClick = param.onClick, translation = param.translation, tooltipOn = param.tooltipOn;
    var ref = (0,react.useState)(false), hasBeenOpened = ref[0], setHasBeenOpened = ref[1];
    var bgColor = "rgba(0, 0, 0, 0.5)";
    var bgHoverColor = "rgba(0, 0, 0, 0.7)";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            spacing: 2,
            alignItems: "center",
            sx: {
                position: "absolute",
                top: "95px",
                right: "0px",
                zIndex: 1
            },
            children: [
                tooltipOn && !hasBeenOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    sx: {
                        background: bgColor,
                        height: "32px !important",
                        px: 1,
                        "@keyframes pulse": {
                            "0%": {
                                transform: "scale(1)"
                            },
                            "50%": {
                                transform: "scale(1.05)"
                            },
                            "100%": {
                                transform: "scale(1)"
                            }
                        },
                        animation: "pulse 2s infinite"
                    },
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        sx: {
                            color: "white"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "#ffffff"
                                },
                                children: (translation === null || translation === void 0 ? void 0 : translation.getInTouchAppointmentTooltip) || "Get in touch"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "far fa-circle-arrow-right",
                                style: {
                                    fontSize: "1.2rem"
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        sx: {
                            background: bgColor,
                            color: "white",
                            width: "40px",
                            "&:hover": {
                                background: bgHoverColor
                            },
                            borderRadius: "10px 0 0 10px"
                        },
                        onClick: function() {
                            setHasBeenOpened(true);
                            onClick();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-envelope"
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/tour/BaseTour.tsx
/* eslint-disable no-return-await */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable class-methods-use-this */ /* eslint-disable no-unused-expressions */ /* eslint-disable @typescript-eslint/no-shadow */ /* eslint-disable radix */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-empty */ /* eslint-disable consistent-return */ /* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-empty-function */ /* eslint-disable no-console */ /* eslint-disable react/no-unused-state */ 

















































































































var ExperiencePopUp = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1606).then(__webpack_require__.bind(__webpack_require__, 61606));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61606)
            ];
        }
    },
    ssr: false
});
var IntroScreen = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 284).then(__webpack_require__.bind(__webpack_require__, 284));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(284)
            ];
        }
    },
    ssr: false
});
var Sweep = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 934).then(__webpack_require__.bind(__webpack_require__, 30934));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30934)
            ];
        }
    },
    ssr: false
});
var Share = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5290).then(__webpack_require__.bind(__webpack_require__, 95290));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95290)
            ];
        }
    },
    ssr: false
});
var Login = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4207).then(__webpack_require__.bind(__webpack_require__, 14207));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14207)
            ];
        }
    },
    ssr: false
});
var DebugWindow = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9617).then(__webpack_require__.bind(__webpack_require__, 99617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99617)
            ];
        }
    },
    ssr: false
});
var Terms = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 117).then(__webpack_require__.bind(__webpack_require__, 90117));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90117)
            ];
        }
    },
    ssr: false
});
var Help = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9493).then(__webpack_require__.bind(__webpack_require__, 49493));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49493)
            ];
        }
    },
    ssr: false
});
var CollectLeadsForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5137).then(__webpack_require__.bind(__webpack_require__, 45137));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45137)
            ];
        }
    },
    ssr: false
});
var RenderTicketingContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1449).then(__webpack_require__.bind(__webpack_require__, 31449));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31449)
            ];
        }
    },
    ssr: false
});
var IntroPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(199), __webpack_require__.e(6750)]).then(__webpack_require__.bind(__webpack_require__, 46750)).then(function(res) {
        return res.IntroPopup;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46750)
            ];
        }
    },
    ssr: false
});
var TicketingRouter = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4762), __webpack_require__.e(7361)]).then(__webpack_require__.bind(__webpack_require__, 17361));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17361)
            ];
        }
    },
    ssr: false
});
var SketchfabPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7441), __webpack_require__.e(378)]).then(__webpack_require__.bind(__webpack_require__, 10378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10378)
            ];
        }
    },
    ssr: false
});
var Minimap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6126), __webpack_require__.e(7268)]).then(__webpack_require__.bind(__webpack_require__, 7268));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7268)
            ];
        }
    },
    ssr: false
});
var Panorama = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9991).then(__webpack_require__.bind(__webpack_require__, 29991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29991)
            ];
        }
    },
    ssr: false
});
var ContactPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1055).then(__webpack_require__.bind(__webpack_require__, 11055));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11055)
            ];
        }
    },
    ssr: false
});
var ExternalPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3777).then(__webpack_require__.bind(__webpack_require__, 93777));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93777)
            ];
        }
    },
    ssr: false
});
var PanoPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6484).then(__webpack_require__.bind(__webpack_require__, 66484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66484)
            ];
        }
    },
    ssr: false
});
var PathFinderPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4889).then(__webpack_require__.bind(__webpack_require__, 4889));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4889)
            ];
        }
    },
    ssr: false
});
var TagsPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6099).then(__webpack_require__.bind(__webpack_require__, 56099));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56099)
            ];
        }
    },
    ssr: false
});
var VSActionsPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7691).then(__webpack_require__.bind(__webpack_require__, 67691));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67691)
            ];
        }
    },
    ssr: false
});
var Countdown = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5360).then(__webpack_require__.bind(__webpack_require__, 45360));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45360)
            ];
        }
    },
    ssr: false
});
var MessengerCustomerChat = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9538).then(__webpack_require__.bind(__webpack_require__, 89538));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89538)
            ];
        }
    },
    ssr: false
});
var MemoizedVideo = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9973), __webpack_require__.e(1922)]).then(__webpack_require__.bind(__webpack_require__, 71922));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71922)
            ];
        }
    },
    ssr: false
});
var Appointment = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9424).then(__webpack_require__.bind(__webpack_require__, 59424));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59424)
            ];
        }
    },
    ssr: false
});
var BottomBarWithRecoil = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8689), __webpack_require__.e(2489)]).then(__webpack_require__.bind(__webpack_require__, 92489));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92489)
            ];
        }
    },
    ssr: false
});
var DEFAULT_VS_SENSOR_RADIUS = deviceManager/* default.isMobile */.Z.isMobile() ? 25 : 25;
var defaultLogo = (0,utils/* getAsset */.Nh)("logo-white.svg");
var audioHandler = AudioModule/* AudioModule.getInstance */.w0.getInstance();
var BaseTour = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseTour, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseTour);
    function BaseTour(props, tourType) {
        (0,_class_call_check/* default */.Z)(this, BaseTour);
        var _this;
        _this = _super.call(this, props);
        _this.ticketValidSweepsHistory = [];
        _this.ticketTimeout = null;
        _this.messengerQ = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "messenger");
        _this.currentSweep = null;
        _this.defaultSweep = null;
        _this.avatarNodes = new Map();
        _this.playAudioTimeout = null;
        _this.mainContainerWaitingForPlay = false;
        _this.pose = {};
        _this.floor = new FRFloor({
            floor: 0,
            position: null
        });
        _this.messenger = parseInt(_this.messengerQ === false ? "1" : _this.messengerQ, 10);
        _this.visibleTags = {};
        _this.hiddenTags = {};
        _this.modelNodes = [];
        _this.vsObjects = [];
        _this.isMobile = deviceManager/* default.isMobile */.Z.isMobile();
        _this.avatarDegree = null;
        _this.connectedAvatarsLastSweep = [] // previous sweep for all other avatars in tour
        ;
        _this.connectedAvatarsTweens = [] // amount of active animations for all other avatars in tour
        ;
        _this.camera = null;
        _this.isShadowEnabled = false;
        _this.gameAnalytic = null;
        _this.matterTagMeshComponents = [];
        _this.VRPointer = {
            component: null,
            target: null
        };
        _this.backpack = {
            items: []
        };
        _this.animate = function() {
            var ref, ref1, ref2, ref3, ref4;
            if (((ref = _this.camera) === null || ref === void 0 ? void 0 : ref.parent.position) && ((ref4 = (ref1 = _this.showCaseTemp) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.scene) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sceneController) === null || ref3 === void 0 ? void 0 : ref3.UI.leverComponent) === null || ref4 === void 0 ? void 0 : ref4.root)) {
                var ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39;
                var vec3 = new _this.THREE.Vector3();
                (ref5 = _this.camera) === null || ref5 === void 0 ? void 0 : ref5.getWorldPosition(vec3);
                var ref40 = getXYZCoordinatesOnCircle(0.85, _this.pose.rotation.x, _this.pose.rotation.y + 180), x = ref40.x, y = ref40.y, z = ref40.z;
                (ref9 = (ref6 = _this.showCaseTemp) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.scene) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.sceneController) === null || ref8 === void 0 ? void 0 : ref8.UI.leverComponent) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.root) === null || ref10 === void 0 ? void 0 : ref10.position.set(vec3.x + x, vec3.y + y, vec3.z + z);
                (ref14 = (ref11 = _this.showCaseTemp) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.scene) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sceneController) === null || ref13 === void 0 ? void 0 : ref13.UI.leverComponent) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.root) === null || ref15 === void 0 ? void 0 : ref15.lookAt(vec3);
                (ref19 = (ref16 = _this.showCaseTemp) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.scene) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.sceneController) === null || ref18 === void 0 ? void 0 : ref18.UI.leverComponent) === null || ref19 === void 0 ? void 0 : ref19.pivot.position.set(-0.15, -0.02, 0.65);
                (ref23 = (ref20 = _this.showCaseTemp) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.scene) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.sceneController) === null || ref22 === void 0 ? void 0 : ref22.UI.buttonIncrease) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.root) === null || ref24 === void 0 ? void 0 : ref24.position.set(vec3.x + x, vec3.y + y, vec3.z + z);
                (ref28 = (ref25 = _this.showCaseTemp) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.scene) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.sceneController) === null || ref27 === void 0 ? void 0 : ref27.UI.buttonIncrease) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.root) === null || ref29 === void 0 ? void 0 : ref29.lookAt(vec3);
                (ref33 = (ref30 = _this.showCaseTemp) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.scene) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.sceneController) === null || ref32 === void 0 ? void 0 : ref32.UI.buttonDecrease) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.root) === null || ref34 === void 0 ? void 0 : ref34.position.set(vec3.x + x, vec3.y + y, vec3.z + z);
                (ref38 = (ref35 = _this.showCaseTemp) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.scene) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.sceneController) === null || ref37 === void 0 ? void 0 : ref37.UI.buttonDecrease) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.root) === null || ref39 === void 0 ? void 0 : ref39.lookAt(vec3);
            }
            requestAnimationFrame(_this.animate);
            tween_module_min/* TWEEN.update */.w.update();
        };
        _this.didAvatarSweepChange = function(avatarId, newSweepId) {
            var shouldAnimationPlay;
            var avatarLastSweepIndex = _this.connectedAvatarsLastSweep.findIndex(function(obj) {
                return obj && obj.id === avatarId;
            });
            if (avatarLastSweepIndex !== -1) {
                var targetAvatarLastSweep = _this.connectedAvatarsLastSweep[avatarLastSweepIndex];
                shouldAnimationPlay = targetAvatarLastSweep.sweepId !== newSweepId;
                _this.connectedAvatarsLastSweep[avatarLastSweepIndex].sweepId = newSweepId;
            } else {
                shouldAnimationPlay = true;
                _this.connectedAvatarsLastSweep.push({
                    id: avatarId,
                    sweepId: newSweepId
                });
            }
            return shouldAnimationPlay;
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getCameraRotation = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                // TODO: pass in props this.camera, not the function
                return [
                    2,
                    {
                        rotation: (ref = _this1.camera) === null || ref === void 0 ? void 0 : ref.rotation,
                        quaternion: (ref1 = _this1.camera) === null || ref1 === void 0 ? void 0 : ref1.quaternion
                    }
                ];
            });
        });
        _this.renderCrashScreen = function() {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_CrashScreen, {
                show: _this.state.crashScreen,
                backgroundImage: "".concat("https://cdn.treedis.com", "/tours/").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.id, "/images/").concat((ref1 = _this.state.tour) === null || ref1 === void 0 ? void 0 : ref1.mainImage)
            });
        };
        _this.showTicketTimeIsOutPopup = function() {
            _this.setState({
                infoModalData: {
                    mode: InfoModal/* EInfoModal.timeIsUp */.Y.timeIsUp,
                    onRequestClose: function() {
                        stopApp();
                    }
                }
            });
        };
        _this.showTicketRestrictedAreaPopup = function(param) {
            var sweepThatCauseTicketRestriction = param.sweepThatCauseTicketRestriction, reelThatCauseTicketRestriction = param.reelThatCauseTicketRestriction;
            _this.setState({
                infoModalData: {
                    mode: InfoModal/* EInfoModal.restrictedArea */.Y.restrictedArea,
                    onRequestClose: function() {
                        if (sweepThatCauseTicketRestriction) _this.goToPreviousValidSweep();
                    },
                    sweepThatCauseTicketRestriction: sweepThatCauseTicketRestriction,
                    reelThatCauseTicketRestriction: reelThatCauseTicketRestriction
                }
            });
        };
        _this.setPathfinderDataState = function(data) {
            _this.setState({
                pathfinderDataState: data
            });
        };
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.goToPreviousValidSweep = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, THREE;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if ((ref = _this2.ticketValidSweepsHistory) === null || ref === void 0 ? void 0 : ref.length) {
                    THREE = _this2.THREE;
                    _this2.moveToSweep(_this2.ticketValidSweepsHistory[_this2.ticketValidSweepsHistory.length - 1], new THREE.Euler());
                } else {
                    stopApp();
                }
                return [
                    2
                ];
            });
        });
        _this.ticketUpdateSweepLoc = function(nextSweep) {
            var ref, ref1, ref2, ref3;
            if (((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.ticket) && ((ref1 = _this.state) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticketing) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketingOrderedTicket) === null || ref3 === void 0 ? void 0 : ref3.ticketType) === "tourByYourself") {
                var ref4;
                var ticketingTourTicket = _this.state.ticketing.ticketingTourTicket;
                var allowedSweeps = ticketingTourTicket.selectedSweeps ? ticketingTourTicket.selectedSweeps[(ref4 = _this.state.tour) === null || ref4 === void 0 ? void 0 : ref4.slug] : [];
                if (allowedSweeps.includes(nextSweep)) {
                    _this.ticketValidSweepsHistory.push(nextSweep);
                } else {
                    _this.showTicketRestrictedAreaPopup({
                        sweepThatCauseTicketRestriction: nextSweep
                    });
                }
            }
        };
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onPlayClick = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var _state, tour, _$tourType, err;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            _state = _this3.state, tour = _state.tour, _$tourType = _state.tourType;
                            _state1.label = 1;
                        case 1:
                            _state1.trys.push([
                                1,
                                ,
                                9,
                                10
                            ]);
                            if (!((tour === null || tour === void 0 ? void 0 : tour.id) && (tour === null || tour === void 0 ? void 0 : tour.collectLeads) && _$tourType !== Tour/* TourType.Game */.v.Game)) return [
                                3,
                                7
                            ];
                            _state1.label = 2;
                        case 2:
                            _state1.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            (0,analytic/* sendToGA */.o$)("event", {
                                eventCategory: "Lead",
                                eventAction: "submit",
                                eventLabel: "entry"
                            });
                            if (Tour/* TourType.Game */.v.Game === _$tourType) {
                                _this3.handleGameStartOnIntroModal(data === null || data === void 0 ? void 0 : data.name);
                            }
                            return [
                                4,
                                (0,util_all/* fetchData */.rQ)("public/setTourLead", "POST", (0,_object_spread/* default */.Z)({
                                    tourId: tour.id
                                }, data))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                4,
                                _this3.handleCollectLeadsSubmit(data)
                            ];
                        case 4:
                            _state1.sent();
                            return [
                                3,
                                6
                            ];
                        case 5:
                            err = _state1.sent();
                            console.error(err.message);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                3,
                                8
                            ];
                        case 7:
                            if (Tour/* TourType.Game */.v.Game === _$tourType) {
                                _this3.handleGameStartOnIntroModal(data === null || data === void 0 ? void 0 : data.name);
                            }
                            _state1.label = 8;
                        case 8:
                            (0,analytic/* sendToGA */.o$)("event", {
                                eventCategory: "IntroScreen",
                                eventAction: "click",
                                eventLabel: "introButton"
                            });
                            return [
                                3,
                                10
                            ];
                        case 9:
                            return [
                                7
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onIntroScreenFinished = function() {
            var _state = _this.state, showIntro = _state.showIntro, showcaseLoaded = _state.showcaseLoaded;
            if (showIntro) {
                var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
                _this.setState({
                    startScreenOn: false
                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!showcaseLoaded) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.playTourAudio().catch(function() {})
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }));
            } else {
                var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
                _this.setState({
                    startScreenOn: false,
                    forcePlayGameIntro: true
                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!showcaseLoaded) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this2.processTourMusic(true)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
            if (_this.state.tourType === Tour/* TourType.Game */.v.Game) {
                _this.setState({
                    gameStatus: types/* GameStatus.Started */.XI.Started
                });
            }
        };
        var _this4 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleCollectLeadsSubmit = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var _state, tour, tourEmail;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            _state = _this4.state, tour = _state.tour, tourEmail = _state.tourEmail;
                            return [
                                4,
                                TreedisPublicDAO/* default.sendEmail */.Z.sendEmail({
                                    data: {
                                        to: tourEmail && tourEmail.leadForms || tour.client && tour.client.email,
                                        params: Object.assign(data, {
                                            tour: tour.title,
                                            userId: tour.userId,
                                            link: window.location.href
                                        })
                                    }
                                })
                            ];
                        case 1:
                            _state1.sent();
                            _this4.loadData(tour);
                            _this4.setState({
                                showCollectLeadsModal: false
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onTicketLoginSuccess = function(tour, ticketing) {
            var ticketingOrderedTicket = ticketing.ticketingOrderedTicket, ticketingTourTicket = ticketing.ticketingTourTicket;
            var ticketLimitMs = ticketingTourTicket.duration * 60 * 1000;
            var ticketSpentFromLogin = Number(new Date(ticketingOrderedTicket.loginDate)) ? Date.now() - Number(new Date(ticketingOrderedTicket.loginDate)) : 0;
            var ticketTimeLeft = ticketLimitMs - ticketSpentFromLogin;
            // set time is up timeout with popup
            if (ticketTimeLeft > 0) {
                react_toastify_esm/* toast.success */.Am.success("logged in");
                setTimeout(_this.showTicketTimeIsOutPopup, ticketTimeLeft);
                _this.setState({
                    ticketTimeLeftMs: ticketTimeLeft,
                    ticketingOpen: false,
                    tour: tour,
                    ticketing: ticketing
                });
                _this.loadData(tour);
                _this.setWhiteLabel(tour);
                socket/* default.emit */.Z.emit("ticketing_login", {
                    ticketingOrderedTicket: ticketingOrderedTicket,
                    deviceId: (0,utils/* getDeviceFingerprint */.UI)(),
                    reel: tour.slug
                });
            } else {
                react_toastify_esm/* toast.error */.Am.error("wrong ticket time left");
                _this.showTicketTimeIsOutPopup();
            }
        };
        _this.handleTicketingReel = function(reel) {
            try {
                if (_this.state.ticketing && reel.type === "treedis") {
                    var url = new URL(reel.url);
                    var urlPathnameArr = url.pathname.split("/");
                    if (urlPathnameArr[1] === "tour") socket/* default.emit */.Z.emit("ticketing_reel", {
                        reel: urlPathnameArr[2]
                    });
                }
            } catch (err) {
                console.warn("handleTicketingReel", err);
            }
        };
        var _this5 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.startTour = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                _this5.setState({
                    startScreenOn: true
                }, function() {
                    setTimeout(function() {
                        var ref;
                        (ref = document.getElementById("start-screen")) === null || ref === void 0 ? void 0 : ref.remove();
                    }, 500);
                });
                return [
                    2
                ];
            });
        });
        var _this6 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getTour = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var id, _changeMenu, changeMenu, _changeMinimap, changeMinimap, _changePanorama, changePanorama, _url, url, _hideIntroScreen, hideIntroScreen, tourData, bypassCookieCheck, _changeReel, changeReel, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, data, _tmp, ref8, tour, tGen, tour1, ticket, iframeId, s, x, y, menuOpenForDevice, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = param.id, _changeMenu = param.changeMenu, changeMenu = _changeMenu === void 0 ? true : _changeMenu, _changeMinimap = param.changeMinimap, changeMinimap = _changeMinimap === void 0 ? true : _changeMinimap, _changePanorama = param.changePanorama, changePanorama = _changePanorama === void 0 ? true : _changePanorama, _url = param.url, url = _url === void 0 ? null : _url, _hideIntroScreen = param.hideIntroScreen, hideIntroScreen = _hideIntroScreen === void 0 ? false : _hideIntroScreen, tourData = param.tourData, bypassCookieCheck = param.bypassCookieCheck, _changeReel = param.changeReel, changeReel = _changeReel === void 0 ? false : _changeReel;
                            // If the user has not yet accepted cookies, and loadTourAfterCookie is true, do not load tour in background (it will be loaded after cookie is accepted)
                            if ((tourData === null || tourData === void 0 ? void 0 : (ref = tourData.tour) === null || ref === void 0 ? void 0 : ref.cookieIsMandatory) && (tourData === null || tourData === void 0 ? void 0 : (ref1 = tourData.tour) === null || ref1 === void 0 ? void 0 : ref1.loadTourAfterCookie) && !(0,CookieConsent/* allowUsesCookie */.q7)() && !bypassCookieCheck) {
                                ;
                                _this6.setState({
                                    tour: tourData === null || tourData === void 0 ? void 0 : tourData.tour
                                });
                                // Doing this here because we need translations for the cookie popup
                                _this6.initTourInfo(tourData === null || tourData === void 0 ? void 0 : (ref2 = tourData.tour) === null || ref2 === void 0 ? void 0 : ref2.id);
                                return [
                                    2
                                ];
                            }
                            _this6.setState({
                                showcaseLoaded: !changeMenu
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                10,
                                ,
                                11
                            ]);
                            _this6.loadingQueue.setLoadingQueueProgress(90, 100);
                            _tmp = tourData;
                            if (_tmp) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                TreedisPublicDAO/* default.getTour */.Z.getTour({
                                    data: {
                                        id: id,
                                        mode: _this6.state.tourType,
                                        excludeTranslation: true
                                    }
                                })
                            ];
                        case 2:
                            _tmp = _state.sent();
                            _state.label = 3;
                        case 3:
                            data = _tmp;
                            _this6.loadingQueue.setLoadingQueueProgress(85, 100);
                            if (!data || !data.tour) {
                                react_toastify_esm/* toast.error */.Am.error("Couldn't find this tour in our databases");
                                return [
                                    2
                                ];
                            }
                            if (data.tour.fontFamily) {
                                document.documentElement.style.setProperty("--custom-font-family", "".concat(data.tour.fontFamily));
                            }
                            _this6.setWhiteLabel(data.tour);
                            _this6.initTourInfo(data.tour.id);
                            if (data.tour.menuEnabled && changeMenu) {
                                (0,menuService/* fetchMenuData */.g)(data.tour.id).then(function(data) {
                                    _this6.setState({
                                        menuSettings: data.menuSettings,
                                        menus: data.menus
                                    });
                                });
                            }
                            if ((data === null || data === void 0 ? void 0 : (ref3 = data.tour) === null || ref3 === void 0 ? void 0 : ref3.languageCode) === 51 || (data === null || data === void 0 ? void 0 : (ref4 = data.tour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.initialDuplicates) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && ((ref7 = data === null || data === void 0 ? void 0 : (ref6 = data.tour) === null || ref6 === void 0 ? void 0 : ref6.initialDuplicates[0]) === null || ref7 === void 0 ? void 0 : ref7.languageCode) === "fr") {
                                window.localStorage.setItem("rightPriceSymbol", "1");
                            } else {
                                window.localStorage.removeItem("rightPriceSymbol");
                            }
                            if (!(data.ticketing && !_this6.state.iframeUrl)) return [
                                3,
                                4
                            ];
                            tour = new Tour/* Tour */.Oj(data.tour);
                            tGen = data === null || data === void 0 ? void 0 : (ref8 = data.ticketing) === null || ref8 === void 0 ? void 0 : ref8.ticketingGeneral;
                            // if (this.state.game) this.loadData(data.tour);
                            _this6.setState({
                                tour: tour,
                                ticketingOpen: true,
                                ticketing: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.ticketing), {
                                    ticketingGeneral: (tGen === null || tGen === void 0 ? void 0 : tGen.length) ? tGen[0] : tGen
                                }),
                                tourLoaded: true
                            });
                            return [
                                3,
                                9
                            ];
                        case 4:
                            if (!(data.tour.collectLeads && !data.tour.introScreen && !_this6.state.iframeUrl)) return [
                                3,
                                5
                            ];
                            tour1 = new Tour/* Tour */.Oj(data.tour);
                            _this6.setState({
                                tour: tour1,
                                showCollectLeadsModal: true
                            });
                            return [
                                3,
                                9
                            ];
                        case 5:
                            if (!url) return [
                                3,
                                8
                            ];
                            if (data.ticketing && _this6.state.iframeUrl) {
                                ticket = new URLSearchParams(window.location.search).get("ticket");
                                if (!ticket || ticket.length === 0) window.location.href = window.location.href.replace(/tour.*/, "tour/".concat(data.tour.slug));
                            }
                            iframeId = (0,util_all/* getQueryVariable */.Dv)(_this6.state.iframeUrl, "m");
                            s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                            x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                            y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                            if (iframeId !== data.tour.matterId) {
                                _this6.setState({
                                    isChangeIframe: true
                                });
                                // Setting vsObjects to empty if we load another tour
                                _this6.vsObjects = [];
                            }
                            if (hideIntroScreen) {
                                data.tour.introScreen = null;
                            }
                            if (!(iframeId == data.tour.matterId && s && x && y)) return [
                                3,
                                8
                            ];
                            menuOpenForDevice = _this6.state.tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager/* default.isMobile */.Z.isMobile() ? data.tour.menuAlwaysOpenMobile : data.tour.menuAlwaysOpenDesktop);
                            _this6.setState({
                                menuOpen: changeMenu ? menuOpenForDevice : _this6.state.menuOpen,
                                showcaseLoaded: true
                            });
                            if (!_this6.showcase.App.Phase.PLAYING.includes(_this6.state.appState)) return [
                                3,
                                7
                            ];
                            return [
                                4,
                                _this6.moveToSweep(String(s), {
                                    x: parseFloat(x),
                                    y: parseFloat(y)
                                })
                            ];
                        case 6:
                            _state.sent();
                            _state.label = 7;
                        case 7:
                            return [
                                2
                            ];
                        case 8:
                            _this6.loadData(data.tour, changeMenu, changeMinimap, changePanorama, url, changeReel);
                            _state.label = 9;
                        case 9:
                            return [
                                3,
                                11
                            ];
                        case 10:
                            err = _state.sent();
                            console.error(err.message);
                            return [
                                3,
                                11
                            ];
                        case 11:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.initTourInfo = function(id) {
            (0,util_all/* fetchData */.rQ)("public/getTranslations/".concat(id), "GET").then(function(data) {
                _this.setState({
                    translation: data.translations
                });
            }).catch(function(err) {
                console.error(err.message);
            });
            (0,util_all/* fetchData */.rQ)("public/getEmails/".concat(id), "GET").then(function(data) {
                _this.setState({
                    tourEmail: data.emails
                });
            }).catch(function(err) {
                console.error(err.message);
            });
        };
        _this.getTagIconId = function(tag) {
            var iconName = tag.iconFile || (tag.customIcon === "null" || tag.customIcon === null ? null : tag.customIcon);
            var iconSid = tag.sid;
            if (iconName && iconSid) {
                return "".concat(iconName, "_").concat(iconSid);
            }
            return null;
        };
        var _this7 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addMattertag = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                var sid, iconId, rgb, addDetails, addRes, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            sid = null;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                6
                            ]);
                            iconId = _this7.getTagIconId(tag);
                            rgb = util_all/* hexToRgb */.oo(tag.iconColor);
                            addDetails = {
                                label: tag.title,
                                description: tag.description,
                                anchorPosition: {
                                    x: tag.positionX,
                                    y: tag.positionY,
                                    z: tag.positionZ
                                },
                                stemVector: {
                                    x: tag.stemVectorX || 0,
                                    y: tag.stemVectorY == null ? 0.3 : tag.stemVectorY,
                                    z: tag.stemVectorZ || 0
                                },
                                color: {
                                    r: rgb.r / 255,
                                    g: rgb.g / 255,
                                    b: rgb.b / 255
                                },
                                stemVisible: typeof tag.stemVisible === "boolean" ? tag.stemVisible : true
                            };
                            if (iconId) addDetails.iconId = iconId;
                            return [
                                4,
                                _this7.showcase.Tag.add(addDetails).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 2:
                            addRes = _state.sent();
                            if (!(addRes && addRes[0])) return [
                                3,
                                4
                            ];
                            // eslint-disable-next-line prefer-destructuring
                            tag.sid = addRes[0];
                            return [
                                4,
                                _this7.editTagMedia(tag)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2,
                                tag.sid
                            ];
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2,
                                sid
                            ];
                    }
                });
            });
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this8 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.registerIcon = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var iconId, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            iconId = param.iconId, url = param.url;
                            return [
                                4,
                                _this8.showcase.Asset.registerTexture(iconId, url).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this9 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.editTagMedia = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                var ref, tour, label, description, ref1, media, size, ref2, ref3, ref4, addedVideoAttachments, attachmentToRemove, htmlToInject, ref5, sandboxId, _, err, ref6, attachmentId;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tour = _this9.state.tour;
                            if (!tag) return [
                                2
                            ];
                            if (!(tag.opacity !== null && typeof tag.opacity === "number")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this9.showcase.Tag.editOpacity(tag.sid, tag.opacity / 100).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            label = tag.mpTitle ? tag.title : "";
                            description = tag.description;
                            if (!(tag.embedMedia && tag.enabled || (tag === null || tag === void 0 ? void 0 : (ref = tag.media) === null || ref === void 0 ? void 0 : ref.type) === Tag/* TagType.Video */.Qy.Video)) return [
                                3,
                                15
                            ];
                            media = null;
                            size = _this9.isMobile ? {
                                w: tag.widthMobile || 300,
                                h: tag.heightMobile || 400
                            } : {
                                w: tag.width || 700,
                                h: tag.height || 500
                            };
                            if (tag.type === Tag/* TagType.Image */.Qy.Image) {
                                media = {
                                    type: _this9.showcase.Mattertag.MediaType.PHOTO,
                                    src: "".concat("https://cdn.treedis.com", "/tours/").concat(tour === null || tour === void 0 ? void 0 : tour.id, "/tags/").concat(tag.url)
                                };
                            }
                            if (tag.type === Tag/* TagType.Gallery */.Qy.Gallery) {
                            // TODO
                            }
                            if (!(tag.type === Tag/* TagType.Video */.Qy.Video || (tag === null || tag === void 0 ? void 0 : (ref1 = tag.media) === null || ref1 === void 0 ? void 0 : ref1.type) === Tag/* TagType.Video */.Qy.Video)) return [
                                3,
                                10
                            ];
                            if (!((0,util_all/* isVimeoUrl */.QD)(tag.url) && deviceManager/* default.isChrome */.Z.isChrome() && !deviceManager/* default.isIOS */.Z.isIOS())) return [
                                3,
                                3
                            ];
                            // FullScreen mode for this condition is not allow
                            _this9.showcase.Mattertag.injectHTML(tag.sid, '<iframe\n              id="tagvideo"\n              allowFullScreen\n              allow="autoplay; fullscreen"\n              src='.concat((0,util_all/* getVideoLink */.rp)(tag.url, {
                                autoplay: tag.autoPlay
                            }), ' \n              frameBorder="0"\n              style="width: 100%;height: 95%;position: fixed;"\n              scrolling="no"\n            ></iframe>'));
                            return [
                                3,
                                10
                            ];
                        case 3:
                            if (!((tag === null || tag === void 0 ? void 0 : (ref2 = tag.media) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.src) === null || ref3 === void 0 ? void 0 : ref3.includes("yout")) && deviceManager/* default.isChrome */.Z.isChrome())) return [
                                3,
                                9
                            ];
                            addedVideoAttachments = _this9.state.addedVideoAttachments;
                            attachmentToRemove = addedVideoAttachments.filter(function(attachment) {
                                var ref;
                                return (attachment === null || attachment === void 0 ? void 0 : attachment.src) === (tag === null || tag === void 0 ? void 0 : (ref = tag.media) === null || ref === void 0 ? void 0 : ref.src);
                            });
                            htmlToInject = '\n            <style>\n              body {\n                overflow: hidden;\n              }\n              iframe {\n                position: absolute;\n                top: 0;\n                left: 0;\n                width:100%;\n                height:100%;\n              }\n            </style>\n            <iframe height="200px" width="350px" style="overflow: hidden; " id="tagvideo" src="https://www.youtube.com/embed/'.concat((0,data/* getYoutubeId */.qS)(tag === null || tag === void 0 ? void 0 : (ref4 = tag.media) === null || ref4 === void 0 ? void 0 : ref4.src), '"\n             title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>');
                            _state.label = 4;
                        case 4:
                            _state.trys.push([
                                4,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                _this9.showcase.Tag.registerSandbox(htmlToInject)
                            ];
                        case 5:
                            ref5 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), sandboxId = ref5[0], _ = ref5[1];
                            return [
                                4,
                                Promise.all(attachmentToRemove.map(function(attachment) {
                                    return _this9.showcase.Tag.detach(tag.sid, attachment.id);
                                }))
                            ];
                        case 6:
                            _state.sent();
                            _this9.showcase.Tag.attach(tag.sid, sandboxId);
                            return [
                                3,
                                8
                            ];
                        case 7:
                            err = _state.sent();
                            console.log("detach tag", err);
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                3,
                                10
                            ];
                        case 9:
                            media = {
                                type: _this9.showcase.Mattertag.MediaType.VIDEO,
                                src: tag.url
                            };
                            _state.label = 10;
                        case 10:
                            if (tag.type === Tag/* TagType.Iframe */.Qy.Iframe) {
                                _this9.showcase.Mattertag.injectHTML(tag.sid, "<iframe src=".concat(tag.url, ' style="width: 100%; height: 100vh"></iframe>'), {
                                    size: size
                                });
                            }
                            if (tag.type === Tag/* TagType.Text */.Qy.Text) {
                                _this9.showcase.Mattertag.injectHTML(tag.sid, tag.text);
                            }
                            return [
                                4,
                                _this9.showcase.Tag.editBillboard(tag.sid, {
                                    label: label,
                                    description: description
                                }).catch(console.error)
                            ];
                        case 11:
                            _state.sent();
                            if (!media) return [
                                3,
                                14
                            ];
                            return [
                                4,
                                _this9.showcase.Tag.registerAttachment(media.src).catch(console.error)
                            ];
                        case 12:
                            ref6 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                1
                            ]), attachmentId = ref6[0];
                            return [
                                4,
                                _this9.showcase.Tag.attach(tag.sid, attachmentId).catch(console.error)
                            ];
                        case 13:
                            _state.sent();
                            _state.label = 14;
                        case 14:
                            return [
                                3,
                                17
                            ];
                        case 15:
                            return [
                                4,
                                _this9.showcase.Tag.editBillboard(tag.sid, {
                                    label: label,
                                    description: description
                                }).catch(console.error)
                            ];
                        case 16:
                            _state.sent();
                            _state.label = 17;
                        case 17:
                            return [
                                4,
                                _this9.showcase.Tag.allowAction(tag.sid, {
                                    // allow opening: true/false
                                    opening: tag.mpTooltip,
                                    navigating: tag.mpNavigation,
                                    docking: true
                                }).catch(console.error)
                            ];
                        case 18:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this10 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.editMattertag = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                var iconId, rgb, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                9,
                                ,
                                10
                            ]);
                            iconId = _this10.getTagIconId(tag);
                            if (!iconId) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this10.showcase.Tag.editIcon(tag.sid, iconId).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                _this10.showcase.Tag.resetIcon(tag.sid).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                4,
                                _this10.showcase.Tag.editPosition(tag.sid, {
                                    anchorPosition: {
                                        x: tag.positionX,
                                        y: tag.positionY,
                                        z: tag.positionZ
                                    },
                                    stemVector: {
                                        x: tag.stemVectorX || 0,
                                        y: tag.stemVectorY == null ? 0.3 : tag.stemVectorY,
                                        z: tag.stemVectorZ || 0
                                    },
                                    stemVisible: typeof tag.stemVisible === "boolean" ? tag.stemVisible : true
                                })
                            ];
                        case 5:
                            _state.sent();
                            if (!(tag.iconColor && /#\w*/i.test(tag.iconColor))) return [
                                3,
                                7
                            ];
                            rgb = util_all/* hexToRgb */.oo(tag.iconColor);
                            return [
                                4,
                                _this10.showcase.Tag.editColor(tag.sid, {
                                    r: rgb.r / 255,
                                    g: rgb.g / 255,
                                    b: rgb.b / 255
                                }).catch(console.error)
                            ];
                        case 6:
                            _state.sent();
                            _state.label = 7;
                        case 7:
                            return [
                                4,
                                _this10.editTagMedia(tag)
                            ];
                        case 8:
                            _state.sent();
                            return [
                                3,
                                10
                            ];
                        case 9:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                10
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this11 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.processTags = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(_tags) {
                var loadedMattertags, allTags, models, promises;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            loadedMattertags = Mattertag.getMatterTags();
                            allTags = _this11.state.allTags;
                            return [
                                4,
                                _this11.showCaseTemp.showcase.Scene.query([
                                    "model"
                                ])
                            ];
                        case 1:
                            models = _state.sent();
                            promises = _tags.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                                    var ref, ref1, ref2, geometry, material, helperSphere, editedTag, foundAddTag;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                geometry = new _this11.THREE.SphereGeometry(0.1, 32, 16);
                                                material = new _this11.THREE.MeshBasicMaterial({
                                                    color: 0xffff00
                                                });
                                                helperSphere = new _this11.THREE.Mesh(geometry, material);
                                                helperSphere.position.set(tag.positionX + tag.stemVectorX, tag.positionY + tag.stemVectorY, tag.positionZ + tag.stemVectorZ);
                                                helperSphere.visible = false;
                                                models[0].parent.add(helperSphere);
                                                editedTag = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                                                    dummyObject: helperSphere
                                                });
                                                if (!(editedTag.modifiedTag && loadedMattertags.has(tag.sid) || (tag === null || tag === void 0 ? void 0 : (ref = tag.media) === null || ref === void 0 ? void 0 : ref.type) === Tag/* TagType.Video */.Qy.Video && (tag === null || tag === void 0 ? void 0 : (ref1 = tag.media) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.src) === null || ref2 === void 0 ? void 0 : ref2.includes("yout")))) return [
                                                    3,
                                                    2
                                                ];
                                                // modified mp tag
                                                return [
                                                    4,
                                                    _this11.editMattertag(editedTag)
                                                ];
                                            case 1:
                                                _state.sent();
                                                allTags.set(editedTag.sid, editedTag);
                                                return [
                                                    2
                                                ];
                                            case 2:
                                                if (!(!editedTag.modifiedTag && !loadedMattertags.has(tag.sid))) return [
                                                    3,
                                                    4
                                                ];
                                                foundAddTag = Array.from(allTags, function(param) {
                                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                                    return value;
                                                }).find(function(item) {
                                                    return item.id === tag.id && item.added;
                                                });
                                                if (!!foundAddTag) return [
                                                    3,
                                                    4
                                                ];
                                                editedTag.defaultSid = editedTag.sid;
                                                allTags.delete(editedTag.sid);
                                                return [
                                                    4,
                                                    _this11.addMattertag(editedTag)
                                                ];
                                            case 3:
                                                editedTag.sid = _state.sent();
                                                editedTag.added = true;
                                                _state.label = 4;
                                            case 4:
                                                allTags.set(editedTag.sid, editedTag);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(tag) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            return [
                                4,
                                Promise.all(promises)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2,
                                allTags
                            ];
                    }
                });
            });
            return function(_tags) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this12 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initTags = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(_tags) {
                var _loop, tagsSize, i, registerIconsPromises, updatedTags, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            _loop = function(i) {
                                var tag = _tags[i];
                                var iconId = _this12.getTagIconId(tag);
                                if (iconId && !_this12.tagIcons.some(function(icon) {
                                    return (icon === null || icon === void 0 ? void 0 : icon.iconId) === iconId;
                                })) {
                                    var tagIconUrl = void 0;
                                    if (tag.iconFile) {
                                        if (tag.iconFile.startsWith("http")) {
                                            tagIconUrl = "".concat(tag.iconFile);
                                        } else {
                                            tagIconUrl = "".concat("https://cdn.treedis.com", "/tours/").concat(tag.tourId, "/tags/icons/").concat(tag.iconFile);
                                        }
                                    } else if (tag.customIcon) {
                                        tagIconUrl = tag.iconColor ? "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(tag.customIcon, "?hex=").concat(encodeURIComponent(tag.iconColor), "&circle=").concat(tag.whiteCircle) : "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(tag.customIcon);
                                    }
                                    _this12.tagIcons.push({
                                        iconId: iconId,
                                        url: tagIconUrl
                                    });
                                }
                            };
                            if (!_tags.length) {
                                _this12.setState({
                                    loadingTags: false
                                });
                                return [
                                    2,
                                    _tags
                                ];
                            }
                            tagsSize = _tags.length;
                            _this12.tagIcons = [];
                            for(i = 0; i < tagsSize; i += 1)_loop(i);
                            registerIconsPromises = _this12.tagIcons.map(_this12.registerIcon);
                            return [
                                4,
                                Promise.all(registerIconsPromises)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this12.processTags(_tags)
                            ];
                        case 2:
                            updatedTags = _state.sent();
                            // This is gonna block the thread:
                            // const promises = _tags.map(processTags);
                            // const mappedTags = await Promise.all(promises);
                            return [
                                2,
                                updatedTags
                            ];
                        case 3:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_tags) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this13 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addThreadToSpace = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(thread) {
                var allTags;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            allTags = _this13.state.allTags;
                            thread.defaultSid = thread.sid;
                            if ((0,_instanceof/* default */.Z)(allTags, Map)) {
                                allTags.delete(thread.sid);
                            } else {
                                allTags = new Map();
                            }
                            return [
                                4,
                                _this13.addMattertag(thread)
                            ];
                        case 1:
                            thread.sid = _state.sent();
                            thread.isThread = true;
                            thread.messages = [
                                thread.message
                            ];
                            allTags.set(thread.sid, thread);
                            _this13.setState({
                                allTags: allTags
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(thread) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this14 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeThreadFromSpace = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(thread) {
                var allTags, foundThread;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            allTags = _this14.state.allTags;
                            foundThread = Array.from(allTags, function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value;
                            }).find(function(t) {
                                return t.defaultSid === thread.defaultSid || t.defaultSid === thread.sid;
                            });
                            if (!foundThread) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this14.showcase.Tag.remove(foundThread.sid)
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(thread) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.toggleVisibleTags = function(tags, isVisible) {
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            tags.forEach(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(_tag) {
                    var sid, mpTooltip, mpNavigation, preventOpening, preventNavigating;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                sid = _tag.sid, mpTooltip = _tag.mpTooltip, mpNavigation = _tag.mpNavigation;
                                if (!sid) return [
                                    2
                                ];
                                // We shouldn't re-toggle tags that are already visible, waste of sources.
                                if (isVisible && _this1.visibleTags[sid]) return [
                                    2
                                ];
                                if (isVisible) _this1.visibleTags[sid] = true;
                                else _this1.visibleTags[sid] = false;
                                if (!isVisible && _this1.hiddenTags[sid]) return [
                                    2
                                ];
                                if (!isVisible) _this1.hiddenTags[sid] = true;
                                else _this1.hiddenTags[sid] = false;
                                if (!(_tag.type === Tag/* TagType.Music */.Qy.Music && !isVisible)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    audioHandler.pauseAudio(AudioModule/* MusicObjectKey.TAGS */.NO.TAGS, _tag.id)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _this1.showcase.Tag.editOpacity(sid, isVisible ? _tag.opacity / 100 : 0).catch(function(e) {
                                        return console.error(e);
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    _this1.showcase.Tag.editPosition(sid, {
                                        anchorPosition: {
                                            x: _tag.positionX,
                                            y: _tag.positionY,
                                            z: _tag.positionZ
                                        },
                                        stemVector: {
                                            x: isVisible ? _tag.stemVectorX || 0 : 0,
                                            y: isVisible ? _tag.stemVectorY == null ? 0.3 : _tag.stemVectorY : 0,
                                            z: isVisible ? _tag.stemVectorZ || 0 : 0
                                        },
                                        floorIndex: _tag.floor
                                    }).catch(function(e) {
                                        console.error("Error edit position with sid: ".concat(sid));
                                        console.error(e);
                                    })
                                ];
                            case 4:
                                _state.sent();
                                preventOpening = isVisible ? !mpTooltip : true;
                                preventNavigating = isVisible ? !mpNavigation : true;
                                return [
                                    4,
                                    _this1.showcase.Tag.allowAction(sid, {
                                        opening: !preventOpening,
                                        navigating: !preventNavigating,
                                        docking: true
                                    }).catch(function(e) {
                                        return console.error(e);
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_tag) {
                    return _ref.apply(this, arguments);
                };
            }());
        };
        _this.getSweepGroupPolygonIdsToHide = function() {
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, polygons = _state.polygons;
            if (!activeSweepGroup) return [];
            var activeSweepGroupObj = sweepGroups.filter(function(item) {
                return (item === null || item === void 0 ? void 0 : item.id) === activeSweepGroup;
            })[0];
            var activeSweepGroupVsElements = (activeSweepGroupObj === null || activeSweepGroupObj === void 0 ? void 0 : activeSweepGroupObj.vsElements) || [];
            var hidePolygons = activeSweepGroupObj.hidePolygons;
            var polygonIds = activeSweepGroupVsElements.reduce(function(acc, item) {
                if ((item === null || item === void 0 ? void 0 : item.type) === "vsPolygon") {
                    acc.push(item === null || item === void 0 ? void 0 : item.elementId);
                }
                return acc;
            }, []);
            if (!polygonIds.length && !hidePolygons) {
                return [];
            }
            return (polygons || []).reduce(function(acc, item) {
                if (hidePolygons || !polygonIds.includes(item.id) && polygonIds.length) {
                    acc.push(item.id);
                }
                return acc;
            }, []);
        };
        _this.filterPolygon = function() {
            var _state = _this.state, _$tourType = _state.tourType, polygons = _state.polygons, isVSVisible = _state.isVSVisible;
            if (Tour/* TourType.Game */.v.Game === _$tourType) return;
            var sweepGroupElementIdsToHide = _this.getSweepGroupPolygonIdsToHide();
            polygons.forEach(function(polygon) {
                var isVisible = !sweepGroupElementIdsToHide.includes(polygon.id) && !polygon.isHiddenAfterClick && isVSVisible;
                polygon.active = isVisible;
            });
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            _this.setState({
                polygons: polygons
            }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.renderPolygons()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
        };
        _this.filterTags = function() {
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, allTags = _state.allTags, _$tourType = _state.tourType, loadingTags = _state.loadingTags;
            if (Tour/* TourType.Game */.v.Game === _$tourType) return; // we skip filtering if it's game
            if (loadingTags || !sweepGroups.length) return;
            var activeGroup = Array.isArray(sweepGroups) ? sweepGroups.find(function(sg) {
                return sg.id === activeSweepGroup;
            }) : false;
            var tagsToRemove = [];
            var tagsToInit = [];
            if (allTags && allTags.size) {
                allTags.forEach(function(tag) {
                    var ref, ref1;
                    var found = activeGroup === null || activeGroup === void 0 ? void 0 : (ref = activeGroup.tags) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                        return item.tagSid === tag.sid || item.tagSid === tag.defaultSid;
                    });
                    if (!activeGroup || ((ref1 = activeGroup.tags) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 || found) {
                        tagsToInit.push(tag);
                    } else {
                        tagsToRemove.push(tag);
                    }
                });
            }
            _this.toggleVisibleTags(tagsToRemove, false);
            _this.toggleVisibleTags(tagsToInit, true);
        };
        var _this15 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleToggleMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, tour, currentFloor, playAudio, pauseAllMusic, isTourMusicPaused, stopTourMusic, ref, music, e;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state1.trys.push([
                            0,
                            10,
                            ,
                            11
                        ]);
                        _state = _this15.state, tour = _state.tour, currentFloor = _state.currentFloor;
                        playAudio = audioHandler.playAudio, pauseAllMusic = audioHandler.pauseAllMusic, isTourMusicPaused = audioHandler.isTourMusicPaused, stopTourMusic = audioHandler.stopTourMusic;
                        if (!_this15.isTourReadyForAudio()) {
                            return [
                                2
                            ];
                        }
                        pauseAllMusic();
                        if (_this15.state.vsAudio) {
                            _this15.state.vsAudio.component.toggleMute();
                            _this15.state.vsAudio.btn.setActive(true);
                            _this15.setState({
                                vsAudio: null
                            });
                        }
                        if (!isTourMusicPaused()) return [
                            3,
                            7
                        ];
                        if (!(((ref = tour.musics) === null || ref === void 0 ? void 0 : ref.length) > 0 && !tour.sameMusicForAllFloors)) return [
                            3,
                            5
                        ];
                        music = tour.musics.find(function(item) {
                            return item.floor === currentFloor;
                        });
                        if (!(!music || !music.isActive)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            playAudio({
                                type: AudioModule/* MusicObj.TOUR */.nR.TOUR,
                                id: _this15.state.tour.id
                            }).then(function() {
                                _this15.setState({
                                    tourAudioPlaying: !isTourMusicPaused()
                                });
                            })
                        ];
                    case 1:
                        _state1.sent();
                        return [
                            2
                        ];
                    case 2:
                        if (!(music && !tour.sameMusicForAllFloors && music.isActive)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            playAudio({
                                type: AudioModule/* MusicObj.FLOORS */.nR.FLOORS,
                                id: music.id
                            }).then(function() {
                                _this15.setState({
                                    tourAudioPlaying: !isTourMusicPaused()
                                });
                            })
                        ];
                    case 3:
                        _state1.sent();
                        _state1.label = 4;
                    case 4:
                        return [
                            2
                        ];
                    case 5:
                        return [
                            4,
                            playAudio({
                                type: AudioModule/* MusicObj.TOUR */.nR.TOUR,
                                id: _this15.state.tour.id
                            }).then(function() {
                                _this15.setState({
                                    tourAudioPlaying: !isTourMusicPaused()
                                });
                            })
                        ];
                    case 6:
                        _state1.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            stopTourMusic()
                        ];
                    case 8:
                        _state1.sent();
                        _state1.label = 9;
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        e = _state1.sent();
                        return [
                            3,
                            11
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        var _this16 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeFloor = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(floorIndex) {
                var _$all, err;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _$all = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            _this16.setState({
                                panoramaOn: false
                            });
                            return [
                                4,
                                _this16.showCaseTemp.floor.changeFloor(floorIndex, _this16.state.tourPlaying, _$all)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(floorIndex) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this17 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.playTour = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _this17.setState({
                            panoramaOn: false
                        });
                        return [
                            4,
                            _this17.showCaseTemp.tour.playTour(_this17.state.tourPlaying, _this17.state.reelStep)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        var _this18 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeViewMode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(mode) {
                var err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            _this18.setState({
                                panoramaOn: false
                            });
                            return [
                                4,
                                _this18.showCaseTemp.tour.changeViewMode(mode, _this18.state.tourPlaying)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(mode) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this19 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.measurementsMode = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this19.showCaseTemp.tour.measurementsMode(_this19.state.tourPlaying)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.error("Failed to change mode.");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        _this.takePosition = function(event) {
            // ctrl+y
            if (event.ctrlKey && event.keyCode === 89) {
                var _state = _this.state, _tour = _state.tour, slug = _tour.slug, matterId = _tour.matterId;
                takePositionData({
                    slug: slug,
                    matterId: matterId,
                    sweep: _this.pose.sweep,
                    rotation: _this.pose.rotation
                });
            }
        };
        var _this20 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.closeTagPop = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, showcaseLoaded, host, room;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this20.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room;
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("close-tag");
                        }
                        return [
                            4,
                            audioHandler.resumeMusic()
                        ];
                    case 1:
                        _state1.sent();
                        _this20.setState({
                            tagPopOn: false,
                            openedTag: null,
                            closedElementPopup: true
                        });
                        return [
                            2
                        ];
                }
            });
        });
        _this.closeConditionPopUp = function() {
            _this.setState({
                conditionPopUp: null
            });
        };
        _this.closeGameLockPop = function(isCorrect) {};
        var _this21 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeTagIconAndColor = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag, icon, color) {
                var iconId, iconUrl;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            iconId = "".concat(icon, "__").concat(Math.random());
                            iconUrl = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(icon, "?hex=").concat(encodeURIComponent(color));
                            return [
                                4,
                                _this21.showcase.Mattertag.registerIcon(iconId, iconUrl).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this21.showcase.Tag.editIcon(tag.sid, iconId).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tag, icon, color) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.closePanoPop = function() {
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                socket/* default.emit */.Z.emit("close-pano-pop");
            }
            _this.setState({
                panoPopOn: false,
                openedPanoHotspot: null
            });
        };
        var _this22 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.closeActionPop = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, showcaseLoaded, room, host, openedVSAction, vsActionPopOn, vsActionIframeInterupt, vsActionMedia;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this22.state, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host, openedVSAction = _state.openedVSAction, vsActionPopOn = _state.vsActionPopOn;
                        vsActionIframeInterupt = openedVSAction.type === VSObject/* TourActionType.Iframe */.mI.Iframe && !(openedVSAction === null || openedVSAction === void 0 ? void 0 : openedVSAction.dontInterruptBgAudio);
                        vsActionMedia = [
                            VSObject/* TourActionType.Music */.mI.Music,
                            VSObject/* TourActionType.Video */.mI.Video
                        ].includes(openedVSAction.type);
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("close-polygon");
                        }
                        if (!(_this22.state.tourType === Tour/* TourType.Game */.v.Game)) return [
                            3,
                            2
                        ];
                        if (!(vsActionPopOn && (vsActionMedia || vsActionIframeInterupt))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            audioHandler.resumeMusic()
                        ];
                    case 1:
                        _state1.sent();
                        _state1.label = 2;
                    case 2:
                        _this22.setState({
                            vsActionPopOn: false,
                            closedElementPopup: true
                        });
                        return [
                            2
                        ];
                }
            });
        });
        _this.closePathFinderPop = function() {
            _this.setState({
                showPathFinderPopup: false
            });
        };
        _this.showcaseLoad = function() {
            var ref, ref1;
            _this.showcaseLoader((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK);
        };
        var _this23 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveModel = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                var keepRotation, instant, THREE, ref, id, iframeId, linkData, rand, linkDataShort, q, quaternion, euler, rotation, xr, yr, zr, mode, position, euler1, rotation1, scanId, err;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            keepRotation = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, instant = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                13,
                                ,
                                14
                            ]);
                            THREE = _this23.THREE;
                            ref = getUrlVariables(url, _this23.state.iframeUrl), id = ref.id, iframeId = ref.iframeId, linkData = ref.linkData, rand = ref.rand, linkDataShort = ref.linkDataShort;
                            if (!linkData) return [
                                3,
                                5
                            ];
                            q = linkData.camera_quaternion;
                            quaternion = new THREE.Quaternion(q.x, q.y, q.z, q.w);
                            euler = new THREE.Euler().setFromQuaternion(quaternion, "YXZ");
                            rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore
                            if (keepRotation || linkData.showcase_sweep) {
                                rotation = _this23.pose.rotation;
                            }
                            if (!(id && iframeId && (id === null || id === void 0 ? void 0 : id.toLowerCase()) != (iframeId === null || iframeId === void 0 ? void 0 : iframeId.toLowerCase()))) return [
                                3,
                                2
                            ];
                            _this23.iframe.removeEventListener("load", _this23.showcaseLoad);
                            _this23.iframe.addEventListener("load", _this23.showcaseLoad, {
                                once: true
                            });
                            _this23.setState({
                                iframeUrl: "".concat(url, "&qs=").concat(instant ? "1" : "0", "&play=1&newtags=1&refreshid=").concat(rand),
                                panoramaOn: false
                            }, function() {
                                if (_this23.state.room && _this23.state.host) {
                                    socket/* default.emit */.Z.emit("tour_load", {
                                        id: id,
                                        mp: true
                                    });
                                }
                            });
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                _this23.moveToSweep(linkData.scan_id, rotation, instant ? "INSTANT" : "FLY")
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                12
                            ];
                        case 5:
                            if (!linkDataShort) return [
                                3,
                                11
                            ];
                            xr = parseFloat(linkDataShort.sr[0] || "0");
                            yr = parseFloat(linkDataShort.sr[1] || "0");
                            zr = parseFloat(linkDataShort.sr[2] || "0");
                            mode = linkDataShort.sm === 2 ? _this23.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE : linkDataShort.sm === 3 ? _this23.showCaseTemp.showcase.Mode.Mode.FLOORPLAN : null;
                            position = null;
                            if (linkDataShort.sp) {
                                position = {
                                    x: parseFloat(linkDataShort.sp[0] || "0"),
                                    y: parseFloat(linkDataShort.sp[1] || "0"),
                                    z: parseFloat(linkDataShort.sp[2] || "0")
                                };
                            }
                            euler1 = new THREE.Euler().set(xr, yr, zr, "XYZ").reorder("YXZ");
                            rotation1 = new THREE.Vector3(euler1.x, euler1.y, euler1.z).multiplyScalar(180 / Math.PI); // @ts-ignore
                            rotation1.z = 0;
                            if (keepRotation) rotation1 = _this23.pose.rotation;
                            if (!(id && iframeId && id.toLowerCase() != iframeId.toLowerCase())) return [
                                3,
                                6
                            ];
                            _this23.iframe.removeEventListener("load", _this23.showcaseLoad);
                            _this23.iframe.addEventListener("load", _this23.showcaseLoad, {
                                once: true
                            }); // {once} for TB-2675
                            _this23.setState({
                                iframeUrl: "".concat(url, "&qs=").concat(instant ? "1" : "0", "&newtags=1&play=1&refreshid=").concat(rand),
                                panoramaOn: false,
                                activePano: null
                            }, function() {
                                if (_this23.state.room && _this23.state.host) {
                                    socket/* default.emit */.Z.emit("tour_load", {
                                        id: id,
                                        mp: true
                                    });
                                }
                            });
                            return [
                                3,
                                10
                            ];
                        case 6:
                            if (!linkDataShort.ss) return [
                                3,
                                8
                            ];
                            scanId = _this23.state.deprecatedSweeps[linkDataShort.ss - 1].sweep_uuid.replace(/-/g, "");
                            return [
                                4,
                                _this23.moveToSweep(scanId, rotation1, instant ? "INSTANT" : "FLY")
                            ];
                        case 7:
                            _state.sent();
                            return [
                                3,
                                10
                            ];
                        case 8:
                            if (!(linkDataShort.sm && position)) return [
                                3,
                                10
                            ];
                            // move to dollhouse
                            return [
                                4,
                                _this23.showCaseTemp.showcase.Mode.moveTo(mode, (0,_object_spread/* default */.Z)({
                                    position: position,
                                    rotation: rotation1,
                                    transition: instant ? _this23.showCaseTemp.showcase.Mode.TransitionType.INSTANT : _this23.showCaseTemp.showcase.Mode.TransitionType.FLY
                                }, linkDataShort.sz && {
                                    zoom: linkDataShort.sz
                                }))
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            return [
                                3,
                                12
                            ];
                        case 11:
                            if (id && iframeId && id.toLowerCase() != iframeId.toLowerCase()) {
                                _this23.iframe.removeEventListener("load", _this23.showcaseLoad);
                                _this23.iframe.addEventListener("load", _this23.showcaseLoad, {
                                    once: true
                                }); // {once} for TB-2675
                                // for no link data, just simple links
                                _this23.setState({
                                    iframeUrl: "".concat(url, "&qs=1&newtags=1&play=1&refreshid=").concat(rand),
                                    panoramaOn: false,
                                    activePano: null
                                }, function() {
                                    if (_this23.state.room && _this23.state.host) {
                                        socket/* default.emit */.Z.emit("tour_load", {
                                            id: id,
                                            mp: true
                                        });
                                    }
                                });
                            }
                            _state.label = 12;
                        case 12:
                            _this23.setState({
                                overlayOn: false,
                                markerPopupOn: false,
                                panoramaOn: false
                            });
                            return [
                                3,
                                14
                            ];
                        case 13:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                14
                            ];
                        case 14:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.markerClick = function(hotspot) {
            _this.setState({
                minimapOn: false
            }, function() {
                if (hotspot.type === "panorama") {
                    var _state = _this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
                    minimaps[selectedMinimap].hotspots.map(function(h) {
                        hotspot.active = h.id === hotspot.id;
                        return hotspot;
                    });
                    _this.setState({
                        panoramaOn: true,
                        minimaps: minimaps,
                        activePano: hotspot.panoramaId,
                        mapWalkerX: hotspot.x,
                        mapWalkerY: hotspot.y
                    });
                    return;
                }
                if (!hotspot.external) {
                    _this.setState({
                        overlayOn: false
                    });
                    if (hotspot.url) {
                        var whiteLabelData = _this.state.whiteLabelData;
                        var url = hotspot.url;
                        var type = [
                            "my.treedis.com",
                            "test.treedis.com",
                            whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.domainUrl,
                            "localhost:"
                        ].find(function(item) {
                            return url.includes(item);
                        }) ? Menu/* MenuType.Treedis */.o.Treedis : Menu/* MenuType.Matterport */.o.Matterport;
                        _this.loadModel(null, url, type);
                    } else {
                        var ref, ref1;
                        var start = encodeURIComponent(JSON.stringify({
                            camera_mode: 1,
                            scan_id: hotspot.scanId,
                            showcase_sweep: hotspot.showcaseSweep,
                            camera_position: {
                                x: hotspot.positionX,
                                y: hotspot.positionY,
                                z: hotspot.positionZ
                            },
                            camera_quaternion: {
                                x: hotspot.rotationX,
                                y: hotspot.rotationY,
                                z: hotspot.rotationZ,
                                w: hotspot.rotationW
                            }
                        }));
                        _this.moveModel("/mp-sdk/".concat("23.5.1", "/showcase.html?applicationKey=").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK, "&m=").concat(_this.state.tour.matterId, "&start=").concat(start));
                    }
                } else {
                    _this.setState({
                        selectedMarker: {
                            url: hotspot.url,
                            external: hotspot.external
                        },
                        markerPopupOn: true,
                        overlayOn: true
                    });
                }
            });
        };
        _this.releaseLock = function() {
            _this.setState({
                lock: false
            });
        };
        _this.toggleAppointmentsModal = function() {
            _this.setState({
                appointmentsModal: !_this.state.appointmentsModal,
                appointmentsHintOn: false
            });
            _this.toggleExternalPopup();
        };
        _this.handleCustomButton = function() {
            var _state = _this.state, tour = _state.tour, externalPopupOn = _state.externalPopupOn;
            if (tour.customButtonOpenAs === Tour/* CustomButtonTypeOpenAsType.Tab */.Bg.Tab) {
                _this.openNewTab(tour.customButtonUrl);
                return;
            }
            if (externalPopupOn) return;
            _this.setState({
                externalPopupUrl: tour.customButtonUrl,
                externalPopupOn: true
            });
        };
        _this.toggleNav = function() {
            var _state = _this.state, menuOpen = _state.menuOpen, _tour = _state.tour, menuAlwaysOpenMobile = _tour.menuAlwaysOpenMobile, menuAlwaysOpenDesktop = _tour.menuAlwaysOpenDesktop, _$tourType = _state.tourType;
            var menuOpenForDevice = _$tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager/* default.isMobile */.Z.isMobile() ? menuAlwaysOpenMobile : menuAlwaysOpenDesktop);
            _this.setState({
                menuOpen: menuOpenForDevice || !menuOpen,
                menuOpened: true,
                activeMenu: null,
                MenuHintOn: false
            });
        };
        _this.setBaseState = function(obj) {
            _this.setState(obj);
        };
        _this.disableContext = function(e) {
            e.preventDefault();
        };
        var _this24 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.processTourMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var initPlay, _state, currentFloor, tour, music, ref, ref1, ref2, ref3;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        initPlay = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                        _state = _this24.state, currentFloor = _state.currentFloor, tour = _state.tour;
                        music = tour.musics.find(function(item) {
                            return item.floor === currentFloor;
                        });
                        if (!initPlay && audioHandler.isTourMusicPaused() && !(music === null || music === void 0 ? void 0 : music.autoplay)) {
                            return [
                                2
                            ];
                        }
                        if (!(music && !tour.sameMusicForAllFloors && (music === null || music === void 0 ? void 0 : music.isActive))) return [
                            3,
                            4
                        ];
                        if (!music.autoplay) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this24.setState({
                                tourAudioPlaying: !!music.autoplay
                            })
                        ];
                    case 1:
                        _state1.sent();
                        return [
                            4,
                            audioHandler.playAudio({
                                type: AudioModule/* MusicObj.FLOORS */.nR.FLOORS,
                                id: music.id
                            })
                        ];
                    case 2:
                        _state1.sent();
                        _state1.label = 3;
                    case 3:
                        return [
                            2
                        ];
                    case 4:
                        if ((!music || tour.sameMusicForAllFloors) && tour.music) {
                            music = {
                                autoplay: tour.autoplayMusic
                            };
                        }
                        if (!music) return [
                            3,
                            13
                        ];
                        if (!!tour.music) return [
                            3,
                            5
                        ];
                        audioHandler.pauseAllMusic();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            audioHandler.stopAudioByType(AudioModule/* MusicObjectKey.FLOORS */.NO.FLOORS)
                        ];
                    case 6:
                        _state1.sent();
                        _state1.label = 7;
                    case 7:
                        if (!(music.autoplay && !(tour.noAudioMode && _this24.state.room) && // in case of Intro Screen is enables, the music
                        // should play after user clicks on play button
                        !_this24.state.startScreenOn)) return [
                            3,
                            13
                        ];
                        if (!(((ref = _this24.props.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.enabled) && ((ref2 = _this24.props.renderer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.xr) === null || ref3 === void 0 ? void 0 : ref3.isPresenting))) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            _this24.playTourAudio().catch(function() {})
                        ];
                    case 8:
                        _state1.sent();
                        return [
                            3,
                            13
                        ];
                    case 9:
                        if (!deviceManager/* default.supportsTouch */.Z.supportsTouch()) return [
                            3,
                            10
                        ];
                        // we force touch to play music
                        _this24.setState({
                            interacted: false
                        });
                        document.addEventListener("touchstart", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this24.setState({
                                            interacted: true
                                        });
                                        return [
                                            4,
                                            _this24.playTourAudio().catch(function() {})
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }), {
                            once: true
                        });
                        return [
                            3,
                            13
                        ];
                    case 10:
                        if (!(!_this24.state.interacted || deviceManager/* default.isMobile */.Z.isMobile())) return [
                            3,
                            11
                        ];
                        _this24.setState({
                            interacted: false
                        });
                        document.addEventListener("click", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this24.setState({
                                            interacted: true
                                        });
                                        return [
                                            4,
                                            _this24.playTourAudio().catch(function() {})
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }), {
                            once: true
                        });
                        return [
                            3,
                            13
                        ];
                    case 11:
                        return [
                            4,
                            _this24.playTourAudio().catch(function() {})
                        ];
                    case 12:
                        _state1.sent();
                        _state1.label = 13;
                    case 13:
                        return [
                            2
                        ];
                }
            });
        });
        var _this25 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.loadData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tourData) {
                var changeMenu, changeMinimap, changePanorama, url, changeReel, ref, ref1, tour, stateTour, _$tourType, matterStartLocation, importAudioData, s, x, y, ss, sr, m, matterId, addons, menuOpenForDevice, initialDuplicates, _tmp, menuOpen, china;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            changeMenu = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true, changeMinimap = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true, changePanorama = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : true, url = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : null, changeReel = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : false;
                            tour = new Tour/* Tour */.Oj(tourData);
                            stateTour = _this25.state.tour;
                            _$tourType = _this25.state.tourType;
                            matterStartLocation = "";
                            importAudioData = audioHandler.importAudioData;
                            if (!url) return [
                                3,
                                3
                            ];
                            s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                            x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                            y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                            if (!(s && x && y)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,queries/* getSweepIndex */.QM)(tour.matterId, tour.slug, s)
                            ];
                        case 1:
                            ss = _state.sent();
                            sr = "".concat(Number(x) * (Math.PI / 180), ",").concat(Number(y) * (Math.PI / 180));
                            if (sr && ss >= 0) {
                                matterStartLocation = "&ss=".concat(ss, "&sr=").concat(sr);
                            }
                            window.history.replaceState(null, "", _this25.buildLink(s, {
                                x: x,
                                y: y
                            }));
                            _state.label = 2;
                        case 2:
                            return [
                                3,
                                4
                            ];
                        case 3:
                            if (tour.ss && tour.sr) {
                                matterStartLocation = "&ss=".concat(tour.ss, "&sr=").concat(tour.sr);
                            }
                            _state.label = 4;
                        case 4:
                            if (!changeMenu && stateTour) {
                                tour.reel = stateTour.reel;
                                tour.menuEnabled = stateTour.menuEnabled;
                                tour.menuAlwaysOpenMobile = stateTour.menuAlwaysOpenMobile;
                                tour.menuAlwaysOpenDesktop = stateTour.menuAlwaysOpenDesktop;
                            }
                            if (!changePanorama && stateTour) tour.panorama = stateTour.panorama;
                            if (!changeMinimap && (stateTour === null || stateTour === void 0 ? void 0 : stateTour.customMinimap)) {
                                tour.customMinimap = stateTour.customMinimap;
                                tour.minimap = true;
                            }
                            if (changeReel) {
                                tour.reel = tourData.reel;
                            }
                            m = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "m");
                            matterId = m || tour.matterId;
                            if (_this25.state.room) {
                                if (_this25.state.host) {
                                    socket/* default.emit */.Z.emit("tour_load", {
                                        id: matterId,
                                        mp: false
                                    });
                                } else if (matterId !== tour.matterId) {
                                    // if host uses a Tour Link, matterId should be updated with id of next tour
                                    matterId = tour.matterId;
                                }
                            }
                            addons = tour.getAddonsUrl();
                            if (tour.introScreen) {
                                addons = addons.replace(/qs=0/g, "qs=1");
                            }
                            menuOpenForDevice = _$tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager/* default.isMobile */.Z.isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop);
                            if (!(tourData === null || tourData === void 0 ? void 0 : tourData.initialDuplicates)) return [
                                3,
                                5
                            ];
                            _tmp = tourData.initialDuplicates;
                            return [
                                3,
                                7
                            ];
                        case 5:
                            return [
                                4,
                                (ref = TreedisPublicDAO/* default.getDuplicates */.Z.getDuplicates(tour.parentId || tour.id)) === null || ref === void 0 ? void 0 : ref.duplicates
                            ];
                        case 6:
                            _tmp = _state.sent();
                            _state.label = 7;
                        case 7:
                            initialDuplicates = _tmp;
                            menuOpen = changeMenu ? _this25.state.room && !_this25.state.host ? false : tour.menuOnStart || menuOpenForDevice || false : _this25.state.menuOpen;
                            china = util_all/* getQueryVariable */.Dv(window.location.href, "china");
                            _this25.setState({
                                initialDuplicates: initialDuplicates,
                                menuOpen: menuOpen,
                                changeMenu: changeMenu,
                                tour: tour,
                                isVSEnabled: tour.enableVS,
                                allowGuestBeforeHost: tour.allowGuestBeforeHost,
                                minimapVisible: tour.minimapVisible && !_this25.state.room && window.innerWidth > 768,
                                iframeUrl: "/mp-sdk/".concat("23.5.1", "/showcase").concat(china ? "-china" : "", ".html?applicationKey=").concat(tour === null || tour === void 0 ? void 0 : (ref1 = tour.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK, "&m=").concat(matterId).concat(addons).concat(matterStartLocation),
                                appointmentsHintOn: tour.appointmentTooltipOn,
                                MenuHintOn: tour.menuTooltipOn,
                                changeReel: changeReel
                            }, function() {
                                if (_this25.iframe) {
                                    _this25.iframe.removeEventListener("load", _this25.showcaseLoad);
                                    _this25.iframe.addEventListener("load", _this25.showcaseLoad, {
                                        once: true
                                    });
                                }
                                if (tour.disableContext) {
                                    document.addEventListener("contextmenu", _this25.disableContext);
                                }
                                (0,util_all/* fetchData */.rQ)("public/getAgentsContactForm/".concat(tour.id), "GET").then(function(data) {
                                    var agents = data.agents.map(function(a) {
                                        return new Agent/* Agent */.P(a.agent);
                                    });
                                    if (agents && agents.length) _this25.setState({
                                        agents: agents
                                    });
                                }).catch(function(err) {
                                    console.error(err.message);
                                });
                                if (tour.minimap && changeMinimap) {
                                    (0,util_all/* fetchData */.rQ)("public/getMinimaps", "POST", {
                                        id: tour.id
                                    }).then(function(data) {
                                        var minimaps = data.minimaps;
                                        _this25.setState({
                                            minimaps: minimaps,
                                            selectedMinimap: 0
                                        });
                                    }).catch(function(err) {
                                        console.error(err.message);
                                    });
                                }
                                if (tour.panorama && changePanorama) {
                                    (0,util_all/* fetchData */.rQ)("public/getPanoramas", "POST", {
                                        id: tour.id
                                    }).then(function(data) {
                                        var panoramas = data.panoramas;
                                        var pano = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "pano");
                                        var pitch = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoPitch"))) || 0;
                                        var yaw = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoYaw"))) || 0;
                                        var hfov = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoHfov"))) || 0;
                                        _this25.setState({
                                            panoramas: panoramas,
                                            activePano: pano && parseInt(String(pano)),
                                            panoramaOn: tour.panoramaStart || Boolean(pano),
                                            panoPose: {
                                                pitch: pitch,
                                                yaw: yaw,
                                                hfov: hfov
                                            }
                                        });
                                        (panoramas || []).forEach(function(panorama) {
                                            var _$data = ((panorama === null || panorama === void 0 ? void 0 : panorama.hotspots) || []).map(function(hotspot) {
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hotspot), {
                                                    tourId: panorama.tourId,
                                                    panoramaUrl: panorama.url
                                                });
                                            });
                                            importAudioData(AudioModule/* MusicObjectKey.PANORAMAS */.NO.PANORAMAS, _$data);
                                        });
                                    }).catch(function(err) {
                                        console.error(err.message);
                                    });
                                }
                                // Sweeps page is locked for free users
                                if (!_this25.isFreeUser) {
                                    TreedisPublicDAO/* default.getGroups */.Z.getGroups({
                                        id: tour.id
                                    }).then(function(groupsData) {
                                        var ref;
                                        if (groupsData === null || groupsData === void 0 ? void 0 : (ref = groupsData.groups) === null || ref === void 0 ? void 0 : ref.length) _this25.setState({
                                            sweepGroups: groupsData === null || groupsData === void 0 ? void 0 : groupsData.groups
                                        });
                                        importAudioData(AudioModule/* MusicObjectKey.SWEEPGROUPS */.NO.SWEEPGROUPS, groupsData === null || groupsData === void 0 ? void 0 : groupsData.groups);
                                    });
                                }
                                if (tour.gameId) {
                                    (0,util_all/* fetchData */.rQ)("public/getGame", "POST", {
                                        id: tour.gameId
                                    }).then(function(data) {
                                        var ref;
                                        var game = new Game/* Game */.lA(data === null || data === void 0 ? void 0 : data.game);
                                        _this25.gameAnalytic = new GameAnalyticService(game.id);
                                        _this25.setState({
                                            showIntro: game.introClip && (game.introClipUrl || game.uploadedIntroUrl),
                                            gameLoaded: true,
                                            game: game,
                                            showBook: (game === null || game === void 0 ? void 0 : game.gameBookOn) && (game === null || game === void 0 ? void 0 : (ref = game.book) === null || ref === void 0 ? void 0 : ref.openByDefault)
                                        });
                                    }).catch(function(err) {
                                        var ref, ref1, ref2, ref3, ref4;
                                        if (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.message) === null || ref2 === void 0 ? void 0 : ref2.includes("trial")) _this25.setState({
                                            gameTrialErr: err === null || err === void 0 ? void 0 : (ref3 = err.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message
                                        });
                                        console.error(err.message);
                                    });
                                }
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tourData) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.getProducts = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tourId, userId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        []
                    ];
                });
            });
            return function(tourId, userId) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.handleGameStartWithoutIntro = function() {
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, initPolygonsDone = _state.initPolygonsDone;
            if (showcaseLoaded && initPolygonsDone) {
                _this.handleGameStart("", true);
                _this.onIntroScreenFinished();
            } else {
                setTimeout(_this.handleGameStartWithoutIntro, 500);
            }
        };
        var _this26 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.showcaseLoader = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(applicationKey) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, mpLoader, mpPresenter, urlParams, newModelSID, tour, config, auth, showcase, observerMPPassword, setTourBackground, starting, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            mpLoader = (ref = _this26.iframe) === null || ref === void 0 ? void 0 : ref.contentWindow.document.getElementById("loading-powered-by");
                            mpPresenter = (ref1 = _this26.iframe) === null || ref1 === void 0 ? void 0 : ref1.contentWindow.document.getElementById("loading-presented-by");
                            if (mpLoader) mpLoader.style.display = "none";
                            if (mpPresenter) mpPresenter.style.display = "none";
                            urlParams = new URLSearchParams((ref2 = _this26.iframe) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contentWindow) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.location) === null || ref4 === void 0 ? void 0 : ref4.search);
                            newModelSID = urlParams.get("m");
                            if (newModelSID != (0,util_all/* getQueryVariable */.Dv)(_this26.state.iframeUrl, "m")) {
                                _this26.setState({
                                    iframeUrl: _this26.state.iframeUrl.replace(/(m=).*?(&)/, "$1".concat(newModelSID, "$2"))
                                });
                                console.log("iframeUrl", _this26.state.iframeUrl);
                                return [
                                    2
                                ];
                            }
                            tour = _this26.state.tour;
                            config = {
                                applicationKey: applicationKey || "295ba0c0f04541318359a8e75af33043",
                                appDomain: "https://api.treedis.com" || 0,
                                version: "23.5.1",
                                logoUrl: ((ref5 = _this26.state.whiteLabelData) === null || ref5 === void 0 ? void 0 : ref5.active) ? (ref6 = _this26.state.whiteLabelData) === null || ref6 === void 0 ? void 0 : ref6.logo : defaultLogo,
                                appAws: "https://cdn.treedis.com",
                                matterId: tour.matterId
                            };
                            auth = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "auth");
                            if (((ref7 = tour.user) === null || ref7 === void 0 ? void 0 : ref7.oauth) && tour.oauthAccess) {
                                config.auth = tour.user.oauthToken;
                            } else if (auth) {
                                config.auth = auth;
                            }
                            return [
                                4,
                                (0,dist/* GetSDK */.xe)(_this26.iframe, config)
                            ];
                        case 1:
                            showcase = _state.sent();
                            // to make the "copy position" work if focus is on the iframe
                            return [
                                4,
                                _this26.iframe.contentWindow.document.addEventListener("keydown", _this26.takePosition)
                            ];
                        case 2:
                            _state.sent();
                            observerMPPassword = (0,util/* setMPPasswordFormObserver */.v2)(_this26.iframe.contentWindow.document.body, function() {
                                _this26.iframe.style.zIndex = 999999;
                            }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    _this26.setState({
                                        waitLoadingPolygons: true
                                    });
                                    _this26.iframe.style.zIndex = "inherit";
                                    return [
                                        2
                                    ];
                                });
                            }));
                            setTourBackground = function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(models, threeInstance) {
                                    var tour, background, url, texture;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                tour = _this26.state.tour;
                                                background = null;
                                                if (!((tour === null || tour === void 0 ? void 0 : tour.background) && utils/* color.isHex */.$_.isHex(tour.background))) return [
                                                    3,
                                                    1
                                                ];
                                                background = new threeInstance.Color(tour.background);
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 1:
                                                if (!(tour === null || tour === void 0 ? void 0 : tour.backgroundImage)) return [
                                                    3,
                                                    3
                                                ];
                                                url = "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/").concat(tour.backgroundImage);
                                                return [
                                                    4,
                                                    new threeInstance.TextureLoader().load(url)
                                                ];
                                            case 2:
                                                texture = _state.sent();
                                                texture.wrapS = threeInstance.RepeatWrapping;
                                                texture.wrapT = threeInstance.RepeatWrapping;
                                                texture.repeat.set(1, 1);
                                                background = texture;
                                                _state.label = 3;
                                            case 3:
                                                if (background) {
                                                    models[0].parent.children[1].material = new threeInstance.ShadowMaterial();
                                                    models[0].parent.background = background;
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function setTourBackground(models, threeInstance) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            _this26.showcase = showcase.showcase;
                            _this26.showCaseTemp = showcase;
                            _this26.loadedShowcaseHandler();
                            _this26.showCaseTemp.on(dist/* TourLoaderEventsType.LOADING */.$D.LOADING, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var models;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _this26.loadingQueue.setLoadingQueueProgress(80, 100);
                                            observerMPPassword && observerMPPassword.disconnect();
                                            return [
                                                4,
                                                _this26.showCaseTemp.showcase.Scene.query([
                                                    "model"
                                                ])
                                            ];
                                        case 1:
                                            models = _state.sent();
                                            _this26.camera = models[0].parent.children[0].camera;
                                            return [
                                                4,
                                                _this26.showCaseTemp.scene.configureThreeInstance()
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                4,
                                                (0,dist/* iTHREE */.Sc)()
                                            ];
                                        case 3:
                                            _this26.THREE = _state.sent();
                                            return [
                                                4,
                                                _this26.showCaseTemp.mpSDK.Scene.configure(function(renderer) {
                                                    var ref, ref1, ref2, ref3;
                                                    _this26.renderer = renderer;
                                                    _this26.rendererRef.current = renderer;
                                                    _this26.renderer.domElement = _this26.iframe.contentWindow.document.getElementsByClassName("webgl-canvas")[0];
                                                    (ref = _this26.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("sessionstart", function() {
                                                        var ref;
                                                        base/* asyncStore.vrIsOn */.k6.vrIsOn = true;
                                                        if (!_this26.SceneVRCameraController) _this26.SceneVRCameraController = new VRCameraController(_this26.THREE, _this26.renderer, _this26.camera, _this26.cameraPose);
                                                        if (_this26.matterTagMeshComponents.length) _this26.matterTagMeshComponents.forEach(function(tag) {
                                                            tag.inputs.visible = true;
                                                        });
                                                        if ((ref = _this26.renderer) === null || ref === void 0 ? void 0 : ref.xr) {
                                                            var controllerL = _this26.renderer.xr.getController(1);
                                                            if (controllerL) controllerL.addEventListener("connected", function(event) {
                                                                _this26.gamepadLRef.current = event.data.gamepad;
                                                            });
                                                            var controllerR = _this26.renderer.xr.getController(0);
                                                            if (controllerR) controllerL.addEventListener("connected", function(event) {
                                                                _this26.gamepadRRef.current = event.data.gamepad;
                                                            });
                                                        }
                                                    });
                                                    (ref2 = _this26.renderer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.xr) === null || ref3 === void 0 ? void 0 : ref3.addEventListener("sessionend", function() {
                                                        base/* asyncStore.vrIsOn */.k6.vrIsOn = false;
                                                        if (_this26.matterTagMeshComponents.length) _this26.matterTagMeshComponents.forEach(function(tag) {
                                                            tag.inputs.visible = false;
                                                        });
                                                    });
                                                })
                                            ];
                                        case 4:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }));
                            starting = false;
                            _this26.showCaseTemp.on(dist/* TourLoaderEventsType.STARTING */.$D.STARTING, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var models;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            starting = true;
                                            _this26.initStarting();
                                            return [
                                                4,
                                                _this26.showCaseTemp.showcase.Scene.query([
                                                    "model"
                                                ])
                                            ];
                                        case 1:
                                            models = _state.sent();
                                            _this26.camera = models[0].parent.children[0].camera;
                                            return [
                                                4,
                                                _this26.showCaseTemp.scene.configureThreeInstance()
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                4,
                                                (0,dist/* iTHREE */.Sc)()
                                            ];
                                        case 3:
                                            _this26.THREE = _state.sent();
                                            setTourBackground(models, _this26.THREE);
                                            return [
                                                4,
                                                _this26.showCaseTemp.mpSDK.Scene.configure(function(renderer) {
                                                    var ref, ref1, ref2, ref3;
                                                    _this26.renderer = renderer;
                                                    _this26.rendererRef.current = renderer;
                                                    _this26.renderer.domElement = _this26.iframe.contentWindow.document.getElementsByClassName("webgl-canvas")[0];
                                                    (ref = _this26.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("sessionstart", function() {
                                                        var ref;
                                                        base/* asyncStore.vrIsOn */.k6.vrIsOn = true;
                                                        if (!_this26.SceneVRCameraController) _this26.SceneVRCameraController = new VRCameraController(_this26.THREE, _this26.renderer, _this26.camera, _this26.cameraPose);
                                                        if (_this26.matterTagMeshComponents.length) _this26.matterTagMeshComponents.forEach(function(tag) {
                                                            tag.inputs.visible = true;
                                                        });
                                                        if ((ref = _this26.renderer) === null || ref === void 0 ? void 0 : ref.xr) {
                                                            var controllerL = _this26.renderer.xr.getController(1);
                                                            if (controllerL) controllerL.addEventListener("connected", function(event) {
                                                                _this26.gamepadLRef.current = event.data.gamepad;
                                                            });
                                                            var controllerR = _this26.renderer.xr.getController(0);
                                                            if (controllerR) controllerL.addEventListener("connected", function(event) {
                                                                _this26.gamepadRRef.current = event.data.gamepad;
                                                            });
                                                        }
                                                    });
                                                    (ref2 = _this26.renderer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.xr) === null || ref3 === void 0 ? void 0 : ref3.addEventListener("sessionend", function() {
                                                        base/* asyncStore.vrIsOn */.k6.vrIsOn = false;
                                                        if (_this26.matterTagMeshComponents.length) _this26.matterTagMeshComponents.forEach(function(tag) {
                                                            tag.inputs.visible = false;
                                                        });
                                                    });
                                                })
                                            ];
                                        case 4:
                                            _state.sent();
                                            _this26.loadingQueue.setLoadingQueueProgress(80, 100);
                                            observerMPPassword && observerMPPassword.disconnect();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }));
                            _this26.showCaseTemp.on(dist/* TourLoaderEventsType.PLAYING */.$D.PLAYING, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, models, watchErrorElem, watchTagPanelElem;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!!starting) return [
                                                3,
                                                5
                                            ];
                                            return [
                                                4,
                                                _this26.showCaseTemp.showcase.Scene.query([
                                                    "model"
                                                ])
                                            ];
                                        case 1:
                                            models = _state.sent();
                                            _this26.camera = models[0].parent.children[0].camera;
                                            return [
                                                4,
                                                (0,dist/* iTHREE */.Sc)()
                                            ];
                                        case 2:
                                            // TODO test for errors in different tour types
                                            _this26.THREE = _state.sent();
                                            setTourBackground(models, _this26.THREE);
                                            return [
                                                4,
                                                _this26.showCaseTemp.scene.configureThreeInstance()
                                            ];
                                        case 3:
                                            _state.sent();
                                            return [
                                                4,
                                                _this26.initStarting()
                                            ];
                                        case 4:
                                            _state.sent();
                                            _state.label = 5;
                                        case 5:
                                            _this26.initPlaying();
                                            _this26.initScene();
                                            _this26.initSweep();
                                            if (_this26.state.tourTransitionLoader) {
                                                _this26.setState({
                                                    panoramaOn: false,
                                                    tourTransitionLoader: false
                                                });
                                            }
                                            if (!(!deviceManager/* default.isMobile */.Z.isMobile() && (((ref = _this26.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.enterprise) || ((ref2 = _this26.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.subscription) === (User/* UserSubscription.Business */.MX.Business || User/* UserSubscription.Enterprise */.MX.Enterprise)))) return [
                                                3,
                                                7
                                            ];
                                            return [
                                                4,
                                                _this26.initVRPointer()
                                            ];
                                        case 6:
                                            _state.sent();
                                            _this26.initPathFinderMesh();
                                            _state.label = 7;
                                        case 7:
                                            watchErrorElem = (ref4 = _this26.iframe) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.contentWindow) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.document) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.body) === null || ref7 === void 0 ? void 0 : ref7.querySelector("#error-container");
                                            (0,util/* setErrorObserver */.D2)(watchErrorElem, function(pageCrashed, observer) {
                                                _this26.setState({
                                                    crashScreen: pageCrashed
                                                });
                                                observer.disconnect();
                                            });
                                            watchTagPanelElem = _this26.iframe.contentWindow.document.body.querySelector(".side-panel-right");
                                            if (!deviceManager/* default.isMobile */.Z.isMobile() && _this26.state.tour.mpTagDockSide === (Tour/* TagDockSideType */.tP === null || Tour/* TagDockSideType */.tP === void 0 ? void 0 : Tour/* TagDockSideType.Left */.tP.Left)) {
                                                (0,util/* setTagPanelObserver */.p$)(watchTagPanelElem, function(isTagPanelOpen, observer) {
                                                    var hasStyle = _this26.iframe.contentWindow.document.head.querySelector("#override-matterport");
                                                    if (isTagPanelOpen && !hasStyle) {
                                                        var style = document.createElement("style");
                                                        style.id = "override-matterport";
                                                        style.innerHTML = "\n                .webgl-canvas {\n                  left: 375px !important;\n                }\n                .side-panel-right {\n                  position: absolute !important;\n                }\n              ";
                                                        _this26.iframe.contentWindow.document.head.appendChild(style);
                                                        _this26.setState({
                                                            hideLogo: true
                                                        });
                                                    } else if (hasStyle) {
                                                        var style1 = _this26.iframe.contentWindow.document.head.querySelector("#override-matterport");
                                                        style1.innerHTML = "\n                .webgl-canvas {\n                  transition: left .5s !important;\n                  left: 0 !important;\n                }\n                .side-panel-right {\n                  position: absolute !important;\n                }\n              ";
                                                        _this26.setState({
                                                            hideLogo: false
                                                        });
                                                        setTimeout(function() {
                                                            style1.remove();
                                                        }, 500); // closing animation duration is .5s
                                                    }
                                                });
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }));
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            console.error(e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(applicationKey) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.filterSweepGroupVsElementsByTourVsElement = function(vsElements, vsElement) {
            var ref;
            if ((0,_instanceof/* default */.Z)(vsElement, VSObject/* TourImage */.oP)) {
                var ref1;
                var vsImageIds = vsElements.filter(function(item) {
                    return item.type === "vsImage";
                }).map(function(param) {
                    var elementId = param.elementId;
                    return elementId;
                });
                if (!vsImageIds.length) return true;
                return !!vsImageIds.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref1 = vsElement.details) === null || ref1 === void 0 ? void 0 : ref1.id);
            }
            if ((0,_instanceof/* default */.Z)(vsElement, VSObject/* TourVideo */.Up)) {
                var ref2;
                var vsVideoIds = vsElements.filter(function(item) {
                    return item.type === "vsVideo";
                }).map(function(param) {
                    var elementId = param.elementId;
                    return elementId;
                });
                if (!vsVideoIds.length) return true;
                return !!vsVideoIds.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref2 = vsElement.details) === null || ref2 === void 0 ? void 0 : ref2.id);
            }
            var vsObjectsIds = vsElements.filter(function(item) {
                return item.type === "vsObject";
            }).map(function(param) {
                var elementId = param.elementId;
                return elementId;
            });
            if (!vsObjectsIds.length) return true;
            return !!vsObjectsIds.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref = vsElement.details) === null || ref === void 0 ? void 0 : ref.id);
        };
        _this.isGameTour = function() {
            var _state = _this.state, _$tourType = _state.tourType, tour = _state.tour;
            return _$tourType === Tour/* TourType.Game */.v.Game && tour.gameId;
        };
        _this.isSweepGroupVsVisible = function(vsElement, sweepGroupElementIdsToHide) {
            var ref;
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups;
            if (sweepGroupElementIdsToHide.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref = vsElement.details) === null || ref === void 0 ? void 0 : ref.id)) return false;
            var response = (sweepGroups || []).find(function(item) {
                return item.id === activeSweepGroup;
            });
            return _this.filterSweepGroupVsElementsByTourVsElement((response === null || response === void 0 ? void 0 : response.vsElements) || [], vsElement);
        };
        _this.hasSweepGroupElements = function() {
            var sweepGroups = _this.state.sweepGroups;
            var elementIds = sweepGroups.reduce(function(acc, param) {
                var _vsElements = param.vsElements, vsElements = _vsElements === void 0 ? [] : _vsElements;
                return acc.concat(vsElements);
            }, []).map(function(item) {
                return item === null || item === void 0 ? void 0 : item.elementId;
            });
            return elementIds.length > 0;
        };
        _this.sortVsItemsByType = function(vsItems) {
            var images = [];
            var videos = [];
            var objects = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // eslint-disable-next-line no-restricted-syntax
                for(var _iterator = vsItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    if ((item === null || item === void 0 ? void 0 : item.type) === "vsVideo") {
                        videos.push(item === null || item === void 0 ? void 0 : item.elementId);
                    }
                    if ((item === null || item === void 0 ? void 0 : item.type) === "vsImage") {
                        images.push(item === null || item === void 0 ? void 0 : item.elementId);
                    }
                    if ((item === null || item === void 0 ? void 0 : item.type) === "vsObject") {
                        objects.push(item === null || item === void 0 ? void 0 : item.elementId);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                images,
                videos,
                objects
            ];
        };
        _this.getSweepGroupElementIdsToHide = function() {
            var _state = _this.state, sweepGroups = _state.sweepGroups, activeSweepGroup = _state.activeSweepGroup;
            if (!activeSweepGroup) return [];
            var activeSweepGroupObj = sweepGroups.filter(function(item) {
                return (item === null || item === void 0 ? void 0 : item.id) === activeSweepGroup;
            })[0];
            var activeSweepGroupVsElements = activeSweepGroupObj === null || activeSweepGroupObj === void 0 ? void 0 : activeSweepGroupObj.vsElements;
            var hideVSImages = activeSweepGroupObj.hideVSImages, hideVSVideos = activeSweepGroupObj.hideVSVideos, hideVSObjects = activeSweepGroupObj.hideVSObjects;
            var ref = (0,_sliced_to_array/* default */.Z)(_this.sortVsItemsByType(activeSweepGroupVsElements), 3), tmp = ref[0], imageIds = tmp === void 0 ? [] : tmp, tmp1 = ref[1], videoIds = tmp1 === void 0 ? [] : tmp1, tmp2 = ref[2], objectIds = tmp2 === void 0 ? [] : tmp2;
            if (!imageIds.length && !videoIds.length && !objectIds.length && !hideVSImages && !hideVSVideos && !hideVSObjects) {
                return [];
            }
            return _this.vsObjects.map(function(item) {
                if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && (hideVSVideos || !videoIds.includes(item.vsVideoId) && videoIds.length)) {
                    return item.vsVideoId;
                }
                if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && (hideVSImages || !imageIds.includes(item.vsImageId) && imageIds.length)) {
                    return item.vsImageId;
                }
                if ((0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && (hideVSObjects || !objectIds.includes(item.vsObjectId) && objectIds.length)) {
                    return item.vsObjectId;
                }
            }).filter(function(item) {
                return !!item;
            });
        };
        // 0 - current item, 1 forward, -1 backward, 2 not found
        _this.pathHasElement = function(id, type) {
            var ref, ref1, ref2;
            var paths = (((ref = _this.state) === null || ref === void 0 ? void 0 : ref.game) || {}).paths;
            var currentPathItem = base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.currentPathStep */.k6.currentPathStep;
            if (!(base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath) && !paths) return;
            var activePathLock = paths[base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath];
            var searchingPathItem = activePathLock === null || activePathLock === void 0 ? void 0 : (ref1 = activePathLock.paths) === null || ref1 === void 0 ? void 0 : ref1.find(function(e) {
                return e.locationType === type && e.locationItem === id;
            });
            if (!currentPathItem || currentPathItem.locationItem === id && currentPathItem.locationType === type) {
                return [
                    0,
                    searchingPathItem
                ];
            }
            var pathItemsArray = [];
            var nextItem = activePathLock === null || activePathLock === void 0 ? void 0 : activePathLock.paths.find(function(e) {
                return !e.triggerType || e.triggerType === -1 || e.triggerType === "-1";
            });
            var cyclesLeft = (activePathLock === null || activePathLock === void 0 ? void 0 : (ref2 = activePathLock.paths) === null || ref2 === void 0 ? void 0 : ref2.length) || 0;
            while(nextItem && !!cyclesLeft){
                pathItemsArray.push(nextItem);
                nextItem = activePathLock === null || activePathLock === void 0 ? void 0 : activePathLock.paths.find(function(e) {
                    return e.triggerType === (nextItem === null || nextItem === void 0 ? void 0 : nextItem.locationType) && e.triggerItem === (nextItem === null || nextItem === void 0 ? void 0 : nextItem.locationItem);
                });
                cyclesLeft--;
            }
            var pathItemsArrayIds = pathItemsArray.map(function(e) {
                return "".concat(e.locationItem).concat(e.locationType);
            });
            var currentItemIndex = pathItemsArrayIds.indexOf("".concat(currentPathItem.locationItem).concat(currentPathItem.locationType));
            var itemsAfter = pathItemsArrayIds.splice(currentItemIndex + 1, pathItemsArrayIds.length - currentItemIndex);
            var itemsBefore = pathItemsArrayIds.splice(0, currentItemIndex);
            if (itemsBefore.includes("".concat(id).concat(type))) {
                return [
                    -1,
                    searchingPathItem
                ];
            }
            if (itemsAfter.includes("".concat(id).concat(type))) {
                return [
                    1,
                    searchingPathItem
                ];
            }
            return [
                2,
                searchingPathItem
            ];
        };
        _this.vsObjectHiddenByPathLock = function(vsObject) {
            var ref, ref1;
            var paths = (((ref = _this.state) === null || ref === void 0 ? void 0 : ref.game) || {}).paths;
            if (!(base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath) && !paths) return;
            var activePathLock = paths[base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath];
            var sId = (ref1 = vsObject.id) === null || ref1 === void 0 ? void 0 : ref1.toString();
            var type = (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourObject */.zB) ? "vsObject" : (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up) ? "vsVideo" : (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP) ? "vsImage" : null;
            var ref2 = (0,_sliced_to_array/* default */.Z)(_this.pathHasElement(sId, type), 2), elementPosition = ref2[0], pathElement = ref2[1];
            if ((activePathLock === null || activePathLock === void 0 ? void 0 : activePathLock.hideItems) && elementPosition === 1 || (pathElement === null || pathElement === void 0 ? void 0 : pathElement.hideStep) && elementPosition === -1) {
                return true;
            }
            return false;
        };
        _this.polygonHiddenByPathLock = function(polygon) {
            var ref, ref1, ref2;
            var paths = (((ref = _this.state) === null || ref === void 0 ? void 0 : ref.game) || {}).paths;
            var pathItemsMap = {}; // id: {type, hideStep}
            if (!(base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath) && !paths) return;
            var activePathLock = paths[base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath];
            activePathLock === null || activePathLock === void 0 ? void 0 : (ref1 = activePathLock.paths) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(l) {
                pathItemsMap[l.locationItem] = {
                    type: l.locationType,
                    hideStep: l.hideStep
                };
            });
            var sId = (ref2 = polygon.id) === null || ref2 === void 0 ? void 0 : ref2.toString();
            if (pathItemsMap[sId] && pathItemsMap[sId].type === "polygon" && (pathItemsMap[sId].hideStep === true || (activePathLock === null || activePathLock === void 0 ? void 0 : activePathLock.hideItems))) {
                return true;
            }
            return false;
        };
        var _this27 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.subscribeToStartTriggerVSAfterAnimation = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(vsObject) {
                var ref, ref1, activateSubscriber, activateSubscriber1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if ((ref = vsObject.node) === null || ref === void 0 ? void 0 : ref.mixer) {
                        activateSubscriber = (vsObject === null || vsObject === void 0 ? void 0 : vsObject.active) && (vsObject === null || vsObject === void 0 ? void 0 : vsObject.animated) && !(vsObject === null || vsObject === void 0 ? void 0 : vsObject.loop);
                        if (!activateSubscriber) return [
                            2
                        ];
                        vsObject.node.mixer.addEventListener("finished", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this27.renderVSAfterAnimation(vsObject)
                                        ];
                                    case 1:
                                        _state.sent();
                                        if (!vsObject.node.inputs.hideOnAnimationFinished) return [
                                            3,
                                            3
                                        ];
                                        return [
                                            4,
                                            _this27.setVSVisible(vsObject, false)
                                        ];
                                    case 2:
                                        _state.sent();
                                        vsObject.videoPlayedOnce = true;
                                        _state.label = 3;
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    } else if ((ref1 = vsObject.node) === null || ref1 === void 0 ? void 0 : ref1.video) {
                        activateSubscriber1 = (vsObject === null || vsObject === void 0 ? void 0 : vsObject.active) && !(vsObject === null || vsObject === void 0 ? void 0 : vsObject.loop);
                        if (!activateSubscriber1) return [
                            2
                        ];
                        vsObject.node.video.addEventListener("ended", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this27.renderVSAfterAnimation(vsObject)
                                        ];
                                    case 1:
                                        _state.sent();
                                        if (!vsObject.node.inputs.hideOnAnimationFinished) return [
                                            3,
                                            3
                                        ];
                                        return [
                                            4,
                                            _this27.setVSVisible(vsObject, false)
                                        ];
                                    case 2:
                                        _state.sent();
                                        vsObject.videoPlayedOnce = true;
                                        _state.label = 3;
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    }
                    return [
                        2
                    ];
                });
            });
            return function(vsObject) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this28 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.renderVSAfterAnimation = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(animatedVSObject) {
                var filteredVsObjects;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    filteredVsObjects = _this28.vsObjects;
                    filteredVsObjects.forEach(function(vsObject) {
                        if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP)) {
                            var afterAnimationId = null;
                            if ((0,_instanceof/* default */.Z)(animatedVSObject, VSObject/* TourObject */.zB)) {
                                afterAnimationId = vsObject.toursVSObjectIdAfterAnimation;
                            } else if ((0,_instanceof/* default */.Z)(animatedVSObject, VSObject/* TourVideo */.Up)) {
                                afterAnimationId = vsObject.toursVSVideoIdAfterAnimation;
                            }
                            if (afterAnimationId === animatedVSObject.id) {
                                _this28.setVSVisible(vsObject, true);
                            }
                        }
                    });
                    return [
                        2
                    ];
                });
            });
            return function(animatedVSObject) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this29 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.renderVS = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(currentSweep) {
                var ref, ref1, ref2, ref3, ref4, _state, isVSVisible, tour, blockRender, THREE, pose, sweepGroupElementIdsToHide, filteredVsObjects, ref5, vsImagesToHide, vsItemsToHide, vsVideosToHide, vsHTMLsToHide;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    _state = _this29.state, isVSVisible = _state.isVSVisible, tour = _state.tour;
                    blockRender = _this29.state.tourMode === _this29.showCaseTemp.showcase.Mode.Mode.OUTSIDE || currentSweep.mode === _this29.showCaseTemp.showcase.Mode.Mode.OUTSIDE || currentSweep.mode === _this29.showCaseTemp.showcase.Mode.Mode.TRANSITIONING || _this29.state.tourMode === _this29.showCaseTemp.showcase.Mode.Mode.TRANSITIONING;
                    if (!currentSweep || blockRender) {
                        return [
                            2
                        ];
                    }
                    if (!isVSVisible) {
                        _this29.loadingQueue.setFullLoadingQueueProgress();
                        return [
                            2
                        ];
                    }
                    THREE = _this29.THREE;
                    if (!THREE) return [
                        2
                    ];
                    pose = new THREE.Vector3(currentSweep === null || currentSweep === void 0 ? void 0 : (ref = currentSweep.position) === null || ref === void 0 ? void 0 : ref.x, currentSweep === null || currentSweep === void 0 ? void 0 : (ref1 = currentSweep.position) === null || ref1 === void 0 ? void 0 : ref1.y, currentSweep === null || currentSweep === void 0 ? void 0 : (ref2 = currentSweep.position) === null || ref2 === void 0 ? void 0 : ref2.z);
                    sweepGroupElementIdsToHide = _this29.getSweepGroupElementIdsToHide();
                    filteredVsObjects = _this29.vsObjects;
                    if (_this29.isGameTour()) {
                        ref5 = _this29.filterVsElementsByGameCondition(), vsImagesToHide = ref5.vsImagesToHide, vsItemsToHide = ref5.vsItemsToHide, vsVideosToHide = ref5.vsVideosToHide, vsHTMLsToHide = ref5.vsHTMLsToHide;
                        filteredVsObjects = _this29.vsObjects.filter(function(item) {
                            return (0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && !vsImagesToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && !vsItemsToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && !vsVideosToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVSHtml */.q8) && !vsHTMLsToHide.includes(item.id);
                        });
                    }
                    (ref3 = _this29.pathFinderMeshComponent) === null || ref3 === void 0 ? void 0 : ref3.setVisible(false);
                    (ref4 = _this29.menuMeshComponent) === null || ref4 === void 0 ? void 0 : ref4.setVisible(false);
                    // if its a game we load everything regardless of radius or sensor.=
                    filteredVsObjects.forEach(function(vsObject) {
                        var ref;
                        if (_this29.vsObjectHiddenByPathLock(vsObject)) return;
                        var assetPose = new THREE.Vector3(vsObject.positionX, vsObject.positionY, vsObject.positionZ);
                        // Multiply by 0.2 because 1 three.js unit is approximately 20cm
                        var distance = pose.distanceTo(assetPose) * 0.2;
                        var inRange = distance <= ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.renderRange) || ((ref = _this29.state.tour) === null || ref === void 0 ? void 0 : ref.vsRenderRange) || DEFAULT_VS_SENSOR_RADIUS);
                        var startAnimationDistance = (vsObject === null || vsObject === void 0 ? void 0 : vsObject.startAnimationDistance) || tour.vsAnimationDistance;
                        var isVisibleVsItems = _this29.isSweepGroupVsVisible(vsObject, sweepGroupElementIdsToHide);
                        if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.toursVSObjectIdAfterAnimation) || (vsObject === null || vsObject === void 0 ? void 0 : vsObject.toursVSVideoIdAfterAnimation)) {
                            // skip it here, renderVSAfterAnimation will render it when time comes...
                            return;
                        }
                        if (inRange && isVisibleVsItems) {
                            _this29.loadingQueue.enqueue(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var ref, loadedObjects, ref1, err;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                _this29.setVSVisible(vsObject, true)
                                            ];
                                        case 1:
                                            _state.sent();
                                            loadedObjects = (0,_to_consumable_array/* default */.Z)(_this29.vsObjects).filter(function(object) {
                                                return object.node && object.node.outputs.loadingState === "Loaded";
                                            });
                                            return [
                                                4,
                                                _this29.setState({
                                                    loadedObjects: loadedObjects
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.node) && (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up) && vsObject.node.video) {
                                                if (distance <= startAnimationDistance && vsObject.node.video.autoplay) {
                                                    if ((vsObject.node.video.paused || !vsObject.node.isLoaded) && !_this29.state.startScreenOn) {
                                                        vsObject.node.play();
                                                    }
                                                } else if (distance > startAnimationDistance && vsObject.node.isLoaded && !vsObject.node.video.paused) {
                                                    ;
                                                    (ref1 = vsObject.node) === null || ref1 === void 0 ? void 0 : ref1.pause();
                                                }
                                            } else if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.node) && (((ref = vsObject.details) === null || ref === void 0 ? void 0 : ref.isGLTF) || (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP))) {
                                                vsObject.node.animate = distance <= startAnimationDistance;
                                            }
                                            _this29.loadingQueue.dequeue();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            err = _state.sent();
                                            console.error(err);
                                            _this29.loadingQueue.dequeue();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }));
                        } else if (vsObject.node) {
                            _this29.setVSVisible(vsObject, false);
                        }
                    });
                    if (_this29.hasSweepGroupElements() && !filteredVsObjects.filter(function(vsObject) {
                        return _this29.isSweepGroupVsVisible(vsObject, sweepGroupElementIdsToHide);
                    }).length) {
                        _this29.loadingQueue.setFullLoadingQueueProgress();
                    }
                    return [
                        2
                    ];
                });
            });
            return function(currentSweep) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.handleShowNearestProduct = function(state) {
            _this.setState({
                isShowNearestProducts: state,
                nearestProducts: []
            });
        };
        _this.fixMatterportTagScrollBug = function() {
            // Matterport text tags don't scroll until the end on iOS Chrome
            setTimeout(function() {
                if (deviceManager/* default.isMobile */.Z.isMobile() && deviceManager/* default.isIOS */.Z.isIOS() && deviceManager/* default.isChrome */.Z.isChrome()) {
                    var ref, ref1;
                    var tagPanel = (ref = _this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.document.querySelector(".tag-view-panel-header");
                    tagPanel === null || tagPanel === void 0 ? void 0 : tagPanel.style.setProperty("padding-bottom", "120px");
                }
            }, 500);
        };
        var _this30 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPlaying = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, tour, loadedOnce, iframeUrl, ref, ref1, ref2, vrOverlay, iframeVrButton, matterId, url, s, x, y, newState;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                _state = _this30.state, tour = _state.tour, loadedOnce = _state.loadedOnce, iframeUrl = _state.iframeUrl;
                _this30.setState({
                    appState: "playing"
                });
                if (deviceManager/* default.isMobile */.Z.isMobile() && !deviceManager/* default.isDesktop */.Z.isDesktop()) {
                    ;
                    vrOverlay = (ref = _this30.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.getElementById("vr-overlay-layer");
                    if (vrOverlay) {
                        iframeVrButton = vrOverlay.querySelector('[role="button"]');
                        if (iframeVrButton) iframeVrButton.style.display = "none";
                    }
                }
                matterId = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m");
                url = window.location.href;
                s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                if (s && x && y) {
                    // We move inside the tour
                    _this30.moveToSweep(String(s), {
                        x: parseFloat(x),
                        y: parseFloat(y)
                    });
                }
                if (!loadedOnce) {
                    (0,analytic/* startGA */.Rj)(tour, true);
                }
                _this30.pathFinderLine = new ScenePathFinderLine(_this30.showCaseTemp, _this30.camera, _this30.currentSweep, _this30.setActionPathNavbarVisible, _this30.updateActionPathNavbar, _this30.isGameTour() ? null : _this30.pathArrowRefBaseTour, _this30.moveToSweep);
                newState = {
                    loadedOnce: true
                };
                // TODO:: Remove when Matterport will fix problem with current floor
                if (matterId === "VE4rJCNFfba") newState.currentFloor = 1;
                _this30.setState(newState, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var ref, hash, polygons, err;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (tour.addon_ts >= 0 && tour.mpPlay) {
                                    setTimeout(function() {
                                        _this30.playTour();
                                    }, tour.addon_ts * 1000);
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                hash = window.location.hash.substring(1);
                                if (hash) {
                                    _this30.loadModel(null, null, Menu/* MenuType.Product */.o.Product, hash, null);
                                }
                                if (!_this30.isTourReadyForAudio()) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this30.processTourMusic(true)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                polygons = _this30.state.polygons;
                                if (!(((ref = _this30.vsObjects) === null || ref === void 0 ? void 0 : ref.length) > 0 || (polygons === null || polygons === void 0 ? void 0 : polygons.length) > 0 || (tour === null || tour === void 0 ? void 0 : tour.enableAvatar))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this30.showCaseTemp.scene.configureScene({
                                        settings: _this30.state.vsSettings,
                                        onShadowEnabled: function(value) {
                                            _this30.isShadowEnabled = value;
                                        },
                                        onShadowNodeCreated: function(shadowNode) {
                                            _this30.shadowNode = shadowNode;
                                        },
                                        cb: function() {
                                            _this30.setState({
                                                isVSReady: true
                                            }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                _this30.showCaseTemp.showcase.Scene.register(virtualStaging_avatar/* avatarComponentType */.bB, virtualStaging_avatar/* makeAvatarComponent */.Sr)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            if (!((polygons === null || polygons === void 0 ? void 0 : polygons.length) || ((ref = _this30.vsObjects) === null || ref === void 0 ? void 0 : ref.length))) return [
                                                                3,
                                                                5
                                                            ];
                                                            if (!(polygons === null || polygons === void 0 ? void 0 : polygons.length)) return [
                                                                3,
                                                                3
                                                            ];
                                                            return [
                                                                4,
                                                                _this30.initPolygons()
                                                            ];
                                                        case 2:
                                                            _state.sent();
                                                            _state.label = 3;
                                                        case 3:
                                                            if (!((ref13 = _this30.vsObjects) === null || ref13 === void 0 ? void 0 : ref13.length)) return [
                                                                3,
                                                                5
                                                            ];
                                                            return [
                                                                4,
                                                                _this30.initVS()
                                                            ];
                                                        case 4:
                                                            _state.sent();
                                                            _state.label = 5;
                                                        case 5:
                                                            return [
                                                                4,
                                                                _this30.initAvatar()
                                                            ];
                                                        case 6:
                                                            _state.sent();
                                                            if (!(!deviceManager/* default.isMobile */.Z.isMobile() && _this30.isGameTour() && (((ref1 = _this30.state.tour) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : ref2.enterprise) || ((ref3 = _this30.state.tour) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.user) === null || ref4 === void 0 ? void 0 : ref4.subscription) === (User/* UserSubscription.Business */.MX.Business || User/* UserSubscription.Enterprise */.MX.Enterprise)))) return [
                                                                3,
                                                                10
                                                            ];
                                                            if (!((ref14 = _this30.state.game) === null || ref14 === void 0 ? void 0 : ref14.backpackOn)) return [
                                                                3,
                                                                8
                                                            ];
                                                            return [
                                                                4,
                                                                _this30.initBackpackMesh()
                                                            ];
                                                        case 7:
                                                            _state.sent();
                                                            _state.label = 8;
                                                        case 8:
                                                            return [
                                                                4,
                                                                _this30.initPathFinderMesh()
                                                            ];
                                                        case 9:
                                                            _state.sent();
                                                            _state.label = 10;
                                                        case 10:
                                                            return [
                                                                4,
                                                                _this30.initVRPointer()
                                                            ];
                                                        case 11:
                                                            _state.sent();
                                                            if (!((ref5 = _this30.iframe) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.contentWindow) === null || ref6 === void 0 ? void 0 : ref6.location.href.includes("m=y9vZoA57wQs"))) return [
                                                                3,
                                                                13
                                                            ];
                                                            return [
                                                                4,
                                                                initPipes(_this30.showCaseTemp, _this30.modelNodes, _this30.state.polygons, _this30.renderer)
                                                            ];
                                                        case 12:
                                                            _this30.pipesData = _state.sent();
                                                            _state.label = 13;
                                                        case 13:
                                                            console.log((ref7 = _this30.iframe) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.contentWindow) === null || ref8 === void 0 ? void 0 : ref8.location.href.includes("m=cKEUCfKQmHn"), (ref9 = _this30.iframe) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.contentWindow) === null || ref10 === void 0 ? void 0 : ref10.location.href);
                                                            if (!((ref11 = _this30.iframe) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.contentWindow) === null || ref12 === void 0 ? void 0 : ref12.location.href.includes("m=cKEUCfKQmHn"))) return [
                                                                3,
                                                                15
                                                            ];
                                                            return [
                                                                4,
                                                                initPipesAmericanWater(_this30.showCaseTemp, _this30.modelNodes, _this30.state.polygons, _this30.renderer)
                                                            ];
                                                        case 14:
                                                            _this30.pipesData = _state.sent();
                                                            _state.label = 15;
                                                        case 15:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }));
                                        }
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                err = _state.sent();
                                console.error(err);
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }));
                return [
                    2
                ];
            });
        });
        _this.setActionPathNavbarVisible = function(visible) {
            _this.setState({
                showActionPathBar: visible
            });
        };
        _this.updateActionPathNavbar = function() {
            var ref;
            if ((ref = _this.pathFinderLine.targetObjectData) === null || ref === void 0 ? void 0 : ref.autoNavigation) {
                _this.setState({
                    actionPathNavbarButtonText: _this.pathFinderLine.inAutoNavigate ? "Pause" : "Play"
                });
            } else _this.setState({
                actionPathNavbarButtonText: _this.state.translation.next || "Next"
            });
        };
        var _this31 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initStarting = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, _state, tour, _$tourType, showcaseLoaded, isChangeIframe, iframeUrl, startScreenOn, isHideTags, condition, matterId, importAudioData, volumeHandler, auth, tagsRes, _tmp, mpTags, treedisTags, threads, isMatterportLink, ref1, polygons, vsObjects, vsSettings, _tmp1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, THREE, pose, isVisibleAsset, err;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state1.trys.push([
                            0,
                            8,
                            ,
                            9
                        ]);
                        _this31.setState({
                            appState: "starting"
                        });
                        _state = _this31.state, tour = _state.tour, _$tourType = _state.tourType, showcaseLoaded = _state.showcaseLoaded, isChangeIframe = _state.isChangeIframe, iframeUrl = _state.iframeUrl, startScreenOn = _state.startScreenOn;
                        isHideTags = tour.addon_hidetags;
                        condition = _$tourType === Tour/* TourType.Game */.v.Game ? true : !showcaseLoaded || isChangeIframe;
                        matterId = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m");
                        importAudioData = audioHandler.importAudioData, volumeHandler = audioHandler.volumeHandler;
                        if (!condition) return [
                            2
                        ];
                        return [
                            4,
                            volumeHandler(tour.audioVolume)
                        ];
                    case 1:
                        _state1.sent();
                        _this31.yAxisVec3 = new _this31.THREE.Vector3(0, 1, 0);
                        _this31.loadingQueue.setLoadingQueueProgress(70, 100);
                        auth = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "auth");
                        if (((ref = tour.user) === null || ref === void 0 ? void 0 : ref.oauth) && tour.oauthAccess) {
                            auth = null; // disregard auth if oauth is enabled on tour
                        }
                        if (!!isHideTags) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.getTags */.Z.getTags({
                                matterId: matterId,
                                slug: matterId === tour.matterId ? tour.slug : null,
                                auth: auth
                            })
                        ];
                    case 2:
                        _tmp = _state1.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _tmp = {};
                        _state1.label = 4;
                    case 4:
                        tagsRes = _tmp;
                        // TODO check with MP!!!
                        // const mpTags = !isHideTags? await new Promise((resolve) => {
                        //   this.showcase.Tag.data.subscribe({
                        //     onCollectionUpdated(collection) {
                        //       const modifiedCollection = {}
                        //       Object.keys(collection).map((item) => {
                        //         const tag = collection[item]
                        //         modifiedCollection[tag.id] = {
                        //           newColor: tag.color,
                        //           color: tag.color.r? rgbToHex(tag.color.r, tag.color.g, tag.color.b) : tag.color, //rgb is decimal numbers??? Why??
                        //           description: tag.description,
                        //           sid: tag.id,
                        //           label: tag.label,
                        //           position: tag.anchorPosition,
                        //           stem: {
                        //             direction: tag.stemVector,
                        //             enabled: tag.stemEnabled
                        //           }
                        //         }
                        //       })
                        //       return resolve(modifiedCollection);
                        //     }
                        //   });
                        // }) : {};
                        // console.log("MP Tags loaded showcase vs legacy API", mpTags, tagsRes.matterTags)
                        if (isHideTags) {
                            _this31.setState({
                                loadingTags: false
                            });
                        }
                        mpTags = tagsRes === null || tagsRes === void 0 ? void 0 : tagsRes.matterTags;
                        treedisTags = tagsRes === null || tagsRes === void 0 ? void 0 : tagsRes.tags;
                        threads = (tour === null || tour === void 0 ? void 0 : tour.isThreadsEnabled) ? tagsRes === null || tagsRes === void 0 ? void 0 : tagsRes.threads : [];
                        _this31.loadingQueue.setLoadingQueueProgress(60, 100);
                        isMatterportLink = (0,util_all/* getQueryVariable */.Dv)(_this31.state.iframeUrl, "m") !== tour.matterId;
                        if (!_this31.isFreeUser) return [
                            3,
                            5
                        ];
                        _tmp1 = {
                            polygons: [],
                            vsObjects: [],
                            vsSettings: {}
                        };
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            (0,queries/* getVSItems */.BZ)(isMatterportLink, {
                                slug: tour.slug,
                                userId: tour.userId,
                                id: tour.id,
                                tourType: _$tourType
                            })
                        ];
                    case 6:
                        _tmp1 = _state1.sent();
                        _state1.label = 7;
                    case 7:
                        ref1 = _tmp1, polygons = ref1.polygons, vsObjects = ref1.vsObjects, vsSettings = ref1.vsSettings;
                        if (tour.patchIconEnabled && tour.patchIcon) {
                            _this31.initPatch("".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/").concat(tour.patchIcon));
                        }
                        importAudioData(AudioModule/* MusicObjectKey.VSIMAGES */.NO.VSIMAGES, vsObjects.filter(function(item) {
                            return (0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP);
                        }).map(function(el) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                                tourId: tour.id
                            });
                        }));
                        importAudioData(AudioModule/* MusicObjectKey.TAGS */.NO.TAGS, treedisTags);
                        importAudioData(AudioModule/* MusicObjectKey.TOUR */.NO.TOUR, [
                            tour
                        ]);
                        importAudioData(AudioModule/* MusicObjectKey.FLOORS */.NO.FLOORS, tour.musics);
                        _this31.setState({
                            allAudio: audioHandler.getAllMusicData()
                        });
                        _this31.loadingQueue.setLoadingQueueProgress(50, 100);
                        _this31.setState({
                            allTags: new Map(),
                            polygons: polygons,
                            vsSettings: vsSettings
                        }, function() {
                            Mattertag.subscribe({
                                mpSdk: _this31.showCaseTemp.showcase,
                                mpTags: mpTags,
                                treedisTags: treedisTags,
                                threads: threads
                            }, function(allTags) {
                                console.log("Setting tags...", allTags.size);
                                _this31.setState({
                                    allTags: allTags
                                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    var ref, ref1, ref2, ref3, ref4, ref5, _$allTags, tags;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _$allTags = _this31.state.allTags;
                                                return [
                                                    4,
                                                    _this31.initTags(Array.from(_$allTags.values()))
                                                ];
                                            case 1:
                                                tags = _state.sent();
                                                if (!deviceManager/* default.isMobile */.Z.isMobile() && ((ref = _this31.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.enabled) && (((ref2 = _this31.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.enterprise) || ((ref4 = _this31.state.tour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : ref5.subscription) === (User/* UserSubscription.Business */.MX.Business || User/* UserSubscription.Enterprise */.MX.Enterprise))) {
                                                    _this31.hasMeshTags = true;
                                                    _this31.initVRTags(tags);
                                                }
                                                _this31.setState({
                                                    loadingTags: false,
                                                    allTags: tags
                                                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                    var ref, ref1, tmConfig, alarms, rules, liveTags, err;
                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                _state.trys.push([
                                                                    0,
                                                                    4,
                                                                    ,
                                                                    5
                                                                ]);
                                                                _this31.hiddenTags = {};
                                                                _this31.visibleTags = {};
                                                                _this31.filterTags();
                                                                if (!(tour.matterId === "EqYHR4sjN3M" || tour.matterId === "SSfUe8iZLK1")) return [
                                                                    3,
                                                                    3
                                                                ];
                                                                return [
                                                                    4,
                                                                    TreedisPublicDAO/* default.getTwinMakerConfig */.Z.getTwinMakerConfig(tour.slug, {
                                                                        bucket: tour.matterId === "EqYHR4sjN3M" ? "twinmaker-workspace-matterportdemo-208209543890-iad" : "twinmaker-workspace-edgelabworkspace-204246732561-dub",
                                                                        key: tour.matterId === "EqYHR4sjN3M" ? "MatterportScene.json" : "Treedis-Vodafone.json"
                                                                    })
                                                                ];
                                                            case 1:
                                                                tmConfig = _state.sent();
                                                                alarms = {};
                                                                rules = tmConfig.data.rules;
                                                                liveTags = [];
                                                                return [
                                                                    4,
                                                                    Promise.all((ref = tmConfig.data) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : ref1.map(function() {
                                                                        var _ref = (0,_async_to_generator/* default */.Z)(function(node) {
                                                                            var ref, ref1, ref2, ref3, ref4, ref5, tagComponent, overlayComponent, tag, ruleId;
                                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                                switch(_state.label){
                                                                                    case 0:
                                                                                        tagComponent = (ref = node.components) === null || ref === void 0 ? void 0 : ref.filter(function(component) {
                                                                                            return component.type === "Tag";
                                                                                        })[0];
                                                                                        overlayComponent = (ref1 = node.components) === null || ref1 === void 0 ? void 0 : ref1.filter(function(component) {
                                                                                            return component.type === "DataOverlay";
                                                                                        })[0];
                                                                                        if (!tagComponent || !tagComponent.valueDataBinding || tagComponent.valueDataBinding.length === 0) return [
                                                                                            2
                                                                                        ]; // not a live tag
                                                                                        if (!overlayComponent || !overlayComponent.valueDataBindings || overlayComponent.valueDataBindings.length === 0) return [
                                                                                            2
                                                                                        ]; // not a live tag with overlay
                                                                                        tag = {
                                                                                            title: node.name,
                                                                                            enabled: true,
                                                                                            mpTitle: true,
                                                                                            mpTooltip: true,
                                                                                            mpNavigation: true,
                                                                                            iconColor: "#0000FF",
                                                                                            positionX: (ref2 = node.transform) === null || ref2 === void 0 ? void 0 : ref2.position[0],
                                                                                            positionY: (ref3 = node.transform) === null || ref3 === void 0 ? void 0 : ref3.position[1],
                                                                                            positionZ: (ref4 = node.transform) === null || ref4 === void 0 ? void 0 : ref4.position[2],
                                                                                            description: (ref5 = overlayComponent === null || overlayComponent === void 0 ? void 0 : overlayComponent.dataRows[0]) === null || ref5 === void 0 ? void 0 : ref5.content.replace(/#/g, "").replace(/\*\*/g, "")
                                                                                        };
                                                                                        return [
                                                                                            4,
                                                                                            _this31.addMattertag(tag)
                                                                                        ];
                                                                                    case 1:
                                                                                        tag.sid = _state.sent();
                                                                                        _this31.showcase.Tag.editStem(tag.sid, {
                                                                                            stemVisible: false
                                                                                        }).catch(console.error);
                                                                                        tag.overlay = overlayComponent.valueDataBindings[0];
                                                                                        liveTags.push(tag);
                                                                                        console.log("liveTag added", tag);
                                                                                        ruleId = tagComponent.ruleBasedMapId;
                                                                                        if (ruleId) alarms[tag.sid] = ruleId;
                                                                                        return [
                                                                                            2
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                        return function(node) {
                                                                            return _ref.apply(this, arguments);
                                                                        };
                                                                    }()))
                                                                ];
                                                            case 2:
                                                                _state.sent();
                                                                setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        liveTags.map(function() {
                                                                            var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                                                                                var ref, ref1, ref2, ref3, ref4, ref5, tmData, replacedValue;
                                                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                                                    switch(_state.label){
                                                                                        case 0:
                                                                                            return [
                                                                                                4,
                                                                                                TreedisPublicDAO/* default.getTwinMakerData */.Z.getTwinMakerData(tour.slug, {
                                                                                                    workspaceId: tour.matterId === "EqYHR4sjN3M" ? "MatterportDemo" : "EdgeLabWorkspace",
                                                                                                    entityId: (ref = tag.overlay) === null || ref === void 0 ? void 0 : ref.valueDataBinding.dataBindingContext.entityId,
                                                                                                    componentName: (ref1 = tag.overlay) === null || ref1 === void 0 ? void 0 : ref1.valueDataBinding.dataBindingContext.componentName,
                                                                                                    propertyName: (ref2 = tag.overlay) === null || ref2 === void 0 ? void 0 : ref2.valueDataBinding.dataBindingContext.propertyName
                                                                                                })
                                                                                            ];
                                                                                        case 1:
                                                                                            tmData = _state.sent();
                                                                                            replacedValue = tag.description.replace("${".concat((ref3 = tag.overlay) === null || ref3 === void 0 ? void 0 : ref3.bindingName, "}"), (ref4 = tmData.data) === null || ref4 === void 0 ? void 0 : ref4.doubleValue);
                                                                                            _this31.showcase.Tag.editBillboard(tag.sid, {
                                                                                                label: tag.title,
                                                                                                description: replacedValue
                                                                                            }).catch(console.error);
                                                                                            (ref5 = rules[alarms[tag.sid]]) === null || ref5 === void 0 ? void 0 : ref5.statements.map(function(statement) {
                                                                                                var ref = _this31.extractAWSRule(statement.expression), comparator = ref.comparator, value = ref.value;
                                                                                                if (comparator(tmData.data.doubleValue, value)) {
                                                                                                    var color = "#0000FF";
                                                                                                    if (statement.target === "iottwinmaker.common.icon:Warning") {
                                                                                                        color = "#FFA500";
                                                                                                    }
                                                                                                    if (statement.target === "iottwinmaker.common.icon:Error") {
                                                                                                        color = "#FF0000";
                                                                                                    }
                                                                                                    var rgb = util_all/* hexToRgb */.oo(color);
                                                                                                    _this31.showcase.Tag.editColor(tag.sid, {
                                                                                                        r: rgb.r / 255,
                                                                                                        g: rgb.g / 255,
                                                                                                        b: rgb.b / 255
                                                                                                    }).catch(console.error);
                                                                                                }
                                                                                            });
                                                                                            return [
                                                                                                2
                                                                                            ];
                                                                                    }
                                                                                });
                                                                            });
                                                                            return function(tag) {
                                                                                return _ref.apply(this, arguments);
                                                                            };
                                                                        }());
                                                                        return [
                                                                            2
                                                                        ];
                                                                    });
                                                                }), 5000);
                                                                _state.label = 3;
                                                            case 3:
                                                                return [
                                                                    3,
                                                                    5
                                                                ];
                                                            case 4:
                                                                err = _state.sent();
                                                                console.error(err);
                                                                return [
                                                                    3,
                                                                    5
                                                                ];
                                                            case 5:
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }));
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }));
                            });
                            if (_$tourType === Tour/* TourType.Game */.v.Game && !tour.introScreen) {
                                _this31.handleGameStartWithoutIntro();
                            }
                            _this31.setState({
                                isChangeIframe: false,
                                showcaseLoaded: true
                            });
                        });
                        _this31.vsObjects = vsObjects.filter(function(obj) {
                            return obj.active;
                        }); // TODO: move to backend..
                        // if no VS objects, Media Images of Media Videos found - loadingQueueProgress is set to 100%
                        // to do not display the loading indicator for VS
                        if (!_this31.vsObjects.length || !startScreenOn) {
                            // if there is no intro screen, we don't wait for VS!
                            _this31.loadingQueue.setFullLoadingQueueProgress();
                        } else if (_this31.pose) {
                            ;
                            THREE = _this31.THREE;
                            pose = new THREE.Vector3((ref2 = _this31.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.x, (ref4 = _this31.pose) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.position) === null || ref5 === void 0 ? void 0 : ref5.y, (ref6 = _this31.pose) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.position) === null || ref7 === void 0 ? void 0 : ref7.z);
                            isVisibleAsset = _this31.vsObjects.find(function(asset) {
                                var assetPose = new THREE.Vector3(asset.positionX, asset.positionY, asset.positionZ);
                                // Multiply by 0.2 because 1 three.js unit is approximately 20cm
                                var distance = pose.distanceTo(assetPose) * 0.2;
                                return distance <= (tour.vsRenderRange || DEFAULT_VS_SENSOR_RADIUS);
                            });
                            if (!isVisibleAsset || ((ref8 = _this31.pose) === null || ref8 === void 0 ? void 0 : ref8.mode) === _this31.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
                                _this31.loadingQueue.setFullLoadingQueueProgress();
                            } else {
                                _this31.renderVS(_this31.pose);
                            }
                        }
                        return [
                            3,
                            9
                        ];
                    case 8:
                        err = _state1.sent();
                        console.error(err);
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        _this.extractAWSRule = function(statement) {
            // Extracting the attribute name
            var attributeNameRegex = /^([a-zA-Z0-9_]+)\s/;
            var attributeNameMatch = statement.match(attributeNameRegex);
            var attribute = attributeNameMatch ? attributeNameMatch[1] : null;
            // Extracting the numerical value and comparison operator
            var comparisonRegex = /[<>=!]=?\s?([0-9.]+)/;
            var comparisonMatch = statement.match(comparisonRegex);
            var comparisonOperator = comparisonMatch ? statement.match(/[<>=!]=?/)[0] : null;
            var numericalValue = comparisonMatch ? comparisonMatch[1] : null;
            // Convert comparisonOperator to an actual comparator
            var comparator;
            switch(comparisonOperator){
                case ">":
                    comparator = function(a, b) {
                        return a > b;
                    };
                    break;
                case ">=":
                    comparator = function(a, b) {
                        return a >= b;
                    };
                    break;
                case "<":
                    comparator = function(a, b) {
                        return a < b;
                    };
                    break;
                case "<=":
                    comparator = function(a, b) {
                        return a <= b;
                    };
                    break;
                case "==":
                    comparator = function(a, b) {
                        return a === b;
                    };
                    break;
                case "!=":
                    comparator = function(a, b) {
                        return a !== b;
                    };
                    break;
                default:
                    console.error("Invalid comparison operator:", comparisonOperator);
                    break;
            }
            return {
                attribute: attribute,
                comparator: comparator,
                value: parseFloat(numericalValue)
            };
        };
        var _this32 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initSweep = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                _this32.showCaseTemp.sweep.subscribe(function(sweeps) {
                    _this32.setState({
                        sweeps: sweeps,
                        sweepsLoaded: true
                    }, function() {
                        return afterSweepsInit({
                            sweeps: _this32.state.sweeps,
                            matterId: _this32.state.tour.matterId,
                            slug: _this32.state.tour.slug,
                            iframeUrl: _this32.state.iframeUrl,
                            setData: function(data) {
                                _this32.setState(data);
                            },
                            cb: function() {
                                var s = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "s");
                                var x = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "x");
                                var y = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "y");
                                if (_this32.pose.mode === _this32.showCaseTemp.showcase.Mode.Mode.INSIDE && s && x && y) {
                                    if (_this32.state.sweeps.some(function(sweep) {
                                        return s === sweep.uuid;
                                    })) {
                                        _this32.moveToSweep(String(s), {
                                            x: parseFloat(x),
                                            y: parseFloat(y)
                                        });
                                    }
                                }
                            }
                        });
                    });
                });
                return [
                    2
                ];
            });
        });
        var _this33 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initScene = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                _this33.showCaseTemp.tag.on(dist/* TagEventsType.OpenTagIframe */.Gc.OpenTagIframe, function(data) {
                    var event = data.event, tagId = data.tagId;
                    if (event === _this33.showCaseTemp.tags.matterTag.Event.CLICK) {
                        _this33.setState({
                            clickedElement: {
                                id: tagId,
                                type: Game/* EntityType.Tag */.py.Tag
                            }
                        });
                    }
                });
                _this33.showCaseTemp.scene.sceneObject.on(dist/* NodeEventsTypes.OBJECT_HOVER */.cA.OBJECT_HOVER, function(param) {
                    var data = param.data, eventData = param.eventData;
                    if (_this33.VRPointer.component) {
                        var ref;
                        var isLockSolution = false;
                        if ((ref = _this33.state.game) === null || ref === void 0 ? void 0 : ref.locks) {
                            _this33.state.game.locks.forEach(function(lock) {
                                var ref;
                                if (lock.locationType === Game/* LockLocationType.vsItem */.A.vsItem && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                    return +id === data.id;
                                }))) {
                                    isLockSolution = true;
                                }
                            });
                        }
                        if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution) && eventData.hover) {
                            _this33.VRPointer.component.setVisible(true);
                            _this33.VRPointer.target = data.node;
                        } else _this33.VRPointer.component.setVisible(false);
                    }
                });
                _this33.showCaseTemp.scene.sceneObject.on(dist/* NodeEventsTypes.OBJECT_CLICK */.cA.OBJECT_CLICK, function(param) {
                    var data = param.data, eventData = param.eventData;
                    var ref, ref1, ref2, ref3;
                    var isLockSolution = false;
                    if ((ref = _this33.state.game) === null || ref === void 0 ? void 0 : ref.locks) {
                        _this33.state.game.locks.forEach(function(lock) {
                            var ref;
                            if (lock.locationType === Game/* LockLocationType.vsItem */.A.vsItem && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                return +id === data.id;
                            }))) {
                                isLockSolution = true;
                            }
                        });
                    }
                    if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution) && ((ref1 = _this33.gamepadRRef.current) === null || ref1 === void 0 ? void 0 : ref1.hapticActuators)) _this33.gamepadRRef.current.hapticActuators[0].pulse(0.8, 100);
                    _this33.setState({
                        isClickedElement: true
                    });
                    _this33.emitVSChangesFromHost({
                        data: data,
                        eventData: eventData,
                        type: VSObject/* VSInteractionType.CLICK */.IG.CLICK
                    });
                    if (_this33.state.tourType === Tour/* TourType.Game */.v.Game) {
                        _this33.openVsObjectIframe(data);
                    } else if (_this33.state.tourType === Tour/* TourType.ECommerce */.v.ECommerce && (data === null || data === void 0 ? void 0 : (ref2 = data.details) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.length)) {
                        _this33.handleVSProduct && _this33.handleVSProduct(data.details);
                    } else {
                        _this33.handleVSAction(data);
                    }
                    _this33.setState({
                        clickedElement: {
                            id: data.id,
                            type: Game/* EntityType.VSItem */.py.VSItem
                        }
                    });
                });
                _this33.showCaseTemp.scene.sceneImage.on(dist/* NodeEventsTypes.IMAGE_HOVER */.cA.IMAGE_HOVER, function(param) {
                    var eventData = param.eventData, data = param.data;
                    if (_this33.VRPointer.component) {
                        var ref;
                        var isLockSolution = false;
                        var isGeniallySolution = false;
                        if ((ref = _this33.state.game) === null || ref === void 0 ? void 0 : ref.locks) {
                            _this33.state.game.locks.forEach(function(lock) {
                                var ref;
                                if (lock.locationType === Game/* LockLocationType.vsImage */.A.vsImage && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                    return +id === data.id;
                                }))) {
                                    isLockSolution = true;
                                }
                                if (lock.type === Game/* LockType.Genially */.Gn.Genially && lock.locationItem === "".concat(data.id)) {
                                    isGeniallySolution = true;
                                }
                            });
                        }
                        if (data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution || isGeniallySolution) {
                            _this33.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                        }
                        if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution || isGeniallySolution) && eventData.hover) {
                            _this33.VRPointer.component.setVisible(true);
                            _this33.VRPointer.target = data.node;
                        } else _this33.VRPointer.component.setVisible(false);
                    }
                    if (data.actionType === VSObject/* TourActionType.None */.mI.None) {
                        return;
                    }
                    _this33.emitVSChangesFromHost({
                        data: data,
                        eventData: eventData,
                        type: VSObject/* VSInteractionType.HOVER */.IG.HOVER
                    });
                    _this33.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                    if (data.action === VSObject/* TourAction.Hover */.b2.Hover && eventData.hover) {
                        _this33.handleVSAction(data);
                    }
                });
                _this33.showCaseTemp.scene.sceneImage.on(dist/* NodeEventsTypes.IMAGE_CLICK */.cA.IMAGE_CLICK, function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                        var eventData, data, ref, ref1, isLockSolution, triggerVSAnimation;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    eventData = param.eventData, data = param.data;
                                    isLockSolution = false;
                                    if ((ref = _this33.state.game) === null || ref === void 0 ? void 0 : ref.locks) {
                                        _this33.state.game.locks.forEach(function(lock) {
                                            var ref;
                                            if (lock.locationType === Game/* LockLocationType.vsImage */.A.vsImage && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                                return +id === data.id;
                                            }))) {
                                                isLockSolution = true;
                                            }
                                        });
                                    }
                                    if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution) && ((ref1 = _this33.gamepadRRef.current) === null || ref1 === void 0 ? void 0 : ref1.hapticActuators)) _this33.gamepadRRef.current.hapticActuators[0].pulse(0.8, 100);
                                    _this33.setState({
                                        clickedElement: {
                                            id: data.id,
                                            type: Game/* EntityType.VSImage */.py.VSImage
                                        }
                                    });
                                    _this33.emitVSChangesFromHost({
                                        data: data,
                                        eventData: eventData,
                                        type: VSObject/* VSInteractionType.CLICK */.IG.CLICK
                                    });
                                    if (_this33.state.tourType === Tour/* TourType.Game */.v.Game) {
                                        _this33.openVsImageIframe(data);
                                    }
                                    triggerVSAnimation = function() {
                                        // handle trigger VS animation event
                                        if (data.toursVSObjectId) {
                                            _this33.showCaseTemp.scene.sceneObject.assets.forEach(function(param) {
                                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), assetKey = _param[0], node = _param[1];
                                                if (assetKey.id === data.toursVSObjectId) {
                                                    var _node = (0,_sliced_to_array/* default */.Z)(node, 2), component = _node[1];
                                                    component.toggleClipAnimation(true);
                                                }
                                            });
                                        }
                                    };
                                    // handle trigger VS video event
                                    if (data.toursVSVideoId) {
                                        _this33.showCaseTemp.scene.sceneVideo.assets.forEach(function(param) {
                                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), assetKey = _param[0], node = _param[1];
                                            if (assetKey.id === data.toursVSVideoId) {
                                                var ref;
                                                var _node = (0,_sliced_to_array/* default */.Z)(node, 2), _ = _node[0], component = _node[1];
                                                var btn = component.muteBtn;
                                                if (component.isMuted()) {
                                                    audioHandler.pauseAllMusic();
                                                    _this33.setState({
                                                        vsAudio: {
                                                            component: component,
                                                            btn: btn
                                                        }
                                                    });
                                                    btn.setActive(!btn.isActive());
                                                    component.toggleMute();
                                                }
                                                if (component.video.autoplay) {
                                                    if (btn.isActive()) {
                                                        var ref1;
                                                        var vsVideos = (ref1 = _this33.vsObjects) === null || ref1 === void 0 ? void 0 : ref1.filter(function(obj) {
                                                            var ref, ref1, ref2, ref3;
                                                            return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components) && ((ref2 = (ref1 = obj.node) === null || ref1 === void 0 ? void 0 : ref1.components[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.instance) === null || ref3 === void 0 ? void 0 : ref3.componentType) === VideoRenderer_component/* videoRendererType */.Im;
                                                        });
                                                        vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                                                            var ref;
                                                            var ref1 = (0,_sliced_to_array/* default */.Z)((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components, 2), vsVideo = ref1[0], muteBtn = ref1[1];
                                                            if (!muteBtn.instance.active) {
                                                                vsVideo.instance.video.muted = true;
                                                                muteBtn.instance.active = true;
                                                                muteBtn.instance.makeBtn(muteBtn.instance.inputs.src);
                                                            }
                                                        });
                                                    }
                                                } else if (component.video.paused) {
                                                    component.video.play();
                                                    component.video.muted = false;
                                                    btn.setActive(!btn.isActive());
                                                }
                                                if (!((ref = component.video) === null || ref === void 0 ? void 0 : ref.hasEndListener)) {
                                                    component.video.hasEndListener = true;
                                                    component.video.addEventListener("ended", function() {
                                                        if (_this33.state.restoreAudio) {
                                                            audioHandler.resumeMusic();
                                                            _this33.setState({
                                                                restoreAudio: null
                                                            });
                                                        }
                                                        btn.setActive(true);
                                                        component.video.muted = true;
                                                    // component.toggleMute(true);
                                                    });
                                                }
                                            // else {
                                            //   component.video.pause();
                                            //   component.video.muted = true;
                                            // }
                                            }
                                        });
                                    }
                                    if (!data.actionType || data.actionType === VSObject/* TourActionType.None */.mI.None) {
                                        // do not wait when the action starts playing, if the is no action
                                        triggerVSAnimation();
                                        return [
                                            2
                                        ];
                                    }
                                    if (!(data.action === VSObject/* TourAction.Click */.b2.Click)) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this33.handleVSAction(data)
                                    ];
                                case 1:
                                    _state.sent();
                                    // waiting for the action to start playing
                                    triggerVSAnimation();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }());
                _this33.showCaseTemp.scene.sceneImage.on(dist/* NodeEventsTypes.AVATAR_BUTTON_HOVER */.cA.AVATAR_BUTTON_HOVER, function(param) {
                    var eventData = param.eventData;
                    _this33.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                });
                _this33.showCaseTemp.scene.scenePolygon.on(dist/* NodeEventsTypes.POLYGON_CLICK */.cA.POLYGON_CLICK, function(param) {
                    var assetId = param.assetId, eventData = param.eventData;
                    _this33.emitPolygonChangesFromHost({
                        type: VSObject/* VSInteractionType.CLICK */.IG.CLICK,
                        assetId: assetId,
                        eventData: eventData
                    });
                });
                _this33.showCaseTemp.scene.scenePolygon.on(dist/* NodeEventsTypes.POLYGON_HOVER */.cA.POLYGON_HOVER, function(param) {
                    var assetId = param.assetId, eventData = param.eventData;
                    _this33.emitPolygonChangesFromHost({
                        type: VSObject/* VSInteractionType.HOVER */.IG.HOVER,
                        assetId: assetId,
                        eventData: eventData
                    });
                });
                _this33.showCaseTemp.scene.scenePolygon.on(dist/* NodeEventsTypes.POLYGON_EVENTS */.cA.POLYGON_EVENTS, function(param) {
                    var type = param.type, component = param.component, eventData = param.eventData, data = param.data;
                    var handleAction = function(action, eventType, eventData) {
                        if (!action) {
                            return;
                        }
                        if (action.type === Polygon/* PolygonActionType.None */.zS.None) {
                            return;
                        }
                        if (action.action === Polygon/* PolygonActionAction.Hover */.IW.Hover && eventType === VSObject/* VSInteractionType.HOVER */.IG.HOVER && eventData.hover) {
                            _this33.handlePolygonAction(action);
                        }
                        if (action.action === Polygon/* PolygonActionAction.Click */.IW.Click && eventType === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                            _this33.handlePolygonAction(action);
                        }
                    };
                    var isGameTour = _this33.state.tourType === Tour/* TourType.Game */.v.Game && _this33.state.tour.gameId;
                    var isECommerceTour = _this33.state.tourType === Tour/* TourType.ECommerce */.v.ECommerce;
                    if (type === VSObject/* VSInteractionType.HOVER */.IG.HOVER) {
                        _this33.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                        if (_this33.VRPointer.component) {
                            var ref;
                            var isLockSolution = false;
                            if ((ref = _this33.state.game) === null || ref === void 0 ? void 0 : ref.locks) {
                                _this33.state.game.locks.forEach(function(lock) {
                                    var ref;
                                    if (lock.locationType === "transparentBox" && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                        return +id === data.id;
                                    }))) {
                                        isLockSolution = true;
                                    }
                                });
                            }
                            if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution) && eventData.hover) {
                                _this33.VRPointer.component.setVisible(true);
                                _this33.VRPointer.target = component;
                            } else _this33.VRPointer.component.setVisible(false);
                        }
                    }
                    if (type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                        var ref1, ref2;
                        var isLockSolution1 = false;
                        if ((ref1 = _this33.state.game) === null || ref1 === void 0 ? void 0 : ref1.locks) {
                            _this33.state.game.locks.forEach(function(lock) {
                                var ref;
                                if (lock.locationType === "transparentBox" && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                    return +id === data.id;
                                }))) {
                                    isLockSolution1 = true;
                                }
                            });
                        }
                        if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution1) && ((ref2 = _this33.gamepadRRef.current) === null || ref2 === void 0 ? void 0 : ref2.hapticActuators)) _this33.gamepadRRef.current.hapticActuators[0].pulse(0.8, 100);
                        var polygons = _this33.state.polygons;
                        var updatedPolygons = (0,_to_consumable_array/* default */.Z)(polygons);
                        var action = data.polygonsActions.find(function(i) {
                            return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                        });
                        var polygonAction = new Polygon/* PolygonAction */.fD(action);
                        var foundPolygon = polygons.find(function(p) {
                            return p.id === polygonAction.polygonId && p.hideAfterClick;
                        });
                        if (foundPolygon) {
                            var nodeIndex = _this33.modelNodes.findIndex(function(node) {
                                var ref, ref1;
                                return ((ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === foundPolygon.uuid;
                            });
                            if (nodeIndex >= 0) {
                                _this33.modelNodes[nodeIndex][0].stop();
                                foundPolygon.uuid = null;
                                foundPolygon.isHiddenAfterClick = true;
                                _this33.modelNodes.splice(nodeIndex, 1);
                                updatedPolygons = polygons.map(function(polygon) {
                                    if (polygon.id === polygonAction.polygonId) {
                                        return foundPolygon;
                                    }
                                    return polygon;
                                });
                            }
                        }
                        _this33.setState({
                            clickedElement: {
                                id: (data === null || data === void 0 ? void 0 : data.id) || (data === null || data === void 0 ? void 0 : data.id),
                                type: Game/* EntityType.Polygon */.py.Polygon,
                                polygons: updatedPolygons
                            }
                        });
                        (0,analytic/* sendToGA */.o$)("event", {
                            eventCategory: "Polygon",
                            eventAction: "click",
                            eventLabel: data.title,
                            eventId: data.sweep_uuid
                        });
                    }
                    if (isGameTour) {
                        if (type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                            var action1 = data.polygonsActions.find(function(i) {
                                return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                            });
                            var polygonAction1 = new Polygon/* PolygonAction */.fD(action1);
                            handleAction(polygonAction1, type, eventData);
                            // @ts-ignore
                            var result = _this33.handlePolygonLock && _this33.handlePolygonLock(data.id);
                            _this33.unlockChapter && _this33.unlockChapter(data, GameBook/* ChapterType.Polygon */._U.Polygon);
                            if (result) {
                                if (polygonAction1.gameBackpack && !_this33.state.polygonsBackpack.find(function(param) {
                                    var id = param.id;
                                    return data.id === id;
                                })) {
                                    _this33.setState({
                                        polygonsBackpack: [
                                            data
                                        ].concat((0,_to_consumable_array/* default */.Z)(_this33.state.polygonsBackpack))
                                    });
                                }
                            } else if (result === undefined) {
                                component.setSelection();
                            }
                        }
                    } else if (isECommerceTour && data.products.length && type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                        _this33.handlePolygonProduct && _this33.handlePolygonProduct(data);
                    } else {
                        var action2 = data.polygonsActions.find(function(i) {
                            return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                        });
                        handleAction(new Polygon/* PolygonAction */.fD(action2), type, eventData);
                    }
                });
                _this33.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_HOVER */.cA.VIDEO_HOVER, function(param) {
                    var data = param.data, eventData = param.eventData;
                    _this33.emitVSChangesFromHost({
                        data: data,
                        eventData: eventData,
                        type: VSObject/* VSInteractionType.HOVER */.IG.HOVER
                    });
                });
                _this33.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_CLICK */.cA.VIDEO_CLICK, function(param) {
                    var data = param.data, eventData = param.eventData;
                    _this33.emitVSChangesFromHost({
                        data: data,
                        eventData: eventData,
                        type: VSObject/* VSInteractionType.CLICK */.IG.CLICK
                    });
                    _this33.subscribeToStartTriggerVSAfterAnimation(data);
                    if (_this33.state.tourType === Tour/* TourType.Game */.v.Game) {
                        _this33.openVsVideoIframe(data);
                    }
                    _this33.setState({
                        clickedElement: {
                            id: data.id,
                            type: Game/* EntityType.VSVideo */.py.VSVideo
                        }
                    });
                });
                _this33.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_BUTTON_HOVER */.cA.VIDEO_BUTTON_HOVER, function(param) {
                    var eventData = param.eventData, data = param.data;
                    _this33.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                    if (_this33.VRPointer.component) {
                        if (data.actionType !== VSObject/* TourActionType.None */.mI.None && eventData.hover) {
                            _this33.VRPointer.component.setVisible(true);
                            _this33.VRPointer.target = data.node;
                        } else _this33.VRPointer.component.setVisible(false);
                    }
                });
                _this33.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_BUTTON_CLICK */.cA.VIDEO_BUTTON_CLICK, _this33.handleVideoButtonClick);
                _this33.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.UNMUTE_AFTER_START */.cA.UNMUTE_AFTER_START, _this33.handleUnmuteAfterStart);
                return [
                    2
                ];
            });
        });
        _this.handleUnmuteAfterStart = function(param) {
            var eventData = param.eventData, data = param.data, component = param.component, btnComponent = param.btnComponent;
            if (_this.isTourReadyForAudio()) {
                // delay to let other audio code run before for proper interaction
                setTimeout(function() {
                    return _this.handleVideoLoaded({
                        eventData: eventData,
                        data: data,
                        component: component,
                        btnComponent: btnComponent
                    });
                }, 500);
            } else {
                setTimeout(function() {
                    return _this.handleUnmuteAfterStart({
                        eventData: eventData,
                        data: data,
                        component: component,
                        btnComponent: btnComponent
                    });
                }, 500);
            }
        };
        _this.muteAllVsVideos = function(currentVideoId) {
            var ref;
            var vsVideos = (ref = _this.vsObjects) === null || ref === void 0 ? void 0 : ref.filter(function(obj) {
                var ref;
                return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.componentType) === VideoRenderer_component/* videoRendererType */.Im;
            });
            vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                if (currentVideoId && obj.id === currentVideoId) return;
                var _node = obj.node, video = _node.video, muteBtn = _node.muteBtn;
                if (video && muteBtn) {
                    video.muted = true;
                    muteBtn.active = true;
                    muteBtn.makeBtn(muteBtn.inputs.src);
                }
            });
        };
        _this.handleVideoButtonClick = function(param) {
            var eventData = param.eventData, data = param.data, component = param.component, btnComponent = param.btnComponent;
            var ref, ref1;
            if ((ref = _this.gamepadRRef.current) === null || ref === void 0 ? void 0 : ref.hapticActuators) _this.gamepadRRef.current.hapticActuators[0].pulse(0.8, 100);
            if (component.isMuted()) {
                audioHandler.pauseAllMusic();
                _this.setState({
                    vsAudio: {
                        component: component,
                        btn: btnComponent
                    }
                });
            }
            if (btnComponent.inputs.type === "mute") {
                // This logic was muting all videos when one video was un-muted, but since now videos are paused when another video is played, this logic is not needed anymore
                // Keeping it commented out until we refactor the Music logic
                // if (btnComponent.isActive()) {
                //   const vsVideos = this.vsObjects?.filter((obj) => obj.node?.componentType === videoRendererType);
                //   vsVideos?.forEach((obj) => {
                //     const { video: vsVideo, muteBtn } = obj.node;
                //     if (muteBtn && !muteBtn.active) {
                //       vsVideo.muted = true;
                //       muteBtn.active = true;
                //       muteBtn.makeBtn(muteBtn.inputs.src);
                //     }
                //   });
                // }
                component.toggleMute();
            }
            if (btnComponent.inputs.type === "play") {
                var _node = data.node, video = _node.video, muteBtn = _node.muteBtn;
                if (video.paused) {
                    // If a video has been played, mute all other videos
                    _this.muteAllVsVideos(data.id);
                    video.play();
                    video.muted = false;
                    video.volume = audioHandler.getVolume();
                    muteBtn.setActive(false);
                } else {
                    video.pause();
                    if (deviceManager/* default.isIOS */.Z.isIOS()) component.muteBtn.setActive(true);
                }
            }
            if (!((ref1 = component.video) === null || ref1 === void 0 ? void 0 : ref1.hasEndListener)) {
                component.video.hasEndListener = true;
                component.video.addEventListener("ended", function(event) {
                    if (_this.state.restoreAudio) {
                        audioHandler.resumeMusic();
                        _this.setState({
                            restoreAudio: null
                        });
                    }
                    btnComponent.setActive(true);
                    component.video.muted = true;
                // component.toggleMute(true);
                });
            }
            btnComponent.setActive(!btnComponent.isActive());
        };
        var _this34 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initObjectNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(asset) {
                var node, isGameTour, showAssetAfterAnimation, ref, ref1, ref2, ref3;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isGameTour = _this34.state.tourType === Tour/* TourType.Game */.v.Game && _this34.state.tour.gameId;
                            if (!(0,_instanceof/* default */.Z)(asset, VSObject/* TourImage */.oP)) return [
                                3,
                                2
                            ];
                            showAssetAfterAnimation = (asset === null || asset === void 0 ? void 0 : asset.toursVSObjectIdAfterAnimation) || (asset === null || asset === void 0 ? void 0 : asset.toursVSVideoIdAfterAnimation);
                            return [
                                4,
                                _this34.initImageNode(asset)
                            ];
                        case 1:
                            node = _state.sent();
                            node[1].animate = true;
                            if ((isGameTour || showAssetAfterAnimation) && node && node.length === 2) node[1].animate = true;
                            return [
                                3,
                                8
                            ];
                        case 2:
                            if (!(0,_instanceof/* default */.Z)(asset, VSObject/* TourVideo */.Up)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this34.initVideoNode(asset)
                            ];
                        case 3:
                            node = _state.sent();
                            // TODO Hardcoded pipes for TB-2112
                            if (((ref = _this34.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.location.href.includes("m=y9vZoA57wQs")) && _this34.pipesData) {
                                if (asset.details.title === "Pressure.mp4") initPolygonUpdateFromVideo(asset, node, _this34.pipesData, _this34.THREE, _this34.renderer, 1);
                            }
                            if (((ref2 = _this34.iframe) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contentWindow) === null || ref3 === void 0 ? void 0 : ref3.location.href.includes("m=cKEUCfKQmHn")) && _this34.pipesData) {
                                if (asset.details.title === "Pressure.mp4") initPolygonUpdateFromVideo(asset, node, _this34.pipesData, _this34.THREE, _this34.renderer, 0);
                                if (asset.details.title === "Pressure2.mp4") initPolygonUpdateFromVideo(asset, node, _this34.pipesData, _this34.THREE, _this34.renderer, 1);
                                if (asset.details.title === "Pressure3.mp4") initPolygonUpdateFromVideo(asset, node, _this34.pipesData, _this34.THREE, _this34.renderer, 2);
                            }
                            return [
                                3,
                                8
                            ];
                        case 4:
                            if (!(0,_instanceof/* default */.Z)(asset, VSObject/* TourVSHtml */.q8)) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                _this34.initVSHtmlNode(asset)
                            ];
                        case 5:
                            node = _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 6:
                            return [
                                4,
                                _this34.initNode(asset)
                            ];
                        case 7:
                            node = _state.sent();
                            if (isGameTour && node && node.length === 2) node[1].animate = true;
                            _state.label = 8;
                        case 8:
                            if (node && node.length === 2) {
                                return [
                                    2,
                                    node[1]
                                ];
                            }
                            return [
                                2,
                                null
                            ];
                    }
                });
            });
            return function(asset) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this35 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setVSVisible = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(vsObject, visible) {
                var trigger, ref, vsObjectType, ref1, ref2, e;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            trigger = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : types/* vsTriggerType.default */.QB["default"];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                ,
                                8
                            ]);
                            if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.videoPlayedOnce) && visible) {
                                return [
                                    2
                                ];
                            }
                            if (!(visible && !vsObject.started)) return [
                                3,
                                5
                            ];
                            if (!(trigger === types/* vsTriggerType.revealCondition */.QB.revealCondition && vsObject.delay)) return [
                                3,
                                2
                            ];
                            setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var ref;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            vsObject.started = true; // we do it here because initObjectNode can take time
                                            return [
                                                4,
                                                _this35.initObjectNode(vsObject)
                                            ];
                                        case 1:
                                            vsObject.node = _state.sent();
                                            if (((ref = vsObject.node) === null || ref === void 0 ? void 0 : ref.video) && vsObject.node.inputs.autoplay) {
                                                vsObject.node.play();
                                            }
                                            _this35.subscribeToStartTriggerVSAfterAnimation(vsObject);
                                            _this35.deferVisibilityVSObjectRef.current.filter(function(item) {
                                                return item.id !== vsObject.id;
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }), vsObject.delay * 1000);
                            _this35.deferVisibilityVSObjectRef.current = (0,_to_consumable_array/* default */.Z)(_this35.deferVisibilityVSObjectRef.current).concat([
                                vsObject
                            ]);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            vsObject.started = true; // we do it here because initObjectNode can take time
                            return [
                                4,
                                _this35.initObjectNode(vsObject)
                            ];
                        case 3:
                            vsObject.node = _state.sent();
                            if (((ref = vsObject.node) === null || ref === void 0 ? void 0 : ref.video) && vsObject.node.inputs.autoplay && !_this35.state.startScreenOn) {
                                vsObject.node.play();
                            }
                            _this35.subscribeToStartTriggerVSAfterAnimation(vsObject);
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            if (!visible && (vsObject === null || vsObject === void 0 ? void 0 : vsObject.started) && vsObject.node) {
                                vsObject.started = false;
                                vsObjectType = dist/* SceneInitEventsTypes.Object */.PS.Object;
                                if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP)) {
                                    vsObjectType = dist/* SceneInitEventsTypes.Image */.PS.Image;
                                } else if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up)) {
                                    if (vsObject.hideOnAnimationFinished) {
                                        vsObject.videoPlayedOnce = true;
                                    }
                                    vsObjectType = dist/* SceneInitEventsTypes.Video */.PS.Video;
                                } else if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVSHtml */.q8)) {
                                    vsObjectType = dist/* SceneInitEventsTypes.HTML */.PS.HTML;
                                }
                                if (vsObjectType && vsObject) {
                                    ;
                                    (ref1 = _this35.showCaseTemp) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.scene) === null || ref2 === void 0 ? void 0 : ref2.remove(vsObjectType, vsObject);
                                }
                            }
                            _state.label = 6;
                        case 6:
                            return [
                                3,
                                8
                            ];
                        case 7:
                            e = _state.sent();
                            console.error(e.message);
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(vsObject, visible) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.changeGameCondition = function(id, key, state) {
            var condition = _this.state.game.conditions.find(function(condition) {
                return condition.id === id;
            });
            var filteredConditions = _this.state.game.conditions.filter(function(condition) {
                return condition.id !== id;
            });
            var game = _this.state.game;
            if (!condition) return;
            condition[key] = state;
            game.conditions = (0,_to_consumable_array/* default */.Z)(filteredConditions).concat([
                condition
            ]);
            _this.setState({
                game: game
            });
        };
        _this.filterVsElementsByGameCondition = function() {
            var startGameHideConditions = _this.state.game.conditions.filter(function(condition) {
                return !condition.lock_ids.length && condition.conditionType === Game/* ConditionType.HIDE */.CP.HIDE;
            });
            var gameHideConditions = _this.state.game.conditions.filter(function(condition) {
                return condition.isHidden && condition.conditionType === Game/* ConditionType.HIDE */.CP.HIDE;
            });
            var gameRevealConditions = _this.state.game.conditions.filter(function(condition) {
                return condition.isRevealed && condition.conditionType === Game/* ConditionType.REVEAL */.CP.REVEAL;
            }).reduce(function(acc, condition, currentIndex, items) {
                var itemsEntityIds = _this.state.game.conditions.filter(function(item) {
                    return item.entity_type === condition.entity_type && item.isHidden && item.lock_ids.length && item.conditionType === Game/* ConditionType.HIDE */.CP.HIDE;
                }).reduce(function(acc, item) {
                    return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(item.entity_ids));
                }, []);
                return (0,_to_consumable_array/* default */.Z)(acc).concat([
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, condition), {
                        entity_ids: condition.entity_ids.filter(function(entityId) {
                            return !itemsEntityIds.includes(entityId);
                        })
                    }), 
                ]);
            }, []);
            var vsItemsToHide = [];
            var vsVideosToHide = [];
            var vsImagesToHide = [];
            var vsHTMLsToHide = [];
            var polygonsToHide = [];
            startGameHideConditions.forEach(function(condition) {
                if (!condition.entity_ids) return;
                if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                    polygonsToHide = (0,_to_consumable_array/* default */.Z)(polygonsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                    vsItemsToHide = (0,_to_consumable_array/* default */.Z)(vsItemsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                    vsVideosToHide = (0,_to_consumable_array/* default */.Z)(vsVideosToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                    vsImagesToHide = (0,_to_consumable_array/* default */.Z)(vsImagesToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSHTML */.py.VSHTML) {
                    vsHTMLsToHide = (0,_to_consumable_array/* default */.Z)(vsHTMLsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                }
            });
            gameHideConditions.forEach(function(condition) {
                if (!condition.entity_ids) return;
                if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                    polygonsToHide = (0,_to_consumable_array/* default */.Z)(polygonsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                    vsItemsToHide = (0,_to_consumable_array/* default */.Z)(vsItemsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                    vsVideosToHide = (0,_to_consumable_array/* default */.Z)(vsVideosToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                    vsImagesToHide = (0,_to_consumable_array/* default */.Z)(vsImagesToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSHTML */.py.VSHTML) {
                    vsHTMLsToHide = (0,_to_consumable_array/* default */.Z)(vsHTMLsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                }
            });
            gameRevealConditions.forEach(function(condition) {
                if (!condition.entity_ids) return;
                if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                    polygonsToHide = polygonsToHide.filter(function(el) {
                        return !condition.entity_ids.includes(el);
                    });
                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                    vsItemsToHide = vsItemsToHide.filter(function(el) {
                        return !condition.entity_ids.includes("".concat(el));
                    });
                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                    vsVideosToHide = vsVideosToHide.filter(function(el) {
                        return !condition.entity_ids.includes("".concat(el));
                    });
                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                    vsImagesToHide = vsImagesToHide.filter(function(el) {
                        return !condition.entity_ids.includes("".concat(el));
                    });
                } else if (condition.entity_type === Game/* EntityType.VSHTML */.py.VSHTML) {
                    vsHTMLsToHide = vsHTMLsToHide.filter(function(el) {
                        return !condition.entity_ids.includes("".concat(el));
                    });
                }
            });
            _this.deferVisibilityVSObjectRef.current.forEach(function(param) {
                var id = param.id, isVSImage = param.isVSImage, isVSVideo = param.isVSVideo, isVSHtml = param.isVSHtml;
                if (isVSImage) {
                    vsImagesToHide.push(id);
                } else if (isVSVideo) {
                    vsVideosToHide.push(id);
                } else if (isVSHtml) {
                    vsHTMLsToHide.push(id);
                }
            });
            return {
                startGameHideConditions: startGameHideConditions,
                vsItemsToHide: vsItemsToHide,
                vsVideosToHide: vsVideosToHide,
                vsImagesToHide: vsImagesToHide,
                vsHTMLsToHide: vsHTMLsToHide
            };
        };
        var _this36 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initVS = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var isVSReady, isGameTour, ref, vsImagesToHide, vsItemsToHide, vsVideosToHide, vsHTMLsToHide, filteredVsObjects;
            return (0,tslib_es6.__generator)(this, function(_state) {
                isVSReady = _this36.state.isVSReady;
                isGameTour = _this36.state.tourType === Tour/* TourType.Game */.v.Game && _this36.state.tour.gameId;
                if (!isVSReady) return [
                    2
                ]; // VS should be initialized for using!
                if (isGameTour) {
                    ref = _this36.filterVsElementsByGameCondition(), vsImagesToHide = ref.vsImagesToHide, vsItemsToHide = ref.vsItemsToHide, vsVideosToHide = ref.vsVideosToHide, vsHTMLsToHide = ref.vsHTMLsToHide;
                    filteredVsObjects = _this36.vsObjects.filter(function(item) {
                        return (0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && !vsImagesToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && !vsItemsToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && !vsVideosToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVSHtml */.q8) && !vsHTMLsToHide.includes(item.id);
                    });
                    filteredVsObjects.forEach(function(obj) {
                        _this36.loadingQueue.enqueue(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var o1, o2, ref, ref1, ref2, ref3, ref4, ref5, ref6, pose, assetPose, distance, inRange;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!((obj === null || obj === void 0 ? void 0 : obj.toursVSObjectIdAfterAnimation) || (obj === null || obj === void 0 ? void 0 : obj.toursVSVideoIdAfterAnimation))) return [
                                            3,
                                            6
                                        ];
                                        if (!obj.toursVSObjectIdAfterAnimation) return [
                                            3,
                                            2
                                        ];
                                        o1 = filteredVsObjects.find(function(item) {
                                            return item.id === obj.toursVSObjectIdAfterAnimation;
                                        });
                                        return [
                                            4,
                                            _this36.setVSVisible(o1, o1 != undefined)
                                        ];
                                    case 1:
                                        _state.sent(); // if o1 is not in filteredVsObjects, it means that it was hidden by game condition, so should not be showned
                                        _state.label = 2;
                                    case 2:
                                        if (!obj.toursVSVideoIdAfterAnimation) return [
                                            3,
                                            4
                                        ];
                                        o2 = filteredVsObjects.find(function(item) {
                                            return item.id === obj.toursVSVideoIdAfterAnimation;
                                        });
                                        return [
                                            4,
                                            _this36.setVSVisible(o2, o2 != undefined)
                                        ];
                                    case 3:
                                        _state.sent(); // if o2 is not in filteredVsObjects, it means that it was hidden by game condition, so should not be showned
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            4,
                                            _this36.setVSVisible(obj, false)
                                        ];
                                    case 5:
                                        _state.sent();
                                        return [
                                            3,
                                            10
                                        ];
                                    case 6:
                                        if (!_this36.THREE) return [
                                            3,
                                            10
                                        ];
                                        pose = new _this36.THREE.Vector3((ref = _this36.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, (ref2 = _this36.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.y, (ref4 = _this36.pose) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.position) === null || ref5 === void 0 ? void 0 : ref5.z);
                                        assetPose = new _this36.THREE.Vector3(obj.positionX, obj.positionY, obj.positionZ);
                                        distance = pose.distanceTo(assetPose) * 0.2;
                                        inRange = distance <= ((obj === null || obj === void 0 ? void 0 : obj.renderRange) || ((ref6 = _this36.state.tour) === null || ref6 === void 0 ? void 0 : ref6.vsRenderRange) || DEFAULT_VS_SENSOR_RADIUS);
                                        if (!inRange) return [
                                            3,
                                            8
                                        ];
                                        return [
                                            4,
                                            _this36.setVSVisible(obj, true)
                                        ];
                                    case 7:
                                        _state.sent();
                                        return [
                                            3,
                                            10
                                        ];
                                    case 8:
                                        return [
                                            4,
                                            _this36.setVSVisible(obj, false)
                                        ];
                                    case 9:
                                        _state.sent();
                                        _state.label = 10;
                                    case 10:
                                        _this36.loadingQueue.dequeue();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    });
                    if (filteredVsObjects.length === 0) {
                        _this36.loadingQueue.setFullLoadingQueueProgress();
                    }
                } else {
                    _this36.renderVS(_this36.pose);
                }
                return [
                    2
                ];
            });
        });
        var _this37 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.stopVS = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    _this37.vsObjects.map(function(asset) {
                        _this37.setVSVisible(asset, false);
                    });
                } catch (e) {
                    console.error(e);
                }
                return [
                    2
                ];
            });
        });
        var _this38 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPolygons = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var promises, polygons;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        promises = _this38.state.polygons.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                var node;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!item.active) {
                                                return [
                                                    2,
                                                    item
                                                ];
                                            }
                                            if (!!item.uuid) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                _this38.initPolygonNode(item)
                                            ];
                                        case 1:
                                            node = _state.sent();
                                            _this38.modelNodes.push(node);
                                            item.uuid = node[0].obj3D.uuid;
                                            return [
                                                2,
                                                item
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                item
                                            ];
                                    }
                                });
                            });
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 1:
                        polygons = _state.sent();
                        if (_this38.state.waitLoadingPolygons) {
                            _this38.setState({
                                gameStatus: types/* GameStatus.Started */.XI.Started
                            });
                        }
                        if (!isEqual_default()(polygons, _this38.state.polygons)) {
                            _this38.setState({
                                polygons: polygons
                            });
                        }
                        _this38.setState({
                            initPolygonsDone: true
                        });
                        return [
                            2
                        ];
                }
            });
        });
        var _this39 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this39.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Object */.PS.Object, data)
                            ];
                        case 1:
                            res = _state.sent();
                            return [
                                2,
                                res.length ? res : []
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this40 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initImageNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this40.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Image */.PS.Image, data)
                            ];
                        case 1:
                            res = _state.sent();
                            if (!res.length) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            return [
                                2,
                                res
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this41 = (0,_assert_this_initialized/* default */.Z)(_this);
        /*

  */ _this.initVideoNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref, ref1, options, elementType, VimeoVideo, vimeoVideo, isValidVideoURL, updatedData, res, res1, videoNode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            options = {
                                vimeoURL: "",
                                hideMuteButton: data.autoplay && data.hideMuteButton,
                                isDefaultMuted: data.hideMuteButton && data.isDefaultMuted,
                                autoplay: data.autoplay,
                                withButton: (0,_object_spread/* default */.Z)({
                                    mute: "/images/mute_icon.png",
                                    unMute: "/images/unmute_icon.png"
                                }, !data.autoplay && {
                                    play: "/images/play_icon.png",
                                    pause: "/images/pause_icon.png"
                                })
                            };
                            elementType = data.details.type;
                            if (!(elementType === VSObject/* VSVideoType.Vimeo */.OV.Vimeo && _this41.state.tour.clientId)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                __webpack_require__.e(/* import() */ 1023).then(__webpack_require__.bind(__webpack_require__, 11023)).then(function(res) {
                                    return res.default;
                                })
                            ];
                        case 1:
                            VimeoVideo = _state.sent();
                            vimeoVideo = new VimeoVideo(VimeoVideo.parseVideoId(data.getVideoURL()));
                            return [
                                4,
                                vimeoVideo.loadFromVideoId(_this41.state.tour.clientId)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                TreedisPublicDAO/* default.getVimeoVideoUrl */.Z.getVimeoVideoUrl(vimeoVideo.getFileURL())
                            ];
                        case 3:
                            options.vimeoURL = _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 4:
                            return [
                                4,
                                file/* default.existFile */.Z.existFile("".concat("https://cdn.treedis.com").concat(data.details.url))
                            ];
                        case 5:
                            isValidVideoURL = _state.sent();
                            if (!isValidVideoURL && !options.vimeoURL) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            _state.label = 6;
                        case 6:
                            if (!((ref = _this41.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.location.href.includes("m=mEMx41aqAaq"))) return [
                                3,
                                8
                            ];
                            if (data.details.title === "Under curl bar reversed.mp4" || data.details.title === "Under curl bar.mp4") {
                                options.autoplay = true;
                                options.hideMuteButton = true;
                                options.isDefaultMuted = true;
                                data.autoplay = true;
                                data.hideMuteButton = true;
                                data.isDefaultMuted = true;
                            }
                            if (!(data.details.title === "Under curl bar reversed.mp4" || data.details.title === "Under curl bar.mp4" || data.details.title === "plates_early" || data.details.title === "plates_late" || data.details.title === "plates_ok")) return [
                                3,
                                8
                            ];
                            updatedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                hasExternalController: true
                            });
                            return [
                                4,
                                _this41.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Video */.PS.Video, updatedData, options)
                            ];
                        case 7:
                            res = _state.sent();
                            if (!res.length || res.length === 1) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            _state.label = 8;
                        case 8:
                            return [
                                4,
                                _this41.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Video */.PS.Video, data, options)
                            ];
                        case 9:
                            res1 = _state.sent();
                            if (!res1.length || res1.length === 1) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            videoNode = res1[1];
                            videoNode.video.volume = audioHandler.getVolume();
                            audioHandler.addMusicToVolumeControl(videoNode);
                            return [
                                2,
                                res1
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this42 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initVSHtmlNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this42.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.HTML */.PS.HTML, data)
                            ];
                        case 1:
                            res = _state.sent();
                            if (!res.length || res.length === 1) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            // On mobile, instead of interacting with HTML, open a popup with iframe
                            if (deviceManager/* default.isMobile */.Z.isMobile()) res[1].onEvent = function(type, eventData) {
                                if (type === Scene_component/* ComponentInteractionType.CLICK */.td.CLICK) {
                                    _this42.setState({
                                        vsHTMLPopup: {
                                            show: true,
                                            src: res[1].inputs.url
                                        }
                                    });
                                }
                            };
                            return [
                                2,
                                res
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.setVsHTMLPopupShow = function(show) {
            _this.setState({
                vsHTMLPopup: {
                    show: show,
                    src: _this.state.vsHTMLPopup.src
                }
            });
        };
        var _this43 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPolygonNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this43.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Polygon */.PS.Polygon, data)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this44 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initAvatarNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var avatar;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this44.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Avatar */.PS.Avatar, data, {
                                    host: _this44.state.host,
                                    withButton: {
                                        mute: "/images/mute_icon.png",
                                        unMute: "/images/unmute_icon.png"
                                    }
                                })
                            ];
                        case 1:
                            avatar = _state.sent();
                            avatar[1].inputs.bodyType = data.bodyType;
                            return [
                                2,
                                avatar
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.openNewTab = function(url) {
            var popupWindow = window.open(url);
            if (popupWindow === null || typeof popupWindow === "undefined") {
                // Some browsers have 'Block pop-up windows' set to true by default and in these cases we show a notification for the user to turn this setting off
                react_toastify_esm/* toast.info */.Am.info("Please allow pop-ups for this site in order to view this content");
            }
        };
        var _this45 = (0,_assert_this_initialized/* default */.Z)(_this);
        // Works for VS Images and VS Objects Action Types for now
        _this.handleVSAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data, isObject) {
                var _tour, noAudioMode, tourId, pauseAllMusic, stopTourMusic, _, currentSID, targetSID, segments, id, tour, changeMinimap, menuData, ref, menuData1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tour = _this45.state.tour, noAudioMode = _tour.noAudioMode, tourId = _tour.id;
                            pauseAllMusic = audioHandler.pauseAllMusic, stopTourMusic = audioHandler.stopTourMusic;
                            _ = data.actionType;
                            switch(_){
                                case VSObject/* TourActionType.Tab */.mI.Tab:
                                    return [
                                        3,
                                        1
                                    ];
                                case VSObject/* TourActionType.Music */.mI.Music:
                                    return [
                                        3,
                                        2
                                    ];
                                case VSObject/* TourActionType.Video */.mI.Video:
                                    return [
                                        3,
                                        4
                                    ];
                                case VSObject/* TourActionType.NavigationPath */.mI.NavigationPath:
                                    return [
                                        3,
                                        8
                                    ];
                                case VSObject/* TourActionType.Treedis */.mI.Treedis:
                                    return [
                                        3,
                                        9
                                    ];
                                case VSObject/* TourActionType.Menu */.mI.Menu:
                                    return [
                                        3,
                                        10
                                    ];
                                case VSObject/* TourActionType.Panorama */.mI.Panorama:
                                    return [
                                        3,
                                        11
                                    ];
                                case VSObject/* TourActionType.ExperiencePopUp */.mI.ExperiencePopUp:
                                    return [
                                        3,
                                        12
                                    ];
                                case VSObject/* TourActionType.Matterport */.mI.Matterport:
                                    return [
                                        3,
                                        13
                                    ];
                                case VSObject/* TourActionType.MatterportInstant */.mI.MatterportInstant:
                                    return [
                                        3,
                                        14
                                    ];
                            }
                            return [
                                3,
                                15
                            ];
                        case 1:
                            if (data.action === VSObject/* TourAction.Hover */.b2.Hover) {
                                _this45.openNewTab(data.actionURL);
                            } else if (data.action === VSObject/* TourAction.Click */.b2.Click) {
                                _this45.openNewTab(data.actionURL);
                            }
                            return [
                                2
                            ];
                        case 2:
                            if (noAudioMode && _this45.state.room) return [
                                2
                            ];
                            if (data.action === VSObject/* TourAction.Hover */.b2.Hover) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                audioHandler.playAudio({
                                    type: AudioModule/* MusicObj.VSIMAGES */.nR.VSIMAGES,
                                    id: data.id
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                        case 4:
                            data.actionURL = (0,util_all/* getVideoLink */.rp)(data.actionURL, {
                                mute: noAudioMode && _this45.state.room
                            });
                            if (!(_this45.state.tourType === Tour/* TourType.Game */.v.Game)) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                stopTourMusic
                            ];
                        case 5:
                            _state.sent();
                            return [
                                3,
                                7
                            ];
                        case 6:
                            pauseAllMusic();
                            _state.label = 7;
                        case 7:
                            return [
                                3,
                                15
                            ];
                        case 8:
                            currentSID = _this45.state.currentSweep.sid || _this45.state.currentSweep.sweep;
                            targetSID = (0,extractSweepIdFromURL/* extractSweepIdFromURL */.D)(data.actionURL);
                            if (!currentSID) {
                                react_toastify_esm/* toast.error */.Am.error("Current sweep not found");
                                return [
                                    2
                                ];
                            }
                            if (!targetSID) {
                                react_toastify_esm/* toast.error */.Am.error("Target sweep not found");
                                return [
                                    2
                                ];
                            }
                            if (_this45.pathFinderLine) {
                                if (_this45.pathFinderLine.targetSID !== targetSID) {
                                    _this45.pathFinderLine.update(currentSID, targetSID);
                                } else {
                                    _this45.pathFinderLine.reset();
                                }
                            }
                            return [
                                3,
                                15
                            ];
                        case 9:
                            segments = data.actionURL.split("/");
                            id = segments[segments.length - 1].split("?")[0];
                            if ((0,util_all/* getQueryVariable */.Dv)(data.actionURL, "m")) {
                                react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                                return [
                                    2
                                ];
                            }
                            tour = _this45.state.tour;
                            changeMinimap = tour && !tour.customMinimap;
                            _this45.setState({
                                panoramaOn: false,
                                activePano: null
                            }, function() {
                                // false = dont change the menu/panorama
                                _this45.getTour({
                                    id: id,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: data.actionURL
                                });
                            });
                            return [
                                2
                            ];
                        case 10:
                            menuData = data; // This case is only for TourImage
                            _this45.setState({
                                menuOpen: false,
                                activeMenu: null
                            }, function() {
                                _this45.setState({
                                    menuOpen: true,
                                    menuOpened: true,
                                    activeMenu: {
                                        id: menuData.menuId,
                                        subMenu: menuData.subMenuId,
                                        subSubMenu: menuData.subSubMenuId
                                    }
                                });
                            });
                            return [
                                2
                            ];
                        case 11:
                            _this45.setState({
                                activePano: data.panoramaId,
                                panoramaOn: true
                            });
                            return [
                                2
                            ];
                        case 12:
                            {
                                ;
                                menuData1 = data; // This case is only for TourImage
                                audioHandler.pauseAllMusic();
                                _this45.setState({
                                    experiencePopUpIsOpen: true,
                                    closedElementPopup: false,
                                    experiencePopUpData: {
                                        title: menuData1.popupTitle,
                                        url: menuData1.actionURL,
                                        description: menuData1.text,
                                        defaultImageUrl: menuData1 === null || menuData1 === void 0 ? void 0 : (ref = menuData1.details) === null || ref === void 0 ? void 0 : ref.url,
                                        prefixImageUrl: "/tours/".concat(tourId, "/vsimages/"),
                                        rotation: menuData1.rotation,
                                        backgroundColor: menuData1.backgroundColor,
                                        backgroundOpacity: menuData1.backgroundOpacity,
                                        textColor: menuData1.textColor,
                                        buttonColor: menuData1.buttonColor
                                    }
                                });
                                return [
                                    2
                                ];
                            }
                            _state.label = 13;
                        case 13:
                            {
                                _this45.setState({
                                    isChangeIframe: _this45.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(data.actionURL, "m")
                                }, function() {
                                    var ref, ref1;
                                    _this45.moveModel("/mp-sdk/".concat("23.5.1", "/showcase.html?applicationKey=").concat((ref = _this45.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.actionURL)), false, false);
                                });
                                return [
                                    2
                                ];
                            }
                            _state.label = 14;
                        case 14:
                            {
                                _this45.setState({
                                    isChangeIframe: _this45.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(data.actionURL, "m")
                                }, function() {
                                    var ref, ref1;
                                    _this45.moveModel("/mp-sdk/".concat("23.5.1", "/showcase.html?applicationKey=").concat((ref = _this45.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.actionURL)), false, true);
                                });
                                return [
                                    2
                                ];
                            }
                            _state.label = 15;
                        case 15:
                            if (data.actionType !== VSObject/* TourActionType.NavigationPath */.mI.NavigationPath) _this45.setState({
                                vsActionPopOn: true,
                                openedVSAction: data,
                                closedElementPopup: false
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data, isObject) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.emitVSChangesFromHost = function(param) {
            var data = param.data, eventData = param.eventData, type = param.type;
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && _this.pose.mode === _this.showcase.Mode.Mode.INSIDE) {
                var key = data.vsImageId ? "vsImageId" : data.vsVideoId ? "vsVideoId" : data.vsObjectId ? "vsObjectId" : "";
                if (!key) return;
                var _obj;
                socket/* default.emit */.Z.emit("vs", (_obj = {}, (0,_define_property/* default */.Z)(_obj, key, data.id), (0,_define_property/* default */.Z)(_obj, "eventData", eventData), (0,_define_property/* default */.Z)(_obj, "type", type), _obj));
            }
        };
        _this.emitPolygonChangesFromHost = function(param) {
            var type = param.type, assetId = param.assetId, eventData = param.eventData;
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && _this.pose.mode === _this.showcase.Mode.Mode.INSIDE) {
                socket/* default.emit */.Z.emit("polygon", {
                    type: type,
                    assetId: assetId,
                    eventData: eventData
                });
            }
        };
        _this.emitTagChangesFromHost = function(tag, action) {
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host;
            if (tag && showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && _this.pose.mode === _this.showcase.Mode.Mode.INSIDE) {
                socket/* default.emit */.Z.emit("tag", {
                    tag: {
                        sid: tag.defaultSid || tag.sid,
                        action: action
                    }
                });
                if (tag.embedMedia) {
                    var watchTagContentElem = _this.iframe.contentWindow.document.body.querySelector(".annotations-preview-layer");
                    (0,util/* closeTagEmbedTagObserver */.hH)(watchTagContentElem, function() {
                        socket/* default.emit */.Z.emit("close-embed-tag");
                    });
                }
            }
        };
        var _this46 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handlePolygonAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var tour, noAudioMode, _, audioData, segments, id, tour1, changeMinimap, ref, ref1, ref2, ref3, ref4;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tour = _this46.state.tour;
                            noAudioMode = tour.noAudioMode;
                            _ = data.type;
                            switch(_){
                                case Polygon/* PolygonActionType.Tab */.zS.Tab:
                                    return [
                                        3,
                                        1
                                    ];
                                case Polygon/* PolygonActionType.Music */.zS.Music:
                                    return [
                                        3,
                                        2
                                    ];
                                case Polygon/* PolygonActionType.Video */.zS.Video:
                                    return [
                                        3,
                                        5
                                    ];
                                case Polygon/* PolygonActionType.Treedis */.zS.Treedis:
                                    return [
                                        3,
                                        6
                                    ];
                                case Polygon/* PolygonActionType.Menu */.zS.Menu:
                                    return [
                                        3,
                                        7
                                    ];
                                case Polygon/* PolygonActionType.Panorama */.zS.Panorama:
                                    return [
                                        3,
                                        8
                                    ];
                                case Polygon/* PolygonActionType.Matterport */.zS.Matterport:
                                    return [
                                        3,
                                        9
                                    ];
                                case Polygon/* PolygonActionType.MatterportInstant */.zS.MatterportInstant:
                                    return [
                                        3,
                                        10
                                    ];
                                case Polygon/* PolygonActionType.ExperiencePopUp */.zS.ExperiencePopUp:
                                    return [
                                        3,
                                        11
                                    ];
                            }
                            return [
                                3,
                                12
                            ];
                        case 1:
                            if (data.action !== Polygon/* PolygonActionAction.Hover */.IW.Hover) {
                                _this46.openNewTab(data.url);
                            }
                            return [
                                2
                            ];
                        case 2:
                            if (noAudioMode && _this46.state.room) return [
                                2
                            ];
                            if (data.action === Polygon/* PolygonActionAction.Hover */.IW.Hover) {
                                return [
                                    2
                                ];
                            }
                            audioData = {
                                id: data.id,
                                actionType: data.type,
                                tourId: _this46.state.tour.id,
                                url: data.url
                            };
                            return [
                                4,
                                audioHandler.importAudioData(AudioModule/* MusicObjectKey.POLYGONS */.NO.POLYGONS, [
                                    audioData
                                ])
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                audioHandler.playAudio({
                                    type: AudioModule/* MusicObj.POLYGONS */.nR.POLYGONS,
                                    id: data.id
                                })
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                        case 5:
                            data.url = (0,util_all/* getVideoLink */.rp)(data.url, {
                                mute: noAudioMode && _this46.state.room,
                                autoplay: data.autoPlay ? 1 : 0
                            });
                            audioHandler.pauseAllMusic();
                            return [
                                3,
                                12
                            ];
                        case 6:
                            segments = data.url.split("/");
                            id = segments[segments.length - 1].split("?")[0];
                            if ((0,util_all/* getQueryVariable */.Dv)(data.url, "m")) {
                                react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                                return [
                                    2
                                ];
                            }
                            tour1 = _this46.state.tour;
                            changeMinimap = tour1 && !tour1.customMinimap;
                            // tourTransitionLoader only if the iframe changes!
                            _this46.setState({
                                panoramaOn: false,
                                activePano: null,
                                tourTransitionLoader: tour1.slug !== id
                            }, function() {
                                // false = dont change the menu/panorama
                                _this46.getTour({
                                    id: id,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: data.url
                                });
                            });
                            return [
                                2
                            ];
                        case 7:
                            _this46.setState({
                                menuOpen: false,
                                activeMenu: {
                                    id: null,
                                    subMenu: null,
                                    subSubMenu: null
                                }
                            }, function() {
                                _this46.setState({
                                    menuOpen: true,
                                    menuOpened: true,
                                    activeMenu: {
                                        id: data.menuId,
                                        subMenu: data.subMenuId,
                                        subSubMenu: data.subSubMenuId
                                    }
                                });
                            });
                            return [
                                2
                            ];
                        case 8:
                            _this46.setState({
                                activePano: data.panoramaId,
                                panoramaOn: true
                            });
                            return [
                                2
                            ];
                        case 9:
                            _this46.moveModel("/mp-sdk/".concat("23.5.1", "/showcase.html?applicationKey=").concat((ref = _this46.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.url)), false, false);
                            return [
                                2
                            ];
                        case 10:
                            _this46.moveModel("/mp-sdk/".concat("23.5.1", "/showcase.html?applicationKey=").concat((ref2 = _this46.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.url)), false, true);
                            return [
                                2
                            ];
                        case 11:
                            _this46.setState({
                                experiencePopUpIsOpen: true,
                                closedElementPopup: false,
                                experiencePopUpData: {
                                    title: data.popupTitle,
                                    url: data.actionURL,
                                    description: data.text,
                                    defaultImageUrl: "",
                                    prefixImageUrl: "/tours/".concat((ref4 = _this46.state.tour) === null || ref4 === void 0 ? void 0 : ref4.id, "/polygons/"),
                                    rotation: data.rotation,
                                    backgroundColor: data.backgroundColor,
                                    backgroundOpacity: data.backgroundOpacity,
                                    textColor: data.textColor,
                                    buttonColor: data.buttonColor
                                }
                            });
                            return [
                                2
                            ];
                        case 12:
                            _this46.setState({
                                vsActionPopOn: true,
                                closedElementPopup: false,
                                openedVSAction: new Polygon/* PolygonAction */.fD(data)
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.updateSweepLoc = function(nextSweep) {
            _this.ticketUpdateSweepLoc(nextSweep.sid);
            // if (this.pose?.mode && this.pose?.mode !== this.showCaseTemp.showcase.Mode.Mode.INSIDE) return;
            var _state = _this.state, tour = _state.tour, sweepGroups = _state.sweepGroups;
            (0,analytic/* sendToGA */.o$)("event", {
                eventCategory: "Sweep",
                eventAction: "move",
                eventLabel: nextSweep.sid
            });
            var activeSweepGroup = null;
            sweepGroups.forEach(function(group, i) {
                var ref;
                (ref = group.sweeps) === null || ref === void 0 ? void 0 : ref.forEach(function(sweep) {
                    if (sweep.uuid === nextSweep.sid) {
                        activeSweepGroup = group.id;
                    }
                });
            });
            _this.setState({
                activeSweepGroup: activeSweepGroup
            }, function() {
                _this.filterTags();
                _this.filterPolygon();
            });
            if (tour.minimap) {
                var loc = _this.calculateLocation(nextSweep);
                if (!loc) return;
                _this.setState({
                    mapWalkerX: loc.px,
                    mapWalkerY: loc.py,
                    minimaps: loc.minimaps
                });
            }
        };
        _this.markMinimap = function(p) {
            var _state = _this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
            if (!minimaps || minimaps.length === 0 || selectedMinimap === null) return;
            minimaps[selectedMinimap].hotspots.forEach(function(h) {
                if (h.type === "panorama" && h.panoramaId === p.id) {
                    _this.setState({
                        mapWalkerX: h.x,
                        mapWalkerY: h.y,
                        activePano: null
                    });
                }
            });
        };
        _this.isTourReadyForAudio = function() {
            var _state = _this.state, showIntro = _state.showIntro, startScreenOn = _state.startScreenOn, gameStatus = _state.gameStatus, _$tourType = _state.tourType, avatar = _state.avatar, tour = _state.tour, showcaseLoaded = _state.showcaseLoaded, room = _state.room;
            return !(!showcaseLoaded || // video tour, before avatar select
            room && (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && !(avatar === null || avatar === void 0 ? void 0 : avatar.imageUrl) || // regular tour, before avatar select
            !room && (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && !(avatar === null || avatar === void 0 ? void 0 : avatar.url) || showIntro || startScreenOn || _$tourType === Tour/* TourType.Game */.v.Game && gameStatus === types/* GameStatus.NotStarted */.XI.NotStarted);
        };
        var _this47 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.playTourAudio = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ignoreTimeout, videoPlaying, isTourMusicPaused;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ignoreTimeout = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                        videoPlaying = _this47.state.videoPlaying;
                        isTourMusicPaused = audioHandler.isTourMusicPaused;
                        if (!ignoreTimeout && _this47.playAudioTimeout) return [
                            2
                        ];
                        _this47.playAudioTimeout = null;
                        if (videoPlaying) {
                            return [
                                2
                            ];
                        }
                        if (!_this47.isTourReadyForAudio()) {
                            _this47.mainContainerWaitingForPlay = true;
                            _this47.playAudioTimeout = setTimeout(function() {
                                return _this47.playTourAudio(true).catch(function() {});
                            }, 500);
                            return [
                                2,
                                _this47.playAudioTimeout
                            ];
                        }
                        if (!isTourMusicPaused()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this47.handleToggleMusic()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        _this47.mainContainerWaitingForPlay = false;
                        return [
                            2
                        ];
                }
            });
        });
        var _this48 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveToSweep = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sweepId, rotation) {
                var transition;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    transition = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "INSTANT";
                    if (_this48.showCaseTemp) {
                        return [
                            2,
                            _this48.showCaseTemp.showcase.Sweep.moveTo(sweepId, {
                                rotation: rotation,
                                transition: _this48.showCaseTemp.showcase.Sweep.Transition[transition]
                            }).then(function() {
                                if (base/* asyncStore.vrIsOn */.k6.vrIsOn) {
                                    if (!_this48.SceneVRCameraController) {
                                        console.error("Error: SceneVRCameraController not initialized");
                                        return;
                                    }
                                    var targetSweep = _this48.state.sweeps.find(function(sweep) {
                                        return sweep.uuid === sweepId;
                                    });
                                    _this48.SceneVRCameraController.rotateVRViewByCameraRotation(targetSweep, rotation);
                                }
                                if (_this48.state.tourType !== Tour/* TourType.Game */.v.Game) {
                                    window.history.replaceState(null, "", _this48.buildLink(sweepId, rotation));
                                }
                            }).catch(function(err) {
                                console.error(err.toString());
                            })
                        ];
                    }
                    react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                    return [
                        2
                    ];
                });
            });
            return function(sweepId, rotation) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this49 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveToStep = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(step) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!_this49.showCaseTemp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this49.showCaseTemp.showcase.Tour.step(step).catch(function(err) {
                                    console.error(err.toString());
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(step) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.closeMenu = function() {
            _this.setState(_this.setState({
                menuOpen: false
            }));
        };
        var _this50 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.stopPolygons = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var polygons, _, _tmp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        polygons = _this50.state.polygons;
                        _ = _this50.setState;
                        _tmp = {};
                        return [
                            4,
                            Promise.all(polygons.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                    var nodeIndex;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        if (!item.active) return [
                                            2,
                                            item
                                        ];
                                        nodeIndex = _this50.modelNodes.findIndex(function(node) {
                                            var ref, ref1;
                                            return ((ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                        });
                                        if (nodeIndex >= 0) {
                                            _this50.modelNodes[nodeIndex][0].stop();
                                            item.uuid = null;
                                            _this50.modelNodes.splice(nodeIndex, 1);
                                        }
                                        return [
                                            2,
                                            item
                                        ];
                                    });
                                });
                                return function(item) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        _.apply(_this50, [
                            (_tmp.polygons = _state.sent(), _tmp)
                        ]);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        var _this51 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.renderPolygons = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var polygons, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        polygons = _this51.state.polygons;
                        return [
                            4,
                            Promise.all(polygons.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                    var node, nodeIndex;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!!_this51.polygonHiddenByPathLock(item)) return [
                                                    3,
                                                    4
                                                ];
                                                if (!item.active) return [
                                                    3,
                                                    3
                                                ];
                                                if (!!item.uuid) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    _this51.initPolygonNode(item)
                                                ];
                                            case 1:
                                                node = _state.sent();
                                                _this51.modelNodes.push(node);
                                                item.uuid = node[0].obj3D.uuid;
                                                return [
                                                    2,
                                                    item
                                                ];
                                            case 2:
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                nodeIndex = _this51.modelNodes.findIndex(function(node) {
                                                    var ref, ref1;
                                                    return ((ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                                });
                                                if (nodeIndex >= 0) {
                                                    _this51.modelNodes[nodeIndex][0].stop();
                                                    item.uuid = null;
                                                    _this51.modelNodes.splice(nodeIndex, 1);
                                                }
                                                _state.label = 4;
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(item) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        var _this52 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleVS = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, _state, isVSEnabled, isVSVisible;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                if (!((ref = _this52.vsObjects) === null || ref === void 0 ? void 0 : ref.length)) {
                    react_toastify_esm/* toast.error */.Am.error("There is no vsObjects to hide");
                    return [
                        2
                    ];
                }
                _state = _this52.state, isVSEnabled = _state.isVSEnabled, isVSVisible = _state.isVSVisible;
                _this52.setState({
                    isVSEnabled: !isVSEnabled,
                    isVSVisible: !isVSVisible
                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(isVSEnabled && isVSVisible)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this52.stopVS()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this52.stopPolygons()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                return [
                                    4,
                                    _this52.initVS()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this52.initPolygons()
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }));
                return [
                    2
                ];
            });
        });
        var _this53 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.resumeTourMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this53.isTourReadyForAudio()) return [
                            2
                        ];
                        if (!audioHandler.isTourMusicPaused()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this53.handleToggleMusic()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        _this.openVR = function() {
            var ref, ref1, ref2;
            var vrOverlay = (ref = _this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.getElementById("vr-overlay-layer");
            var iframeVrButton = vrOverlay.querySelector('[role="button"]');
            iframeVrButton.click();
        };
        var _this54 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleTogglePano = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, panoramaOn, showcaseLoaded, room, host, tourPlaying, data;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this54.state, panoramaOn = _state.panoramaOn, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host, tourPlaying = _state.tourPlaying;
                        if (!(!panoramaOn && tourPlaying)) return [
                            3,
                            2
                        ];
                        // We pause the tour if the user wants the pano
                        return [
                            4,
                            _this54.showCaseTemp.showcase.Tour.stop()
                        ];
                    case 1:
                        _state1.sent();
                        _state1.label = 2;
                    case 2:
                        data = {
                            interacted: true,
                            panoramaOn: !panoramaOn,
                            activePano: panoramaOn ? null : _this54.state.activePano
                        };
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("toggle-pano", data);
                        }
                        if (!_this54.state.lock) {
                            _this54.setState(data);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        _this.getShareLocation = function() {
            var location = sdk/* getLocation.call */.k$.call((0,_assert_this_initialized/* default */.Z)(_this));
            var _state = _this.state, panoramaOn = _state.panoramaOn, panoramas = _state.panoramas;
            if (panoramaOn && (panoramas === null || panoramas === void 0 ? void 0 : panoramas.length) > 0 && _this.currentPanorama) {
                var pano = "pano=".concat(_this.currentPanorama.id);
                var panoPitch = "panoPitch=".concat(_this.panoPose.pitch);
                var panoYaw = "panoYaw=".concat(_this.panoPose.yaw);
                var panoHfov = "panoHfov=".concat(_this.panoPose.hfov);
                var query = "".concat(pano, "&").concat(panoPitch, "&").concat(panoYaw, "&").concat(panoHfov);
                if (location.split("?")[1]) {
                    location += "&".concat(query);
                } else {
                    location += "?".concat(query);
                }
            }
            return location;
        };
        _this.updatePanoRotation = function(north, pos, scene) {
            var _state = _this.state, room = _state.room, host = _state.host, lock = _state.lock, panoramas = _state.panoramas;
            if (room && socket/* default */.Z && socket/* default.connected */.Z.connected) {
                if (host) {
                    var pano = panoramas.find(function(p) {
                        return p.name === scene;
                    });
                    if ((pano === null || pano === void 0 ? void 0 : pano.id) === _this.currentPanorama.id) {
                        socket/* default.emit */.Z.emit("move-pano", {
                            panoPose: pos,
                            currentPanorama: _this.currentPanorama
                        });
                    }
                    util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
                } else if (!lock) {
                    util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
                }
            } else {
                util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
            }
        };
        _this.handlePanoSceneChange = function(scene) {
            _this.currentPanorama = scene;
            var _state = _this.state, room = _state.room, showcaseLoaded = _state.showcaseLoaded, host = _state.host;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                socket/* default.emit */.Z.emit("move-pano", {
                    panoPose: {
                        pitch: 0,
                        yaw: 0,
                        hfov: 100
                    },
                    currentPanorama: scene
                });
            }
        };
        _this.handleGameStartOnIntroModal = function(username) {
            _this.handleGameStart(username, true);
        };
        var _this55 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addAvatar = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, myX, myZ, ref21, x, z, json, modelId, response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ref20 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, 180 + _this55.avatarDegree, data === null || data === void 0 ? void 0 : (ref = data.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, data === null || data === void 0 ? void 0 : (ref2 = data.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.z), 2), myX = ref20[0], myZ = ref20[1];
                            ref21 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, data.degree, myX, myZ), 2), x = ref21[0], z = ref21[1];
                            if (!(data.avatarUrl && !data.avatarUrl.includes("base64"))) return [
                                3,
                                3
                            ];
                            modelId = getRPMModelId(data.avatarUrl);
                            return [
                                4,
                                fetch("https://models.readyplayer.me/".concat(modelId, ".json"))
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            json = _state.sent();
                            _state.label = 3;
                        case 3:
                            return [
                                4,
                                _this55.onAddAvatar(new virtualStaging_avatar/* Avatar */.qE({
                                    uuid: data.avatarId,
                                    bodyType: (json === null || json === void 0 ? void 0 : json.bodyType) || "image",
                                    name: data === null || data === void 0 ? void 0 : data.name,
                                    url: data.avatarUrl || null,
                                    positionX: _this55.defaultSweep && _this55.defaultSweep.sid === _this55.state.currentSweep.sid ? x : _this55.defaultSweep.position.x,
                                    positionY: (ref4 = data.pose) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.position) === null || ref5 === void 0 ? void 0 : ref5.y,
                                    positionZ: _this55.defaultSweep && _this55.defaultSweep.sid === _this55.state.currentSweep.sid ? z : _this55.defaultSweep.position.z,
                                    rotationX: (ref6 = data.pose) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.rotation) === null || ref7 === void 0 ? void 0 : ref7._x,
                                    rotationY: (ref8 = data.pose) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.rotation) === null || ref9 === void 0 ? void 0 : ref9._y,
                                    rotationZ: (ref10 = data.pose) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.rotation) === null || ref11 === void 0 ? void 0 : ref11._z,
                                    quaternionX: (ref12 = data.pose) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.quaternion) === null || ref13 === void 0 ? void 0 : ref13._x,
                                    quaternionY: (ref14 = data.pose) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.quaternion) === null || ref15 === void 0 ? void 0 : ref15._y,
                                    quaternionZ: (ref16 = data.pose) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.quaternion) === null || ref17 === void 0 ? void 0 : ref17._z,
                                    quaternionW: (ref18 = data.pose) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.quaternion) === null || ref19 === void 0 ? void 0 : ref19._w,
                                    degree: data.degree
                                }))
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this56 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onAddAvatar = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref, avatarNode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!_this56.avatarNodes.has(data.uuid)) return [
                                3,
                                2
                            ];
                            if (!data.positionX && !data.positionY && !data.positionZ) {
                                data.positionX = _this56.pose.position.x;
                                data.positionY = _this56.pose.position.y;
                                data.positionZ = _this56.pose.position.z;
                            }
                            return [
                                4,
                                _this56.initAvatarNode(data)
                            ];
                        case 1:
                            avatarNode = _state.sent();
                            avatarNode[0].obj3D.position.set(data.positionX, data.positionY, data.positionZ);
                            avatarNode[0].obj3D.rotation.set(data.rotationX, data.rotationY, data.rotationZ);
                            avatarNode[0].obj3D.quaternion.set(data.quaternionX, data.quaternionY, data.quaternionZ, data.quaternionW);
                            (ref = avatarNode[0].obj3D.children[0]) === null || ref === void 0 ? void 0 : ref.rotation.set(0, Math.PI, 0);
                            if (avatarNode === null || avatarNode === void 0 ? void 0 : avatarNode.length) {
                                if (!(data === null || data === void 0 ? void 0 : data.muted)) {
                                    if (avatarNode[2]) {
                                        // changing state to !active if video is not muted
                                        avatarNode[2].setActive(!avatarNode[2].isActive());
                                    }
                                }
                                _this56.avatarNodes.set(data.uuid, avatarNode);
                            }
                            return [
                                2,
                                avatarNode
                            ];
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this57 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onRemoveAvatar = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(uuid) {
                var ref, avatar;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (_this57.avatarNodes.size) {
                        ref = (0,_sliced_to_array/* default */.Z)(_this57.avatarNodes.get(uuid), 1), avatar = ref[0];
                        if (avatar) {
                            avatar.stop();
                            _this57.avatarNodes.delete(uuid);
                        }
                    }
                    return [
                        2
                    ];
                });
            });
            return function(uuid) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.videoEndCall = function() {
            socket/* default.close */.Z.close();
            _this.setState({
                reelVideos: []
            });
        };
        _this.videoChangeTour = function(data) {
            var tour = _this.state.tour;
            var m = (0,util_all/* getQueryVariable */.Dv)(_this.state.iframeUrl, "m");
            if (data.id && data.id !== m) {
                if (data.mp) {
                    var ref;
                    _this.moveModel("/mp-sdk/".concat("23.5.1", "/showcase.html?applicationKey=").concat(tour === null || tour === void 0 ? void 0 : (ref = tour.user) === null || ref === void 0 ? void 0 : ref.mpSDK, "&m=").concat(data.id));
                } else {
                    _this.getTour({
                        id: data.id,
                        changeMenu: false,
                        changeMinimap: true,
                        changePanorama: false
                    });
                }
            }
        };
        _this.changeMuteStatus = function(name, muted) {
            var _state = _this.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos, reelVideos = _state.reelVideos;
            var isReeled = reelVideos.findIndex(function(i) {
                return i.name === name;
            });
            var isPinned = pinnedVideos.findIndex(function(i) {
                return i.name === name;
            });
            var isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.name) === name;
            if (isFullscreen) {
                fullscreenVideo.muted = muted;
            } else if (isPinned >= 0) {
                pinnedVideos[isPinned].muted = muted;
                _this.addPinnedVideo(pinnedVideos[isPinned]);
            } else if (isReeled >= 0) {
                reelVideos[isReeled].muted = muted;
                _this.addVideoReel(reelVideos[isReeled]);
            }
        };
        var _this58 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addTrack = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(p) {
                var ref, ref1, _state, fullscreenVideo, pinnedVideos, audioEl, isFullscreen, isPinned;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    try {
                        ;
                        _state = _this58.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos;
                        if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "audio" && !p.self) {
                            audioEl = new Audio();
                            audioEl.append(p.track.attach());
                            audioEl.setAttribute("data-cy-audio-track-name", p.track.name);
                            audioEl.setAttribute("data-cy-audio-track-sid", p.sid);
                            document.body.appendChild(audioEl);
                            if (!p.enabled) {
                                audioEl.pause();
                                _this58.changeMuteStatus(p.name, true);
                            } else {
                                _this58.changeMuteStatus(p.name, false);
                            }
                        } else if (((ref1 = p.track) === null || ref1 === void 0 ? void 0 : ref1.kind) === "video") {
                            isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === p.sid;
                            isPinned = pinnedVideos.findIndex(function(i) {
                                return i.sid === p.sid;
                            });
                            if (p.dominant) {
                                _this58.setState({
                                    dominantSpeaker: p
                                });
                            } else if (isFullscreen) {
                                _this58.setState({
                                    fullscreenVideo: p
                                });
                            } else if (isPinned >= 0) {
                                // || p.track.name.includes('-screen')
                                // we pin screen shares
                                _this58.addPinnedVideo(p);
                            } else {
                                _this58.addVideoReel(p);
                            }
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this59 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeTrack = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sid) {
                var _state, fullscreenVideo, pinnedVideos, audioOnly, isFullscreen, isPinned;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    try {
                        _state = _this59.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos, audioOnly = _state.audioOnly;
                        isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === sid;
                        isPinned = pinnedVideos.findIndex(function(i) {
                            return i.sid === sid;
                        });
                        if (isFullscreen) {
                            _this59.setState({
                                fullscreenVideo: null
                            });
                        } else if (isPinned >= 0) {
                            _this59.removePinnedVideo(sid);
                            if (audioOnly) _this59.removePinnedVideo("".concat(sid, "_video"));
                        } else {
                            _this59.removeVideoReel(sid);
                            if (audioOnly) _this59.removeVideoReel("".concat(sid, "_video"));
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this60 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.updateAvatarsInList = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(name, avatarImage) {
                var reelVideos, index;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    try {
                        if (!avatarImage) return [
                            2
                        ];
                        reelVideos = (0,_to_consumable_array/* default */.Z)(_this60.state.reelVideos);
                        index = reelVideos.findIndex(function(i) {
                            return i.name === name;
                        });
                        if (index >= 0 && !reelVideos[index].avatarImage) {
                            reelVideos[index] = Object.assign(reelVideos[index], {
                                avatarImage: avatarImage
                            });
                            _this60.setState({
                                reelVideos: reelVideos
                            });
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(name, avatarImage) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this61 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addVideoReel = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(p) {
                var ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    try {
                        ;
                        if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "video") {
                            _this61.setState(function(prevState) {
                                var reelVideos = (0,_to_consumable_array/* default */.Z)(prevState.reelVideos);
                                var index = reelVideos.findIndex(function(i) {
                                    return i.sid === p.sid;
                                });
                                if (index >= 0) {
                                    reelVideos[index] = Object.assign(reelVideos[index], p);
                                } else {
                                    reelVideos.push(p);
                                }
                                return {
                                    reelVideos: reelVideos
                                };
                            });
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this62 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeVideoReel = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sid) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    console.log("Removing ".concat(sid, " from reel"));
                    _this62.setState(function(prevState) {
                        return {
                            reelVideos: prevState.reelVideos.filter(function(i) {
                                return i.sid !== sid;
                            })
                        };
                    });
                    return [
                        2
                    ];
                });
            });
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this63 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addPinnedVideo = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(p) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    addPinnedVideoFunc(p, _this63.state.pinnedVideos, function(pinnedVideos) {
                        _this63.setState({
                            pinnedVideos: pinnedVideos
                        }, function() {
                            if (!p.pinned) _this63.removeVideoReel(p.sid);
                        });
                    });
                    return [
                        2
                    ];
                });
            });
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this64 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removePinnedVideo = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sid) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _this64.setState({
                        pinnedVideos: _this64.state.pinnedVideos.filter(function(i) {
                            return i.sid !== sid;
                        })
                    });
                    return [
                        2
                    ];
                });
            });
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this65 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleFullscreenVideo = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(participant) {
                var pinned, _state, fullscreenVideo, pinnedVideos, newPinnedVideos;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    pinned = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    _state = _this65.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos;
                    if ((fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === participant.sid) {
                        // close fullscreen video
                        if (fullscreenVideo.pinned) {
                            _this65.addPinnedVideo((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fullscreenVideo), {
                                pinned: pinned
                            }));
                        } else {
                            _this65.addVideoReel(fullscreenVideo);
                        }
                        _this65.setState({
                            fullscreenVideo: null
                        });
                        document.removeEventListener("keydown", _this65.exitFullscreenVideo);
                    } else {
                        // open fullscreen video
                        _this65.setState({
                            fullscreenVideo: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, participant), {
                                pinned: pinned
                            })
                        });
                        if (fullscreenVideo) {
                            // first close old one, then add the new one
                            if (fullscreenVideo.pinned) {
                                newPinnedVideos = (0,_to_consumable_array/* default */.Z)(pinnedVideos.filter(function(p) {
                                    return p.sid !== participant.sid;
                                })).concat([
                                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fullscreenVideo), {
                                        pinned: false
                                    })
                                ]);
                                _this65.setState({
                                    pinnedVideos: newPinnedVideos
                                });
                            } else {
                                _this65.addVideoReel(fullscreenVideo);
                            }
                        } else {
                            _this65.removePinnedVideo(participant.sid);
                        }
                        _this65.removeVideoReel(participant.sid);
                        document.addEventListener("keydown", _this65.exitFullscreenVideo);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(participant) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.exitFullscreenVideo = function(event) {
            if (event.key === "Escape") {
                event.preventDefault();
                if (_this.state.fullscreenVideo) {
                    _this.toggleFullscreenVideo(_this.state.fullscreenVideo);
                }
            }
        };
        var _this66 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initAvatar = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, tour, room, avatar, e;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this66.state, tour = _state.tour, room = _state.room;
                        if (!tour.enableAvatar) return [
                            2
                        ];
                        _state1.label = 1;
                    case 1:
                        _state1.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        avatar = (0,storage/* storage */.t)("avatar").get();
                        if (!!avatar) return [
                            3,
                            2
                        ];
                        _this66.setState({
                            avatar: null,
                            chatParticipant: null
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        if (!!room) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            _this66.setAvatar(avatar)
                        ];
                    case 3:
                        _state1.sent();
                        _state1.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state1.sent();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        var _this67 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleMuteParticipants = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sid) {
                var audioEl, mute;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    audioEl = document.querySelectorAll("[data-cy-audio-track-sid=".concat(sid, "]"));
                    mute = false;
                    if (audioEl && audioEl.length > 0) {
                        if (audioEl[0].playing) {
                            audioEl[0].pause();
                            mute = true;
                        } else {
                            audioEl[0].play();
                            mute = false;
                        }
                        if (_this67.state.host) {
                            socket/* default.emit */.Z.emit("mute_participant", {
                                participantId: sid,
                                mute: mute
                            });
                        }
                    }
                    return [
                        2
                    ];
                });
            });
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this68 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getAvatarImage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                var id, response, json, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            if (!url.includes(".glb")) throw new Error("No GLB");
                            id = url.split("/").pop().split(".glb")[0];
                            return [
                                4,
                                fetch("https://models.readyplayer.me/".concat(id, ".json"))
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            json = _state.sent();
                            return [
                                4,
                                new Promise(function(resolve) {
                                    var imageUrl = "https://api.readyplayer.me/v1/avatars/".concat(id, ".png?scene=").concat(json.bodyType, "-portrait-v1-transparent");
                                    _this68.setState({
                                        avatarImage: imageUrl
                                    }, function() {
                                        return resolve(imageUrl);
                                    });
                                })
                            ];
                        case 3:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 4:
                            err = _state.sent();
                            console.log(err);
                            return [
                                2,
                                ""
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this69 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setAvatarImage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _this69.setState({
                        avatarImage: url
                    });
                    return [
                        2
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this70 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setAvatar = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref, ref1, _state, tour, room, avatarImage, _, _tmp, _1, _tmp1, _tmp2, _tmp3, avatarId, avatar, user;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            _state = _this70.state, tour = _state.tour, room = _state.room, avatarImage = _state.avatarImage;
                            _ = _this70.setState;
                            _tmp = {};
                            _1 = Object.assign;
                            _tmp1 = [
                                data
                            ];
                            _tmp2 = {};
                            _tmp3 = avatarImage;
                            if (_tmp3) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this70.getAvatarImage(data.url)
                            ];
                        case 1:
                            _tmp3 = _state1.sent();
                            _state1.label = 2;
                        case 2:
                            _.apply(_this70, [
                                (_tmp.chatParticipant = _1.apply(Object, _tmp1.concat((_tmp2.imageUrl = _tmp3, _tmp2))), _tmp)
                            ]);
                            if (!tour.enableAvatar) return [
                                2
                            ];
                            avatarId = (0,v4/* default */.Z)();
                            avatar = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                uuid: avatarId,
                                imageUrl: avatarImage
                            });
                            (0,storage/* storage */.t)("avatar").set(avatar);
                            _this70.setState({
                                avatar: avatar
                            });
                            user = {
                                name: data === null || data === void 0 ? void 0 : data.name,
                                room: room || tour.id,
                                avatarUrl: data.url,
                                avatarId: avatarId,
                                avatarImage: avatarImage,
                                model: data.model,
                                pose: {
                                    rotation: (ref = _this70.camera) === null || ref === void 0 ? void 0 : ref.rotation,
                                    quaternion: (ref1 = _this70.camera) === null || ref1 === void 0 ? void 0 : ref1.quaternion,
                                    position: _this70.pose.position
                                },
                                sweep: _this70.pose.sweep
                            };
                            socket/* default.emit */.Z.emit("user_joining", user);
                            console.log("Joining avatar to room ".concat(room));
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.toggleSketchfabPopup = function(state) {
            return function() {
                _this.setState({
                    showSketchfabPopup: state
                });
            };
        };
        _this.onCloseIntro = function() {
            var _state = _this.state, tour = _state.tour, _$tourType = _state.tourType;
            if (_$tourType === Tour/* TourType.Game */.v.Game) {
                var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
                _this.setState({
                    showIntro: false
                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(tour === null || tour === void 0 ? void 0 : tour.autoplayMusic)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.playTourAudio().catch(function() {})
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }));
            } else {
                var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
                _this.setState({
                    showIntro: false,
                    forcePlayGameIntro: true
                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this2.playTourAudio().catch(function() {})
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        };
        _this.getCurrentLanguage = function() {
            var ref;
            return (ref = _this.state.initialDuplicates) === null || ref === void 0 ? void 0 : ref.find(function(duplicate) {
                var ref, ref1;
                return duplicate.slug === ((ref = _this.state) === null || ref === void 0 ? void 0 : (ref1 = ref.tour) === null || ref1 === void 0 ? void 0 : ref1.slug);
            });
        };
        _this.unlockChapter = function(targetObj, type) {
            var _state = _this.state, _game = _state.game, book = _game.book, gameBookOn = _game.gameBookOn, unlockedChapterIds = _state.unlockedChapterIds, clickedElements = _state.clickedElements;
            var value = targetObj === null || targetObj === void 0 ? void 0 : targetObj.id;
            _this.setState({
                clickedElements: (0,_to_consumable_array/* default */.Z)(clickedElements).concat([
                    {
                        type: type,
                        value: value,
                        sid: targetObj === null || targetObj === void 0 ? void 0 : targetObj.sid,
                        defaultSid: targetObj === null || targetObj === void 0 ? void 0 : targetObj.defaultSid
                    }, 
                ])
            });
            if (!gameBookOn || !book) return;
            var chapters = sortBy_default()(book === null || book === void 0 ? void 0 : book.chapters, "order");
            var chapter = chapters.find(function(item) {
                return item.order === unlockedChapterIds.length + 1;
            });
            var unblock = false;
            switch(type){
                case GameBook/* ChapterType.Tag */._U.Tag:
                    {
                        var tag = targetObj;
                        unblock = chapter && chapter.type === GameBook/* ChapterType.Tag */._U.Tag && (chapter.value === String(tag.id) || chapter.value === tag.sid);
                        break;
                    }
                case GameBook/* ChapterType.Polygon */._U.Polygon:
                    var polygon = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.Polygon */._U.Polygon && chapter.value === String(polygon.id);
                    break;
                case GameBook/* ChapterType.VSItem */._U.VSItem:
                    var vsItem = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSItem */._U.VSItem && chapter.value === String(vsItem.id);
                    break;
                case GameBook/* ChapterType.VSImage */._U.VSImage:
                    var vsImage = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSImage */._U.VSImage && chapter.value === String(vsImage.id);
                    break;
                case GameBook/* ChapterType.VSVideo */._U.VSVideo:
                    var vsVideo = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSVideo */._U.VSVideo && chapter.value === String(vsVideo.id);
                    break;
                default:
                    break;
            }
            if (unblock) {
                _this.tryButtonPlaySound();
                _this.setState({
                    unlockedChapterIds: (0,_to_consumable_array/* default */.Z)(unlockedChapterIds).concat([
                        chapter.id
                    ])
                });
            }
        };
        var _this71 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onPathAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(element, type) {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(type === GameBook/* ChapterType.Tag */._U.Tag)) return [
                                3,
                                1
                            ];
                            _this71.openTagIframe(element.sid);
                            return [
                                3,
                                7
                            ];
                        case 1:
                            if (!(type === GameBook/* ChapterType.VSItem */._U.VSItem)) return [
                                3,
                                2
                            ];
                            _this71.openVsObjectIframe(element);
                            return [
                                3,
                                7
                            ];
                        case 2:
                            if (!(type === GameBook/* ChapterType.VSVideo */._U.VSVideo)) return [
                                3,
                                3
                            ];
                            _this71.openVsVideoIframe(element);
                            return [
                                3,
                                7
                            ];
                        case 3:
                            if (!(type === GameBook/* ChapterType.Polygon */._U.Polygon)) return [
                                3,
                                5
                            ];
                            data = (element === null || element === void 0 ? void 0 : element.polygonsActions) ? element.polygonsActions[0] : element;
                            return [
                                4,
                                _this71.handlePolygonAction(data)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                3,
                                7
                            ];
                        case 5:
                            if (!(type === GameBook/* ChapterType.VSImage */._U.VSImage)) return [
                                3,
                                7
                            ];
                            return [
                                4,
                                _this71.handleVSAction(element)
                            ];
                        case 6:
                            _state.sent();
                            _state.label = 7;
                        case 7:
                            _this71.setState({
                                clickedElement: {
                                    id: element.id,
                                    type: type
                                }
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(element, type) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this72 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.__hideConditions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(conditions) {
                var _Sweep, ref, _state, polygons, allTags, availableSweeps, _tags, polygonsToHide, vsItemsToHide, vsVideosToHide, vsImagesToHide, sweeps, currentRevealedConditions, uniqueCondSweeps, availableCondSweeps, allTagsArray, tagsToHide;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            // mattertag - editOpacity and make it 0 |  mpSdk.Mattertag.getData(); mpSdk.Mattertag.editOpacity(mattertagData[0].sid, 0);
                            if (!conditions.length) return [
                                2
                            ];
                            console.debug("__hideConditions", conditions);
                            _state = _this72.state, polygons = _state.polygons, allTags = _state.allTags;
                            availableSweeps = (ref = _this72.state.sweeps) === null || ref === void 0 ? void 0 : ref.map(function(s) {
                                return s.sid;
                            });
                            _tags = [];
                            polygonsToHide = [];
                            vsItemsToHide = [];
                            vsVideosToHide = [];
                            vsImagesToHide = [];
                            sweeps = [];
                            currentRevealedConditions = [];
                            conditions.forEach(function(condition) {
                                if (!condition.entity_ids) return;
                                if (condition.entity_type === Game/* EntityType.Tag */.py.Tag) {
                                    _tags = (0,_to_consumable_array/* default */.Z)(_tags).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                                    polygonsToHide = (0,_to_consumable_array/* default */.Z)(polygonsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                                    vsItemsToHide = (0,_to_consumable_array/* default */.Z)(vsItemsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                                    vsVideosToHide = (0,_to_consumable_array/* default */.Z)(vsVideosToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                                    vsImagesToHide = (0,_to_consumable_array/* default */.Z)(vsImagesToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Sweep */.py.Sweep) {
                                    sweeps = (0,_to_consumable_array/* default */.Z)(sweeps).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                }
                                currentRevealedConditions.push(condition.id);
                            });
                            console.debug("-----------disabling sweeps-----------", sweeps);
                            uniqueCondSweeps = new Set(sweeps);
                            availableCondSweeps = Array.from(uniqueCondSweeps).filter(function(s) {
                                return availableSweeps.includes(s);
                            });
                            (_Sweep = _this72.showcase.Sweep).disable.apply(_Sweep, (0,_to_consumable_array/* default */.Z)(availableCondSweeps)).catch(function(err) {
                                return console.error(err);
                            });
                            allTagsArray = Array.from(allTags, function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value;
                            });
                            tagsToHide = _tags.map(function(tag) {
                                return allTagsArray.find(function(allTagItem) {
                                    return allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag;
                                });
                            });
                            console.debug("-----------disabling tags-----------", tagsToHide);
                            tagsToHide.forEach(function(_tag) {
                                return _tag && _this72._changeTagPos(_tag, false);
                            });
                            if (!(polygons && polygons.map)) return [
                                3,
                                2
                            ];
                            console.debug("Polygons to hide", polygonsToHide, polygons);
                            return [
                                4,
                                Promise.all(polygons.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, nodeIndex;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            if (polygonsToHide.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1 || polygonsToHide.indexOf(item === null || item === void 0 ? void 0 : item.id) !== -1) {
                                                if (!(item === null || item === void 0 ? void 0 : item.active)) {
                                                    console.debug("-----------not hiding polygon (inactive) ----------", item);
                                                }
                                                nodeIndex = _this72.modelNodes.findIndex(function(node) {
                                                    var ref, ref1;
                                                    return (node === null || node === void 0 ? void 0 : (ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                                });
                                                if (nodeIndex >= 0 && item.uuid) {
                                                    console.debug("-----------hiding polygon ----------", item);
                                                    _this72.modelNodes[nodeIndex][0].stop();
                                                    item.uuid = null;
                                                    _this72.modelNodes.splice(nodeIndex, 1);
                                                }
                                            }
                                            return [
                                                2
                                            ];
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            _state1.sent();
                            _state1.label = 2;
                        case 2:
                            return [
                                4,
                                Promise.all((_this72.vsObjects || []).map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, targetObjToHide;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP)) {
                                                        targetObjToHide = vsImagesToHide;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up)) {
                                                        targetObjToHide = vsVideosToHide;
                                                    } else {
                                                        targetObjToHide = vsItemsToHide;
                                                    }
                                                    if (!(targetObjToHide && (targetObjToHide.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1 || targetObjToHide.indexOf(item === null || item === void 0 ? void 0 : item.id) !== -1))) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (item && !item.active) return [
                                                        2,
                                                        item
                                                    ];
                                                    console.debug("-----------hiding vs ----------", item);
                                                    return [
                                                        4,
                                                        _this72.setVSVisible(item, false)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2,
                                                        (0,_object_spread/* default */.Z)({}, item)
                                                    ];
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(conditions) {
                return _ref.apply(this, arguments);
            };
        }();
        _this._changeTagPos = function(_tag, isVisible) {
            var sid = _tag.sid;
            console.debug("-----------".concat(isVisible ? "revealing" : "hiding", " tag ----------"), _tag);
            _this.showcase.Tag.editOpacity(sid, isVisible ? 1 : 0).catch(function(e) {
                return console.error(e);
            });
            _this.showcase.Tag.editPosition(sid, {
                anchorPosition: {
                    x: isVisible ? _tag.positionX : 0,
                    y: isVisible ? _tag.positionY : 0,
                    z: isVisible ? _tag.positionZ : 0
                },
                stemVector: {
                    x: isVisible ? _tag.stemVectorX : 0,
                    y: isVisible ? _tag.stemVectorY : 0,
                    z: isVisible ? _tag.stemVectorZ : 0
                },
                // floorIndex: isVisible ? _tag.floor : 0,
                floorIndex: _tag.floor
            }).catch(function(e) {
                return console.error(e);
            });
        };
        var _this73 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.__revealConditions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(conditions) {
                var _Sweep, ref, _state, polygons, allTags, availableSweeps, _tags, polygonsToReveal, vsItemsToReveal, vsVideosToReveal, vsImagesToReveal, sweeps, _$popups, currentRevealedConditions, uniqueCondSweeps, availableCondSweeps, allTagsArray, tagsToShow;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            // this.showcase.Sweep.disable(sweep.uuid, sweep2.uuid,...)
                            // mattertag - editOpacity and make it 0 |  mpSdk.Mattertag.getData(); mpSdk.Mattertag.editOpacity(mattertagData[0].sid, 0);
                            if (!conditions.length) return [
                                2
                            ];
                            console.debug("__revealConditions", conditions);
                            _state = _this73.state, polygons = _state.polygons, allTags = _state.allTags;
                            availableSweeps = (ref = _this73.state.sweeps) === null || ref === void 0 ? void 0 : ref.map(function(s) {
                                return s.sid;
                            });
                            _tags = [];
                            polygonsToReveal = [];
                            vsItemsToReveal = [];
                            vsVideosToReveal = [];
                            vsImagesToReveal = [];
                            sweeps = [];
                            _$popups = [];
                            currentRevealedConditions = [];
                            conditions.forEach(function(condition) {
                                if (!condition.entity_ids) return;
                                if (condition.entity_type === Game/* EntityType.Tag */.py.Tag) {
                                    _tags = (0,_to_consumable_array/* default */.Z)(_tags).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                                    polygonsToReveal = (0,_to_consumable_array/* default */.Z)(polygonsToReveal).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                                    vsItemsToReveal = (0,_to_consumable_array/* default */.Z)(vsItemsToReveal).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                                    vsVideosToReveal = (0,_to_consumable_array/* default */.Z)(vsVideosToReveal).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                                    vsImagesToReveal = (0,_to_consumable_array/* default */.Z)(vsImagesToReveal).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Sweep */.py.Sweep) {
                                    sweeps = (0,_to_consumable_array/* default */.Z)(sweeps).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Popup */.py.Popup) {
                                    _$popups = (0,_to_consumable_array/* default */.Z)(_$popups).concat([
                                        condition
                                    ]);
                                }
                                currentRevealedConditions.push(condition.id);
                            });
                            console.debug("-----------enabling sweeps-----------", sweeps);
                            uniqueCondSweeps = new Set(sweeps);
                            availableCondSweeps = Array.from(uniqueCondSweeps).filter(function(s) {
                                return availableSweeps.includes(s);
                            });
                            (_Sweep = _this73.showcase.Sweep).enable.apply(_Sweep, (0,_to_consumable_array/* default */.Z)(availableCondSweeps)).catch(function(err) {
                                return console.error(err);
                            });
                            allTagsArray = Array.from(allTags, function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value;
                            });
                            tagsToShow = _tags.map(function(tag) {
                                return allTagsArray.find(function(allTagItem) {
                                    return allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag;
                                });
                            });
                            tagsToShow.forEach(function(_tag) {
                                return _tag && _this73._changeTagPos(_tag, true);
                            });
                            if (!(polygons && polygons.map)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                Promise.all(polygons.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, node;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(polygonsToReveal.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1 || polygonsToReveal.indexOf(item === null || item === void 0 ? void 0 : item.id) !== -1)) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (!item.active) {
                                                        console.debug("-----------not revealing polygons (inactive)----------", item);
                                                    }
                                                    console.debug("-----------revealing polygons ----------", item);
                                                    if (!!item.uuid) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        _this73.initPolygonNode(item)
                                                    ];
                                                case 1:
                                                    node = _state.sent();
                                                    _this73.modelNodes.push(node);
                                                    item.uuid = node[0].obj3D.uuid;
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            _state1.sent();
                            _state1.label = 2;
                        case 2:
                            return [
                                4,
                                Promise.all((_this73.vsObjects || []).map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, targetObjToReveal;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP)) {
                                                        targetObjToReveal = vsImagesToReveal;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up)) {
                                                        targetObjToReveal = vsVideosToReveal;
                                                    } else {
                                                        targetObjToReveal = vsItemsToReveal;
                                                    }
                                                    if (!(targetObjToReveal && (targetObjToReveal.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1 || targetObjToReveal.indexOf(item === null || item === void 0 ? void 0 : item.id) !== -1))) return [
                                                        3,
                                                        2
                                                    ];
                                                    // console.log('game item, item.active', item, item.active);
                                                    if (item && !item.active) return [
                                                        2,
                                                        item
                                                    ];
                                                    console.debug("-----------revealing vsItem ----------", item);
                                                    return [
                                                        4,
                                                        _this73.setVSVisible(item, true, types/* vsTriggerType.revealCondition */.QB.revealCondition)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2,
                                                        (0,_object_spread/* default */.Z)({}, item)
                                                    ];
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(conditions) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this74 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.showElements = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var tagsToReveal, polygonsToReveal, vsImagesToReveal, vsVideosToReveal, vsItemsToReveal, _state, allTags, polygons, allTagsArray, tagsToShow, currentObjUuid;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            tagsToReveal = param.tagsToReveal, polygonsToReveal = param.polygonsToReveal, vsImagesToReveal = param.vsImagesToReveal, vsVideosToReveal = param.vsVideosToReveal, vsItemsToReveal = param.vsItemsToReveal;
                            _state = _this74.state, allTags = _state.allTags, polygons = _state.polygons;
                            allTagsArray = Array.from(allTags, function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value;
                            });
                            tagsToShow = tagsToReveal.map(function(tag) {
                                return allTagsArray.find(function(allTagItem) {
                                    return allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag;
                                });
                            });
                            tagsToShow.forEach(function(_tag) {
                                return _tag && _this74._changeTagPos(_tag, true);
                            });
                            currentObjUuid = null;
                            if (!(polygons && polygons.map)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                Promise.all(polygons.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, node;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(polygonsToReveal.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1)) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (!(item.active && !item.uuid)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        _this74.initPolygonNode(item)
                                                    ];
                                                case 1:
                                                    node = _state.sent();
                                                    _this74.modelNodes.push(node);
                                                    item.uuid = node[0].obj3D.uuid;
                                                    currentObjUuid = item.uuid;
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            _state1.sent();
                            _state1.label = 2;
                        case 2:
                            return [
                                4,
                                Promise.all((_this74.vsObjects || []).map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, targetObjToReveal;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP)) {
                                                        targetObjToReveal = vsImagesToReveal;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up)) {
                                                        targetObjToReveal = vsVideosToReveal;
                                                    } else {
                                                        targetObjToReveal = vsItemsToReveal;
                                                    }
                                                    if (!(targetObjToReveal && targetObjToReveal.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1)) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (item && !item.active) return [
                                                        2,
                                                        item
                                                    ];
                                                    return [
                                                        4,
                                                        _this74.setVSVisible(item, true)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                2,
                                currentObjUuid
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this75 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.hideElements = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var hideTags, polygonsToHide, vsImagesToHide, vsVideosToHide, vsItemsToHide, initial, _state, allTags, polygons, allTagsArray, tagsToHide;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            hideTags = param.hideTags, polygonsToHide = param.polygonsToHide, vsImagesToHide = param.vsImagesToHide, vsVideosToHide = param.vsVideosToHide, vsItemsToHide = param.vsItemsToHide, initial = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                            _state = _this75.state, allTags = _state.allTags, polygons = _state.polygons;
                            allTagsArray = Array.from(allTags, function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value;
                            });
                            tagsToHide = hideTags.map(function(tag) {
                                return allTagsArray.find(function(allTagItem) {
                                    return allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag;
                                });
                            });
                            console.debug("-----------disabling tags-----------", tagsToHide);
                            tagsToHide.forEach(function(_tag) {
                                return _tag && _this75._changeTagPos(_tag, false);
                            });
                            if (!(polygons && polygons.map)) return [
                                3,
                                2
                            ];
                            console.debug("(hideElements) Polygons to hide", polygonsToHide, polygons);
                            return [
                                4,
                                Promise.all(polygons.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, nodeIndex;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            if (polygonsToHide.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1) {
                                                if (!(item === null || item === void 0 ? void 0 : item.active)) {
                                                    console.debug("-----------not hiding polygon (inactive) ----------", item);
                                                }
                                                console.debug("-----------hiding polygon ----------", item);
                                                nodeIndex = _this75.modelNodes.findIndex(function(node) {
                                                    var ref, ref1;
                                                    return (node === null || node === void 0 ? void 0 : (ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                                });
                                                if (nodeIndex >= 0) {
                                                    _this75.modelNodes[nodeIndex][0].stop();
                                                    item.uuid = null;
                                                    _this75.modelNodes.splice(nodeIndex, 1);
                                                }
                                            }
                                            return [
                                                2
                                            ];
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            _state1.sent();
                            _state1.label = 2;
                        case 2:
                            return [
                                4,
                                Promise.all((_this75.vsObjects || []).map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, targetObjToHide;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP)) {
                                                        targetObjToHide = vsImagesToHide;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up)) {
                                                        targetObjToHide = vsVideosToHide;
                                                    } else {
                                                        targetObjToHide = vsItemsToHide;
                                                    }
                                                    if (!(targetObjToHide && targetObjToHide.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1)) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (item && !item.active) return [
                                                        2,
                                                        item
                                                    ];
                                                    console.debug("-----------hiding setVSVisible vs ----------", item);
                                                    return [
                                                        4,
                                                        _this75.setVSVisible(item, false)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2,
                                                        (0,_object_spread/* default */.Z)({}, item)
                                                    ];
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.updateCssMenuWidth = function(width) {
            var menuWidth = _this.state.menuOpen ? width || _this.state.menuWidth : 0;
            document.documentElement.style.setProperty("--menu-width", "".concat(menuWidth, "px"));
            document.documentElement.style.setProperty("--pano-close-btn-width", "".concat(_this.state.panoramaOn ? 60 : 0, "px"));
        };
        _this.state = {
            isTagHovered: false,
            allAudio: null,
            iframeId: "iframe_".concat(randomNumberId()),
            showcaseLoaded: false,
            showSketchfabPopup: false,
            tour: null,
            floors: [],
            allowGuestBeforeHost: false,
            changeMenu: false,
            pathfinderDataState: {},
            menus: [],
            menuSettings: {},
            reelVideos: [],
            pinnedVideos: [],
            reel: [],
            changeReel: false,
            sweeps: [],
            mpFloors: [],
            mpLabels: [],
            translation: {},
            tourEmail: null,
            sweepGroups: [],
            loadedObjects: [],
            host: props.rule === "host",
            audioOnly: props.videoType === "audio",
            minimaps: [],
            clickedTag: false,
            allTags: new Map(),
            interacted: false,
            selectedMinimap: 0,
            menuOpened: false,
            iframeUrl: null,
            menuOpen: false,
            musicPausedByUser: false,
            tourAudioPlaying: false,
            vsHTMLPopup: {
                show: false,
                src: null
            },
            overlayOn: false,
            videoPlaying: false,
            externalPopupOn: false,
            contactPopupOn: false,
            panoramas: [],
            polygons: [],
            agents: [],
            tagPopOn: false,
            panoPopOn: false,
            gameLockPopOn: false,
            openedLock: null,
            userAnswerForGameLock: null,
            videoChatTagPopOn: false,
            vsActionPopOn: false,
            panoramaOn: false,
            openedTag: null,
            openedPanoHotspot: null,
            openedVSAction: new VSObject/* TourImage */.oP(),
            externalPopupUrl: null,
            minimapOn: false,
            minimapVisible: false,
            mesurementsOn: false,
            markerPopupOn: false,
            sharePopupOn: false,
            tourPlaying: false,
            mapWalkerRotation: 0,
            reelStep: 0,
            mapWalkerX: null,
            mapWalkerY: null,
            activeSweepGroup: null,
            dominantSpeaker: null,
            // user: null,
            selectedMarker: {
                url: null,
                external: null
            },
            tokenRemainingTime: -1,
            tokenExpiresAt: null,
            // createdAt: null,
            // clock: false,
            ticketingOpen: false,
            activePano: null,
            appointmentsModal: false,
            appointmentsHintOn: true,
            getInTouchHintOn: true,
            MenuHintOn: true,
            lock: false,
            room: props.room,
            whiteLabelData: null,
            showHelpModal: false,
            showTermsModal: false,
            showCollectLeadsModal: false,
            activeMenu: null,
            products: [],
            tourType: tourType,
            vsSettings: new VSSettings/* VSSettings */.E(),
            isVSReady: false,
            containerId: "public",
            loadingTags: true,
            game: null,
            currentFloor: null,
            panoPose: {
                yaw: 0,
                pitch: 0,
                hfov: 0
            },
            isVSEnabled: true,
            isVSVisible: true,
            loadedOnce: false,
            showPathFinderPopup: false,
            ticketTimeLeftMs: null,
            tourMode: null,
            experiencePopUpIsOpen: false,
            onExperienceCloseCallback: function() {
                return undefined;
            },
            currentSweep: null,
            experiencePopUpData: null,
            closedElementPopup: true,
            isEnableNextPathLock: true,
            initialDuplicates: null,
            isChangeIframe: false,
            avatar: {},
            chatParticipant: {},
            infoModalData: null,
            gameTrialErr: null,
            crashScreen: false,
            unlockedChapterIds: [],
            clickedElements: [],
            hideSubtitlesGroupId: null,
            showBottomBar: true,
            hideBottomBarForWhile: false,
            isShowNearestProducts: true,
            nearestProducts: [],
            waitLoadingPolygons: false,
            isClickedElement: false,
            isShowProducts: false,
            isShowProduct: false,
            startScreenOn: false,
            showCookieFullScreen: false,
            hideLogo: false,
            tourTransitionLoader: false,
            mondelezTabletVideo: {
                videoId: undefined,
                sweepsHistory: []
            },
            menuWidth: 0,
            showActionPathBar: false,
            actionPathNavbarButtonText: null,
            closeBurgerMenuFromThreads: false,
            isThreadsDrawerOpen: false
        };
        _this.loadingQueue = LoadingQueue/* default.getInstance */.Z.getInstance();
        _this.loadingQueue.subscribe(function(loaded) {
            if (loaded === true) {
                // commented untill find good solution for youtube embed scroll fix for windows that will not affect other attachments
                // const style = document.createElement('style');
                // style.innerText = '.tag-media .attachment-carousel .attachment-carousel-view .attachment {height: 205px;}';
                // this.iframe.contentDocument.head.appendChild(style);
                _this.setState({
                    loaded: true
                });
            }
        });
        _this.rendererRef = /*#__PURE__*/ react.createRef();
        _this.gamepadLRef = /*#__PURE__*/ react.createRef();
        _this.gamepadRRef = /*#__PURE__*/ react.createRef();
        _this.cameraPose = /*#__PURE__*/ react.createRef();
        _this.pathArrowRefBaseTour = /*#__PURE__*/ react.createRef();
        _this.deferVisibilityVSObjectRef = /*#__PURE__*/ react.createRef();
        _this.deferVisibilityVSObjectRef.current = [];
        _this.calculateLocation = calculateLocation.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.buildLink = util_all/* buildLink.bind */.DF.bind((0,_assert_this_initialized/* default */.Z)(_this)); // need this code ??
        _this.openTagIframe = sdk/* openTagIframe.bind */.$O.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsObjectIframe = sdk/* openVsObjectIframe.bind */.BY.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsImageIframe = sdk/* openVsImageIframe.bind */.IW.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsVideoIframe = sdk/* openVsVideoIframe.bind */.O7.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.loadModel = sdk/* loadModel.bind */.u7.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.moveToMPLabels = sdk/* moveToMPLabels.bind */.QO.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.setWhiteLabel = util_all/* setWhiteLabel.bind */.Jw.bind((0,_assert_this_initialized/* default */.Z)(_this));
        document.addEventListener("keydown", _this.takePosition);
        _this.toggleExternalPopup = popups/* toggleExternalPopup.bind */.J.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.toggleExternalPopupNull = popups/* toggleExternalPopup.bind */.J.bind((0,_assert_this_initialized/* default */.Z)(_this), null);
        _this.toggleContactPopup = popups/* toggleContactPopup.bind */.O.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.takeScreenshot = sdk/* takeScreenshot.bind */.ss.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.takePano = sdk/* takePano.bind */.Zy.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openedPanoHotspot = sdk/* openedPanoHotspot.bind */.Z4.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.login = util_all/* login.bind */.x4.bind((0,_assert_this_initialized/* default */.Z)(_this));
        var room = _this.state.room;
        _this.prevPathFinderData = {
            isEnablePreviousStep: false,
            description: ""
        };
        _this.menuMeshState = null;
        _this.animate();
        socket/* default.on */.Z.on("move_avatar", function(data) {
            var ref, ref1, ref2, ref3;
            var tour = _this.state.tour;
            var THREE = (0,_assert_this_initialized/* default */.Z)(_this).THREE;
            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return;
            var avatar = _this.avatarNodes.get(data.avatarId);
            // Is the avatar moving into my sweep? (sweep id...)
            // if it does, use relative position, avatar.relative
            var ref4 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, 180 + _this.avatarDegree, data === null || data === void 0 ? void 0 : (ref = data.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, (ref2 = data.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.z), 2), myX = ref4[0], myZ = ref4[1];
            var ref5 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, data.degree, myX, myZ), 2), x = ref5[0], z = ref5[1];
            if (avatar && avatar[1] && avatar[1].outputs.loadingState === VSObject/* LoadingState.Loaded */.Gu.Loaded) {
                console.log(avatar[1].inputs.bodyType);
                if (avatar[1].inputs.bodyType === "fullbody") {
                    if (data.pose.sweep.sid !== "") {
                        // check if avatar sweep has changed
                        var shouldAnimationPlay = _this.didAvatarSweepChange(avatar[1].id, data.pose.sweep.id);
                        if (shouldAnimationPlay) {
                            var targetPosVec3 = new THREE.Vector3(data.degree && _this.avatarDegree ? x : data.pose.sweep.position.x, data.pose.sweep.position.y, data.degree && _this.avatarDegree ? z : data.pose.sweep.position.z);
                            _this.moveAvatarToPoint(avatar, targetPosVec3, THREE);
                        }
                        avatar[0].obj3D.children[0].children[0].rotation.set(-Math.PI / 2, 0, 0);
                    }
                    var vec3 = new THREE.Vector3(0, 0, 1);
                    var quaternion = new THREE.Quaternion(data.pose.quaternion._x, data.pose.quaternion._y, data.pose.quaternion._z, data.pose.quaternion._w);
                    vec3.applyQuaternion(quaternion);
                    var vec3Projected = vec3.clone();
                    vec3Projected.projectOnPlane(_this.yAxisVec3);
                    vec3Projected.negate().normalize();
                    var mx = new THREE.Matrix4().lookAt(vec3Projected, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 1, 0));
                    var qt = new THREE.Quaternion().setFromRotationMatrix(mx);
                    avatar[1].rotateTo(qt, function(tween) {
                        // If there is active tween, stops it. Replaces/adds this tween to avatarId
                        var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                            return el.avatarId === avatar[1].id;
                        });
                        if (avatarTweenData) {
                            if (avatarTweenData.activeRotationTween) avatarTweenData.activeRotationTween.stop();
                            if (avatarTweenData.activeTween) tween.stop();
                            avatarTweenData.activeRotationTween = tween;
                        } else _this.connectedAvatarsTweens.push({
                            avatarId: avatar[1].id,
                            activeTween: null,
                            activeRotationTween: tween
                        });
                    }, function() {
                        var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                            return el.avatarId === avatar[1].id;
                        });
                        avatarTweenData.activeRotationTween = null;
                    });
                // uncomment if performance is bad due to rotation smoothing
                // avatar[0].obj3D.children[0].quaternion.set(qt.x, qt.y, qt.z, qt.w);
                // avatar[0].obj3D.children[0].rotateX(-Math.PI / 2);
                }
                if (avatar[1].inputs.bodyType === "halfbody") {
                    var ref6;
                    avatar[1].avatarHasMoved = true;
                    avatar[1].root.visible = true;
                    avatar[0].obj3D.position.set(data.degree && _this.avatarDegree ? x : data.pose.sweep.position.x, data.pose.position.y, data.degree && _this.avatarDegree ? z : data.pose.sweep.position.z);
                    avatar[0].obj3D.children[0].position.set(0, -0.6, 0);
                    avatar[0].obj3D.quaternion.set(data.pose.quaternion._x, data.pose.quaternion._y, data.pose.quaternion._z, data.pose.quaternion._w);
                    (ref6 = avatar[0].obj3D.children[0]) === null || ref6 === void 0 ? void 0 : ref6.rotation.set(0, Math.PI, 0);
                }
                if (avatar[1].inputs.bodyType === "image") {
                    avatar[1].avatarHasMoved = true;
                    avatar[1].root.visible = true;
                    avatar[0].obj3D.position.set(// data.degree && this.avatarDegree ? x : data.pose.sweep.position.x,
                    x || data.pose.sweep.position.x, data.pose.position.y, z || data.pose.sweep.position.z);
                // avatar[0].obj3D.children[0].position.set(0, -0.6, 0);
                }
            }
        });
        socket/* default.on */.Z.on("move_avatar_face", function(data) {
            var tour = _this.state.tour;
            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return;
            var avatar = _this.avatarNodes.get(data.avatarId);
            if (avatar) {
                avatar[1].updateFromResults(data.pose);
            }
        });
        socket/* default.on */.Z.on("all_users", function(users) {
            var tour = _this.state.tour;
            if (tour.enableAvatar) {
                // first we set our degree
                if (_this.avatarDegree === null) {
                    var myself = users.find(function(user) {
                        return user.socketId === socket/* default.id */.Z.id;
                    });
                    _this.avatarDegree = myself.degree;
                    console.log("Assigned degree", _this.avatarDegree);
                }
                // then we add all avatars
                users.forEach(function(user, i) {
                    if (user.socketId !== socket/* default.id */.Z.id) {
                        // user.degree = (i+1)*7;
                        _this.addAvatar(user);
                    }
                });
            }
        });
        var _this76 = (0,_assert_this_initialized/* default */.Z)(_this);
        socket/* default.on */.Z.on("user_leave", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var tour;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tour = _this76.state.tour;
                            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this76.onRemoveAvatar(data.avatarId)
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        socket/* default.on */.Z.on("move", function(pose) {
            if (_this.state.lock) {
                _this.moveToSweepIO(pose);
            }
        });
        if (room) {
            socket/* default.on */.Z.on("menu", function(menu) {
                _this.loadModel(menu.name, menu.url, menu.type);
            });
            socket/* default.on */.Z.on("tag", debounce_default()(function(tag) {
                if (_this.state.lock) {
                    _this.moveToTagIO(tag, tag.action === "click");
                }
            }, 100));
            socket/* default.on */.Z.on("vs", function(data) {
                if (_this.state.lock) {
                    var vsImageId = data.vsImageId, vsVideoId = data.vsVideoId, vsObjectId = data.vsObjectId, eventData = data.eventData, type = data.type;
                    var instance = null;
                    var searchId = vsImageId;
                    if (vsImageId) {
                        instance = _this.showCaseTemp.scene.sceneImage;
                        searchId = vsImageId;
                    } else if (vsVideoId) {
                        instance = _this.showCaseTemp.scene.sceneVideo;
                        searchId = vsVideoId;
                    } else if (vsObjectId) {
                        instance = _this.showCaseTemp.scene.sceneObject;
                        searchId = vsObjectId;
                    }
                    if (instance && (instance === null || instance === void 0 ? void 0 : instance.assets)) {
                        instance.assets.forEach(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), assetKey = _param[0], node = _param[1];
                            if (assetKey.id === searchId) {
                                var _node = (0,_sliced_to_array/* default */.Z)(node, 2), component = _node[1];
                                component.onEvent(type, eventData);
                            }
                        });
                    }
                }
            });
            socket/* default.on */.Z.on("polygon", function(data) {
                if (_this.state.lock) {
                    var type = data.type, assetId = data.assetId, eventData = data.eventData;
                    var ref = (0,_sliced_to_array/* default */.Z)(_this.showCaseTemp.scene.scenePolygon.assets.get(assetId), 2), component = ref[1];
                    if (component && type) {
                        component.onEvent(type, eventData);
                    }
                }
            });
            socket/* default.on */.Z.on("lock", function(_lock) {
                if (_this.state.lock !== _lock) {
                    _this.setState({
                        lock: _lock
                    });
                }
            });
            socket/* default.on */.Z.on("close-tag", function() {
                _this.setState({
                    tagPopOn: false
                });
            });
            socket/* default.on */.Z.on("close-embed-tag", debounce_default()(function() {
                var embedTagContentElem = _this.iframe.contentWindow.document.body.querySelector(".annotations-preview-layer");
                if (embedTagContentElem === null || embedTagContentElem === void 0 ? void 0 : embedTagContentElem.firstChild) {
                    setTimeout(function() {
                        embedTagContentElem.firstChild.click();
                    }, 500);
                }
            }, 100));
            socket/* default.on */.Z.on("close-polygon", function() {
                _this.closeActionPop();
            });
            socket/* default.on */.Z.on("close-pano-pop", function() {
                _this.setState({
                    panoPopOn: false
                });
            });
            socket/* default.on */.Z.on("toggle-pano", function(data) {
                _this.setState(data);
            });
            socket/* default.on */.Z.on("move-pano", function(data) {
                _this.setState({
                    panoPose: data.panoPose,
                    activePano: data.currentPanorama.id
                });
            });
            socket/* default.on */.Z.on("pano-hotspot-click", function(data) {
                _this.setState({
                    panoramaOn: false,
                    activePano: null
                }, function() {
                    _this.getTour({
                        id: data.id,
                        changeMenu: data.changeMenu,
                        changeMinimap: data.changeMinimap,
                        changePanorama: data.changePanorama,
                        url: data.url,
                        tourData: props.tourData
                    });
                });
            });
        }
        socket/* default.on */.Z.on("disconnect", function(reason) {
            console.error("Socket disconnected", reason);
        });
        socket/* default.io.on */.Z.io.on("reconnect", function() {
            console.log("Reconnecting socket.. enabling avatar again");
            _this.initAvatar().catch(function(e) {
                console.error("Error enabling avatar", e);
            });
        });
        window.addEventListener("beforeunload", function() {
            var ref, ref1, ref2;
            return logoutHandler({
                ticket: (ref = _this.state) === null || ref === void 0 ? void 0 : (ref1 = ref.tour) === null || ref1 === void 0 ? void 0 : ref1.ticket,
                ticketingOrderedTicket: (ref2 = _this.state.ticketing) === null || ref2 === void 0 ? void 0 : ref2.ticketingOrderedTicket
            });
        });
        (0,styles/* calculateMobileHeight */.U_)();
        window.addEventListener("resize", styles/* calculateMobileHeight */.U_);
        return _this;
    }
    var _proto = BaseTour.prototype;
    _proto.moveAvatarToPoint = function moveAvatarToPoint(avatar, targetPosVec3, THREE) {
        var _this = this;
        // Make avatar look at direction of target sweep while in animation
        var qt = getProjectedQuaternion(avatar[0].obj3D.position, targetPosVec3, this.yAxisVec3, THREE);
        avatar[1].moveToPos(targetPosVec3, qt, function(tween) {
            // If there is active tween, stops it. Replaces/adds this tween to avatarId
            var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                return el.avatarId === avatar[1].id;
            });
            if (avatarTweenData) {
                if (avatarTweenData.activeTween) avatarTweenData.activeTween.stop();
                avatarTweenData.activeTween = tween;
            } else _this.connectedAvatarsTweens.push({
                avatarId: avatar[1].id,
                activeTween: tween,
                activeRotationTween: null
            });
        }, function() {
            var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                return el.avatarId === avatar[1].id;
            });
            avatarTweenData.activeTween = null;
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("resize", styles/* calculateMobileHeight */.U_);
    };
    _proto.setParentState = function setParentState(attr, val) {
        this.setState((0,_define_property/* default */.Z)({}, attr, val));
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
        var ref, ref1, ref2, ref3;
        // TODO hardcoded for Georgia Pacific TB-2219
        if ((ref = this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.location.href.includes("m=mEMx41aqAaq")) {
            this.processGeorgiaPacificTour();
        }
        if ((ref2 = this.state.game) === null || ref2 === void 0 ? void 0 : ref2.backpackOn) {
            this.updateBackpackMesh();
        }
        if (!deviceManager/* default.isMobile */.Z.isMobile() && ((ref3 = this.showCaseTemp) === null || ref3 === void 0 ? void 0 : ref3.showcase)) {
            var ref4, ref5, ref6, ref7, ref8;
            if (!this.menuMeshState && ((ref4 = this.state.menus) === null || ref4 === void 0 ? void 0 : ref4.length) && (((ref5 = this.state.tour) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.user) === null || ref6 === void 0 ? void 0 : ref6.enterprise) || ((ref7 = this.state.tour) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.user) === null || ref8 === void 0 ? void 0 : ref8.subscription) === (User/* UserSubscription.Business */.MX.Business || User/* UserSubscription.Enterprise */.MX.Enterprise))) {
                this.menuMeshState = "loading";
                this.initMenuMesh();
            }
        }
        this.updatePathFinderMeshHtml();
        this.updateCssMenuWidth();
    };
    _proto.updatePathFinderMeshHtml = function updatePathFinderMeshHtml() {
        var ref;
        var hasData = hasPathFinderData(this.state.pathfinderDataState);
        if (!this.pathFinderMeshComponent || !this.pathFinderMeshComponent.inputs.refs || !hasData) return;
        this.pathFinderMeshComponent.inputs.hasPathFinderData = hasData;
        if (!this.pathFinderMeshComponent.hostPose) (ref = this.pathFinderMeshComponent) === null || ref === void 0 ? void 0 : ref.setHostPose(this.pose);
        updateStylesAndContent({
            pathFinderMeshComponent: this.pathFinderMeshComponent,
            pathfinderDataState: this.state.pathfinderDataState,
            game: this.state.game,
            prevPathFinderData: this.prevPathFinderData
        });
    };
    _proto.initVRTags = function initVRTags(tags) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(matterTagMeshComponentType, makeMatterTagMeshComponent)
                        ];
                    case 1:
                        _state.sent();
                        tags.forEach(function(tag) {
                            _this.initTagMesh(tag);
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.updateBackpackMesh = function updateBackpackMesh() {
        var ref;
        var items = (ref = this.state.game) === null || ref === void 0 ? void 0 : ref.locks.filter(function(lock) {
            return lock.type === "collectItems";
        });
        if (items === null || items === void 0 ? void 0 : items.length) {
            this.backpack = {
                items: items
            };
            if (this.backpackMeshComponent) {
                var itemElements = this.backpackMeshComponent.inputs.refs.itemElements;
                items.forEach(function(item) {
                    var itemElement = itemElements.find(function(el) {
                        return el.name === item.name;
                    });
                    if (!itemElement) {
                        console.error("Tour backpack and VR backpack items mismatch");
                        return;
                    }
                    itemElement.ref.textContent = "".concat(item.name, " ").concat(item.collected.length, "/").concat(item.solution.split("|").length);
                });
            }
        }
    };
    _proto.initTagMesh = function initTagMesh(tagData) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, media, dimensions, ref1, html, imageContainer, modelNode, component;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        media = null;
                        if (tagData.url) media = tagData.embedMedia && tagData.enabled ? "".concat("https://cdn.treedis.com", "/tours/").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.id, "/tags/").concat(tagData.url) : null;
                        dimensions = {
                            width: media ? 400 : 360
                        };
                        ref1 = createMatterTagHTML(tagData, media, dimensions), html = ref1.html, imageContainer = ref1.imageContainer;
                        if (!imageContainer) return [
                            3,
                            2
                        ];
                        imageContainer.src = media;
                        return [
                            4,
                            imageContainer.decode()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 3:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(matterTagMeshComponentType, {
                                html: html,
                                tagData: tagData,
                                media: media,
                                dimensions: dimensions,
                                scale: 0.08,
                                visible: typeof base/* asyncStore.vrIsOn */.k6.vrIsOn === "boolean" ? base/* asyncStore.vrIsOn */.k6.vrIsOn : false,
                                popupScale: 10
                            })
                        ];
                    case 4:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 5:
                        _state.sent();
                        _this.matterTagMeshComponents.push(component);
                        component.onEvent = function(type, eventData) {
                            if (type === Scene_component/* ComponentInteractionType.CLICK */.td.CLICK) {
                                var ref, ref1;
                                if (((ref = eventData.collider) === null || ref === void 0 ? void 0 : ref.name) === "tag") {
                                    if (_this.openedVRTag && tagData.id !== _this.openedVRTag) {
                                        var openedTag = _this.matterTagMeshComponents.find(function(tag) {
                                            return tag.tagId === _this.openedVRTag;
                                        });
                                        if (openedTag) openedTag.inputs.popupVisible = false;
                                    }
                                    component.inputs.popupVisible = !component.inputs.popupVisible;
                                }
                                if (((ref1 = eventData.collider) === null || ref1 === void 0 ? void 0 : ref1.name) === "closeBtn") component.inputs.popupVisible = false;
                                _this.openedVRTag = component.inputs.popupVisible ? tagData.id : null;
                            }
                            if (type === Scene_component/* ComponentInteractionType.HOVER */.td.HOVER && _this.VRPointer.component) {
                                if (eventData.hover) {
                                    _this.VRPointer.component.setVisible(true);
                                    _this.VRPointer.target = component;
                                } else _this.VRPointer.component.setVisible(false);
                            }
                        };
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initVRPointer = function initVRPointer() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var modelNode, component;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(VRPointerComponentType, makeVRPointerComponent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 2:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(VRPointerComponentType, {})
                        ];
                    case 3:
                        component = _state.sent();
                        component.hostPose = _this.camera;
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 4:
                        _state.sent();
                        _this.VRPointer.component = component;
                        _this.showCaseTemp.mpSDK.Pointer.intersection.subscribe(function(intersectionData) {
                            if (component.root && _this.VRPointer.target) {
                                var _position = intersectionData.position, x = _position.x, y = _position.y, z = _position.z;
                                component.root.position.set(x, y, z);
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initPathFinderMesh = function initPathFinderMesh() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, html, refs, modelNode, component;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ref1 = createPathFinderHTML(), html = ref1.html, refs = ref1.refs;
                        refs.buttonBack.addEventListener("click", function() {
                            try {
                                var ref, ref1;
                                (ref = _this.state.pathfinderDataState) === null || ref === void 0 ? void 0 : ref.handlePreviousStep();
                                (ref1 = _this.pathFinderMeshComponent) === null || ref1 === void 0 ? void 0 : ref1.setVisible(false);
                            } catch (error) {
                                react_toastify_esm/* toast.error */.Am.error("Starting sweep not found");
                                console.error(error);
                            }
                        });
                        refs.buttonNext.addEventListener("click", function() {
                            try {
                                var ref, ref1;
                                (ref = _this.state.pathfinderDataState) === null || ref === void 0 ? void 0 : ref.handleNextStep();
                                (ref1 = _this.pathFinderMeshComponent) === null || ref1 === void 0 ? void 0 : ref1.setVisible(false);
                            } catch (error) {
                                react_toastify_esm/* toast.error */.Am.error("Starting sweep not found");
                                console.error(error);
                            }
                        });
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(pathFinderMeshComponentType, makePathFinderMeshComponent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 2:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(pathFinderMeshComponentType, {
                                html: html,
                                visible: false,
                                scale: 0.5,
                                refs: refs,
                                hasPathFinderData: false
                            })
                        ];
                    case 3:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 4:
                        _state.sent();
                        _this.pathFinderMeshComponent = component;
                        (ref = _this.pathFinderMeshComponent) === null || ref === void 0 ? void 0 : ref.setHostPose(_this.pose);
                        component.onEvent = function(type, eventData) {
                            if (type === Scene_component/* ComponentInteractionType.HOVER */.td.HOVER && _this.VRPointer.component) {
                                if (eventData.hover) {
                                    _this.VRPointer.component.setVisible(true);
                                    _this.VRPointer.target = component;
                                } else _this.VRPointer.component.setVisible(false);
                            }
                        };
                        _this.updatePathFinderMeshHtml();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.moveToMenuItem = function moveToMenuItem(menu) {
        var ref = this, moveToMPLabels = ref.moveToMPLabels, loadModel = ref.loadModel;
        if (menu.type === Menu/* MenuType.MatterportLabel */.o.MatterportLabel || menu.type === Menu/* MenuType.MatterportFloor */.o.MatterportFloor) {
            moveToMPLabels(menu);
        } else {
            loadModel(menu.title, menu.url, menu.type, menu.tag, menu.panoramaId, menu.changeMinimap, menu.changePanorama, menu.iframeSettings);
        }
    };
    _proto.initMenuMesh = function initMenuMesh() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, html, itemRefArr, modelNode, component, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        ref = createMenuHTML(_this.state.menus), html = ref.html, itemRefArr = ref.itemRefArr;
                        itemRefArr.forEach(function(menu, index) {
                            menu.addEventListener("click", function() {
                                _this.moveToMenuItem(_this.state.menus[index]);
                                _this.menuMeshComponent.setVisible(false);
                            });
                        });
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(menuMeshComponentType, makeMenuMeshComponent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 2:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(menuMeshComponentType, {
                                html: html,
                                visible: false,
                                scale: 0.5,
                                itemRefArr: itemRefArr
                            })
                        ];
                    case 3:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 4:
                        _state.sent();
                        _this.menuMeshComponent = component;
                        _this.menuMeshState = "loaded";
                        component.onEvent = function(type, eventData) {
                            if (type === Scene_component/* ComponentInteractionType.HOVER */.td.HOVER && _this.VRPointer.component) {
                                if (eventData.hover) {
                                    _this.VRPointer.component.setVisible(true);
                                    _this.VRPointer.target = component;
                                } else _this.VRPointer.component.setVisible(false);
                            }
                        };
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state.sent();
                        console.error(e);
                        _this.menuMeshState = "error";
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initBackpackMesh = function initBackpackMesh() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, items, ref1, html, refs, modelNode, component, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        items = (ref = _this.state.game) === null || ref === void 0 ? void 0 : ref.locks.filter(function(lock) {
                            return lock.type === "collectItems";
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        _this.backpackMeshState = "loading";
                        ref1 = createBackpackhtml(items), html = ref1.html, refs = ref1.refs;
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(backpackMeshComponentType, makeBackpackMeshComponent)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 3:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(backpackMeshComponentType, {
                                html: html,
                                visible: false,
                                scale: 0.5,
                                refs: refs
                            })
                        ];
                    case 4:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 5:
                        _state.sent();
                        _this.backpackMeshComponent = component;
                        _this.backpackMeshState = "loaded";
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        console.error(e);
                        _this.backpackMeshState = "error";
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.loadedShowcaseHandler = function loadedShowcaseHandler() {
        var cb = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, _state, tour, room, changeReel, isEcommerceTour, isOpticalCenter, auth, ref1, access_token, expires_in, fetcher, reel;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this.state, tour = _state.tour, room = _state.room, changeReel = _state.changeReel;
                        isEcommerceTour = tour.mode === Tour/* TourType.ECommerce */.v.ECommerce;
                        isOpticalCenter = _this.state.externalProvider === types/* ExternalProvider.OPTICAL_CENTER */.FX.OPTICAL_CENTER;
                        // TODO revert back
                        if ((tour === null || tour === void 0 ? void 0 : tour.enableAvatar) || room || (tour === null || tour === void 0 ? void 0 : tour.isThreadsEnabled)) {
                            socket/* default.open */.Z.open();
                        }
                        auth = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "auth");
                        if (!(((ref = tour.user) === null || ref === void 0 ? void 0 : ref.oauth) && (auth || tour.oauthAccess))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.refreshOAuth */.Z.refreshOAuth({
                                id: tour.userId
                            })
                        ];
                    case 1:
                        ref1 = _state1.sent(), access_token = ref1.access_token, expires_in = ref1.expires_in;
                        fetcher = {
                            fetch: function fetch1(oldToken) {
                                return (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        console.log("OAuth Token Expired, refreshing...");
                                        return [
                                            2,
                                            TreedisPublicDAO/* default.refreshOAuth */.Z.refreshOAuth({
                                                id: tour.userId
                                            })
                                        ];
                                    });
                                })();
                            }
                        };
                        _this.showCaseTemp.showcase.OAuth.createTokenRefresher({
                            access_token: access_token,
                            expires_in: expires_in
                        }, fetcher);
                        _state1.label = 2;
                    case 2:
                        return [
                            4,
                            _this.showCaseTemp.showcase.Tour.getData().catch(function() {
                                return [];
                            })
                        ];
                    case 3:
                        reel = _state1.sent();
                        if ((reel === null || reel === void 0 ? void 0 : reel.length) && !changeReel) {
                            _this.setState({
                                reel: reel
                            });
                        }
                        _this.showCaseTemp.showcase.Settings.update("highlight_reel", false);
                        _this.showCaseTemp.showcase.Settings.update("tour_buttons", false);
                        return [
                            4,
                            _this.showCaseTemp.showcase.Link.setShareLinkPolicy(_this.showCaseTemp.showcase.Link.CreationPolicy.REFERRER).catch(function() {
                                return [];
                            })
                        ];
                    case 4:
                        _state1.sent();
                        return [
                            4,
                            _this.showCaseTemp.showcase.Tag.toggleDocking(!tour.hideMPTagDock)
                        ];
                    case 5:
                        _state1.sent();
                        if (tour.hidePucks) {
                            _this.showCaseTemp.showcase.Settings.update("features/sweep_pucks", false);
                        }
                        _this.showCaseTemp.showcase.Mode.current.subscribe(function(mode) {
                            if (mode === _this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
                                _this.stopVS();
                            }
                            _this.setState({
                                tourMode: mode
                            });
                            // hide models from other floors on view change
                            if (_this.showCaseTemp.scene.sceneObject && _this.showCaseTemp.scene.sceneObject.assets.length) {
                                if (mode === _this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN || _this.showCaseTemp.showcase.Mode.Mode.TRANSITIONING) {
                                    _this.showCaseTemp.scene.sceneObject.assets.forEach(function(asset) {
                                        if (asset[0].floor !== _this.state.currentFloor) asset[0].node.pivot.visible = false;
                                    });
                                }
                                if (mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE) {
                                    _this.showCaseTemp.scene.sceneObject.assets.forEach(function(asset) {
                                        asset[0].node.pivot.visible = true;
                                    });
                                }
                            }
                        });
                        _this.showCaseTemp.showcase.Camera.pose.subscribe(debounce_default()(function(p) {
                            _this.pose = (0,_object_spread/* default */.Z)({}, p);
                            cb();
                        }, 50));
                        _this.showcase.Tag.attachments.subscribe({
                            onAdded: function(index, item, collection) {
                                var ref;
                                // const { allTags } = this.state;
                                // console.log('aaa item allTags', item, allTags,item?.src?.includes('yout'));
                                if (item === null || item === void 0 ? void 0 : (ref = item.src) === null || ref === void 0 ? void 0 : ref.includes("yout")) {
                                    // //@ts-ignore
                                    // window.allTags = allTags;
                                    // let tagSid;
                                    // allTags?.forEach((value, key, map) => {
                                    //   console.log('aaa item?.src === value?.media?.src',item?.src, value?.media?.src)
                                    //   if (item?.src === value?.media?.src) {tagSid = key;}
                                    // });
                                    // console.log('aaa attachment', index, item, collection, tagSid);
                                    // if(tagSid){
                                    //   this.showCaseTemp.showcase.Tag.detach(tagSid, index);
                                    // }
                                    var addedVideoAttachments = _this.state.addedVideoAttachments || [];
                                    _this.setState({
                                        addedVideoAttachments: (0,_to_consumable_array/* default */.Z)(addedVideoAttachments).concat([
                                            item
                                        ])
                                    });
                                }
                            },
                            onCollectionUpdated: function onCollectionUpdated(collection) {}
                        });
                        _this.showCaseTemp.showcase.Sweep.current.subscribe(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(currentSweep) {
                                var ref, openedTag;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    _this.currentSweep = currentSweep;
                                    if (isEcommerceTour) {
                                        _this.handleShowNearestProduct(false);
                                    }
                                    if (currentSweep.sid !== "") {
                                        // This line was causing the music to stop when changing sweeps. Ely said it's a bug. Remove this line in a month if everything is fine without it.
                                        // await audioHandler.stopAudioByPriority(PriorityNumbers.FIRST);
                                        if (!_this.defaultSweep) _this.defaultSweep = structuredClone(currentSweep);
                                        _this.updateSweepLoc(currentSweep);
                                        _this.renderVS(currentSweep);
                                        _this.setState({
                                            currentSweep: currentSweep
                                        }, function() {
                                            if (isEcommerceTour && !isOpticalCenter) {
                                                _this.handleShowNearestProduct(true);
                                            }
                                        });
                                    }
                                    (ref = _this.pathFinderMeshComponent) === null || ref === void 0 ? void 0 : ref.setVisible(false);
                                    if (base/* asyncStore.vrIsOn */.k6.vrIsOn && _this.openedVRTag) {
                                        openedTag = _this.matterTagMeshComponents.find(function(tag) {
                                            return tag.tagId === _this.openedVRTag;
                                        });
                                        if (openedTag) {
                                            openedTag.inputs.popupVisible = false;
                                            _this.openedVRTag = null;
                                        }
                                    }
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(currentSweep) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Camera.Event.MOVE, function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(p) {
                                var ref, ref1, ref2, ref3, ref4, ref5, _state, showcaseLoaded, host, room, tour, panoramaOn, ref6, ref7, pose;
                                return (0,tslib_es6.__generator)(this, function(_state1) {
                                    _this.cameraPose.current = p;
                                    _state = _this.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room, tour = _state.tour, panoramaOn = _state.panoramaOn;
                                    if (!showcaseLoaded) return [
                                        2
                                    ];
                                    if (!((ref = _this.menuMeshComponent) === null || ref === void 0 ? void 0 : ref.hostPose)) (ref1 = _this.menuMeshComponent) === null || ref1 === void 0 ? void 0 : ref1.setHostPose(_this.pose);
                                    if (!((ref2 = _this.pathFinderMeshComponent) === null || ref2 === void 0 ? void 0 : ref2.hostPose)) (ref3 = _this.pathFinderMeshComponent) === null || ref3 === void 0 ? void 0 : ref3.setHostPose(_this.pose);
                                    if (!((ref4 = _this.backpackMeshComponent) === null || ref4 === void 0 ? void 0 : ref4.hostPose)) (ref5 = _this.backpackMeshComponent) === null || ref5 === void 0 ? void 0 : ref5.setHostPose(_this.pose);
                                    _this.matterTagMeshComponents.forEach(function(tag) {
                                        if (!tag.hostPose) tag.hostPose = _this.pose;
                                    });
                                    if (socket/* default */.Z && socket/* default.connected */.Z.connected && (room || tour.enableAvatar)) {
                                        ;
                                        pose = {
                                            walking: p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE,
                                            position: p.position,
                                            rotation: (ref6 = _this.camera) === null || ref6 === void 0 ? void 0 : ref6.rotation,
                                            quaternion: (ref7 = _this.camera) === null || ref7 === void 0 ? void 0 : ref7.quaternion,
                                            mode: p.mode,
                                            degree: _this.avatarDegree,
                                            sweep: _this.state.currentSweep
                                        };
                                        _this.lastAvatarCameraPose = pose;
                                        if (room) {
                                            if (host) {
                                                socket/* default.emit */.Z.emit("move", {
                                                    pose: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                                                        walking: p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE
                                                    })
                                                });
                                            }
                                        }
                                        if (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) {
                                            socket/* default.emit */.Z.emit("move_avatar", {
                                                pose: pose
                                            });
                                        }
                                    }
                                    if (tour.minimap) {
                                        if (p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE && !panoramaOn) {
                                            _this.setState({
                                                mapWalkerRotation: p.rotation.y * -1
                                            });
                                        }
                                    }
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(p) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _this.showCaseTemp.showcase.Sweep.current.subscribe(function(sweep) {
                            var pose = _this.lastAvatarCameraPose;
                            if (pose) socket/* default.emit */.Z.emit("move_avatar", {
                                pose: pose
                            });
                        });
                        _this.showCaseTemp.showcase.Floor.current.subscribe(function(floor) {
                            // hide models from other floors on floor change
                            if (floor && typeof floor.sequence === "number" && _this.showCaseTemp.scene.sceneObject && _this.showCaseTemp.scene.sceneObject.assets.length) {
                                if (_this.state.tourMode === _this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN) {
                                    _this.showCaseTemp.scene.sceneObject.assets.forEach(function(asset) {
                                        asset[0].node.pivot.visible = asset[0].floor === floor.sequence;
                                    });
                                }
                                if (_this.state.tourMode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE) {
                                    _this.showCaseTemp.scene.sceneObject.assets.forEach(function(asset) {
                                        asset[0].node.pivot.visible = true;
                                    });
                                }
                            }
                            if (floor.sequence !== -1 && floor.sequence !== undefined && floor.sequence !== _this.state.selectedMinimap) {
                                var minimaps = _this.state.minimaps;
                                if (minimaps.length > 0 && minimaps[floor.sequence]) {
                                    _this.setState({
                                        selectedMinimap: floor.sequence
                                    });
                                }
                            }
                            if (floor.sequence !== -1 && floor.sequence !== undefined && _this.state.currentFloor !== floor.sequence) {
                                _this.setState({
                                    currentFloor: floor.sequence
                                }, function() {
                                    if (!_this.state.showIntro && !_this.state.startScreenOn && _this.state.showcaseLoaded) {
                                        _this.processTourMusic();
                                    }
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Measurements.mode.subscribe(function(measurementModeState) {
                            _this.setState({
                                mesurementsOn: measurementModeState.active
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STEPPED, function(i) {
                            _this.setState({
                                reelStep: i,
                                panoramaOn: false
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STARTED, function() {
                            _this.setState({
                                tourPlaying: true,
                                panoramaOn: false,
                                tourMode: _this.pose.mode
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STOPPED, function() {
                            _this.setState({
                                tourPlaying: false,
                                panoramaOn: false
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.ENDED, function() {
                            _this.setState({
                                tourPlaying: false,
                                panoramaOn: false,
                                reelStep: 0
                            });
                        });
                        _this.showcase.on(_this.showcase.Mattertag.Event.CLICK, function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(tagId) {
                                var tour, tags, tag, watchTagPanelElem;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            tour = _this.state.tour;
                                            tags = Array.from(_this.state.allTags.values());
                                            tag = tags.find(function(t) {
                                                return t.sid === tagId || t.defaultSid === tagId;
                                            });
                                            if (tour.hideMPTagSwitcher) {
                                                _this.hideTagsNavigationButtons();
                                            }
                                            if (!tag) return [
                                                2
                                            ];
                                            _this.emitTagChangesFromHost(tag, "click");
                                            _this.setState({
                                                clickedTag: false
                                            });
                                            return [
                                                4,
                                                _this.openTagIframe(tagId)
                                            ];
                                        case 1:
                                            _state.sent();
                                            _this.setState({
                                                clickedTag: true
                                            });
                                            watchTagPanelElem = _this.iframe.contentWindow.document.body.querySelector(".side-panel-right");
                                            if (!tag.mpTooltip && deviceManager/* default.isMobile */.Z.isMobile()) {
                                                (0,util/* closeTagPanelObserver */.zx)(watchTagPanelElem);
                                            } else if (tag.mpTooltip && deviceManager/* default.isMobile */.Z.isMobile()) {
                                                (0,util/* setTagPanelObserver */.p$)(watchTagPanelElem, function(isTagPanelOpen, observer) {
                                                    _this.setState({
                                                        hideBottomBarForWhile: isTagPanelOpen
                                                    });
                                                    if (!isTagPanelOpen) {
                                                        observer.disconnect();
                                                    }
                                                });
                                            }
                                            if (tag && tag.title && !tag.isThread) {
                                                (0,analytic/* sendToGA */.o$)("event", {
                                                    eventCategory: "Mattertag",
                                                    eventAction: "click",
                                                    eventLabel: tag.title,
                                                    eventType: tag.type
                                                });
                                            }
                                            if (tag.isThread) {
                                                _this.setState({
                                                    isThreadsDrawerOpen: true,
                                                    selectedThread: tag
                                                });
                                            }
                                            _this.fixMatterportTagScrollBug();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(tagId) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _this.showcase.on(_this.showcase.Mattertag.Event.HOVER, function(tagId) {
                            try {
                                var ref, ref1;
                                var _state = _this.state, tour = _state.tour, isTagHovered = _state.isTagHovered;
                                var tags = Array.from(_this.state.allTags.values());
                                var tag = tags.find(function(t) {
                                    return t.sid === tagId || t.defaultSid === tagId;
                                });
                                if (((ref = tag.media) === null || ref === void 0 ? void 0 : ref.type) === "video" || tag.type === "video") {
                                    if (!isTagHovered) {
                                        var ref2;
                                        var vsVideos = (ref2 = _this.vsObjects) === null || ref2 === void 0 ? void 0 : ref2.filter(function(obj) {
                                            var ref;
                                            return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.componentType) === VideoRenderer_component/* videoRendererType */.Im;
                                        });
                                        vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                                            var _node = obj.node, vsVideo = _node.video, muteBtn = _node.muteBtn;
                                            if (muteBtn && !muteBtn.active) {
                                                vsVideo.muted = true;
                                                muteBtn.active = true;
                                                muteBtn.makeBtn(muteBtn.inputs.src);
                                            }
                                        });
                                    }
                                    _this.setState({
                                        isTagHovered: !isTagHovered
                                    });
                                }
                                if (tour.hideMPTagSwitcher) {
                                    _this.hideTagsNavigationButtons();
                                }
                                if (!tag) return;
                                _this.emitTagChangesFromHost(tag, "hover");
                                if (((ref1 = tag.media) === null || ref1 === void 0 ? void 0 : ref1.type) === "video" || tag.type === "video") {
                                    audioHandler.pauseAllMusic();
                                }
                                if (tag.title) {
                                    (0,analytic/* sendToGA */.o$)("event", {
                                        eventCategory: "Mattertag",
                                        eventAction: "hover",
                                        eventLabel: tag.title
                                    });
                                }
                            } catch (err) {
                                console.error(err.message);
                            }
                        });
                        _this.showCaseTemp.showcase.Floor.data.subscribe({
                            // Get floor data
                            onCollectionUpdated: function(collection) {
                                var mpFloors = [];
                                Object.keys(collection).forEach(function(o) {
                                    var floor = collection[o];
                                    if (!floor.name || floor.name.length === 0) return;
                                    mpFloors.unshift(floor);
                                });
                                _this.setState({
                                    mpFloors: mpFloors
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Label.getData().then(function(labels) {
                            if (labels === null || labels === void 0 ? void 0 : labels.length) _this.setState({
                                mpLabels: labels
                            });
                        }).catch(function() {
                            return console.error("Error to load MP labels");
                        });
                        _this.showCaseTemp.showcase.Tag.data.subscribe({
                            onAdded: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(sid, item) {
                                    var ref, room, clone, urlC, ref1, attachmentId;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (tour === null || tour === void 0 ? void 0 : tour.addon_hidetags) {
                                                    _this.showCaseTemp.showcase.Tag.remove(sid);
                                                    return [
                                                        2
                                                    ];
                                                }
                                                room = _this.state.room;
                                                if (!(room && (item === null || item === void 0 ? void 0 : (ref = item.media) === null || ref === void 0 ? void 0 : ref.type) === _this.showCaseTemp.showcase.Mattertag.MediaType.VIDEO)) return [
                                                    3,
                                                    2
                                                ];
                                                clone = cloneDeep_default()(item);
                                                urlC = clone.media.src.split("https://vimeo.com/");
                                                clone.media.src += urlC.length > 1 ? "?muted=1" : "&muted=1";
                                                _this.showCaseTemp.showcase.Tag.editBillboard(sid, clone);
                                                return [
                                                    4,
                                                    _this.showcase.Tag.registerAttachment(clone.media.src)
                                                ];
                                            case 1:
                                                ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                                    _state.sent(),
                                                    1
                                                ]), attachmentId = ref1[0];
                                                _this.showcase.Tag.attach(sid, attachmentId);
                                                _state.label = 2;
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(sid, item) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.handleVideoLoaded = function handleVideoLoaded(param) {
        var eventData = param.eventData, data = param.data, component = param.component;
        var ref;
        // unmute if mute button is hidden
        if (((ref = component.muteBtn) === null || ref === void 0 ? void 0 : ref.inputs.size) === 0) component.toggleMute(component.inputs.isDefaultMuted);
        if (!component.inputs.autoplay) {
            component.toggleMute(false);
            if (component.muteBtn.button) {
                component.muteBtn.button.visible = true;
                if (!deviceManager/* default.isIOS */.Z.isIOS()) component.muteBtn.setActive(false);
            }
        } else {
            component.play();
        }
    };
    _proto.processGeorgiaPacificTour = function processGeorgiaPacificTour() {
        var _this = this;
        var ref;
        // If all required assets are present, init ControllerNode
        if (this.state.gameStatus === "started" && !this.hasController) {
            var titlesToKeys = {
                "Under curl bar reversed.mp4": "targetDecrease",
                "Under curl bar.mp4": "targetIncrease",
                "plates_ok.png": "resultOk",
                "q_early.png": "qEarly",
                "q_early_success.png": "qEarlySuccess",
                "q_early_fail.png": "qEarlyFail",
                "q_late.png": "qLate",
                "q_late_success.png": "qLateSuccess",
                "q_late_fail.png": "qLateFail",
                "q1.png": "q1",
                "q1_success.png": "q1Success",
                "q1_fail.png": "q1Fail",
                "Paper rolling": "paperRolling",
                "Front of plates": "frontOfPlates",
                "completed.png": "completedImage"
            };
            var results = this.vsObjects.reduce(function(acc, obj) {
                var ref;
                var key = titlesToKeys[(ref = obj.details) === null || ref === void 0 ? void 0 : ref.title];
                if (key) acc[key] = obj;
                return acc;
            }, {});
            var allKeysExist = Object.values(titlesToKeys).every(function(key) {
                var ref;
                return (ref = results[key]) === null || ref === void 0 ? void 0 : ref.node;
            });
            if (allKeysExist) {
                this.initGeorgiaPacificGameTour(results);
                this.hasController = true;
            }
        }
        // If Quiz1 is completed, overwrite 'Q1_show' polygon onClick event to show plate status instead of quiz
        if (((ref = this.state.lockSolved) === null || ref === void 0 ? void 0 : ref.lock.name) === "q1_complete" && this.showCaseTemp.scene.sceneController && !this.showCaseTemp.scene.sceneController.active) {
            this.showCaseTemp.scene.sceneController.active = true;
            var polygonShow = this.state.polygons.find(function(polygon) {
                return polygon.title === "Q1_show";
            });
            this.showCaseTemp.scene.scenePolygon.assets.get(polygonShow.id)[1].onEvent = function(type, eventData) {
                if (type === Scene_component/* ComponentInteractionType.CLICK */.td.CLICK && _this.showCaseTemp.scene.sceneController.active) {
                    _this.showCaseTemp.scene.sceneController.result.early.node.pivot.visible = true;
                    _this.showCaseTemp.scene.sceneController.result.ok.node.pivot.visible = true;
                    _this.showCaseTemp.scene.sceneController.result.late.node.pivot.visible = true;
                }
            };
        }
    };
    _proto.initGeorgiaPacificGameTour = function initGeorgiaPacificGameTour(results) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var targetIncrease, targetDecrease, resultOk, qEarly, qEarlySuccess, qEarlyFail, qLate, qLateSuccess, qLateFail, q1, q1Success, q1Fail, paperRolling, frontOfPlates, completedImage, getPolygonArr, q1Polygons, qEarlyPolygons, qLatePolygons, completePolygon, asset;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        targetIncrease = results.targetIncrease, targetDecrease = results.targetDecrease, resultOk = results.resultOk, qEarly = results.qEarly, qEarlySuccess = results.qEarlySuccess, qEarlyFail = results.qEarlyFail, qLate = results.qLate, qLateSuccess = results.qLateSuccess, qLateFail = results.qLateFail, q1 = results.q1, q1Success = results.q1Success, q1Fail = results.q1Fail, paperRolling = results.paperRolling, frontOfPlates = results.frontOfPlates, completedImage = results.completedImage;
                        getPolygonArr = function(str) {
                            var keys = _this.state.polygons.filter(function(polygon) {
                                return polygon.title.includes(str);
                            }).sort(function(a, b) {
                                var numA = parseInt(a.title.match(/\d+$/)[0], 10);
                                var numB = parseInt(b.title.match(/\d+$/)[0], 10);
                                return numA - numB;
                            }).map(function(el) {
                                return el.id;
                            });
                            // Convert map keys to an array
                            var mapKeysArray = Array.from(_this.showCaseTemp.scene.scenePolygon.assets.keys());
                            // Filter keysArray based on mapKeysArray
                            var filteredKeys = keys.filter(function(key) {
                                return mapKeysArray.includes(key);
                            });
                            // Then map filteredKeys to values in the map
                            return filteredKeys.map(function(key) {
                                return _this.showCaseTemp.scene.scenePolygon.assets.get(key)[1];
                            });
                        };
                        q1Polygons = getPolygonArr("Q1_option");
                        qEarlyPolygons = getPolygonArr("Q_early_option");
                        qLatePolygons = getPolygonArr("Q_late_option");
                        completePolygon = getPolygonArr("complete_polygon");
                        asset = {
                            scaleX: 1,
                            scaleY: 1,
                            scaleZ: 1,
                            positionX: 0,
                            positionY: 0,
                            positionZ: 0,
                            rotationX: 0,
                            rotationY: 0,
                            rotationZ: 0,
                            targetDecrease: targetDecrease,
                            targetIncrease: targetIncrease,
                            q1: {
                                default: q1,
                                success: q1Success,
                                fail: q1Fail,
                                polygons: q1Polygons,
                                solutionIndex: 0
                            },
                            q_early: {
                                default: qEarly,
                                success: qEarlySuccess,
                                fail: qEarlyFail,
                                polygons: qEarlyPolygons,
                                solutionIndex: 1
                            },
                            q_late: {
                                default: qLate,
                                success: qLateSuccess,
                                fail: qLateFail,
                                polygons: qLatePolygons,
                                solutionIndex: 1
                            },
                            result: {
                                ok: resultOk
                            },
                            paperMachineVideoAssets: [
                                paperRolling,
                                frontOfPlates
                            ],
                            startOutroVideo: _this.startOutroVideo.bind(_this),
                            completed: {
                                image: completedImage,
                                polygons: completePolygon
                            }
                        };
                        return [
                            4,
                            _this.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Controller */.PS.Controller, asset)
                        ];
                    case 1:
                        _state.sent();
                        _this.showCaseTemp.scene.sceneController.on(dist/* NodeEventsTypes.CONTROLLER_MODEL_CLICK */.cA.CONTROLLER_MODEL_CLICK, function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                var data;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = param.data;
                                            return [
                                                4,
                                                _this.moveToSweep("c1c38440428f485d9487045fa0ba9cf4", {
                                                    x: 60,
                                                    y: 180
                                                }, "FLY")
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(_) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.startOutroVideo = function startOutroVideo() {
        this.setState({
            gameStatus: types/* GameStatus.OutroClip */.XI.OutroClip
        });
    };
    _proto.initPatch = function initPatch(url) {
        this.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Patch */.PS.Patch, {
            url: url,
            opacity: 0.6
        });
    };
    _proto.getPolygons = function getPolygons() {
        return this.state.polygons;
    };
    _proto.handlePolygonProduct = function handlePolygonProduct(polygon) {};
    _proto.handleVSProduct = function handleVSProduct(vsObject) {};
    _proto.moveToSweepIO = function moveToSweepIO(p) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (_this.state.showcaseLoaded) {
                    setTimeout(function() {
                        if (!p.walking) {
                            _this.showCaseTemp.showcase.Mode.moveTo(p.mode, {
                                position: p.position,
                                rotation: p.rotation,
                                transition: _this.showCaseTemp.showcase.Mode.TransitionType.FLY
                            }).catch(function(e) {});
                        } else {
                            _this.showcase.Sweep.moveTo(p.sweep, {
                                position: p.position,
                                rotation: p.rotation,
                                transition: _this.showCaseTemp.showcase.Sweep.Transition.FLY
                            }).catch(function(e) {});
                        }
                    }, 100);
                }
                return [
                    2
                ];
            });
        })();
    };
    _proto.moveToTagIO = function moveToTagIO(tag) {
        var doOpenTag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _this = this;
        if (this.state.showcaseLoaded) {
            setTimeout(function() {
                var tags = Array.from(_this.state.allTags.values());
                var foundTag = tags.find(function(t) {
                    return tag.sid && (t.sid === tag.sid || t.defaultSid === tag.sid);
                });
                if (!foundTag) {
                    return;
                }
                if (_this.pose.mode !== _this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
                    _this.showCaseTemp.showcase.Mattertag.navigateToTag(foundTag.sid, _this.showCaseTemp.showcase.Mattertag.Transition.FLY).then(function() {
                        if (doOpenTag) {
                            _this.openTagIframe(tag.sid);
                        }
                    }).catch(function(err) {
                        console.error(err.toString());
                    });
                } else if (doOpenTag) {
                    _this.openTagIframe(foundTag.sid);
                }
            }, 100);
        }
    };
    _proto.getLogoUrl = function getLogoUrl() {
        var ref;
        var tour = this.state.tour;
        return tour && (tour === null || tour === void 0 ? void 0 : tour.client) ? "".concat("https://cdn.treedis.com", "/clients/").concat(tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)) : "";
    };
    // Should be deleted in about a month
    // renderMenu() {
    //   const { tour, room, tokenRemainingTime, whiteLabelData, menuOpen, changeMenu, translation, tourEmail, menuSettings, menus, tourType, currentSweep, deprecatedSweeps } =
    //     this.state;
    //   return (
    //     this.isTourReadyForAudio() && (
    //       <>
    //         <MenuWithSidebarState
    //           isEcommerce={tourType === TourType.ECommerce}
    //           tourType={tourType}
    //           activeMenu={this.state.activeMenu}
    //           tourMode={tour.mode}
    //           tourId={tour.id}
    //           changeMenu={changeMenu}
    //           menuOpen={menuOpen}
    //           menuSearch={tour.menuSearch}
    //           menuCategoryExpand={tour.menuCategoryExpand}
    //           bookUrl={tour.bookUrl}
    //           bookText={tour.bookText}
    //           bookColor={tour.bookColor}
    //           client={tour.client}
    //           unbranded={tour.unbranded}
    //           bookAppointment={tour.appointmentsOn && !room && tokenRemainingTime < 1}
    //           toggleAppointmentsModal={this.toggleAppointmentsModal}
    //           contact={tour.contactForm && (tour.client?.phone || tour.client?.email || tourEmail?.contactPhone)}
    //           whitelabel={whiteLabelData}
    //           address={tour.address}
    //           loadModel={this.loadModel}
    //           moveToMPLabels={this.moveToMPLabels}
    //           closeMenu={this.toggleNav}
    //           onClose={this.closeMenu}
    //           toggleContactPopup={this.toggleContactPopup}
    //           toggleExternalPopup={this.toggleExternalPopup}
    //           translation={translation}
    //           menuSettings={menuSettings}
    //           menus={menus}
    //           currentSweep={currentSweep}
    //           deprecatedSweeps={deprecatedSweeps}
    //         />
    //       </>
    //     )
    //   );
    // }
    _proto.injectBottomBg = function injectBottomBg() {};
    _proto.hideIframeButtons = function hideIframeButtons() {
        try {
            if (this.iframe) {
                var ref, ref1, ref2;
                var iframeButtons = (ref = this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.querySelector("#bottom-ui");
                if (iframeButtons && iframeButtons.style.display !== "none") {
                    iframeButtons.style.display = "none";
                }
            }
        } catch (err) {
            console.error(err);
        }
    };
    _proto.hideTagsNavigationButtons = function hideTagsNavigationButtons() {
        this.showcase.Tag.toggleNavControls(false);
    };
    _proto.renderBottomBar = function renderBottomBar(isFullScreen, toggleFullscreen) {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4;
        var _state = this.state, tour = _state.tour, room = _state.room, sharePopupOn = _state.sharePopupOn, minimapVisible = _state.minimapVisible, panoramaOn = _state.panoramaOn, mesurementsOn = _state.mesurementsOn, whiteLabelData = _state.whiteLabelData, reel = _state.reel, reelStep = _state.reelStep, translation = _state.translation, currentFloor = _state.currentFloor, isVSEnabled = _state.isVSEnabled, ticketing = _state.ticketing, mpFloors = _state.mpFloors, host = _state.host, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, hideBottomBarForWhile = _state.hideBottomBarForWhile, tourMode = _state.tourMode, clickedTag = _state.clickedTag, changeReel = _state.changeReel, chatParticipant = _state.chatParticipant;
        var activeSweepGroupObject = sweepGroups.find(function(g) {
            return g.id === activeSweepGroup;
        });
        var firstAudio = audioHandler.getFirstMusic();
        var audio;
        if ((firstAudio === null || firstAudio === void 0 ? void 0 : (ref = firstAudio.type) === null || ref === void 0 ? void 0 : ref.name) === AudioModule/* MusicObjectKey.TAGS */.NO.TAGS) {
            audio = firstAudio.audio;
        }
        var _this1 = this;
        var handleSoundControlClose = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this1.setState({
                                clickedTag: false
                            });
                            return [
                                4,
                                _this1.resumeTourMusic()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleSoundControlClose() {
                return _ref.apply(this, arguments);
            };
        }();
        var setTourMusicState = function(state) {
            _this.setState({
                tourAudioPlaying: state
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                tour.musicControl && clickedTag && audio && /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundControls["default"], {
                    vsObjects: this.vsObjects,
                    audio: audio,
                    onClose: handleSoundControlClose
                }),
                !this.state.showIntro && !this.state.startScreenOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBarWithRecoil, {
                    audio: audioHandler.getAudio(AudioModule/* MusicObjectKey.TOUR */.NO.TOUR, tour.id),
                    host: host,
                    musicPausedByUser: this.state.musicPausedByUser,
                    activeSweepGroup: activeSweepGroupObject,
                    tourAudioPlaying: this.state.tourAudioPlaying,
                    setTourMusicState: setTourMusicState,
                    allowedTours: ticketing === null || ticketing === void 0 ? void 0 : (ref1 = ticketing.ticketingTourTicket) === null || ref1 === void 0 ? void 0 : ref1.accessTours,
                    showTicketRestrictedAreaPopup: this.showTicketRestrictedAreaPopup,
                    onTicketingReel: this.handleTicketingReel,
                    toggleSketchfabPopup: this.toggleSketchfabPopup,
                    isFull: isFullScreen,
                    translation: translation,
                    vsObjects: this.vsObjects,
                    changeFull: toggleFullscreen,
                    mainPlaying: this.state.tourAudioPlaying,
                    openShare: function() {
                        _this.setState({
                            sharePopupOn: !sharePopupOn
                        });
                    },
                    reelVideos: this.state.reelVideos,
                    reel: reel,
                    changeReel: changeReel,
                    mpFloors: mpFloors,
                    room: room,
                    loadModel: this.loadModel,
                    tour: tour,
                    reelStep: reelStep,
                    sharePopupOn: sharePopupOn,
                    isVSEnabled: isVSEnabled,
                    moveToStep: this.moveToStep,
                    playTour: this.playTour,
                    tourPlaying: this.state.tourPlaying,
                    showcase: this.showCaseTemp.showcase,
                    tourMode: tourMode,
                    changeViewMode: this.changeViewMode,
                    mesurementsOn: mesurementsOn,
                    panoramaOn: panoramaOn,
                    measurementsMode: this.measurementsMode,
                    changeFloor: this.changeFloor,
                    showPanorama: tour.panorama,
                    toggleExternalPopup: this.toggleExternalPopup,
                    handleToggleMusic: this.handleToggleMusic,
                    takeScreenshot: this.takeScreenshot,
                    takePano: this.takePano,
                    whitelabel: whiteLabelData,
                    showMinimapClick: function() {
                        _this.setState({
                            minimapVisible: !minimapVisible
                        });
                    },
                    showPanoramaClick: this.handleTogglePano,
                    onHelpClick: function() {
                        _this.setState({
                            showHelpModal: true,
                            showTermsModal: false
                        });
                    },
                    onTermsClick: function() {
                        _this.setState({
                            showTermsModal: true,
                            showHelpModal: false
                        });
                    },
                    toggleVS: this.toggleVS,
                    openVR: this.openVR,
                    onStartVideo: function() {
                        _this.setState({
                            videoPlaying: true
                        });
                        audioHandler.pauseAllMusic();
                    },
                    onStopVideo: function() {
                        audioHandler.playAudio({
                            type: AudioModule/* MusicObj.TOUR */.nR.TOUR,
                            id: _this.state.tour.id
                        });
                        _this.setState({
                            videoPlaying: false
                        });
                    },
                    currentFloor: currentFloor,
                    onMuteClick: this.toggleMuteParticipants,
                    onFullscreenClick: this.toggleFullscreenVideo,
                    onPinClick: this.addPinnedVideo,
                    initialDuplicates: (ref2 = this.props) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tourData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.tour) === null || ref4 === void 0 ? void 0 : ref4.initialDuplicates,
                    audioOnly: this.state.audioOnly,
                    hideForWhile: hideBottomBarForWhile,
                    showCaseTemp: this.showCaseTemp,
                    iframe: this.iframe,
                    toggleThreadsDrawer: function() {
                        return _this.setState(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                isThreadsDrawerOpen: !prevState.isThreadsDrawerOpen
                            });
                        });
                    },
                    closeThreadsDrawer: function() {
                        return _this.setState({
                            isThreadsDrawerOpen: false,
                            selectedThread: null
                        });
                    },
                    openThreadsDrawer: function() {
                        return _this.setState({
                            isThreadsDrawerOpen: true
                        });
                    },
                    isThreadsDrawerOpen: this.state.isThreadsDrawerOpen,
                    selectedThread: this.state.selectedThread,
                    threads: Array.from(this.state.allTags, function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                        return value;
                    }).filter(function(t) {
                        return t.isThread;
                    }),
                    appState: this.state.appState,
                    addThreadToSpace: this.addThreadToSpace,
                    removeThreadFromSpace: this.removeThreadFromSpace,
                    toggleThreadVisibility: this._changeTagPos,
                    hideElements: this.hideElements,
                    avatar: chatParticipant
                })
            ]
        });
    };
    _proto.injectChildComponents = function injectChildComponents() {};
    /** experience handlers * */ _proto.renderGameContent = function renderGameContent() {};
    _proto.hideItemsFromConditions = function hideItemsFromConditions() {};
    _proto.renderEndGameScreen = function renderEndGameScreen() {};
    _proto.handleGameStart = function handleGameStart(username, skipValidation) {};
    _proto.tryButtonPlaySound = function tryButtonPlaySound() {};
    /** experience handlers * */ _proto.isRenderAuth = function isRenderAuth() {
        var tour = this.state.tour;
        var p = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "p");
        if (tour.password && p && atob(decodeURIComponent(p)) === tour.password) return false;
        return tour.password;
    };
    _proto.renderAuth = function renderAuth() {
        var _state = this.state, tour = _state.tour, whiteLabelData = _state.whiteLabelData;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
            tour: tour,
            whitelabel: whiteLabelData,
            login: this.login
        });
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        (0,renderDebug/* dLog */.a)("BaseTour");
        var _state = this.state, tour = _state.tour, game = _state.game, gameStatus = _state.gameStatus, sweepGroups = _state.sweepGroups, mesurementsOn = _state.mesurementsOn, allowGuestBeforeHost = _state.allowGuestBeforeHost, room = _state.room, activeSweepGroup = _state.activeSweepGroup, sharePopupOn = _state.sharePopupOn, overlayOn = _state.overlayOn, showcaseLoaded = _state.showcaseLoaded, currentSweep = _state.currentSweep, tokenRemainingTime = _state.tokenRemainingTime, tokenExpiresAt = _state.tokenExpiresAt, showSketchfabPopup = _state.showSketchfabPopup, whiteLabelData = _state.whiteLabelData, minimapVisible = _state.minimapVisible, minimapOn = _state.minimapOn, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap, mapWalkerX = _state.mapWalkerX, mapWalkerY = _state.mapWalkerY, mapWalkerRotation = _state.mapWalkerRotation, lock = _state.lock, tagPopOn = _state.tagPopOn, panoPopOn = _state.panoPopOn, openedTag = _state.openedTag, openedPanoHotspot = _state.openedPanoHotspot, vsActionPopOn = _state.vsActionPopOn, openedVSAction = _state.openedVSAction, contactPopupOn = _state.contactPopupOn, externalPopupOn = _state.externalPopupOn, externalPopupUrl = _state.externalPopupUrl, panoramaOn = _state.panoramaOn, host = _state.host, selectedMarker = _state.selectedMarker, showHelpModal = _state.showHelpModal, showTermsModal = _state.showTermsModal, showCollectLeadsModal = _state.showCollectLeadsModal, panoramas = _state.panoramas, interacted = _state.interacted, showIntro = _state.showIntro, containerId = _state.containerId, loadingTags = _state.loadingTags, agents = _state.agents, tourEmail = _state.tourEmail, translation = _state.translation, tourType = _state.tourType, reelVideos = _state.reelVideos, experiencePopUpIsOpen = _state.experiencePopUpIsOpen, initialDuplicates = _state.initialDuplicates, experiencePopUpData = _state.experiencePopUpData, forcePlayGameIntro = _state.forcePlayGameIntro, // --- to add
        ticketingOpen = _state.ticketingOpen, ticketing = _state.ticketing, avatar = _state.avatar, chatParticipant = _state.chatParticipant, iframeUrl = _state.iframeUrl, audioOnly = _state.audioOnly, showBottomBar = _state.showBottomBar, iframeSettings = _state.iframeSettings, startScreenOn = _state.startScreenOn, isThreadsDrawerOpen = _state.isThreadsDrawerOpen;
        var _props = this.props, _tour = _props._tour, tourImage = _props.tourImage, tourData = _props.tourData;
        var tourForIS = tour || (tourData === null || tourData === void 0 ? void 0 : tourData.tour);
        var preview = !!_tour;
        var loadSweeps = !showIntro && !startScreenOn && !loadingTags && showcaseLoaded && sweepGroups && sweepGroups.length > 0;
        var isGameTour = tourType === Tour/* TourType.Game */.v.Game;
        var isEcommerceTour = tourType === Tour/* TourType.ECommerce */.v.ECommerce;
        var showMinimap = isGameTour ? gameStatus !== types/* GameStatus.NotStarted */.XI.NotStarted : showcaseLoaded;
        var showPanorama = !isGameTour && panoramaOn && (panoramas === null || panoramas === void 0 ? void 0 : panoramas.length) > 0;
        var showIntroScreen = startScreenOn && tourForIS && !tourForIS.password && this.state.tourType !== Tour/* TourType.Game */.v.Game && !tourForIS.matterPassword;
        var showMenu = (tour === null || tour === void 0 ? void 0 : tour.menuEnabled) && tourType !== Tour/* TourType.Game */.v.Game && showcaseLoaded && !mesurementsOn && !startScreenOn && !showIntro;
        var hasAcceptedCookies = this.context.hasAcceptedCookies;
        var ticketingContentTickets = [];
        if ((ticketing === null || ticketing === void 0 ? void 0 : (ref = ticketing.ticketingOrderedTicket) === null || ref === void 0 ? void 0 : ref.ticketType) === "tourByYourself") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingToursByYourself;
        else if ((ticketing === null || ticketing === void 0 ? void 0 : (ref1 = ticketing.ticketingOrderedTicket) === null || ref1 === void 0 ? void 0 : ref1.ticketType) === "gameTour") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGameTour;
        else if ((ticketing === null || ticketing === void 0 ? void 0 : (ref2 = ticketing.ticketingOrderedTicket) === null || ref2 === void 0 ? void 0 : ref2.ticketType) === "guidedTour") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGuidedTour;
        var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
        var isChrome = deviceManager/* default.isChrome */.Z.isChrome();
        var isIOS = deviceManager/* default.isIOS */.Z.isIOS();
        var tourStarted = this.isTourReadyForAudio();
        var customButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
            onClick: this.handleCustomButton,
            tourId: tour === null || tour === void 0 ? void 0 : tour.id,
            customButtonIcon: tour === null || tour === void 0 ? void 0 : tour.customButtonIcon
        });
        var isBusinessOrEnterprise = ((ref3 = this.state.tour) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.user) === null || ref4 === void 0 ? void 0 : ref4.enterprise) || ((ref5 = this.state.tour) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.user) === null || ref6 === void 0 ? void 0 : ref6.subscription) === (User/* UserSubscription.Business */.MX.Business || User/* UserSubscription.Enterprise */.MX.Enterprise);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreen/* default */.Z, {
            attrs: {
                id: "global-fullscreen",
                class: classnames_default()((tour === null || tour === void 0 ? void 0 : (ref7 = tour.client) === null || ref7 === void 0 ? void 0 : ref7.rtl) && "rtl")
            },
            rootBody: true,
            children: function(param) {
                var isFullScreen = param.isFullScreen, toggleFullscreen = param.toggleFullscreen;
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        _this.state.mondelezTabletVideo.videoId && /*#__PURE__*/ (0,jsx_runtime.jsx)(MondelezTabletVideo/* default */.Z, {
                            videoId: _this.state.mondelezTabletVideo.videoId,
                            onClose: function() {
                                return _this.setState({
                                    mondelezTabletVideo: {
                                        videoId: undefined,
                                        sweepsHistory: _this.state.mondelezTabletVideo.sweepsHistory
                                    }
                                });
                            }
                        }),
                        showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuRedesigned, {
                            open: _this.state.menuOpen && !isThreadsDrawerOpen,
                            settings: _this.state.menuSettings,
                            menus: _this.state.menus,
                            tour: _this.state.tour,
                            translations: _this.state.translation,
                            moveToMPLabels: _this.moveToMPLabels,
                            loadModel: _this.loadModel,
                            toggleContactPopup: _this.toggleContactPopup,
                            toggleExternalPopup: _this.toggleExternalPopup,
                            tourEmail: tourEmail,
                            whitelabel: whiteLabelData,
                            hideTriggerButton: isEcommerceTour && panoramaOn || isThreadsDrawerOpen,
                            disableShouldHighlight: !isBusinessOrEnterprise,
                            currentSid: currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.sid,
                            triggerButton: isEcommerceTour ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : undefined,
                            customButton: (tour === null || tour === void 0 ? void 0 : tour.customButton) && tourType === Tour/* TourType.Regular */.v.Regular && !isThreadsDrawerOpen ? customButton : null,
                            // If minimap is ON, we subtract it's height from Menu's height so they don't overlap
                            minimapHeight: minimapVisible && !!(tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.minimap) ? minimapOn ? 450 : 200 : 0,
                            onClose: function() {
                                _this.setState({
                                    menuOpen: false
                                });
                            },
                            onOpen: function() {
                                _this.setState({
                                    menuOpen: true
                                });
                            },
                            onWidthChange: function(width) {
                                _this.setState({
                                    menuWidth: width
                                });
                            }
                        }),
                        !(tour === null || tour === void 0 ? void 0 : tour.menuEnabled) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (tour === null || tour === void 0 ? void 0 : tour.contactForm) && ((tour === null || tour === void 0 ? void 0 : tour.client) && (tour === null || tour === void 0 ? void 0 : tour.client.email) || (tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.menuGetInTouch)) && tourType === Tour/* TourType.Regular */.v.Regular && !isThreadsDrawerOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetInTouchButton, {
                                    onClick: _this.toggleContactPopup,
                                    tooltipOn: tour.getInTouchTooltipOn,
                                    translation: translation
                                }),
                                (tour === null || tour === void 0 ? void 0 : tour.customButton) && tourType === Tour/* TourType.Regular */.v.Regular && !mesurementsOn && !startScreenOn && !showIntro && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        padding: "4px 0px 4px 4px",
                                        position: "absolute",
                                        top: "170px",
                                        right: "0px",
                                        zIndex: 1,
                                        overflow: "hidden"
                                    },
                                    children: customButton
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNavigationArrow/* ScreenNavigationArrow */.Q, {
                            refProp: _this.pathArrowRefBaseTour
                        }),
                        !renderDebug/* stopLogs */.d && /*#__PURE__*/ (0,jsx_runtime.jsx)(DebugWindow, {}),
                        _this.state.gameTrialErr && _this.state.tourType === Tour/* TourType.Game */.v.Game && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "gameTrialErr",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "gameTrialErr-text",
                                    children: _this.state.gameTrialErr
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(units/* Button */.zx, {
                                    onClick: function() {
                                        return window.close();
                                    },
                                    children: "Close"
                                })
                            ]
                        }),
                        experiencePopUpIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperiencePopUp, {
                            isRtl: (ref = tour.client) === null || ref === void 0 ? void 0 : ref.rtl,
                            onInit: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    // changed according to TB-2459
                                    // if (this.state.tourType === TourType.Game) {
                                    // await stopTourMusic();
                                    // } else {
                                    audioHandler.pauseAllMusic();
                                    return [
                                        2
                                    ];
                                });
                            // }
                            }),
                            tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                            getCurrentLanguage: _this.getCurrentLanguage,
                            tryButtonPlaySound: _this.tryButtonPlaySound,
                            experiencePopUpData: experiencePopUpData,
                            isOpen: experiencePopUpIsOpen,
                            setIsOpen: function(status) {
                                // as I understand this using only for closing experience from itself
                                audioHandler.resumeMusic();
                                _this.state.onExperienceCloseCallback();
                                _this.setState({
                                    experiencePopUpIsOpen: status,
                                    closedElementPopup: !status,
                                    onExperienceCloseCallback: function() {
                                        return undefined;
                                    }
                                });
                            }
                        }),
                        _this.state.vsHTMLPopup.show && deviceManager/* default.isMobile */.Z.isMobile() && /*#__PURE__*/ (0,jsx_runtime.jsx)(VSHTMLPopup, {
                            setShow: _this.setVsHTMLPopupShow,
                            src: _this.state.vsHTMLPopup.src
                        }),
                        ticketingOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingRouter, {
                            matterId: tour.slug,
                            parentTourId: tour.parentId,
                            tourId: tour.id,
                            gameId: tour.gameId,
                            ticketing: ticketing,
                            reactAppDomain: _this.root,
                            reactAws: _this.props.reactAws,
                            tourImage: tourImage,
                            onTicketLoginSuccess: _this.onTicketLoginSuccess,
                            translation: translation,
                            whiteLabelData: whiteLabelData
                        }),
                        showIntroScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroScreen, {
                            rtl: (ref1 = tourForIS.client) === null || ref1 === void 0 ? void 0 : ref1.rtl,
                            tour: tourForIS,
                            initialDuplicates: initialDuplicates,
                            introScreen: tourForIS.introScreen,
                            whiteLabelData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, whiteLabelData), {
                                isWLUser: !!(tourForIS === null || tourForIS === void 0 ? void 0 : (ref2 = tourForIS.user) === null || ref2 === void 0 ? void 0 : ref2.whitelabelId)
                            }),
                            translation: translation,
                            showCollectLeadsModal: showCollectLeadsModal,
                            onStart: _this.onPlayClick,
                            onFinish: _this.onIntroScreenFinished,
                            preventSubmit: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.cookieIsMandatory) && !(0,CookieConsent/* allowUsesCookie */.q7)() && window.self === window.top,
                            preventSubmitCallback: function() {
                                return _this.setState({
                                    showCookieFullScreen: true
                                });
                            },
                            inputs: {
                                name: tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads,
                                phone: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) && (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.leadsPhone),
                                email: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) && (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.leadsEmail)
                            },
                            checkbox: {
                                legal1: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) ? (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.legalBookingBox) || "" : "",
                                legal2: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) ? (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.legalBookingBox2) || "" : ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "".concat(containerId, "-tour-root"),
                            className: classnames_default()(preview ? "preview base-tour tour-container" : "base-tour tour-container", isMobile && "no-visible-scrollbar", tourType === Tour/* TourType.Game */.v.Game && host && "game-container"),
                            // eslint-disable-next-line no-return-assign
                            ref: function(el) {
                                return _this.root = el;
                            },
                            children: [
                                tokenRemainingTime > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "countDownWrap",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "countDown",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {
                                            date: tokenExpiresAt,
                                            zeroPadDays: 0,
                                            onComplete: function() {
                                                _this.props.history.push("/");
                                            }
                                        })
                                    })
                                }),
                                showCollectLeadsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectLeadsForm, {
                                    tour: tour,
                                    rtl: (ref3 = tour.client) === null || ref3 === void 0 ? void 0 : ref3.rtl,
                                    translation: translation,
                                    onStart: _this.handleCollectLeadsSubmit
                                }),
                                !ticketingOpen && tour && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: _this.isRenderAuth() ? _this.renderAuth() : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("inner", {
                                            mobile: isMobile,
                                            isChromeInIOS: isIOS && isChrome
                                        }),
                                        style: showCollectLeadsModal && tour.mainImage ? {
                                            backgroundColor: "#000"
                                        } : {},
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "ui-wrap",
                                                children: [
                                                    _this.state.showActionPathBar && !isGameTour && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ActionPathNavbar */.h5, {
                                                        pathFinderLine: _this.pathFinderLine,
                                                        setVisible: _this.setActionPathNavbarVisible,
                                                        sdk: _this.showCaseTemp.showcase,
                                                        buttonText: _this.state.actionPathNavbarButtonText,
                                                        translation: _this.state.translation
                                                    }),
                                                    tour.messengerLink && tour.messengerGreeting && _this.messenger !== 0 && !room && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerCustomerChat, {
                                                        pageId: tour.messengerLink,
                                                        loggedInGreeting: tour.messengerGreeting,
                                                        loggedOutGreeting: tour.messengerGreeting,
                                                        themeColor: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) || "#ea475c"
                                                    }),
                                                    externalPopupUrl && externalPopupOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalPopup, {
                                                        show: externalPopupUrl && externalPopupOn,
                                                        url: externalPopupUrl,
                                                        onClose: _this.toggleExternalPopupNull,
                                                        logo: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.active) ? whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo : defaultLogo,
                                                        iframeSettings: iframeSettings
                                                    }),
                                                    _this.injectChildComponents(),
                                                    !isGameTour && (tour === null || tour === void 0 ? void 0 : tour.gameId) && ((ref4 = _this.state) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.game) === null || ref5 === void 0 ? void 0 : ref5.paths) && !_this.state.showIntro && _this.isTourReadyForAudio() && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularPaths, {
                                                        panoIsOpen: panoramaOn,
                                                        pathfinderDataState: _this.state.pathfinderDataState,
                                                        setPathfinderDataState: _this.setPathfinderDataState,
                                                        isRtl: (ref6 = tour.client) === null || ref6 === void 0 ? void 0 : ref6.rtl,
                                                        translation: _this.state.translation,
                                                        gameId: game.id,
                                                        gamePaths: _this.state.game.paths,
                                                        allTags: _this.state.allTags,
                                                        polygons: _this.state.polygons,
                                                        showcase: _this.showCaseTemp,
                                                        vsObjects: _this.vsObjects,
                                                        sweeps: _this.state.sweeps,
                                                        currentSweep: _this.state.currentSweep,
                                                        clickedElement: _this.state.clickedElement,
                                                        onAction: _this.onPathAction,
                                                        __hideItems: _this.__hideConditions,
                                                        __revealItems: _this.__revealConditions,
                                                        showElements: _this.showElements,
                                                        hideElements: _this.hideElements
                                                    }),
                                                    tagPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsPopup, {
                                                        logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo,
                                                        obj: openedTag,
                                                        type: "tags",
                                                        tourId: tour.id,
                                                        closePop: _this.closeTagPop
                                                    }),
                                                    !ticketingOpen && (ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingOrderedTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderTicketingContent, {
                                                        tickets: ticketingContentTickets,
                                                        translation: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingTranslation,
                                                        tourSlug: tour.slug,
                                                        ticketingOrderedTicket: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingOrderedTicket,
                                                        ticketTimeLeftMs: _this.state.ticketTimeLeftMs,
                                                        ticketModalInfo: _this.state.ticketModalInfo,
                                                        root: _this.root,
                                                        tourId: tour.id,
                                                        gameId: tour.gameId,
                                                        ticketingGeneral: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGeneral,
                                                        showTicketModal: _this.state.showTicketModal
                                                    }),
                                                    openedPanoHotspot && panoPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(PanoPopup, {
                                                        hotspot: openedPanoHotspot,
                                                        show: panoPopOn,
                                                        onClose: _this.closePanoPop,
                                                        logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo
                                                    }),
                                                    _this.state.showPathFinderPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(PathFinderPopup, {
                                                        open: _this.state.showPathFinderPopup,
                                                        closePopup: _this.closePathFinderPop
                                                    }),
                                                    vsActionPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(VSActionsPopup, {
                                                        tourId: tour.id,
                                                        object: openedVSAction,
                                                        onClose: _this.closeActionPop
                                                    }),
                                                    contactPopupOn && showcaseLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPopup, {
                                                        agents: agents,
                                                        rtl: (ref7 = tour.client) === null || ref7 === void 0 ? void 0 : ref7.rtl,
                                                        translation: translation,
                                                        to: (tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.menuGetInTouch) || (tour === null || tour === void 0 ? void 0 : (ref8 = tour.client) === null || ref8 === void 0 ? void 0 : ref8.email),
                                                        legalBookingBox: tour.legalBookingBox,
                                                        legalBookingBox2: tour.legalBookingBox2,
                                                        userId: tour.userId,
                                                        tourId: tour.id,
                                                        title: tour.title,
                                                        client: tour.client,
                                                        hideClientContact: tour.hideClientContact,
                                                        phone: tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactPhone,
                                                        name: tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactName,
                                                        toggleContactPopup: _this.toggleContactPopup
                                                    }),
                                                    !room && tour.ad && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdRedesigned/* default */.Z, {
                                                        to: tourEmail && tourEmail.leadForms || tour.client && tour.client.email,
                                                        tour: tour,
                                                        translation: translation,
                                                        rtl: _this.state.rtl,
                                                        whitelabel: whiteLabelData,
                                                        form: {
                                                            imageSrc: "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/ad.jpg").concat((0,util_all/* getVersion */.bo)(tour.updatedAt)),
                                                            phone: tour.leadsTimedPhone,
                                                            name: tour.leadsTimedName,
                                                            email: tour.leadsTimedEmail,
                                                            checkbox1: tour.legalBookingBox,
                                                            checkbox2: tour.legalBookingBox2,
                                                            url: tour.adUrl,
                                                            time: tour.adTime
                                                        }
                                                    }),
                                                    showPanorama && /*#__PURE__*/ (0,jsx_runtime.jsx)(Panorama, {
                                                        panoramas: panoramas,
                                                        markMinimap: _this.markMinimap,
                                                        panoPose: _this.state.panoPose,
                                                        activePano: _this.state.activePano,
                                                        transition: tour.panoramaTransition,
                                                        isChatGuest: room && socket/* default */.Z && socket/* default.connected */.Z.connected && !host,
                                                        defaultPanorama: tour.defaultPanorama,
                                                        updatePanoRotation: _this.updatePanoRotation,
                                                        openHotspot: _this.openedPanoHotspot,
                                                        onSceneChange: _this.handlePanoSceneChange,
                                                        handleTogglePano: _this.handleTogglePano
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "overlay ".concat(overlayOn ? "open" : "")
                                                    }),
                                                    room && _this.showCaseTemp && _this.pose && !startScreenOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedVideo, {
                                                        iframeId: _this.state.iframeId,
                                                        sdk: _this.showCaseTemp.showcase,
                                                        tour: tour,
                                                        host: host,
                                                        audioOnly: audioOnly,
                                                        measurementsOn: mesurementsOn,
                                                        room: room,
                                                        slug: tour.slug,
                                                        name: chatParticipant === null || chatParticipant === void 0 ? void 0 : chatParticipant.name,
                                                        avatar: chatParticipant,
                                                        reelVideos: reelVideos,
                                                        endCall: _this.videoEndCall,
                                                        clientId: tour.clientId,
                                                        tourId: tour.id,
                                                        enterprise: isBusinessOrEnterprise,
                                                        translation: translation,
                                                        allowGuestBeforeHost: allowGuestBeforeHost,
                                                        changeTour: _this.videoChangeTour,
                                                        addTrack: _this.addTrack,
                                                        removeTrack: _this.removeTrack,
                                                        pinnedVideos: _this.state.pinnedVideos,
                                                        removePinnedVideo: _this.removePinnedVideo,
                                                        onToggleMute: _this.toggleMuteParticipants,
                                                        onToggleFullscreen: _this.toggleFullscreenVideo,
                                                        dominantSpeaker: _this.state.dominantSpeaker,
                                                        fullscreenVideo: _this.state.fullscreenVideo,
                                                        addVideoReel: _this.addVideoReel,
                                                        enableAvatar: tour === null || tour === void 0 ? void 0 : tour.enableAvatar,
                                                        imageInsteadOfAvatar: tour === null || tour === void 0 ? void 0 : tour.imageInsteadOfAvatar,
                                                        setAvatar: _this.setAvatar,
                                                        getAvatarImage: _this.getAvatarImage,
                                                        setAvatarImage: _this.setAvatarImage,
                                                        updateAvatarsInList: _this.updateAvatarsInList,
                                                        isWalkieTalkieOn: ((ref9 = _this.props) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.tourData) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.tour) === null || ref11 === void 0 ? void 0 : ref11.isWalkieTalkieOn) && audioOnly
                                                    }),
                                                    _this.showCaseTemp && !_this.state.startScreenOn && !avatar && !room && (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "video-name-overlay",
                                                        className: "overlay",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroPopup, {
                                                            sdk: _this.showCaseTemp.showcase,
                                                            enableAvatar: tour === null || tour === void 0 ? void 0 : tour.enableAvatar,
                                                            avatarType: (tour === null || tour === void 0 ? void 0 : tour.imageInsteadOfAvatar) ? "image" : "model",
                                                            translation: translation,
                                                            setAvatar: _this.setAvatar,
                                                            setAvatarImage: _this.setAvatarImage,
                                                            getAvatarImage: _this.getAvatarImage,
                                                            audioOnly: audioOnly
                                                        })
                                                    }),
                                                    tour.legalNote && !_this.state.startScreenOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalNote, {
                                                        note: tour.legalNote
                                                    }),
                                                    showcaseLoaded && !tour.unbranded && tour.client && tour.client.logo && !room && !_this.state.startScreenOn && !_this.state.showNewHintModal && !_this.state.hideLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: ((ref12 = tour.client) === null || ref12 === void 0 ? void 0 : ref12.website) ? ((ref13 = tour.client.website) === null || ref13 === void 0 ? void 0 : ref13.includes("https://")) ? tour.client.website : "https://".concat(tour.client.website) : "",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: tour.client.widthLogo ? "logo width" : "logo",
                                                            style: {
                                                                display: "block"
                                                            },
                                                            src: "".concat("https://cdn.treedis.com", "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)),
                                                            alt: ""
                                                        })
                                                    }),
                                                    _this.state.markerPopupOn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "popup",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn",
                                                                onClick: function() {
                                                                    _this.setState({
                                                                        overlayOn: false,
                                                                        markerPopupOn: false
                                                                    });
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-times"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "What do you want to do?"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: _this.toggleExternalPopup.bind(_this, _this.state.selectedMarker.external),
                                                                children: "Open Autodesk Viewer"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: function() {
                                                                    return _this.moveModel(selectedMarker.url);
                                                                },
                                                                children: "Move to this point"
                                                            })
                                                        ]
                                                    }),
                                                    showMinimap && /*#__PURE__*/ (0,jsx_runtime.jsx)(Minimap, {
                                                        tour: tour,
                                                        minimapOn: minimapOn,
                                                        minimapVisible: minimapVisible,
                                                        minimaps: minimaps,
                                                        selectedMinimap: selectedMinimap,
                                                        mapWalkerX: mapWalkerX,
                                                        mapWalkerY: mapWalkerY,
                                                        mapWalkerRotation: mapWalkerRotation,
                                                        markerClick: _this.markerClick,
                                                        onClick: function() {
                                                            _this.setState({
                                                                minimapOn: !minimapOn
                                                            });
                                                        }
                                                    }),
                                                    _this.state.appointmentsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Appointment, {
                                                        tour: tour,
                                                        translation: translation,
                                                        tourEmail: tourEmail,
                                                        rtl: tour.client && tour.client.rtl,
                                                        appointmentsModal: _this.state.appointmentsModal,
                                                        toggleAppointmentsModal: _this.toggleAppointmentsModal,
                                                        appointmentTime: tour.appointmentTime
                                                    }),
                                                    sharePopupOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Share, {
                                                        tourType: tourType,
                                                        closeOnOutsideClick: tourType === Tour/* TourType.ECommerce */.v.ECommerce,
                                                        getLocation: _this.getShareLocation,
                                                        onClose: function() {
                                                            _this.setState({
                                                                sharePopupOn: false
                                                            });
                                                        },
                                                        tour: tour,
                                                        translation: translation,
                                                        onColor: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) || "#ea475c"
                                                    }),
                                                    showBottomBar && showcaseLoaded && !(window.innerWidth < 1024 && mesurementsOn) && _this.renderBottomBar(isFullScreen, toggleFullscreen),
                                                    loadSweeps && currentSweep && !panoramaOn && (avatar || !room || !(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sweep, {
                                                        renderer: _this.renderer,
                                                        interacted: _this.state.interacted,
                                                        tourReadyForAudio: tourStarted,
                                                        handleToggleMusic: _this.handleToggleMusic,
                                                        hideSubtitlesGroupId: _this.state.hideSubtitlesGroupId,
                                                        videoContainer: {
                                                            pause: audioHandler.stopTourMusic,
                                                            play: _this.resumeTourMusic
                                                        },
                                                        tour: tour,
                                                        tourEmail: tourEmail,
                                                        userId: tour.userId,
                                                        whitelabel: whiteLabelData,
                                                        groups: sweepGroups,
                                                        selectedGroup: _this.state.activeSweepGroup,
                                                        loadedObjects: _this.state.loadedObjects,
                                                        noAudioMode: tour.noAudioMode && room,
                                                        translation: translation,
                                                        showPanoramaClick: function(panoramaId) {
                                                            var pIndex = panoramas.findIndex(function(p) {
                                                                return p.id === panoramaId;
                                                            });
                                                            panoramas[pIndex].default = true;
                                                            _this.setState({
                                                                panoramas: panoramas,
                                                                panoramaOn: !panoramaOn
                                                            });
                                                        },
                                                        onInteractedChange: function(interacted) {
                                                            _this.setState({
                                                                interacted: interacted
                                                            });
                                                        },
                                                        logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo
                                                    }),
                                                    showHelpModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Help, {
                                                        translation: translation,
                                                        onClose: function() {
                                                            _this.setState({
                                                                showHelpModal: false
                                                            });
                                                        }
                                                    }),
                                                    showTermsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Terms, {
                                                        translation: translation,
                                                        tourId: tour.id,
                                                        onClose: function() {
                                                            _this.setState({
                                                                showTermsModal: false
                                                            });
                                                        }
                                                    }),
                                                    lock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "lock-layer"
                                                    }),
                                                    !showIntro && !startScreenOn && showcaseLoaded && (tour.music && tour.autoplayMusic || activeSweepGroup) && !room && !interacted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "music-cover",
                                                        style: {
                                                            zIndex: 2,
                                                            position: "fixed",
                                                            height: "100vh",
                                                            width: "100vw",
                                                            top: 0,
                                                            left: 0
                                                        },
                                                        onClick: function() {
                                                            _this.setState({
                                                                interacted: true
                                                            });
                                                        }
                                                    }),
                                                    showIntro && !startScreenOn && (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar) || (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && avatar) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipScreen/* default */.Z, {
                                                        videoUrl: (game === null || game === void 0 ? void 0 : game.introClipUrl) || "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/game/").concat(game.id, "/").concat(game.uploadedIntroUrl).concat(util_all/* getVersion */.bo(game.updatedAt)) || 0,
                                                        close: function() {
                                                            _this.onCloseIntro();
                                                        },
                                                        forcePlay: forcePlayGameIntro,
                                                        subtitles: (ref14 = _this.getCurrentLanguage()) === null || ref14 === void 0 ? void 0 : ref14.languageCode,
                                                        onStartEvent: function() {},
                                                        iframe: _this.iframe
                                                    }) : _this.renderGameContent(),
                                                    !isGameTour && (game === null || game === void 0 ? void 0 : game.book) && tourStarted && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameBookHandle/* GameBookHandle */.V, {
                                                        isEcommerce: tourType === Tour/* TourType.ECommerce */.v.ECommerce,
                                                        gameBook: game.book,
                                                        onToggleGameBookModal: function() {
                                                            return _this.setState(function(state) {
                                                                return {
                                                                    showBook: !state.showBook
                                                                };
                                                            });
                                                        },
                                                        showBook: _this.state.showBook,
                                                        showBookBtn: (game === null || game === void 0 ? void 0 : game.gameBookOn) && (game === null || game === void 0 ? void 0 : game.book) && !_this.state.showBook,
                                                        closeGameBook: function() {
                                                            return _this.setState({
                                                                showBook: false
                                                            });
                                                        },
                                                        unlockedChapterIds: _this.state.unlockedChapterIds,
                                                        tryButtonPlaySound: _this.tryButtonPlaySound,
                                                        moveToSweep: _this.moveToSweep,
                                                        tourType: tourType
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loadTourIframe_LoadTourIframe, {
                                                iframeId: _this.state.iframeId,
                                                mesurementsOn: mesurementsOn,
                                                iframeStyle: getIframeStyle({
                                                    tour: _this.state.tour,
                                                    activeSweepGroup: _this.state.activeSweepGroup,
                                                    sweepGroups: _this.state.sweepGroups
                                                }),
                                                cb: function(el) {
                                                    _this.iframe = el;
                                                    _this.hideIframeButtons();
                                                },
                                                iframeUrl: iframeUrl,
                                                isFullScreen: isFullScreen
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        tour && !tour.hideCookie && /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent/* CustomCookieConsent */.Le, {
                            tour: tour,
                            loaded: showcaseLoaded,
                            message: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentText),
                            messageMandatoryTitle: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentTextMandatoryTitle),
                            messageMandatoryDescription: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentTextMandatoryDescription),
                            accept: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentAccept),
                            acceptMandatory: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentAcceptMandatory),
                            decline: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentDecline),
                            declineMandatory: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentDeclineMandatory),
                            showFullScreen: _this.state.showCookieFullScreen || tour.cookieIsMandatory && !startScreenOn,
                            startScreenOn: startScreenOn,
                            onAccept: function() {
                                // If loadTourAfterCookie is true, it means that tour loading was paused until user accept the cookie, so on accept we need to load the tour
                                if (tour.cookieIsMandatory && tour.loadTourAfterCookie) {
                                    _this.getTour({
                                        id: _this.props.matterId,
                                        tourData: tourData,
                                        bypassCookieCheck: true,
                                        url: (0,getLocationUrl/* getLocationUrl */.v)()
                                    });
                                }
                            }
                        }),
                        showSketchfabPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(SketchfabPopup, {
                            show: showSketchfabPopup,
                            vsObjects: _this.vsObjects,
                            onClose: _this.toggleSketchfabPopup(false)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SetDataToRecoil, {
                            translation: translation,
                            tourConfigsInput: {
                                rtl: tour === null || tour === void 0 ? void 0 : (ref15 = tour.client) === null || ref15 === void 0 ? void 0 : ref15.rtl,
                                tourType: tourType
                            }
                        }),
                        _this.renderCrashScreen(),
                        _this.state.tourTransitionLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loader_spinner_dist/* default */.Z, {
                            type: "Oval",
                            className: "loader",
                            style: {
                                width: "100%"
                            },
                            color: "#ea475c",
                            height: 100,
                            width: 100
                        }),
                        tour && (!tour.loadTourAfterCookie || tour.loadTourAfterCookie && hasAcceptedCookies) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                    dangerouslySetInnerHTML: {
                                        __html: "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\nm=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                    src: "https://www.googletagmanager.com/gtag/js?id=G-R2FVP1NTYY"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                    dangerouslySetInnerHTML: {
                                        __html: "\n                    window.dataLayer = window.dataLayer || [];\n                    function gtag(){dataLayer.push(arguments);}\n                    gtag('js', new Date());\n    \n                    gtag('config', 'G-R2FVP1NTYY');\n                  "
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                    id: "google-leapis",
                                    strategy: "afterInteractive",
                                    type: "text/javascript",
                                    src: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk&libraries=places"
                                })
                            ]
                        })
                    ]
                });
            }
        });
    };
    (0,_create_class/* default */.Z)(BaseTour, [
        {
            key: "isFreeUser",
            get: function get() {
                var ref, ref1, ref2, ref3;
                // If subscription is unknown/undefined yet, we shouldn't block any features
                if (![
                    User/* UserSubscription.Free */.MX.Free,
                    User/* UserSubscription.Growth */.MX.Growth,
                    User/* UserSubscription.Business */.MX.Business,
                    User/* UserSubscription.Enterprise */.MX.Enterprise
                ].includes((ref = this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.subscription)) {
                    return false;
                }
                return ((ref2 = this.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.subscription) === User/* UserSubscription.Free */.MX.Free;
            }
        }
    ]);
    return BaseTour;
}(react.PureComponent);
BaseTour.whyDidYouRender = true;
BaseTour.contextType = useCookies/* CookieAcceptanceContext */.cg;



/***/ }),

/***/ 66446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ getPlayerType; },
/* harmony export */   "Iw": function() { return /* binding */ getYoukuId; },
/* harmony export */   "L2": function() { return /* binding */ getVimeoId; },
/* harmony export */   "qS": function() { return /* binding */ getYoutubeId; }
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13589);

var getPlayerType = function(url) {
    if (url.includes("https://vimeo.com/")) {
        return _types__WEBPACK_IMPORTED_MODULE_0__/* .PlayerType.VIMEO */ .G.VIMEO;
    }
    if (url.includes("https://www.youtube.com/") || url.includes("youtu.be")) {
        return _types__WEBPACK_IMPORTED_MODULE_0__/* .PlayerType.YOUTUBE */ .G.YOUTUBE;
    }
    if (url.includes("youku.com")) {
        return _types__WEBPACK_IMPORTED_MODULE_0__/* .PlayerType.YOUKU */ .G.YOUKU;
    }
    return _types__WEBPACK_IMPORTED_MODULE_0__/* .PlayerType.NONE */ .G.NONE;
};
var getVimeoId = function(url) {
    var match = /vimeo.*\/(\d+)/i.exec(url);
    if (match) {
        return match[1];
    }
    return "";
};
var getYoutubeId = function(url) {
    var videoId = url.split("v=")[1] || url.split("youtu.be/")[1];
    var ampersandPosition = videoId.indexOf("&");
    if (ampersandPosition !== -1) {
        videoId = videoId.substring(0, ampersandPosition);
    }
    return videoId;
};
var getYoukuId = function(url) {
    var match = /id_(\w+)/i.exec(url);
    if (match) {
        return match[1];
    }
    return "";
};


/***/ }),

/***/ 13491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _vimeo_player__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48333);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13589);
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66446);
/* harmony import */ var _util_deviceManager__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99080);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12781);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18533);
/* harmony import */ var _treedis_tour_loader__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58490);
/* eslint-disable @typescript-eslint/ban-ts-comment */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .cs-introWrap {\n    height: 100%;\n  }\n  #intro-clip-iframe {\n    max-height: calc(100% - 60px);\n    background: black;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var PERCENT_AFTER_START_EVENT = 0.7;
var LoaderWrap = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ClipScreen__LoaderWrap",
    componentId: "sc-6457db6-0"
})(_templateObject());
var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ClipScreen__MainWrap",
    componentId: "sc-6457db6-1"
})(_templateObject1());
var ClipScreen = function(props) {
    var ref;
    var videoUrl = props.videoUrl, close = props.close, disableAutoplay = props.disableAutoplay, hideBtnGroup = props.hideBtnGroup, forcePlay = props.forcePlay, showControls = props.showControls, noMobile = props.noMobile, subtitles = props.subtitles, onStartEvent = props.onStartEvent, _autoClose = props.autoClose, autoClose = _autoClose === void 0 ? true : _autoClose, iframe = props.iframe;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), muted = ref2[0], setMuted = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.NOTSET */ .G.NOTSET), type = ref3[0], setType = ref3[1];
    var translation = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_8__/* .translationDataState */ .Jv);
    var player = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var isEventStarted = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (player && forcePlay && disableAutoplay) {
            var ref, ref1, ref2, ref3;
            if (type === _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.VIMEO */ .G.VIMEO && typeof ((ref = player.current) === null || ref === void 0 ? void 0 : ref.play) === "function") (ref1 = player.current) === null || ref1 === void 0 ? void 0 : ref1.play();
            else if (typeof ((ref2 = player.current) === null || ref2 === void 0 ? void 0 : ref2.playVideo) === "function") (ref3 = player.current) === null || ref3 === void 0 ? void 0 : ref3.playVideo();
        }
    }, [
        player,
        forcePlay,
        disableAutoplay,
        type
    ]);
    var subtitlesCustomReplace = function(subCode) {
        // vimeo only
        // vimeo have different language codes (non iso) for some languages
        // for more check
        // https://vimeo.zendesk.com/hc/en-us/articles/224968828-Captions-and-subtitles#h_01FH9P8GQJ1ERMDZB2DRHJKAR0
        var subsToReplace = {
            he: "iw"
        };
        return subsToReplace[subCode] || subCode;
    };
    var loadVimeoVideo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var playerVars = {
            id: (0,_data__WEBPACK_IMPORTED_MODULE_6__/* .getVimeoId */ .L2)(videoUrl),
            autoplay: !disableAutoplay && !_util_deviceManager__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isIOS */ .Z.isIOS(),
            controls: !!showControls || _util_deviceManager__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isIOS */ .Z.isIOS()
        };
        if (subtitles) playerVars.texttrack = subtitlesCustomReplace(subtitles);
        var introClipBlock = document.querySelector("#intro-clip-iframe");
        player.current = new _vimeo_player__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(introClipBlock, playerVars);
        player.current.on("timeupdate", function(data) {
            if (onStartEvent && data.percent >= PERCENT_AFTER_START_EVENT && !isEventStarted.current) {
                onStartEvent();
                isEventStarted.current = true;
            }
        });
        player.current.on("loaded", function() {
            setLoading(false);
            if (disableAutoplay) return;
            player.current.play().catch(function() {
            //nothing
            });
        });
        if (close) player.current.on("ended", function() {
            return autoClose && close();
        });
    }, [
        videoUrl,
        disableAutoplay,
        showControls,
        subtitles,
        close,
        onStartEvent,
        autoClose
    ]);
    var loadYKUVideo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var container = window.document.getElementById("intro-clip-iframe");
        var iframe = document.createElement("iframe");
        iframe.setAttribute("src", "https://player.youku.com/embed/".concat((0,_data__WEBPACK_IMPORTED_MODULE_6__/* .getYoukuId */ .Iw)(videoUrl), "?autoplay=1&controls=0&rel=0&showinfo=0"));
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        setTimeout(function() {
            return setLoading(false);
        }, 2000);
        container.appendChild(iframe);
    }, [
        videoUrl
    ]);
    var loadYTVideo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        // @ts-ignore
        var playerVars = {
            autoplay: disableAutoplay ? 0 : 1,
            controls: showControls ? 1 : 0,
            rel: 0,
            showinfo: 0,
            disablekb: 1,
            fs: 0,
            modestbranding: 1
        };
        if (subtitles) playerVars.hl = subtitles;
        // @ts-ignore
        player.current = new window.YT.Player("intro-clip-iframe", {
            videoId: (0,_data__WEBPACK_IMPORTED_MODULE_6__/* .getYoutubeId */ .qS)(videoUrl),
            playerVars: playerVars,
            events: {
                onStateChange: function(event) {
                    // @ts-ignore
                    if (event.data === window.YT.PlayerState.ENDED && close) {
                        if (autoClose) close();
                    }
                },
                onReady: function(event) {
                    setLoading(false);
                    if (disableAutoplay) return;
                    event.target.playVideo();
                }
            }
        });
    }, [
        disableAutoplay,
        showControls,
        subtitles,
        videoUrl,
        close,
        autoClose
    ]);
    var loadNativeVideo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (videoUrl) {
            var videoElement = document.createElement("video");
            videoElement.src = videoUrl;
            videoElement.controls = false;
            videoElement.autoplay = !disableAutoplay;
            videoElement.style.width = "100%";
            videoElement.style.height = "100%";
            videoElement.setAttribute("playsinline", "");
            videoElement.setAttribute("webkit-playsinline", "");
            videoElement.addEventListener("loadeddata", function() {
                setLoading(false);
            });
            videoElement.addEventListener("ended", function() {
                if (autoClose) {
                    close();
                }
            });
            player.current = videoElement;
            document.getElementById("intro-clip-iframe").appendChild(videoElement);
        }
    }, [
        autoClose,
        close,
        disableAutoplay,
        videoUrl
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        //should load video once
        if (!videoUrl || type !== _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.NOTSET */ .G.NOTSET) return;
        var newType = (0,_data__WEBPACK_IMPORTED_MODULE_6__/* .getPlayerType */ .Aq)(videoUrl);
        switch(newType){
            case _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.VIMEO */ .G.VIMEO:
                loadVimeoVideo();
                break;
            case _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.YOUTUBE */ .G.YOUTUBE:
                // @ts-ignore
                if (!window.YT) {
                    var tag = document.createElement("script");
                    tag.src = "https://www.youtube.com/iframe_api";
                    // @ts-ignore
                    window.onYouTubeIframeAPIReady = loadYTVideo;
                    var firstScriptTag = document.getElementsByTagName("script")[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                } else {
                    loadYTVideo();
                }
                break;
            case _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.YOUKU */ .G.YOUKU:
                loadYKUVideo();
                break;
            default:
                loadNativeVideo();
        }
        setType(newType);
    }, [
        loadNativeVideo,
        loadVimeoVideo,
        loadYKUVideo,
        loadYTVideo,
        type,
        videoUrl
    ]);
    var mute = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!player.current) return;
        switch(type){
            case _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.VIMEO */ .G.VIMEO:
                player.current.setMuted(true);
                break;
            case _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.YOUTUBE */ .G.YOUTUBE:
                player.current.mute();
                break;
            default:
                break;
        }
        setMuted(true);
    }, [
        type
    ]);
    var unMute = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!player.current) return;
        switch(type){
            case _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.VIMEO */ .G.VIMEO:
                player.current.setMuted(false);
                break;
            case _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.YOUTUBE */ .G.YOUTUBE:
                player.current.unMute();
                break;
            default:
                break;
        }
        setMuted(false);
    }, [
        type
    ]);
    var isMobile = _util_deviceManager__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isMobile */ .Z.isMobile();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        id: "intro",
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("intro", _util_deviceManager__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isMobile */ .Z.isMobile() && "mobile"),
        children: [
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoaderWrap, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_treedis_tour_loader__WEBPACK_IMPORTED_MODULE_9__/* .Loader */ .aN, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                style: {
                    display: loading ? "none" : "initial"
                },
                className: "cs-introWrap",
                children: [
                    !hideBtnGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "intro-btn-group",
                        children: [
                            type !== _types__WEBPACK_IMPORTED_MODULE_5__/* .PlayerType.YOUKU */ .G.YOUKU && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                className: "intro-button",
                                onClick: muted ? unMute : mute,
                                children: muted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    className: "fas fa-volume-off"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    className: "fas fa-volume-mute"
                                })
                            }),
                            // TODO hardcoded for Georgia Pacific TB-2219
                            !(iframe === null || iframe === void 0 ? void 0 : (ref = iframe.contentWindow) === null || ref === void 0 ? void 0 : ref.location.href.includes("m=mEMx41aqAaq")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                className: "intro-button",
                                onClick: close || function() {
                                    return null;
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    children: (translation === null || translation === void 0 ? void 0 : translation.skip) || "Skip"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        id: "intro-clip-iframe",
                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(!noMobile && isMobile && "mobile")
                    })
                ]
            })
        ]
    });
};
function areEqual(prevProps, nextProps) {
    return prevProps.videoUrl !== nextProps.videoUrl;
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(ClipScreen, areEqual));


/***/ }),

/***/ 13589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PlayerType; }
/* harmony export */ });
var PlayerType;
(function(PlayerType) {
    PlayerType[PlayerType["NOTSET"] = 0] = "NOTSET";
    PlayerType[PlayerType["NONE"] = 1] = "NONE";
    PlayerType[PlayerType["YOUTUBE"] = 2] = "YOUTUBE";
    PlayerType[PlayerType["VIMEO"] = 3] = "VIMEO";
    PlayerType[PlayerType["YOUKU"] = 4] = "YOUKU";
})(PlayerType || (PlayerType = {}));


/***/ }),

/***/ 25406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ GameBookHandle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./components/tour/game/gameBook/types.ts
var types = __webpack_require__(81389);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./units/Icon/index.ts + 45 modules
var Icon = __webpack_require__(34915);
// EXTERNAL MODULE: ./units/Iframe/style.tsx
var style = __webpack_require__(54811);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Root/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.65);\n  z-index: 120;\n  position: absolute;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  color: white;\n  font-size: 16px;\n  font-family: Roboto;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-4278e250-0"
})(_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, theme = param.theme;
    var styles = "";
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Root/index.tsx





var Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Root = (Root);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Header/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1em 2em;\n  /* Frosted background */\n  backdrop-filter: blur(80px);\n  -webkit-backdrop-filter: blur(80px);\n\n  h2 {\n    font-size: 2em;\n    font-weight: 500;\n    line-height: 0.8em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n\n  .close-modal {\n    position: absolute;\n    right: 35px;\n    cursor: pointer;\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ",
        "\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-d339e66e-0"
})(style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Header/index.tsx





var Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Header = (Header);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/List/style.tsx

function List_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 80vh;\n  overflow-y: auto;\n  font-size: 1em;\n  width: 200px;\n\n  .chapter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 1em;\n    width: 100%;\n    color: #fff;\n    position: relative;\n    cursor: pointer;\n    padding: 0.5em 1.25em;\n    overflow-wrap: anywhere;\n\n    &.active {\n      background-color: #2055ff;\n      ",
        "\n    }\n\n    &:hover {\n      background-color: #2055ff;\n      ",
        "\n      opacity: 0.7;\n    }\n\n    &.locked {\n      cursor: none;\n      pointer-events: none;\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    List_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ListStyled = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "style__ListStyled",
    componentId: "sc-27471df0-0"
})(List_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/List/index.tsx





var List = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ListStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_List = (List);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Content/style.tsx

function Content_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  padding: 3em 10em;\n\n  ",
        "\n"
    ]);
    Content_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ContentStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ContentStyled",
    componentId: "sc-3a0c8cfe-0"
})(Content_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n      padding: 1em 6em;\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Content/index.tsx





var Content = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ContentStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Content = (Content);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Main/style.tsx

function Main_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    max-height: 70vh;\n    width: 100%;\n  }\n\n  p {\n    max-height: 70vh;\n    width: 30vw;\n    min-height: 50vh;\n    word-wrap: break-word;\n    overflow-y: auto;\n  }\n\n  ",
        "\n"
    ]);
    Main_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__MainStyled",
    componentId: "sc-9195c60f-0"
})(Main_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    p {\n      width: 50vw;\n    }\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Main/index.tsx





var Main = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(MainStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Main = (Main);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Footer/style.tsx

function Footer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    font-size: 1em;\n    background-color: #2055ff;\n    padding: 0.4em 1em;\n    color: white;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    Footer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FooterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__FooterStyled",
    componentId: "sc-d65b2058-0"
})(Footer_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor, color = param.color;
    return buttonColor && color && "\n      background-color: ".concat(buttonColor, ";\n      color: ").concat(color, "\n    ");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Footer/index.tsx





var Footer = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    return show && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Footer = (Footer);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/index.ts







// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Root/style.tsx

function Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  height: 100vh;\n  height: 100%;\n  background: rgba(0, 0, 0, 1);\n  z-index: 1200;\n  position: absolute;\n  top: 0;\n  font-family: WorkSans;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n\n  .game-book-no-content {\n    padding: 70px 60px 30px 60px;\n    font-family: WorkSans;\n    font-size: 28px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.36;\n    letter-spacing: -0.56px;\n    text-align: center;\n    color: var(--white);\n  }\n"
    ]);
    Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-7d6a60d3-0"
})(Root_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Root/index.tsx





var Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var BannerHorizontalViewOnly_styled_Root = (Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Header/style.tsx

function Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .close-modal {\n    right: 10px;\n    position: absolute;\n    color: white;\n  }\n"
    ]);
    Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-881094ed-0"
})(Header_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Header/index.tsx





var Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var BannerHorizontalViewOnly_styled_Header = (Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/index.ts



;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/BannerHorizontalViewOnly.tsx






var BannerHorizontalViewOnly = function(param) {
    var show = param.show, onClose = param.onClose;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    if (!show) return null;
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    var isHorMob = deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView();
    if (isMobile && !isHorMob) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerHorizontalViewOnly_styled_Root, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly_styled_Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                        className: "close-modal",
                        onClick: onClose,
                        fontSize: "large"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "game-book-no-content",
                    children: (translation === null || translation === void 0 ? void 0 : translation.expGbNoContent) || "Available only for horizontal view"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "game-book-gif",
                    src: "/experience/mobile.gif",
                    alt: "Screen orientation"
                })
            ]
        });
    }
    return null;
};

// EXTERNAL MODULE: ./_helpers/base.tsx
var base = __webpack_require__(41154);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_helpers/renderDebug.ts
var renderDebug = __webpack_require__(66725);
;// CONCATENATED MODULE: ./components/tour/game/gameBook/index.tsx


















var GameBook = function(param) {
    var onClose = param.onClose, book = param.book, unlockedChapterIds = param.unlockedChapterIds, tryButtonPlaySound = param.tryButtonPlaySound, show = param.show, moveToSweep = param.moveToSweep, tourType = param.tourType;
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor, chapterLocked = book.chapterLocked;
    if (!show) return null;
    var ref = (0,react.useState)(), activePage = ref[0], setActivePage = ref[1];
    var ref1 = (0,react.useState)([]), pages = ref1[0], setPages = ref1[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    (0,react.useEffect)(function() {
        var ref;
        if ((book === null || book === void 0 ? void 0 : (ref = book.chapters) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var data = sortBy_default()(book.chapters, "order").reduce(function(acc, chapter) {
                acc.push({
                    id: chapter.id,
                    title: chapter.title,
                    description: chapter.description,
                    url: chapter.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/chapter/").concat(chapter.id, "/").concat(chapter.img) : undefined,
                    moveToSweepUuid: chapter.sweepUuid,
                    locationType: chapter === null || chapter === void 0 ? void 0 : chapter.locationType,
                    locationTourLink: chapter === null || chapter === void 0 ? void 0 : chapter.locationTourLink
                });
                return acc;
            }, [
                {
                    id: 0,
                    title: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover",
                    description: book.description,
                    url: book.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/").concat(book.img) : undefined,
                    moveToSweepUuid: undefined,
                    locationType: undefined,
                    locationTourLink: undefined
                }, 
            ]);
            setPages(data);
            setActivePage(data[0]);
        }
    }, [
        book
    ]);
    (0,react.useEffect)(function() {
        handleMoveToSweep(true);
    }, [
        activePage
    ]);
    var isPageLocked = function(chapterId) {
        if (chapterId === 0 || !chapterLocked) return false;
        return !unlockedChapterIds.includes(chapterId);
    };
    var changePage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!isPageLocked(page.id)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            tryButtonPlaySound()
                        ];
                    case 1:
                        _state.sent();
                        setActivePage(page);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function changePage(page) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMoveToSweep = function() {
        var first = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        try {
            if (activePage && (first && !activePage.url || !first)) {
                if (activePage.locationType === types/* GameBookLocationType.sweep */.d.sweep && activePage.moveToSweepUuid) {
                    moveToSweep(activePage.moveToSweepUuid);
                } else if (activePage.locationType === types/* GameBookLocationType.tourLink */.d.tourLink && activePage.locationTourLink) {
                    var parsedLink = (0,base/* parseTourLink */.Qs)(activePage.locationTourLink);
                    if (parsedLink) {
                        moveToSweep(parsedLink.s, {
                            x: parsedLink.x,
                            y: parsedLink.y
                        });
                    }
                } else if (activePage.id !== 0) {
                    onClose();
                }
            }
        } catch (err) {
            console.error("gameBook handleMoveToSweep error");
        }
    };
    //timeout will prevent reopen configs closed by sidebar configs icon
    var handleClickAway = function(ev) {
        if (tourType === Tour/* TourType.ECommerce */.v.ECommerce) {
            window.setTimeout(function() {
                onClose();
            }, 100);
        }
    };
    (0,renderDebug/* dLog */.a)("GameBook");
    //disable for mobile
    if (deviceManager/* default.isMobile */.Z.isMobile()) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly, {
                onClose: onClose,
                show: show
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                mouseEvent: "onMouseUp",
                onClickAway: handleClickAway,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "handleClickAwayNotWorksWithoutThisWrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Root, {
                        background: backgroundColor,
                        opacity: backgroundOpacity,
                        color: textColor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Header, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: (book === null || book === void 0 ? void 0 : book.description) || (translation === null || translation === void 0 ? void 0 : translation.expJournBook) || "Journey book"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                                        className: "close-modal",
                                        onClick: onClose,
                                        fontSize: "large"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Content, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Main, {
                                        children: [
                                            activePage ? activePage.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "book",
                                                src: activePage.url,
                                                alt: ""
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "page-description",
                                                children: activePage.description
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Loader */.aN, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Footer, {
                                                show: !!(activePage === null || activePage === void 0 ? void 0 : activePage.moveToSweepUuid),
                                                buttonColor: buttonColor,
                                                color: textColor,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    onClick: function() {
                                                        return handleMoveToSweep();
                                                    },
                                                    children: [
                                                        (translation === null || translation === void 0 ? void 0 : translation.experienceTeleport) || "Take me there",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowRight */.Z.ArrowRight, {
                                                            fontSize: "inherit"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_List, {
                                        color: textColor,
                                        buttonColor: buttonColor,
                                        children: (pages || []).map(function(page) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: classnames_default()("chapter", isPageLocked(page.id) && "locked", !isPageLocked(page.id) && activePage.id === page.id && "active"),
                                                onClick: function() {
                                                    return changePage(page);
                                                },
                                                children: [
                                                    page.title,
                                                    isPageLocked(page.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Lock */.Z.Lock, {
                                                        fontSize: "inherit"
                                                    })
                                                ]
                                            }, page.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var game_gameBook = (/*#__PURE__*/(0,react.memo)(GameBook));

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Root/style.tsx

function styled_Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 999;\n  top: 20px;\n  right: 260px;\n  color: #ffffff;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(15px);\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  padding: 1.25em;\n  justify-content: space-between;\n  max-width: 60%;\n  min-width: 320px;\n  min-height: 320px;\n\n  ",
        "\n"
    ]);
    styled_Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Root_style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-2405e9d5-0"
})(styled_Root_style_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, withFooter = param.withFooter, theme = param.theme;
    var styles = "";
    if (!withFooter) {
        styles += "justify-content: flex-start;";
    }
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Root/index.tsx





var styled_Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Root_style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Root = (styled_Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Header/style.tsx

function styled_Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n\n  h2 {\n    font-size: 1.25em;\n  }\n\n  ",
        "\n"
    ]);
    styled_Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Header_style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-87aa418e-0"
})(styled_Header_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Header/index.tsx





var styled_Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Header_style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Header = (styled_Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Body/style.tsx

function Body_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1em 0;\n\n  img {\n    max-height: 70vh;\n    width: 100%;\n  }\n\n  p {\n    overflow-wrap: anywhere;\n  }\n\n  ",
        "\n"
    ]);
    Body_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BodyStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__BodyStyled",
    componentId: "sc-d3e442b0-0"
})(Body_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    img {\n      max-height: 60vh;\n    }\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Body/index.tsx





var Body = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(BodyStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Body = (Body);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Footer/style.tsx

function styled_Footer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    font-size: 1em;\n    background-color: #2055ff;\n    padding: 0.4em 1em;\n    color: white;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    styled_Footer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_FooterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__FooterStyled",
    componentId: "sc-1575e035-0"
})(styled_Footer_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor, color = param.color;
    return buttonColor && color && "\n      background-color: ".concat(buttonColor, ";\n      color: ").concat(color, "\n    ");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Footer/index.tsx





var Footer_Footer = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    return show && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_FooterStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Footer = (Footer_Footer);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/index.ts





;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/ChapterDetails.tsx









var ChapterDetails = /*#__PURE__*/ (0,react.memo)(function(param) {
    var book = param.book, chapter = param.chapter, onClose = param.onClose, moveToSweep = param.moveToSweep;
    if (!chapter || !(chapter.locationType === types/* GameBookLocationType.sweep */.d.sweep && chapter.moveToSweepUuid)) return null;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor;
    var showFooter = !!chapter.moveToSweepUuid;
    var handleMoveToSweep = function() {
        try {
            if (chapter) {
                if (chapter.locationType === types/* GameBookLocationType.sweep */.d.sweep && chapter.moveToSweepUuid) {
                    moveToSweep(chapter.moveToSweepUuid);
                } else if (chapter.locationType === types/* GameBookLocationType.tourLink */.d.tourLink && chapter.locationTourLink) {
                    var parsedLink = (0,base/* parseTourLink */.Qs)(chapter.locationTourLink);
                    if (parsedLink) {
                        moveToSweep(parsedLink.s, {
                            x: parsedLink.x,
                            y: parsedLink.y
                        });
                    }
                }
                onClose();
            }
        } catch (err) {
            console.error("gameBook ChapterDetails handleMoveToSweep error");
        }
    };
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ChapterDetails_styled_Root, {
        background: backgroundColor,
        opacity: backgroundOpacity,
        color: textColor,
        withFooter: showFooter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChapterDetails_styled_Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: chapter.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Body, {
                children: chapter.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: chapter.url,
                    alt: ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: chapter.description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChapterDetails_styled_Footer, {
                show: showFooter,
                buttonColor: buttonColor,
                color: textColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: handleMoveToSweep,
                    children: [
                        (translation === null || translation === void 0 ? void 0 : translation.experienceTeleport) || "Take me there",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowRight */.Z.ArrowRight, {
                            fontSize: "inherit"
                        })
                    ]
                })
            })
        ]
    }), document.getElementById("page-root"));
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/index.ts

/* harmony default export */ var components_ChapterDetails = (ChapterDetails);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Root/style.tsx

function OpenGameBook_styled_Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 200px;\n  top: 210px;\n  right: 50px;\n  z-index: 110;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(15px);\n  border-radius: 15px;\n  padding: 0.5em 0;\n  color: white;\n  font-size: 16px;\n  font-family: Roboto;\n\n  ",
        "\n"
    ]);
    OpenGameBook_styled_Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styled_Root_style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-1da506d6-0"
})(OpenGameBook_styled_Root_style_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, customTop = param.customTop, theme = param.theme;
    var styles = "";
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    if (customTop) {
        styles += "top: ".concat(customTop, ";");
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Root/index.tsx





var OpenGameBook_styled_Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styled_Root_style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_Root = (OpenGameBook_styled_Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Header/style.tsx

function OpenGameBook_styled_Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5em 1.25em;\n\n  h2 {\n    font-size: 0.8em;\n    font-weight: 500;\n    line-height: 0.8em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n\n  ",
        "\n"
    ]);
    OpenGameBook_styled_Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styled_Header_style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-9a2c996e-0"
})(OpenGameBook_styled_Header_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Header/index.tsx





var OpenGameBook_styled_Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styled_Header_style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_Header = (OpenGameBook_styled_Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/List/style.tsx

function styled_List_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 80vh;\n  overflow-y: auto;\n  font-size: 1em;\n  ",
        "\n\n  .chapter {\n    display: block;\n    font-size: ",
        ";\n    width: 100%;\n    color: #fff;\n    position: relative;\n    cursor: pointer;\n    overflow: hidden;\n    padding: 0.5em 1.25em;\n    overflow-wrap: anywhere;\n\n    &:hover {\n      background-color: #2055ff;\n      ",
        "\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    styled_List_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_ListStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ListStyled",
    componentId: "sc-dcf0b53e-0"
})(styled_List_style_templateObject(), function(param) {
    var isHorizontalMobileView = param.isHorizontalMobileView;
    return isHorizontalMobileView && "height: 100px; overflow-y: scroll;";
}, function(param) {
    var isHorizontalMobileView = param.isHorizontalMobileView;
    return isHorizontalMobileView ? "0.8em" : "1em";
}, function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/List/index.tsx





var List_List = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_ListStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_List = (List_List);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/index.ts




;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/OpenGameBook.tsx














var OpenGameBook = function(param) {
    var book = param.book, show = param.show, unlockedChapterIds = param.unlockedChapterIds, onClose = param.onClose, moveToSweep = param.moveToSweep, tourType = param.tourType;
    if (!show) return null;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var sbIsOpen = (0,recoil/* useRecoilValue */.sJ)(store/* sidebarOpenState */.eo);
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor, chapterLocked = book.chapterLocked;
    var ref = (0,react.useState)(), activeData = ref[0], setActiveData = ref[1];
    var isEcommerce = tourType === Tour/* TourType.ECommerce */.v.ECommerce;
    var isHorizontalMobileView = deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView();
    var isChapterLocked = function(chapterId) {
        if (!chapterLocked) return false;
        return !unlockedChapterIds.includes(chapterId);
    };
    var openChapter = function(chapterId) {
        var data;
        if (chapterId === 0) {
            data = {
                title: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover",
                description: book.description,
                url: book.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/").concat(book.img) : undefined,
                moveToSweepUuid: undefined
            };
        } else if (!isChapterLocked(chapterId)) {
            var chapter = book.chapters.find(function(x) {
                return x.id === chapterId;
            });
            data = {
                // ...chapter,
                locationType: chapter.locationType,
                locationTourLink: chapter.locationTourLink,
                title: chapter.title,
                description: chapter.description,
                url: chapter.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/chapter/").concat(chapter.id, "/").concat(chapter.img) : undefined,
                moveToSweepUuid: chapter.sweepUuid
            };
        }
        if (data) {
            setActiveData(data);
        }
    };
    (0,react.useEffect)(function() {
        try {
            if (activeData) {
                if (activeData.locationType === types/* GameBookLocationType.sweep */.d.sweep && activeData.moveToSweepUuid) {
                    moveToSweep(activeData.moveToSweepUuid);
                } else if (activeData.locationType === types/* GameBookLocationType.tourLink */.d.tourLink && activeData.locationTourLink) {
                    var parsedLink = (0,base/* parseTourLink */.Qs)(activeData.locationTourLink);
                    if (parsedLink) {
                        moveToSweep(parsedLink.s, {
                            x: parsedLink.x,
                            y: parsedLink.y
                        });
                    }
                }
                setActiveData(undefined);
            }
        } catch (err) {
            console.error("gameBook ChapterDetails handleMoveToSweep error");
        }
    }, [
        activeData,
        moveToSweep,
        onClose
    ]);
    var eCommerceStyle = {
        top: "100px",
        marginTop: 0,
        right: sbIsOpen ? "180px" : "50px"
    };
    //timeout will prevent reopen configs closed by sidebar configs icon
    var handleClickAway = function(ev) {
        if (isEcommerce) {
            window.setTimeout(function() {
                onClose();
            }, 100);
        }
    };
    //disable for mobile
    if (deviceManager/* default.isMobile */.Z.isMobile()) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly, {
                show: show,
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                mouseEvent: "onMouseUp",
                onClickAway: handleClickAway,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "handleClickAwayNotWorksWithoutThisWrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_Root, {
                        background: backgroundColor,
                        opacity: backgroundOpacity,
                        color: textColor,
                        style: isEcommerce ? eCommerceStyle : undefined,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_Header, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: (book === null || book === void 0 ? void 0 : book.description) || (translation === null || translation === void 0 ? void 0 : translation.expJournBook) || "Journey book"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                                        onClick: onClose
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_List, {
                                buttonColor: buttonColor,
                                color: textColor,
                                isHorizontalMobileView: isHorizontalMobileView,
                                children: [
                                    book.img && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "chapter",
                                        onClick: function() {
                                            return openChapter(0);
                                        },
                                        children: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover"
                                    }, "0"),
                                    sortBy_default()(book.chapters || [], "order").map(function(chapter) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "d-flex justify-content-between align-center chapter",
                                            onClick: function() {
                                                return openChapter(chapter.id);
                                            },
                                            children: [
                                                chapter.title,
                                                isChapterLocked(chapter.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Lock */.Z.Lock, {
                                                    fontSize: "inherit"
                                                })
                                            ]
                                        }, chapter.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChapterDetails, {
                                book: book,
                                chapter: activeData,
                                onClose: function() {
                                    return setActiveData(undefined);
                                },
                                moveToSweep: moveToSweep
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/index.ts

/* harmony default export */ var game_OpenGameBook = (OpenGameBook);

// EXTERNAL MODULE: ./_models/game/GameBook.ts
var game_GameBook = __webpack_require__(97741);
;// CONCATENATED MODULE: ./components/tour/game/GameBookHandle/index.tsx
// import GameBookBtn from '../gameBookBtn';




// import { TourType } from '@/_models/Tour';
var GameBookHandle = function(param) {
    var isEcommerce = param.isEcommerce, gameBook = param.gameBook, showBook = param.showBook, tourType = param.tourType, closeGameBook = param.closeGameBook, unlockedChapterIds = param.unlockedChapterIds, moveToSweep = param.moveToSweep, tryButtonPlaySound = param.tryButtonPlaySound;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (gameBook === null || gameBook === void 0 ? void 0 : gameBook.type) === game_GameBook/* GameBookType.Close */.u6.Close && showBook && /*#__PURE__*/ (0,jsx_runtime.jsx)(game_gameBook, {
                tourType: tourType,
                show: showBook,
                onClose: closeGameBook,
                book: gameBook,
                unlockedChapterIds: unlockedChapterIds,
                tryButtonPlaySound: tryButtonPlaySound,
                moveToSweep: function(sweepUuid, rotation) {
                    moveToSweep(sweepUuid, rotation);
                    closeGameBook();
                }
            }),
            (gameBook === null || gameBook === void 0 ? void 0 : gameBook.type) === game_GameBook/* GameBookType.Open */.u6.Open && showBook && /*#__PURE__*/ (0,jsx_runtime.jsx)(game_OpenGameBook, {
                show: showBook,
                onClose: closeGameBook,
                book: gameBook,
                unlockedChapterIds: unlockedChapterIds,
                moveToSweep: moveToSweep,
                tourType: tourType
            })
        ]
    });
};


/***/ }),

/***/ 20000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ScreenNavigationArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ScreenNavigationArrow = function(param) {
    var refProp = param.refProp, _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? 100 : _zIndex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "direction-arrow",
        ref: refProp,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/direction-arrow.svg",
            className: "direction-arrow-image",
            alt: "arrow",
            style: {
                zIndex: zIndex
            }
        })
    });
};


/***/ }),

/***/ 2520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AdRedesigned; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67836);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22841);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75158);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71927);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10160);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21448);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68346);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(49837);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(91359);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(62026);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(54225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(74821);
/* harmony import */ var components_new__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72132);
/* harmony import */ var _components_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97666);
/* harmony import */ var _models_TourLead__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60988);











var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function Input(param, ref) {
    var label = param.label, type = param.type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        inputRef: ref,
        sx: {
            "& .MuiInputBase-root": {
                height: "50px"
            }
        },
        label: label,
        type: type,
        fullWidth: true,
        required: true
    });
});
var LegalCheckbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        componentsProps: {
            typography: {
                fontSize: {
                    xs: "14px",
                    md: "16px"
                }
            }
        },
        sx: {
            m: 0
        },
        // @ts-ignore
        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            ref: ref,
            required: true
        }),
        label: label
    });
});
function AdRedesigned(param) {
    var tour = param.tour, form = param.form, to = param.to, translation = param.translation, whitelabel = param.whitelabel, rtl = param.rtl;
    var id = tour.id, title = tour.title, userId = tour.userId, clientId = tour.clientId;
    var phone = form.phone, name = form.name, email = form.email, checkbox1 = form.checkbox1, url = form.url, time = form.time, checkbox2 = form.checkbox2;
    var primaryColor = (whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.primaryColor) || "#2055ff";
    var secondaryColor = (whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.secondaryColor) || "#000000";
    var hasOnlyImage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return !name && !email && !phone && !checkbox1 && !checkbox2;
    }, [
        email,
        name,
        phone,
        checkbox1,
        checkbox2
    ]);
    var isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), submitted = ref1[0], setSubmitted = ref1[1];
    var onClose = function() {
        setOpen(false);
    };
    var validatePhone = function(value) {
        var regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
        return regex.test(value);
    };
    var validateEmail = function(emailStr) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(emailStr).toLowerCase());
    };
    var nameRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var emailRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var phoneRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var legalRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var legalRef2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(event) {
            var ref, ref1, ref2, ref3, ref4, nameValue, emailValue, phoneValue, checkbox1Value, checkbox2Value, params, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        nameValue = (ref = nameRef.current) === null || ref === void 0 ? void 0 : ref.value;
                        emailValue = (ref1 = emailRef.current) === null || ref1 === void 0 ? void 0 : ref1.value;
                        phoneValue = (ref2 = phoneRef.current) === null || ref2 === void 0 ? void 0 : ref2.value;
                        checkbox1Value = (ref3 = legalRef.current) === null || ref3 === void 0 ? void 0 : ref3.checked;
                        checkbox2Value = (ref4 = legalRef2.current) === null || ref4 === void 0 ? void 0 : ref4.checked;
                        if (email && !validateEmail(emailValue)) {
                            react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .Am.error("Please enter a valid email address");
                            return [
                                2
                            ];
                        }
                        if (phone && !validatePhone(phoneValue)) {
                            react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .Am.error("Please enter a valid phone number");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        setSubmitted(true);
                        (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .sendToGA */ .o$)("event", {
                            eventCategory: "Lead",
                            eventAction: "submit",
                            eventLabel: time ? "image" : "sweep"
                        });
                        params = {
                            link: window.location.href,
                            tour: title,
                            userId: userId,
                            clientId: clientId,
                            name: nameValue,
                            email: emailValue,
                            phone: phoneValue,
                            legalBookingBox: checkbox1Value,
                            legalBookingBox2: checkbox2Value
                        };
                        return [
                            4,
                            (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .fetchData */ .rQ)("public/sendEmail", "POST", {
                                to: to,
                                params: params
                            })
                        ];
                    case 2:
                        _state.sent();
                        react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.success */ .Am.success("E-Mail sent");
                        return [
                            4,
                            (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .fetchData */ .rQ)("public/setTourLead", "POST", {
                                name: params.name,
                                email: params.email,
                                phone: params.phone,
                                category: _models_TourLead__WEBPACK_IMPORTED_MODULE_5__/* .LeadCategory.InTourLeadImage */ .k.InTourLeadImage,
                                tourId: id
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .Am.error(error.message);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        onClose();
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // If time is present, then it's a timed lead form, if not, then it's a 3Dscan lead form
        if (time) {
            setTimeout(function() {
                setOpen(true);
                (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .sendToGA */ .o$)("event", {
                    eventCategory: "Lead",
                    eventAction: "open",
                    eventLabel: "image"
                });
            }, time * 1000);
        } else {
            setOpen(true);
            (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .sendToGA */ .o$)("event", {
                eventCategory: "Lead",
                eventAction: "open",
                eventLabel: "sweep"
            });
        }
    }, [
        time
    ]);
    var topButtonsMargin = "16px";
    var _obj, _obj1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        theme: function() {
            return (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                // @ts-ignore
                palette: {
                    primary: {
                        main: primaryColor
                    },
                    secondary: {
                        main: secondaryColor
                    }
                }
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            dir: rtl ? "rtl" : "ltr",
            open: open,
            onClose: onClose,
            maxWidth: "md",
            sx: {
                "& .MuiDialog-paper": {
                    width: "100%",
                    borderRadius: "25px",
                    overflow: "hidden"
                }
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    onClick: onClose,
                    sx: (_obj = {
                        position: "absolute",
                        top: topButtonsMargin
                    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, rtl ? "left" : "right", topButtonsMargin), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "width", "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "height", "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "minHeight", "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "zIndex", 1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "boxShadow", "none"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "fontSize", "18px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "background", "#fff"), _obj),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fa-regular fa-times"
                    })
                }),
                url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    component: _mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z,
                    target: "_blank",
                    href: url,
                    sx: (_obj1 = {
                        position: "absolute",
                        top: topButtonsMargin
                    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, rtl ? "right" : "left", topButtonsMargin), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "zIndex", 1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "boxShadow", "none"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "color", "#fff"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "fontWeight", "bolder"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "cursor", "pointer"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "background", "rgba(0,0,0,0.4)"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "&:hover", {
                        textDecoration: "none",
                        color: "#fff"
                    }), _obj1),
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "fa-regular fa-arrow-up-right-from-square"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                variant: "body2",
                                sx: {
                                    color: "#fff",
                                    mx: 1
                                },
                                children: (translation === null || translation === void 0 ? void 0 : translation.clickToOpen) || "Click to Open"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    sx: {
                        background: "#fff",
                        width: "100%",
                        padding: "0",
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_new__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                            src: form.imageSrc,
                            ratio: hasOnlyImage ? "4/3" : "21/9",
                            objectFit: "cover"
                        }),
                        !hasOnlyImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            sx: {
                                overflowY: "auto",
                                padding: {
                                    xs: 2
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        sx: {
                                            padding: 0
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            spacing: 2,
                                            children: [
                                                name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, {
                                                    ref: nameRef,
                                                    label: (translation === null || translation === void 0 ? void 0 : translation.name) || "Name"
                                                }),
                                                email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, {
                                                    ref: emailRef,
                                                    label: (translation === null || translation === void 0 ? void 0 : translation.email) || "E-Mail",
                                                    type: "email"
                                                }),
                                                phone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, {
                                                    ref: phoneRef,
                                                    label: (translation === null || translation === void 0 ? void 0 : translation.phone) || "Phone"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    sx: {
                                                        marginX: "-8px !important",
                                                        width: "100%",
                                                        textAlign: rtl ? "right" : "left"
                                                    },
                                                    children: [
                                                        checkbox1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalCheckbox, {
                                                            ref: legalRef,
                                                            label: checkbox1
                                                        }),
                                                        checkbox2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalCheckbox, {
                                                            ref: legalRef2,
                                                            label: checkbox2
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                        sx: {
                                            padding: 0,
                                            mt: 2
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                            type: "submit",
                                            fullWidth: true,
                                            variant: "contained",
                                            size: "large",
                                            disabled: submitted,
                                            sx: {
                                                height: isDesktop ? "56px" : "50px"
                                            },
                                            children: (translation === null || translation === void 0 ? void 0 : translation.submit) || "Submit"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 67644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12781);
/* harmony import */ var _helpers_renderDebug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66725);
/* harmony import */ var _models_virtualStaging_VideoRenderer_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23276);









var lastTimestamp = 0;
var SoundControls = function(param) {
    var audio = param.audio, onClose = param.onClose, vsObjects = param.vsObjects;
    var ref;
    (0,_helpers_renderDebug__WEBPACK_IMPORTED_MODULE_4__/* .dLog */ .a)("SoundControls");
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), soundTime = ref1[0], setSoundTime = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowVolumeRange = ref2[0], toggleVolumeRange = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_store__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(_store__WEBPACK_IMPORTED_MODULE_3__/* .audioConfigsState */ .hm), 2), audioConfigs = ref3[0], setAudioConfigs = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeupdate = function() {
            if (!audio.currentTime || !audio.duration) {
                return;
            }
            setSoundTime(audio.currentTime / audio.duration * 100);
        };
        audio === null || audio === void 0 ? void 0 : audio.addEventListener("timeupdate", timeupdate);
        return function() {
            audio.removeEventListener("timeupdate", timeupdate);
        };
    }, [
        audio
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), volume = ref4[0], setVolume = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (audio) {
            // eslint-disable-next-line no-param-reassign
            audio.volume = volume;
        }
        return function() {
            var ref;
            if (audio) audio === null || audio === void 0 ? void 0 : (ref = audio.closeReceivers) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new Event("close"));
        };
    }, [
        audio,
        volume
    ]);
    var getSoundTime = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ONE_MINUTE = 60;
        if (audio) {
            var duration = !Number.isNaN(audio.duration) ? audio.duration : 0;
            var hour = parseInt(String(duration / ONE_MINUTE), 10);
            var minutes = Math.round(duration % ONE_MINUTE);
            return "".concat(hour, ":").concat(String(minutes).length === 1 ? "0".concat(minutes) : minutes);
        }
        return "00:00";
    }, [
        audio
    ]);
    var setCurrentTime = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(time, data) {
        if (data.timeStamp - lastTimestamp > 300) {
            lastTimestamp = data.timeStamp;
            var duration = audio.duration;
            if (audio && !Number.isNaN(duration)) {
                // eslint-disable-next-line no-param-reassign
                audio.currentTime = time * duration / 100;
            }
        }
    }, [
        audio
    ]);
    var setTogglePlay = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!(audio === null || audio === void 0 ? void 0 : audio.paused)) {
            audio.pause();
        } else {
            var vsVideos = vsObjects === null || vsObjects === void 0 ? void 0 : vsObjects.filter(function(obj) {
                var ref;
                return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.componentType) === _models_virtualStaging_VideoRenderer_component__WEBPACK_IMPORTED_MODULE_5__/* .videoRendererType */ .Im;
            });
            vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                var _node = obj.node, vsVideo = _node.video, muteBtn = _node.muteBtn;
                if (!muteBtn.active) {
                    vsVideo.muted = true;
                    muteBtn.active = true;
                    muteBtn.makeBtn(muteBtn.inputs.src);
                }
            });
            audio.play();
        }
    }, [
        audio
    ]);
    var handleClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(mode) {
        return function() {
            if (mode === "close") {
                audio === null || audio === void 0 ? void 0 : audio.pause();
                if (audio === null || audio === void 0 ? void 0 : audio.closeReceivers) {
                    var ref;
                    audio === null || audio === void 0 ? void 0 : (ref = audio.closeReceivers) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new Event("close"));
                }
            }
            if (onClose && typeof onClose === "function") {
                onClose();
            }
        };
    }, [
        audio,
        onClose
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sounds",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container-controls",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-minus",
                        onClick: handleClose("hide")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-times",
                        onClick: handleClose("close")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sound-range",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "range",
                    step: "0.1",
                    min: "0",
                    max: "100",
                    value: soundTime,
                    onChange: function(data) {
                        return setCurrentTime(parseFloat(data.target.value), data);
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sound-controls",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "left-side",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "play",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("fas", !(audio === null || audio === void 0 ? void 0 : audio.paused) ? "fa-pause" : "fa-play"),
                                    onClick: setTogglePlay
                                })
                            }),
                            (audio === null || audio === void 0 ? void 0 : (ref = audio.textTracks) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(audioConfigs.captionsEnabled ? "fas fa-closed-captioning" : "fal fa-closed-captioning"),
                                    onClick: function() {
                                        return setAudioConfigs((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, audioConfigs), {
                                            captionsEnabled: !audioConfigs.captionsEnabled
                                        }));
                                    }
                                })
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "volume",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fas fa-volume-up",
                                        onClick: function() {
                                            return toggleVolumeRange(!isShowVolumeRange);
                                        }
                                    }),
                                    isShowVolumeRange && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "range",
                                        step: "0.1",
                                        min: "0",
                                        max: "1",
                                        value: volume,
                                        onChange: function(data) {
                                            return setVolume(parseFloat(data.target.value));
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "right-side",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "time",
                            children: getSoundTime()
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SoundControls));


/***/ }),

/***/ 44:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FullScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* eslint-disable prefer-promise-reject-errors,class-methods-use-this */ // noinspection TypeScriptValidateTypes









var FullScreenContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isFullScreen: false,
    toggleFullscreen: function() {
        return null;
    }
});
var FullScreenStateProvider = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FullScreenStateProvider, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(FullScreenStateProvider);
    function FullScreenStateProvider(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, FullScreenStateProvider);
        var _this;
        _this = _super.call(this, props);
        _this.targetRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)();
        _this.state = {
            isFullScreen: false,
            // eslint-disable-next-line react/no-unused-state
            toggleFullscreen: _this.toggleFullscreen.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this))
        };
        return _this;
    }
    var _proto = FullScreenStateProvider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var targetElem = this.getTargetElement();
        targetElem.onfullscreenchange = function(event) {
            var isTargetElem = targetElem === event.target;
            if (!isTargetElem) {
                // Need to sync state when fullscreen mode turned off but isFullScreen is true
                // Case when more than one fullscreen mode is active and user closed mode by ESC tab
                if (_this.state.isFullScreen === true && !document.fullscreenElement) {
                    _this.setState({
                        isFullScreen: false
                    });
                }
                return;
            }
            var isFullScreen = document.fullscreenElement === event.target;
            _this.setState({
                isFullScreen: isFullScreen
            });
        };
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props.startFullscreen) {
            this.toggleFullscreen();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var targetElem = this.getTargetElement();
        targetElem.onfullscreenchange = null;
    };
    _proto.toggleFullscreen = function toggleFullscreen() {
        if (!this.state.isFullScreen) {
            var ref;
            (ref = this.openFullscreen()) === null || ref === void 0 ? void 0 : ref.catch(console.error);
        } else {
            var ref1;
            (ref1 = this.exitFullscreen()) === null || ref1 === void 0 ? void 0 : ref1.catch(console.error);
        }
        // noinspection TypeScriptValidateTypes
        this.setState({
            isFullScreen: !this.state.isFullScreen
        });
    };
    _proto.exitFullscreen = function exitFullscreen() {
        if (document.exitFullscreen) {
            return document.exitFullscreen();
        }
        if (document.webkitExitFullscreen) {
            return document.webkitExitFullscreen();
        }
        if (document.msExitFullscreen) {
            return document.msExitFullscreen();
        }
        return Promise.reject("API does not response");
    };
    _proto.openFullscreen = function openFullscreen() {
        var elem = this.getTargetElement();
        if (elem.requestFullscreen) {
            return elem.requestFullscreen();
        }
        if (elem.webkitRequestFullscreen) {
            return elem.webkitRequestFullscreen();
        }
        if (elem.msRequestFullscreen) {
            return elem.msRequestFullscreen();
        }
        return Promise.reject("API does not response");
    };
    _proto.getTargetElement = function getTargetElement() {
        var rootBody = this.props.rootBody;
        return rootBody ? window.document.body : this.targetRef.current;
    };
    _proto.render = function render() {
        var _props = this.props, children = _props.children, attrs = _props.attrs;
        var attr = {
            id: attrs === null || attrs === void 0 ? void 0 : attrs.id,
            className: attrs === null || attrs === void 0 ? void 0 : attrs.class
        };
        var customStyles = (attrs === null || attrs === void 0 ? void 0 : attrs.styles) || {};
        var styles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            height: "100%",
            width: "100%",
            background: "#fff"
        }, customStyles);
        return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenContext.Provider, {
            value: this.state,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                ref: this.targetRef
            }, attr), {
                style: styles,
                children: children
            }))
        }));
    };
    return FullScreenStateProvider;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
function FullScreen(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenStateProvider, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenContext.Consumer, {
            children: children
        })
    }));
}


/***/ }),

/***/ 39901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MondelezTabletVideo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95398);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25425);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9942);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17575);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70918);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59248);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21448);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80562);
/* harmony import */ var _treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58490);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22004);








var INIT_SETTINGS = {
    url: "",
    playing: false,
    volume: 1,
    played: 0,
    duration: 0
};
function formatDuration(value) {
    var minute = Math.floor(value / 60);
    var secondLeft = value - minute * 60;
    return "".concat(minute, ":").concat(secondLeft < 10 ? "0".concat(secondLeft) : secondLeft);
}
function MondelezTabletVideo(param) {
    var videoId = param.videoId, onClose = param.onClose;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), videoReady = ref[0], setVideoReady = ref[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var playerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, INIT_SETTINGS), {
        url: "https://player.vimeo.com/video/".concat(videoId, "?autoplay=1&autopause=0&background=1}")
    })), player = ref1[0], setPlayer = ref1[1];
    var handleSeek = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        var newValue = player.played + value;
        if (newValue < 0) {
            var ref;
            playerRef === null || playerRef === void 0 ? void 0 : (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.seekTo(0);
            setPlayer(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                    played: 0
                });
            });
        }
        if (newValue > player.duration) {
            var ref1;
            playerRef === null || playerRef === void 0 ? void 0 : (ref1 = playerRef.current) === null || ref1 === void 0 ? void 0 : ref1.seekTo(player.duration);
            setPlayer(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                    played: player.duration
                });
            });
        } else if (newValue > 0 && newValue < player.duration) {
            var ref2;
            playerRef === null || playerRef === void 0 ? void 0 : (ref2 = playerRef.current) === null || ref2 === void 0 ? void 0 : ref2.seekTo(newValue);
            setPlayer(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                    played: newValue
                });
            });
        }
    }, [
        player.duration,
        player.played
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        open: true,
        fullScreen: true,
        onClose: onClose,
        PaperProps: {
            sx: {
                background: "rgba(127,127,127,0.9)",
                backdropFilter: "blur(0)"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            ref: containerRef,
            sx: {
                position: "relative",
                width: "100%",
                display: "flex",
                alignItems: "end",
                overflow: "hidden",
                padding: 0
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    onClick: onClose,
                    sx: {
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        zIndex: 999,
                        color: "#fff"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fa-solid fa-times"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    timeout: 1500,
                    in: true,
                    direction: "up",
                    container: containerRef.current,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        sx: {
                            position: "relative",
                            width: "100%",
                            height: "auto",
                            maxHeight: "100vh"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                component: "img",
                                src: "/images/ipad_and_hands.png",
                                sx: {
                                    width: "100%",
                                    height: "auto",
                                    maxHeight: "100vh",
                                    objectFit: "contain",
                                    visibility: "visible !important",
                                    zIndex: 2,
                                    position: "relative",
                                    marginBottom: "-7px"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                sx: {
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-48%, -56%)",
                                    width: "min(55%, 110vh)",
                                    height: "80%",
                                    background: "white",
                                    zIndex: 1
                                },
                                children: [
                                    !videoReady && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        sx: {
                                            zIndex: 99,
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            background: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aN, {
                                            color: "#2055FF"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        in: true,
                                        timeout: 1000,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            width: "100%",
                                            height: "100%",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                ref: playerRef,
                                                width: "100%",
                                                height: "100%",
                                                url: player.url,
                                                volume: player.volume,
                                                playing: player.playing,
                                                onReady: function() {
                                                    setTimeout(function() {
                                                        setVideoReady(true);
                                                    }, 500);
                                                },
                                                onEnded: function() {
                                                    return setTimeout(function() {
                                                        onClose();
                                                    }, 500);
                                                },
                                                onProgress: function(progress) {
                                                    setPlayer(function(prev) {
                                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                            played: Math.floor(progress.playedSeconds)
                                                        });
                                                    });
                                                },
                                                onDuration: function(duration) {
                                                    setPlayer(function(prev) {
                                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                            duration: Math.floor(duration)
                                                        });
                                                    });
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            !player.playing && videoReady && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                sx: {
                                    position: "absolute",
                                    top: "40%",
                                    left: "50%",
                                    zIndex: 5,
                                    width: "50px",
                                    height: "50px",
                                    color: "rgba(0,0,0,0.8)",
                                    transform: "translateX(-50%)",
                                    "&>i": {
                                        fontSize: "7vw"
                                    }
                                },
                                onClick: function() {
                                    return setPlayer(function(prev) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                            playing: !player.playing
                                        });
                                    });
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "fa-solid fa-circle-play"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                direction: "row",
                                spacing: 2,
                                alignItems: "center",
                                sx: {
                                    position: "absolute",
                                    bottom: "2%",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    borderRadius: "10px",
                                    background: "rgba(255,255,255,0.8)",
                                    px: 1
                                },
                                zIndex: 5,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        onClick: function() {
                                            return setPlayer(function(prev) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                    playing: !player.playing
                                                });
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fa-solid ".concat(player.playing ? "fa-pause" : "fa-play")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "-10s",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                return handleSeek(-10);
                                            },
                                            disabled: player.played === 0,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fa-solid fa-undo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "+10s",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                return handleSeek(10);
                                            },
                                            disabled: player.played === 0,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fa-solid fa-redo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        enterDelay: 100,
                                        placement: "right",
                                        arrow: false,
                                        components: {
                                            Tooltip: _mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z
                                        },
                                        componentsProps: {
                                            tooltip: {
                                                sx: {
                                                    background: "rgba(255,255,255,0.8)",
                                                    mr: 2
                                                }
                                            }
                                        },
                                        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                                            size: "small",
                                            value: player.volume * 100,
                                            onChange: function(e, value) {
                                                if (Number(value)) {
                                                    setPlayer(function(prev) {
                                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                            volume: Number(value) / 100
                                                        });
                                                    });
                                                }
                                            },
                                            min: 0,
                                            max: 100,
                                            sx: {
                                                width: "200px"
                                            }
                                        }),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                return setPlayer(function(prev) {
                                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                        volume: player.volume > 0 ? 0 : 1
                                                    });
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fa-solid ".concat(player.volume === 0 ? "fa-volume-slash" : "fa-volume")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        label: "".concat(formatDuration(player.played), " / ").concat(formatDuration(player.duration))
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 49058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getLocationUrl; }
/* harmony export */ });
function getLocationUrl() {
    // If params are included, return the url which will get passed to getTour and load specific tour location
    var params = [
        "s=",
        "x=",
        "y="
    ];
    var hasParams = params.every(function(param) {
        return window.location.href.includes(param);
    });
    var url = hasParams ? window.location.href : null;
    return url;
}


/***/ }),

/***/ 19004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G$": function() { return /* reexport */ hooks_useGame; },
  "AG": function() { return /* reexport */ useGlobalDOMEvents; },
  "ZK": function() { return /* reexport */ hooks_useLanguage; },
  "OT": function() { return /* reexport */ hooks_useToggle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useGlobalDOMEvents.ts
/* eslint-disable @typescript-eslint/ban-ts-comment,no-restricted-syntax */ 

function useGlobalDOMEvents(props) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    (0,react.useEffect)(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], func = _value[1];
                // @ts-ignore
                window.addEventListener(key, func, false);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], func = _value[1];
                    // @ts-ignore
                    window.removeEventListener(key, func, false);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

;// CONCATENATED MODULE: ./hooks/useToggle.tsx

var initialDefault = false;
var useToggle = function(initial) {
    var ref = (0,react.useState)(initial !== null && initial !== void 0 ? initial : initialDefault), isOpen = ref[0], setIsOpen = ref[1];
    var set = (0,react.useCallback)(function(value) {
        return setIsOpen(value);
    }, [
        setIsOpen
    ]);
    var open = (0,react.useCallback)(function() {
        return setIsOpen(true);
    }, [
        setIsOpen
    ]);
    var close = (0,react.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    var toggle = (0,react.useCallback)(function() {
        return setIsOpen(function(prev) {
            return !prev;
        });
    }, [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        set: set,
        open: open,
        close: close,
        toggle: toggle
    };
};
/* harmony default export */ var hooks_useToggle = (useToggle);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./hooks/useLanguage.ts




var useLanguage = function(param) {
    var initialDuplicates = param.initialDuplicates, tourSlug = param.tourSlug;
    var languageOptions = (0,react.useMemo)(function() {
        return initialDuplicates === null || initialDuplicates === void 0 ? void 0 : initialDuplicates.map(function(duplicate) {
            return {
                label: (duplicate === null || duplicate === void 0 ? void 0 : duplicate.language) || (duplicate === null || duplicate === void 0 ? void 0 : duplicate.languageEn),
                value: duplicate.slug
            };
        }).filter(function(o) {
            return !!o.label;
        });
    }, [
        initialDuplicates
    ]);
    var defaultLanguage = (0,react.useMemo)(function() {
        return languageOptions === null || languageOptions === void 0 ? void 0 : languageOptions.find(function(o) {
            return o.value === tourSlug;
        });
    }, [
        languageOptions,
        tourSlug
    ]);
    var handleChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(lang) {
            var ref, ref1, tourRes, slug, gameId, pathnames, newPathname;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisPublicDAO/* default.getTourBySlug */.Z.getTourBySlug({
                                slug: lang.value
                            })
                        ];
                    case 1:
                        tourRes = _state.sent();
                        slug = tourRes === null || tourRes === void 0 ? void 0 : (ref = tourRes.tour) === null || ref === void 0 ? void 0 : ref.slug;
                        gameId = tourRes === null || tourRes === void 0 ? void 0 : (ref1 = tourRes.tour) === null || ref1 === void 0 ? void 0 : ref1.gameId;
                        pathnames = window.location.pathname.split("/");
                        pathnames.shift();
                        switch(pathnames[0]){
                            case "tour":
                                newPathname = "tour/".concat(slug);
                                break;
                            case "experience":
                                if (gameId) {
                                    newPathname = "experience/".concat(gameId, "/").concat(slug);
                                } else {
                                    console.error("No experience configuration for tour ".concat(slug));
                                }
                                break;
                            case "e-commerce-tour":
                                newPathname = "e-commerce-tour/".concat(slug);
                                break;
                            default:
                                break;
                        }
                        if (newPathname) {
                            window.location.replace("".concat(window.location.origin, "/").concat(newPathname));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(lang) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        languageOptions: languageOptions,
        defaultLanguage: defaultLanguage,
        handleChange: handleChange
    };
};
/* harmony default export */ var hooks_useLanguage = (useLanguage);

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./components/types.ts
var types = __webpack_require__(31828);
;// CONCATENATED MODULE: ./hooks/useGame.ts





var useGame = function(param) {
    var game = param.game, analytic = param.analytic, gameStatus = param.gameStatus, onEndExperience = param.onEndExperience;
    var ref = (0,react.useState)(0), gameTime = ref[0], setGameTime = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,recoil/* useRecoilState */.FV)(store/* lockTimerState */.bG), 2), lockTimer = ref1[0], setLockTimer = ref1[1];
    // 2nd level
    var initGameData = function() {
        var limitTime = game.limitTime * 60 * 1000;
        var currentGameTime = game.timerType === "stopwatch" ? 1 : limitTime;
        setGameTime(currentGameTime);
        analytic.setTime(game.timerType === "stopwatch" ? 1 : 0);
    };
    var mainGameTimer = function() {
        if (gameStatus === types/* GameStatus.SuccessfullyEndedWithoutFinalScreen */.XI.SuccessfullyEndedWithoutFinalScreen || gameStatus === types/* GameStatus.NotStarted */.XI.NotStarted) {
            return;
        }
        if ((lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.running) && (lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.value)) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setLockTimer(function(lockTimer) {
                if ((lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.running) && (lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.value)) return {
                    running: lockTimer.running,
                    value: lockTimer.value - 1
                };
                return lockTimer;
            });
        }
        var currentGameTime = gameTime;
        if (game.timerType === "stopwatch") currentGameTime += 1000;
        else currentGameTime -= 1000;
        analytic.setTime(game.timerType === "stopwatch" ? currentGameTime : game.limitTime * 60 * 1000 - currentGameTime);
        if (currentGameTime > 0 && (!game.limitTime || currentGameTime < game.limitTime * 60 * 1000)) {
            setGameTime(currentGameTime);
        } else {
            // end experience setstate result screen
            onEndExperience();
        }
    };
    (0,react.useEffect)(function() {
        if (gameStatus === types/* GameStatus.Started */.XI.Started) {
            initGameData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        gameStatus
    ]);
    (0,react.useEffect)(function() {
        var timerInterval = setTimeout(mainGameTimer, 1000);
        return function cleanup() {
            clearTimeout(timerInterval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        gameTime
    ]);
    return {
        gameTime: gameTime
    };
};
/* harmony default export */ var hooks_useGame = (useGame);

;// CONCATENATED MODULE: ./hooks/index.ts






/***/ }),

/***/ 99151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18533);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  position: absolute;\n  bottom: 70px;\n  left: ",
        ";\n  z-index: 100;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  transition: all 0.25s ease;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: -10px;\n  top: -10px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 50%;\n  color: #fff;\n  padding: 8px;\n  font-size: 14px;\n  line-height: 10px;\n  z-index: 2;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "VideoBox__Container",
    componentId: "sc-ccea8b1d-0"
})(_templateObject(), function(param) {
    var width = param.width, isMobile = param.isMobile, landscape = param.landscape;
    return isMobile ? !landscape ? "95vw" : "70vw" : "".concat(width || 350, "px");
}, function(param) {
    var height = param.height, isMobile = param.isMobile;
    return isMobile ? "auto" : "".concat(height || 200, "px");
}, function(param) {
    var isMobile = param.isMobile, landscape = param.landscape;
    return isMobile && !landscape ? "10px" : "60px";
});
var Iframe = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    displayName: "VideoBox__Iframe",
    componentId: "sc-ccea8b1d-1"
})(_templateObject1());
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].i.withConfig */ .ZP.i.withConfig({
    displayName: "VideoBox__Icon",
    componentId: "sc-ccea8b1d-2"
})(_templateObject2());
/* harmony default export */ __webpack_exports__["Z"] = ({
    Container: Container,
    Iframe: Iframe,
    Icon: Icon
});


/***/ }),

/***/ 19326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ units_Button; },
  "XZ": function() { return /* reexport */ units_Checkbox; },
  "PZ": function() { return /* reexport */ units_CloseButton; },
  "gN": function() { return /* reexport */ units_Field; },
  "l0": function() { return /* reexport */ units_Form; },
  "dY": function() { return /* reexport */ units_FullscreenButton; },
  "JO": function() { return /* reexport */ units_Icon/* default */.Z; },
  "II": function() { return /* reexport */ units_Input; },
  "xv": function() { return /* reexport */ units_Text; },
  "c6": function() { return /* reexport */ VideoBox/* default */.Z; }
});

// UNUSED EXPORTS: Alert, Collapse, DatePicker, Iframe, Watermark

// EXTERNAL MODULE: ./units/Alert/index.tsx + 1 modules
var Alert = __webpack_require__(47835);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./units/Button/defaultProps.ts
var defaultProps = {
    palette: "default",
    size: "medium",
    variant: "solid",
    flow: "auto",
    type: "button",
    borderRadius: "small"
};
/* harmony default export */ var Button_defaultProps = (defaultProps);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./units/Button/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: 1fr;\n  align-items: center;\n  overflow: hidden;\n\n  height: ",
        ";\n\n  min-width: ",
        ";\n\n  width: ",
        ";\n\n  color: ",
        ";\n\n  border-style: solid;\n\n  border-radius: ",
        ";\n\n  border-width: ",
        ";\n\n  border-color: ",
        ";\n\n  --background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  height: inherit;\n  background: var(--background);\n\n  width: ",
        ";\n\n  text-decoration: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  gap: ",
        ";\n\n  padding: 0 1rem;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n\n  & > svg {\n    font-size: inherit;\n  }\n\n  transition: 0.3s background ease-in;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  & + & {\n    border-left: 1px solid currentColor;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    transform: rotate(1turn);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Root",
    componentId: "sc-7c7d2c4-0"
})(_templateObject(), function(param) {
    var size = param.size, variant = param.variant;
    switch(variant){
        case "link":
            {
                return "auto";
            }
        default:
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
    }
}, function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "unset";
            }
        default:
            {
                return "80px";
            }
    }
}, function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "100%";
            }
        default:
            {
                return "initial";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "transparent":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    case "secondary":
                        {
                            return "#fff";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        case "ghost":
        case "soft":
        case "link":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        // case "solid"
        default:
            {
                return "#fff";
            }
    }
}, function(param) {
    var borderRadius = param.borderRadius;
    switch(borderRadius){
        case "large":
            {
                return "15px";
            }
        case "medium":
            {
                return "10px";
            }
        case "small":
            {
                return "5px";
            }
        case "none":
            {
                return "0px";
            }
        default:
            {
                return "4px";
            }
    }
}, function(param) {
    var variant = param.variant, size = param.size;
    switch(variant){
        case "ghost":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "1px";
                        }
                    case "small":
                        {
                            return "1px";
                        }
                    default:
                        {
                            return "2px";
                        }
                }
            }
        default:
            {
                return "0";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "ghost":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        case "soft":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        // case "transparent"
        // case "solid"
        // case "link"
        default:
            {
                return "transparent";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "transparent":
        case "ghost":
        case "link":
            {
                return "transparent";
            }
        case "soft":
            {
                switch(palette){
                    case "primary":
                        {
                            // TODO: add opacity
                            return "rgb(234 71 92 / .2)";
                        }
                    default:
                        {
                            // TODO: add opacity
                            return "rgb(41 41 41 / .2)";
                        }
                }
            }
        // case "solid"
        default:
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(--color-secondary)";
                        }
                    default:
                        {
                            return "var(--color-primary)";
                        }
                }
            }
    }
});
var ButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__ButtonStyled",
    componentId: "sc-7c7d2c4-1"
})(_templateObject1(), function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "100%";
            }
        default:
            {
                return "initial";
            }
    }
}, function(param) {
    var variant = param.variant;
    switch(variant){
        case "link":
            {
                return "underline";
            }
        // case "solid"
        // case "link"
        default:
            {
                return "none";
            }
    }
}, function(param) {
    var size = param.size;
    switch(size){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
}, function(param) {
    var size = param.size;
    switch(size){
        case "xsmall":
            {
                return "4px";
            }
        case "small":
            {
                return "6px";
            }
        default:
            {
                return "10px";
            }
    }
}, function(param) {
    var variant = param.variant;
    switch(variant){
        case "transparent":
            {
                return "rgba(0, 0, 0, .2)";
            }
        default:
            {
                return "var(--background)";
            }
    }
});
var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject2());
var Rotate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__Rotate",
    componentId: "sc-7c7d2c4-2"
})(_templateObject3(), rotate);

;// CONCATENATED MODULE: ./units/Button/index.tsx







var Button = function(_param) /*#__PURE__*/ {
    var _palette = _param.palette, palette = _palette === void 0 ? Button_defaultProps.palette : _palette, _size = _param.size, size = _size === void 0 ? Button_defaultProps.size : _size, _variant = _param.variant, variant = _variant === void 0 ? Button_defaultProps.variant : _variant, _flow = _param.flow, flow = _flow === void 0 ? Button_defaultProps.flow : _flow, _type = _param.type, type = _type === void 0 ? Button_defaultProps.type : _type, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? Button_defaultProps.borderRadius : _borderRadius, disabled = _param.disabled, loading = _param.loading, className = _param.className, onClear = _param.onClear, onClick = _param.onClick, onMouseDown = _param.onMouseDown, children = _param.children, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette",
        "size",
        "variant",
        "flow",
        "type",
        "borderRadius",
        "disabled",
        "loading",
        "className",
        "onClear",
        "onClick",
        "onMouseDown",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(Root, {
        palette: palette,
        size: size,
        variant: variant,
        flow: flow,
        borderRadius: borderRadius,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                palette: palette,
                size: size,
                variant: variant,
                flow: flow,
                borderRadius: borderRadius,
                type: type,
                onClick: onClick,
                onMouseDown: onMouseDown,
                disabled: disabled || loading,
                className: className
            }, restProps), {
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rotate, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Loading */.Z.Loading, {})
                    }),
                    children
                ]
            })),
            onClear && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyled, {
                palette: palette,
                size: size,
                flow: "square",
                variant: "transparent",
                borderRadius: borderRadius,
                type: "button",
                disabled: disabled || loading,
                onClick: onClear,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Close */.Z.Close, {})
            })
        ]
    });
};
/* harmony default export */ var units_Button = (Button);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-checkbox/es/index.js
var es = __webpack_require__(50132);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/omit.js
var omit = __webpack_require__(18475);
;// CONCATENATED MODULE: ./units/Checkbox/Group/index.tsx









var GroupContext = /*#__PURE__*/ (0,react.createContext)(null);
var CheckboxGroup = function(_param) {
    var defaultValue = _param.defaultValue, children = _param.children, _options = _param.options, options = _options === void 0 ? [] : _options, _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "checkbox" : _prefixCls, className = _param.className, style = _param.style, onChange = _param.onChange, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "style",
        "onChange"
    ]);
    var ref = (0,react.useState)(restProps.value || defaultValue || []), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)([]), registeredValues = ref1[0], setRegisteredValues = ref1[1];
    (0,react.useEffect)(function() {
        if ("value" in restProps) {
            setValue(restProps.value || []);
        }
    }, [
        restProps
    ]);
    var getOptions = function() {
        return options.map(function(option) {
            if (typeof option === "string") {
                return {
                    label: option,
                    value: option
                };
            }
            return option;
        });
    };
    var cancelValue = function(val) {
        setRegisteredValues(function(prevValues) {
            return prevValues.filter(function(v) {
                return v !== val;
            });
        });
    };
    var registerValue = function(val) {
        setRegisteredValues(function(prevValues) {
            return (0,_to_consumable_array/* default */.Z)(prevValues).concat([
                val
            ]);
        });
    };
    var toggleOption = function(option) {
        var optionIndex = value.indexOf(option.value);
        var newValue = (0,_to_consumable_array/* default */.Z)(value);
        if (optionIndex === -1) {
            newValue.push(option.value);
        } else {
            newValue.splice(optionIndex, 1);
        }
        if (!("value" in restProps)) {
            setValue(newValue);
        }
        var opts = getOptions();
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue.filter(function(val) {
            return registeredValues.indexOf(val) !== -1;
        }).sort(function(a, b) {
            var indexA = opts.findIndex(function(opt) {
                return opt.value === a;
            });
            var indexB = opts.findIndex(function(opt) {
                return opt.value === b;
            });
            return indexA - indexB;
        }));
    };
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var domProps = (0,omit/* default */.Z)(restProps, [
        "value",
        "disabled"
    ]);
    if (options && options.length > 0) {
        children = getOptions().map(function(option) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Checkbox_Checkbox, {
                prefixCls: prefixCls,
                disabled: "disabled" in option ? option.disabled : restProps.disabled,
                value: option.value,
                checked: value.indexOf(option.value) !== -1,
                onChange: option.onChange,
                className: "".concat(groupPrefixCls, "-item"),
                style: option.style,
                children: option.label
            }, (ref = option.value) === null || ref === void 0 ? void 0 : ref.toString());
        });
    }
    var context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        // https://github.com/ant-design/ant-design/issues/16376
        registerValue: registerValue,
        cancelValue: cancelValue
    };
    var classString = classnames_default()(groupPrefixCls, className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: classString,
        style: style
    }, domProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupContext.Provider, {
            value: context,
            children: react.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react.cloneElement)(child, {
                    value: value,
                    toggleOption: toggleOption
                });
            })
        })
    }));
};
/* harmony default export */ var Group = (/*#__PURE__*/(0,react.memo)(CheckboxGroup));

;// CONCATENATED MODULE: ./units/Checkbox/Checkbox/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n\n  & .checkbox {\n    width: 20px;\n    height: 20px;\n    display: block;\n    border-radius: 2px;\n    position: relative;\n    overflow: hidden;\n\n    & .checkbox-input {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      height: 100%;\n      width: 100%;\n      margin: 0;\n      padding: 0;\n      opacity: 0;\n    }\n\n    & .checkbox-inner {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      height: 100%;\n      width: 100%;\n      border: 2px solid #2c2c2c;\n      transition: background 0.2s ease-in;\n\n      border-color: ",
        ";\n    }\n\n    &.checkbox-checked {\n      & .checkbox-inner {\n        background: #2c2c2c;\n\n        &:after {\n          // eslint-disable-next-line max-len\n          content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'%3E%3C/path%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n        }\n      }\n    }\n\n    &.checkbox-indeterminate {\n      & .checkbox-inner {\n        background: #2c2c2c;\n        opacity: 0.8;\n\n        &:after {\n          // eslint-disable-next-line max-len\n          content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M19 13H5v-2h14v2z'%3E%3C/path%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n        }\n      }\n    }\n  }\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_SIZES = {
    // XXSMALL: 20,
    // XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var style_Root = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "style__Root",
    componentId: "sc-7b231797-0"
})(style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        default:
            {
                return "#292929";
            }
    }
});

;// CONCATENATED MODULE: ./units/Checkbox/Checkbox/index.tsx











var InternalCheckbox = function(_param, ref) {
    var _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "checkbox" : _prefixCls, className = _param.className, children = _param.children, _indeterminate = _param.indeterminate, indeterminate = _indeterminate === void 0 ? false : _indeterminate, style = _param.style, onMouseEnter = _param.onMouseEnter, onMouseLeave = _param.onMouseLeave, _skipGroup = _param.skipGroup, skipGroup = _skipGroup === void 0 ? false : _skipGroup, palette = _param.palette, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "prefixCls",
        "className",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "palette"
    ]);
    var checkboxGroup = (0,react.useContext)(GroupContext);
    var prevValue = (0,react.useRef)(restProps.value);
    (0,react.useEffect)(function() {
        checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
    }, [
        checkboxGroup,
        restProps.value
    ]);
    (0,react.useEffect)(function() {
        if (skipGroup) {
            return;
        }
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
        }
        // eslint-disable-next-line consistent-return
        return function() {
            return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
        };
    }, [
        checkboxGroup,
        restProps.value,
        skipGroup
    ]);
    var checkboxProps = (0,src_object_spread/* default */.Z)({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (restProps.onChange) {
                var _restProps;
                (_restProps = restProps).onChange.apply(_restProps, (0,_to_consumable_array/* default */.Z)(args));
            }
            if (checkboxGroup.toggleOption) {
                checkboxGroup.toggleOption({
                    label: children,
                    value: restProps.value
                });
            }
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.indexOf(restProps.value) !== -1;
        checkboxProps.disabled = restProps.disabled || checkboxGroup.disabled;
    }
    var _obj;
    var classString = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper"), true), (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _obj), className);
    var checkboxClass = classnames_default()((0,_define_property/* default */.Z)({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
    return(// eslint-disable-next-line jsx-a11y/label-has-associated-control
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Root, {
        palette: palette,
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, checkboxProps), {
                prefixCls: prefixCls,
                className: checkboxClass,
                // @ts-ignore
                ref: ref
            })),
            children
        ]
    }));
};
// @ts-ignore
var Checkbox = /*#__PURE__*/ (0,react.forwardRef)(InternalCheckbox);
Checkbox.displayName = "Checkbox";
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);

// EXTERNAL MODULE: ./node_modules/rc-collapse/assets/index.css
var assets = __webpack_require__(29969);
// EXTERNAL MODULE: ./node_modules/rc-collapse/es/index.js + 3 modules
var rc_collapse_es = __webpack_require__(16538);
;// CONCATENATED MODULE: ./units/Collapse/Panel/style.tsx

function Panel_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.rc-collapse-item {\n    padding: 0;\n    color: #666;\n    transition: 0.2s background ease-in;\n\n    & > .rc-collapse-header {\n      --background: ",
        ";\n\n      background: var(--background);\n      display: grid;\n      grid-template-columns: 1fr auto;\n      grid-template-areas: 'content arrow';\n      align-items: center;\n      overflow: hidden;\n      line-height: 1;\n      padding: 0;\n\n      &:hover {\n        background: ",
        ";\n      }\n\n      & .arrow {\n        grid-area: arrow;\n        border: none;\n        display: block;\n        width: 40px;\n        margin: 0;\n        position: relative;\n        top: 0;\n        background: transparent;\n        transition: 0.2s transform ease-in;\n        transform: rotate(180deg);\n        padding-bottom: 100%;\n\n        &:before {\n          content: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Ctitle%3EChevron Up%3C/title%3E%3Cpath fill='none' stroke='%23727272' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M112 328l144-144 144 144'/%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          padding: 10px;\n        }\n      }\n\n      & .arrow + * {\n        grid-area: content;\n      }\n    }\n\n    &.rc-collapse-item-active {\n      & > .rc-collapse-header {\n        & .arrow {\n          transform: rotate(0deg);\n        }\n      }\n    }\n  }\n"
    ]);
    Panel_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PanelStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_collapse_es/* default.Panel */.Z.Panel).withConfig({
    displayName: "style__PanelStyled",
    componentId: "sc-e8df8a15-0"
})(Panel_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475ccc";
            }
        default:
            {
                return "#292929cc";
            }
    }
});

;// CONCATENATED MODULE: ./units/Collapse/Panel/index.tsx






var Panel = function(_param) /*#__PURE__*/ {
    var // custom
    palette = _param.palette, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette"
    ]);
    return (0,jsx_runtime.jsx)(PanelStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restProps), {
        // custom
        palette: palette
    }));
};
/* harmony default export */ var Collapse_Panel = (Panel);

;// CONCATENATED MODULE: ./units/Collapse/style.tsx

function Collapse_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0;\n  border: none;\n  margin-bottom: 12px;\n  background: transparent;\n\n  & .rc-collapse-content {\n    padding: 0;\n    background: transparent;\n\n    & .rc-collapse-content-box {\n      margin: 8px 0;\n    }\n  }\n"
    ]);
    Collapse_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CollapseStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_collapse_es/* default */.Z).withConfig({
    displayName: "style__CollapseStyled",
    componentId: "sc-ffd29dd0-0"
})(Collapse_style_templateObject());

;// CONCATENATED MODULE: ./units/Collapse/index.tsx






var Collapse = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette"
    ]);
    return (0,jsx_runtime.jsx)(CollapseStyled, (0,src_object_spread/* default */.Z)({
        // custom
        palette: palette
    }, rest));
};
Collapse.Panel = Collapse_Panel;
/* harmony default export */ var units_Collapse = (Collapse);

;// CONCATENATED MODULE: ./units/Checkbox/Collapsable/style.tsx

function Collapsable_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  height: 100%;\n  display: grid;\n  justify-content: inherit;\n\n  & > label {\n    padding-left: 25px;\n  }\n"
    ]);
    Collapsable_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Header",
    componentId: "sc-f04741cd-0"
})(Collapsable_style_templateObject());

;// CONCATENATED MODULE: ./units/Checkbox/Collapsable/index.tsx






var defaultCheckedList = [];
var Collapsable_CheckboxGroup = function(param) {
    var name = param.name, label = param.label, children = param.children, onChangeAll = param.onChangeAll;
    var optionsAll = (0,react.useMemo)(function() {
        return children.map(function(e) {
            return e.props.name;
        });
    }, [
        children
    ]);
    var ref = (0,react.useState)(defaultCheckedList), checkedList = ref[0], setCheckedList = ref[1];
    var ref1 = (0,react.useState)(false), indeterminate = ref1[0], setIndeterminate = ref1[1];
    var ref2 = (0,react.useState)(false), checkAll = ref2[0], setCheckAll = ref2[1];
    var handleChange = (0,react.useCallback)(function(list) {
        setCheckedList(list);
        setIndeterminate(!!list.length && list.length < optionsAll.length);
        setCheckAll(list.length === optionsAll.length);
    }, [
        optionsAll
    ]);
    var onCheckAllChange = (0,react.useCallback)(function(e) {
        setCheckedList(e.target.checked ? optionsAll : []);
        setIndeterminate(false);
        setCheckAll(e.target.checked);
        // sorting out nodes with the same state as group checkbox
        var list = children.filter(function(node) {
            return node.props.checked !== e.target.checked;
        });
        onChangeAll === null || onChangeAll === void 0 ? void 0 : onChangeAll(e.target.checked, list.map(function(event) {
            return event.props.name;
        }));
    }, [
        children,
        onChangeAll,
        optionsAll
    ]);
    var header = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox, {
                indeterminate: indeterminate,
                onChange: onCheckAllChange,
                checked: checkAll,
                name: name,
                palette: "primary",
                children: label
            })
        });
    }, [
        name,
        label,
        indeterminate,
        onCheckAllChange,
        checkAll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Collapse, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Collapse.Panel, {
            header: header,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group, {
                name: name,
                value: checkedList,
                onChange: handleChange,
                children: children
            })
        })
    });
};
/* harmony default export */ var Collapsable = (/*#__PURE__*/(0,react.memo)(Collapsable_CheckboxGroup));

;// CONCATENATED MODULE: ./units/Checkbox/index.tsx




var units_Checkbox_Checkbox = Checkbox_Checkbox;
units_Checkbox_Checkbox.Collapsable = Collapsable;
units_Checkbox_Checkbox.Group = Group;
/* harmony default export */ var units_Checkbox = (units_Checkbox_Checkbox);

;// CONCATENATED MODULE: ./units/CloseButton/style.tsx

function CloseButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  z-index: 3;\n  top: ",
        ";\n  right: ",
        ";\n  border-radius: 50%;\n  background-color: var(--color-primary);\n\n  cursor: pointer;\n\n  svg,\n  i {\n    color: #fff;\n    font-size: 14px;\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    svg,\n    i {\n      color: var(--color-secondary);\n    }\n  }\n\n  @media screen and (max-width: 425px) and (orientation: portrait) {\n    right: ",
        ";\n  }\n"
    ]);
    CloseButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CloseButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__CloseButtonStyled",
    componentId: "sc-2535d2b1-0"
})(CloseButton_style_templateObject(), function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "15px" : "68px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-33px" : "18px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-15px" : "18px";
});

;// CONCATENATED MODULE: ./units/CloseButton/index.tsx


var CloseButton = function(param) {
    var onClick = param.onClick, isFullscreen = param.isFullscreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonStyled, {
        onClick: onClick,
        isFullscreen: isFullscreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "fas fa-times"
        })
    });
};
/* harmony default export */ var units_CloseButton = (CloseButton);

// EXTERNAL MODULE: ./node_modules/rc-field-form/es/index.js + 13 modules
var rc_field_form_es = __webpack_require__(54216);
;// CONCATENATED MODULE: ./units/Field/Group/style.tsx

function Group_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-flow: column;\n  gap: ",
        ";\n"
    ]);
    Group_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Content",
    componentId: "sc-1d2645c-0"
})(Group_style_templateObject(), function(param) {
    var gap = param.gap;
    return "".concat(gap !== null && gap !== void 0 ? gap : 0, "px");
});

;// CONCATENATED MODULE: ./units/Field/style.tsx

function Field_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n"
    ]);
    Field_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Lato', sans-serif;\n  font-size: 12px;\n  margin: 0 0 6px;\n  display: grid;\n  grid-template-areas: 'icon label lock';\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n\n  color: ",
        ";\n\n  font-weight: ",
        ";\n\n  & svg {\n    font-size: 15px;\n    margin-right: 9px;\n  }\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: icon;\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: label;\n"
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: lock;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #ea475c;\n  margin-top: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Field_style_SIZES = {
    // XXSMALL: 20,
    // XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Label",
    componentId: "sc-4f2f6e14-0"
})(Field_style_templateObject(), function(param) {
    var labelInline = param.labelInline;
    if (labelInline) {
        return "flex";
    }
    return "block";
});
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Title",
    componentId: "sc-4f2f6e14-1"
})(style_templateObject1(), function(param) {
    var labelPalette = param.labelPalette;
    switch(labelPalette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#888";
            }
    }
}, function(param) {
    var labelPalette = param.labelPalette;
    switch(labelPalette){
        case "primary":
            {
                return "normal";
            }
        default:
            {
                return "bolder";
            }
    }
});
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Icon",
    componentId: "sc-4f2f6e14-2"
})(style_templateObject2());
var Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Name",
    componentId: "sc-4f2f6e14-3"
})(style_templateObject3());
var Lock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Lock",
    componentId: "sc-4f2f6e14-4"
})(_templateObject4());
var Error = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Error",
    componentId: "sc-4f2f6e14-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./units/Field/Group/index.tsx



var Group_Group = function(param) {
    var label = param.label, labelIcon = param.labelIcon, labelPalette = param.labelPalette, gap = param.gap, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                labelPalette: labelPalette,
                children: [
                    labelIcon,
                    label
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                gap: gap,
                children: children
            })
        ]
    });
};
/* harmony default export */ var Field_Group = (Group_Group);

;// CONCATENATED MODULE: ./units/Field/index.tsx








var Field = function(_param) {
    var name = _param.name, label = _param.label, labelIcon = _param.labelIcon, labelPalette = _param.labelPalette, noStyle = _param.noStyle, labelInline = _param.labelInline, lockable = _param.lockable, isLocked = _param.isLocked, isLockedByDefault = _param.isLockedByDefault, children = _param.children, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "labelIcon",
        "labelPalette",
        "noStyle",
        "labelInline",
        "lockable",
        "isLocked",
        "isLockedByDefault",
        "children"
    ]);
    var ref;
    var ref1 = (0,react.useState)((ref = isLocked !== null && isLocked !== void 0 ? isLocked : isLockedByDefault) !== null && ref !== void 0 ? ref : false), locked = ref1[0], setLocked = ref1[1];
    (0,react.useEffect)(function() {
        if (typeof isLocked === "boolean") {
            setLocked(isLocked);
        }
    }, [
        isLocked
    ]);
    if (noStyle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_field_form_es/* Field */.gN, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            name: name
        }, restProps), {
            children: function(control, meta, form) {
                var childNode = typeof children === "function" ? children((0,src_object_spread/* default */.Z)({}, lockable ? {
                    disabled: locked
                } : {}, control), meta, form) : /*#__PURE__*/ (0,react.cloneElement)(children, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, control), {
                    name: name
                }));
                return childNode;
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_field_form_es/* Field */.gN, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        name: name
    }, restProps), {
        children: function(control, meta, form) {
            var error = name && form.getFieldError(name)[0] || "";
            var childNode = typeof children === "function" ? children((0,src_object_spread/* default */.Z)({}, lockable ? {
                disabled: locked
            } : {}, control), meta, form) : /*#__PURE__*/ (0,react.cloneElement)(children, (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, control), {
                name: name
            }), lockable ? {
                disabled: locked
            } : {}));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                labelInline: labelInline,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                        labelPalette: labelPalette,
                        children: [
                            labelIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                children: labelIcon
                            }),
                            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                children: label
                            })
                        ]
                    }),
                    childNode,
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                        children: error
                    })
                ]
            });
        }
    }));
};
Field.Group = Field_Group;
/* harmony default export */ var units_Field = (Field);

;// CONCATENATED MODULE: ./units/Form/style.tsx

function Form_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n\n  /* global override */\n  max-height: unset !important;\n  overflow: unset !important;\n"
    ]);
    Form_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Form = (0,styled_components_browser_esm/* default */.ZP)(rc_field_form_es/* default */.ZP).withConfig({
    displayName: "style__Form",
    componentId: "sc-a03062af-0"
})(Form_style_templateObject());

;// CONCATENATED MODULE: ./units/Form/index.tsx

/* harmony default export */ var units_Form = (Form);

;// CONCATENATED MODULE: ./units/FullscreenButton/style.tsx

function FullscreenButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  z-index: 3;\n  border-radius: 50%;\n  top: ",
        ";\n  right: ",
        ";\n  background-color: var(--color-secondary);\n\n  cursor: pointer;\n\n  svg,\n  i {\n    color: #fff;\n    font-size: 14px;\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    svg,\n    i {\n      color: var(--color-primary);\n    }\n  }\n\n  @media screen and (max-width: 425px) and (orientation: portrait) {\n    top: ",
        ";\n    right: ",
        ";\n  }\n"
    ]);
    FullscreenButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FullscreenButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__FullscreenButtonStyled",
    componentId: "sc-17a6388c-0"
})(FullscreenButton_style_templateObject(), function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "48px" : "100px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-33px" : "18px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "52px" : "100px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-15px" : "18px";
});
/* harmony default export */ var style = (FullscreenButtonStyled);

// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./units/FullscreenButton/index.tsx



var FullscreenButton = function(param) {
    var onClick = param.onClick, isFullscreen = param.isFullscreen;
    return !deviceManager/* default.isMobile */.Z.isMobile() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(style, {
        onClick: onClick,
        isFullscreen: isFullscreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: isFullscreen ? "fas fa-compress" : "fas fa-expand"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var units_FullscreenButton = (FullscreenButton);

// EXTERNAL MODULE: ./units/Iframe/index.tsx + 1 modules
var Iframe = __webpack_require__(12978);
// EXTERNAL MODULE: ./node_modules/rc-textarea/es/index.js + 2 modules
var rc_textarea_es = __webpack_require__(57239);
;// CONCATENATED MODULE: ./units/Input/TextArea/style.tsx

function TextArea_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n\n  color: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  border-radius: 4px;\n  border: none;\n  margin: 0;\n  line-height: 1.2;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n"
    ]);
    TextArea_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TextArea_style_SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var TextAreaStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_textarea_es/* default */.Z).withConfig({
    displayName: "style__TextAreaStyled",
    componentId: "sc-ea1cbca6-0"
})(TextArea_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "rgba(255, 255, 255, 0.5)";
            }
        case "tertiary":
            {
                return "rgba(255, 255, 255, 1)";
            }
        default:
            {
                return "rgba(136, 136, 136, 0.1)";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
});

;// CONCATENATED MODULE: ./units/Input/TextArea/index.tsx




var autoSizeDefault = {
    minRows: 3,
    maxRows: 5
};
var TextArea = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, design = _param.design, size = _param.size, _autoSize = _param.autoSize, autoSize = _autoSize === void 0 ? autoSizeDefault : _autoSize, _value = _param.value, value = _value === void 0 ? "" : _value, placeholder = _param.placeholder, name = _param.name, disabled = _param.disabled, onChange = _param.onChange, _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "textarea" : _prefixCls, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette",
        "design",
        "size",
        "autoSize",
        "value",
        "placeholder",
        "name",
        "disabled",
        "onChange",
        "prefixCls"
    ]);
    return (0,jsx_runtime.jsx)(TextAreaStyled, (0,src_object_spread/* default */.Z)({
        palette: palette,
        design: design,
        xsize: size,
        autoSize: autoSize,
        value: value,
        placeholder: placeholder,
        name: name,
        disabled: disabled,
        onChange: onChange,
        prefixCls: prefixCls
    }, props));
};
/* harmony default export */ var Input_TextArea = (TextArea);

;// CONCATENATED MODULE: ./units/Input/style.tsx

function Input_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n\n  background: ",
        ";\n\n  color: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  min-width: 60px;\n  border-radius: 4px;\n  border: none;\n  margin: 0;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n"
    ]);
    Input_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Input_style_SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var InputStyled = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "style__InputStyled",
    componentId: "sc-60cb3ca-0"
})(Input_style_templateObject(), function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "".concat(Input_style_SIZES.XSMALL, "px");
            }
        case "small":
            {
                return "".concat(Input_style_SIZES.SMALL, "px");
            }
        default:
            {
                return "".concat(Input_style_SIZES.MEDIUM, "px");
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "rgba(255, 255, 255, 0.5)";
            }
        case "tertiary":
            {
                return "rgba(255, 255, 255, 1)";
            }
        default:
            {
                return "rgba(136, 136, 136, 0.1)";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
});

;// CONCATENATED MODULE: ./units/Input/index.tsx
// noinspection TypeScriptValidateTypes





var Input = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, design = _param.design, size = _param.size, value = _param.value, min = _param.min, max = _param.max, step = _param.step, onChange = _param.onChange, onBlur = _param.onBlur, placeholder = _param.placeholder, name = _param.name, disabled = _param.disabled, onKeyDown = _param.onKeyDown, tabIndex = _param.tabIndex, type = _param.type, className = _param.className, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette",
        "design",
        "size",
        "value",
        "min",
        "max",
        "step",
        "onChange",
        "onBlur",
        "placeholder",
        "name",
        "disabled",
        "onKeyDown",
        "tabIndex",
        "type",
        "className"
    ]);
    return (0,jsx_runtime.jsx)(InputStyled, (0,src_object_spread/* default */.Z)({
        palette: palette,
        design: design,
        xsize: size,
        value: value,
        min: min,
        max: max,
        step: step,
        onChange: onChange,
        onBlur: onBlur,
        placeholder: placeholder,
        name: name,
        disabled: disabled,
        onKeyDown: onKeyDown,
        tabIndex: tabIndex,
        type: type,
        className: className
    }, restProps));
};
Input.TextArea = Input_TextArea;
/* harmony default export */ var units_Input = (Input);

;// CONCATENATED MODULE: ./units/Text/style.tsx

function Text_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  font-weight: ",
        ";\n\n  text-transform: ",
        ";\n  text-decoration: ",
        ";\n  overflow-wrap: anywhere;\n"
    ]);
    Text_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Text_style_Root = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__Root",
    componentId: "sc-51413b4b-0"
})(Text_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "#888";
            }
        default:
            {
                return "#fff";
            }
    }
}, function(param) {
    var weight = param.weight;
    switch(weight){
        case "regular":
            {
                return "bolder";
            }
        case "strong":
            {
                return "bold";
            }
        // case "weak"
        default:
            {
                return "normal";
            }
    }
}, function(param) {
    var uppercase = param.uppercase;
    return uppercase ? "uppercase" : "none";
}, function(param) {
    var underline = param.underline;
    return underline ? "underline" : "none";
});

;// CONCATENATED MODULE: ./units/Text/index.tsx


var Text = function(param) {
    var size = param.size, weight = param.weight, align = param.align, truncate = param.truncate, underline = param.underline, uppercase = param.uppercase, palette = param.palette, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_style_Root, {
        size: size,
        weight: weight,
        align: align,
        truncate: truncate,
        underline: underline,
        uppercase: uppercase,
        palette: palette,
        children: children
    });
};
/* harmony default export */ var units_Text = (Text);

// EXTERNAL MODULE: ./units/Icon/index.ts + 45 modules
var units_Icon = __webpack_require__(34915);
// EXTERNAL MODULE: ./units/VideoBox/index.tsx
var VideoBox = __webpack_require__(99151);
;// CONCATENATED MODULE: ./units/Watermark/style.tsx

function Watermark_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  width: 100%;\n  top: 30%;\n  text-align: center;\n  opacity: 0.5;\n  z-index: 99999;\n  color: white;\n  transform: rotate(-30deg);\n  font-size: 30vh;\n  pointer-events: none;\n  @media (orientation: portrait) {\n    transform: rotate(-45deg);\n    font-size: 22vh;\n  }\n"
    ]);
    Watermark_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_WatermarkStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__WatermarkStyled",
    componentId: "sc-74f85d7c-0"
})(Watermark_style_templateObject());
/* harmony default export */ var Watermark_style = ((/* unused pure expression or super */ null && (style_WatermarkStyled)));

;// CONCATENATED MODULE: ./units/Watermark/index.tsx





var Watermark = function(_param) {
    var id = _param.id, show = _param.show, children = _param.children, restProps = _object_without_properties(_param, [
        "id",
        "show",
        "children"
    ]);
    if (show) {
        return /*#__PURE__*/ _jsx(WatermarkStyled, _object_spread_props(_object_spread({
            id: id
        }, restProps), {
            children: children
        }));
    }
    return null;
};
/* harmony default export */ var units_Watermark = ((/* unused pure expression or super */ null && (Watermark)));

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(39828);
;// CONCATENATED MODULE: ./units/DatePicker/index.tsx



var DatePickerCreator = function(param) {
    var dateFormat = param.dateFormat, startDate = param.startDate, handleDateChange = param.handleDateChange;
    return /*#__PURE__*/ _jsx(DatePicker, {
        dateFormat: dateFormat,
        selected: startDate,
        onChange: handleDateChange,
        autoComplete: "disable_autocomplete"
    });
};
/* harmony default export */ var units_DatePicker = ((/* unused pure expression or super */ null && (DatePickerCreator)));

;// CONCATENATED MODULE: ./units/index.ts

















/***/ }),

/***/ 75410:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 48628:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 67792:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 52007:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 75042:
/***/ (function() {

/* (ignored) */

/***/ })

}]);